(function (X, Y) {
    "use strict";
    var Z = {};

    function require(a, b) {
        var c, defs = [];
        for (var i = 0; i < a.length; ++i) {
            c = Z[a[i]] || resolve(a[i]);
            if (!c) {
                throw 'module definition dependecy not found: ' + a[i]
            }
            defs.push(c)
        }
        b.apply(null, defs)
    }
    function define(a, b, c) {
        if (typeof a !== 'string') {
            throw 'invalid module definition, module id must be defined and be a string'
        }
        if (b === Y) {
            throw 'invalid module definition, dependencies must be specified'
        }
        if (c === Y) {
            throw 'invalid module definition, definition function must be specified'
        }
        require(b, function () {
            Z[a] = c.apply(null, arguments)
        })
    }
    function defined(a) {
        return !!Z[a]
    }
    function resolve(a) {
        var b = X;
        var c = a.split(/[.\/]/);
        for (var d = 0; d < c.length; ++d) {
            if (!b[c[d]]) {
                return
            }
            b = b[c[d]]
        }
        return b
    }
    function expose(a) {
        var i, target, id, fragments, privateModules;
        for (i = 0; i < a.length; i++) {
            target = X;
            id = a[i];
            fragments = id.split(/[.\/]/);
            for (var b = 0; b < fragments.length - 1; ++b) {
                if (target[fragments[b]] === Y) {
                    target[fragments[b]] = {}
                }
                target = target[fragments[b]]
            }
            target[fragments[fragments.length - 1]] = Z[id]
        }
        if (X.AMDLC_TESTS) {
            privateModules = X.privateModules || {};
            for (id in Z) {
                privateModules[id] = Z[id]
            }
            for (i = 0; i < a.length; i++) {
                delete privateModules[a[i]]
            }
            X.privateModules = privateModules
        }
    }
    define("tinymce/geom/Rect", [], function () {
        "use strict";
        var f = Math.min,
            max = Math.max,
            round = Math.round;

        function relativePosition(a, b, c) {
            var x, y, w, h, targetW, targetH;
            x = b.x;
            y = b.y;
            w = a.w;
            h = a.h;
            targetW = b.w;
            targetH = b.h;
            c = (c || '').split('');
            if (c[0] === 'b') {
                y += targetH
            }
            if (c[1] === 'r') {
                x += targetW
            }
            if (c[0] === 'c') {
                y += round(targetH / 2)
            }
            if (c[1] === 'c') {
                x += round(targetW / 2)
            }
            if (c[3] === 'b') {
                y -= h
            }
            if (c[4] === 'r') {
                x -= w
            }
            if (c[3] === 'c') {
                y -= round(h / 2)
            }
            if (c[4] === 'c') {
                x -= round(w / 2)
            }
            return create(x, y, w, h)
        }
        function findBestRelativePosition(a, b, c, d) {
            var e, i;
            for (i = 0; i < d.length; i++) {
                e = relativePosition(a, b, d[i]);
                if (e.x >= c.x && e.x + e.w <= c.w + c.x && e.y >= c.y && e.y + e.h <= c.h + c.y) {
                    return d[i]
                }
            }
            return null
        }
        function inflate(a, w, h) {
            return create(a.x - w, a.y - h, a.w + w * 2, a.h + h * 2)
        }
        function intersect(a, b) {
            var c, y1, x2, y2;
            c = max(a.x, b.x);
            y1 = max(a.y, b.y);
            x2 = f(a.x + a.w, b.x + b.w);
            y2 = f(a.y + a.h, b.y + b.h);
            if (x2 - c < 0 || y2 - y1 < 0) {
                return null
            }
            return create(c, y1, x2 - c, y2 - y1)
        }
        function clamp(a, b, c) {
            var d, underflowY1, overflowX2, overflowY2, x1, y1, x2, y2, cx2, cy2;
            x1 = a.x;
            y1 = a.y;
            x2 = a.x + a.w;
            y2 = a.y + a.h;
            cx2 = b.x + b.w;
            cy2 = b.y + b.h;
            d = max(0, b.x - x1);
            underflowY1 = max(0, b.y - y1);
            overflowX2 = max(0, x2 - cx2);
            overflowY2 = max(0, y2 - cy2);
            x1 += d;
            y1 += underflowY1;
            if (c) {
                x2 += d;
                y2 += underflowY1;
                x1 -= overflowX2;
                y1 -= overflowY2
            }
            x2 -= overflowX2;
            y2 -= overflowY2;
            return create(x1, y1, x2 - x1, y2 - y1)
        }
        function create(x, y, w, h) {
            return {
                x: x,
                y: y,
                w: w,
                h: h
            }
        }
        function fromClientRect(a) {
            return create(a.left, a.top, a.width, a.height)
        }
        return {
            inflate: inflate,
            relativePosition: relativePosition,
            findBestRelativePosition: findBestRelativePosition,
            intersect: intersect,
            clamp: clamp,
            create: create,
            fromClientRect: fromClientRect
        }
    });
    define("tinymce/util/Promise", [], function () {
        if (window.Promise) {
            return window.Promise
        }
        var h = Promise.immediateFn || (typeof setImmediate === 'function' && setImmediate) ||
            function (a) {
                setTimeout(a, 1)
            };

        function bind(a, b) {
            return function () {
                a.apply(b, arguments)
            }
        }
        var j = Array.isArray ||
            function (a) {
                return Object.prototype.toString.call(a) === "[object Array]"
            };

        function Promise(a) {
            if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
            if (typeof a !== 'function') throw new TypeError('not a function');
            this._state = null;
            this._value = null;
            this._deferreds = [];
            doResolve(a, bind(resolve, this), bind(reject, this))
        }
        function handle(c) {
            var d = this;
            if (this._state === null) {
                this._deferreds.push(c);
                return
            }
            h(function () {
                var a = d._state ? c.onFulfilled : c.onRejected;
                if (a === null) {
                    (d._state ? c.resolve : c.reject)(d._value);
                    return
                }
                var b;
                try {
                    b = a(d._value)
                } catch (e) {
                    c.reject(e);
                    return
                }
                c.resolve(b)
            })
        }
        function resolve(a) {
            try {
                if (a === this) throw new TypeError('A promise cannot be resolved with itself.');
                if (a && (typeof a === 'object' || typeof a === 'function')) {
                    var b = a.then;
                    if (typeof b === 'function') {
                        doResolve(bind(b, a), bind(resolve, this), bind(reject, this));
                        return
                    }
                }
                this._state = true;
                this._value = a;
                finale.call(this)
            } catch (e) {
                reject.call(this, e)
            }
        }
        function reject(a) {
            this._state = false;
            this._value = a;
            finale.call(this)
        }
        function finale() {
            for (var i = 0, len = this._deferreds.length; i < len; i++) {
                handle.call(this, this._deferreds[i])
            }
            this._deferreds = null
        }
        function Handler(a, b, c, d) {
            this.onFulfilled = typeof a === 'function' ? a : null;
            this.onRejected = typeof b === 'function' ? b : null;
            this.resolve = c;
            this.reject = d
        }
        function doResolve(b, c, d) {
            var e = false;
            try {
                b(function (a) {
                    if (e) return;
                    e = true;
                    c(a)
                }, function (a) {
                    if (e) return;
                    e = true;
                    d(a)
                })
            } catch (ex) {
                if (e) return;
                e = true;
                d(ex)
            }
        }
        Promise.prototype['catch'] = function (a) {
            return this.then(null, a)
        };
        Promise.prototype.then = function (c, d) {
            var e = this;
            return new Promise(function (a, b) {
                handle.call(e, new Handler(c, d, a, b))
            })
        };
        Promise.all = function () {
            var g = Array.prototype.slice.call(arguments.length === 1 && j(arguments[0]) ? arguments[0] : arguments);
            return new Promise(function (d, e) {
                if (g.length === 0) return d([]);
                var f = g.length;

                function res(i, b) {
                    try {
                        if (b && (typeof b === 'object' || typeof b === 'function')) {
                            var c = b.then;
                            if (typeof c === 'function') {
                                c.call(b, function (a) {
                                    res(i, a)
                                }, e);
                                return
                            }
                        }
                        g[i] = b;
                        if (--f === 0) {
                            d(g)
                        }
                    } catch (ex) {
                        e(ex)
                    }
                }
                for (var i = 0; i < g.length; i++) {
                    res(i, g[i])
                }
            })
        };
        Promise.resolve = function (b) {
            if (b && typeof b === 'object' && b.constructor === Promise) {
                return b
            }
            return new Promise(function (a) {
                a(b)
            })
        };
        Promise.reject = function (c) {
            return new Promise(function (a, b) {
                b(c)
            })
        };
        Promise.race = function (c) {
            return new Promise(function (a, b) {
                for (var i = 0, len = c.length; i < len; i++) {
                    c[i].then(a, b)
                }
            })
        };
        return Promise
    });
    define("tinymce/util/Delay", ["tinymce/util/Promise"], function (e) {
        var f;

        function requestAnimationFrame(b, c) {
            var i, requestAnimationFrameFunc = window.requestAnimationFrame,
                vendors = ['ms', 'moz', 'webkit'];

            function featurefill(a) {
                window.setTimeout(a, 0)
            }
            for (i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
                requestAnimationFrameFunc = window[vendors[i] + 'RequestAnimationFrame']
            }
            if (!requestAnimationFrameFunc) {
                requestAnimationFrameFunc = featurefill
            }
            requestAnimationFrameFunc(b, c)
        }
        function wrappedSetTimeout(a, b) {
            if (typeof b != 'number') {
                b = 0
            }
            return setTimeout(a, b)
        }
        function wrappedSetInterval(a, b) {
            if (typeof b != 'number') {
                b = 1
            }
            return setInterval(a, b)
        }
        function wrappedClearTimeout(a) {
            return clearTimeout(a)
        }
        function wrappedClearInterval(a) {
            return clearInterval(a)
        }
        return {
            requestAnimationFrame: function (b, c) {
                if (f) {
                    f.then(b);
                    return
                }
                f = new e(function (a) {
                    if (!c) {
                        c = document.body
                    }
                    requestAnimationFrame(a, c)
                }).then(b)
            },
            setTimeout: wrappedSetTimeout,
            setInterval: wrappedSetInterval,
            setEditorTimeout: function (a, b, c) {
                return wrappedSetTimeout(function () {
                    if (!a.removed) {
                        b()
                    }
                }, c)
            },
            setEditorInterval: function (a, b, c) {
                var d;
                d = wrappedSetInterval(function () {
                    if (!a.removed) {
                        b()
                    } else {
                        clearInterval(d)
                    }
                }, c);
                return d
            },
            throttle: function (b, c) {
                var d, func;
                func = function () {
                    var a = arguments;
                    clearTimeout(d);
                    d = wrappedSetTimeout(function () {
                        b.apply(this, a)
                    }, c)
                };
                func.stop = function () {
                    clearTimeout(d)
                };
                return func
            },
            clearInterval: wrappedClearInterval,
            clearTimeout: wrappedClearTimeout
        }
    });
    define("tinymce/Env", [], function () {
        var b = navigator,
            userAgent = b.userAgent;
        var c, webkit, ie, ie11, ie12, gecko, mac, iDevice, android, fileApi, phone, tablet, windowsPhone;

        function matchMediaQuery(a) {
            return "matchMedia" in window ? matchMedia(a).matches : false
        }
        c = window.opera && window.opera.buildNumber;
        android = /Android/.test(userAgent);
        webkit = /WebKit/.test(userAgent);
        ie = !webkit && !c && (/MSIE/gi).test(userAgent) && (/Explorer/gi).test(b.appName);
        ie = ie && /MSIE (\w+)\./.exec(userAgent)[1];
        ie11 = userAgent.indexOf('Trident/') != -1 && (userAgent.indexOf('rv:') != -1 || b.appName.indexOf('Netscape') != -1) ? 11 : false;
        ie12 = (userAgent.indexOf('Edge/') != -1 && !ie && !ie11) ? 12 : false;
        ie = ie || ie11 || ie12;
        gecko = !webkit && !ie11 && /Gecko/.test(userAgent);
        mac = userAgent.indexOf('Mac') != -1;
        iDevice = /(iPad|iPhone)/.test(userAgent);
        fileApi = "FormData" in window && "FileReader" in window && "URL" in window && !!URL.createObjectURL;
        phone = matchMediaQuery("only screen and (max-device-width: 480px)") && (android || iDevice);
        tablet = matchMediaQuery("only screen and (min-width: 800px)") && (android || iDevice);
        windowsPhone = userAgent.indexOf('Windows Phone') != -1;
        if (ie12) {
            webkit = false
        }
        var d = !iDevice || fileApi || userAgent.match(/AppleWebKit\/(\d*)/)[1] >= 534;
        return {
            opera: c,
            webkit: webkit,
            ie: ie,
            gecko: gecko,
            mac: mac,
            iOS: iDevice,
            android: android,
            contentEditable: d,
            transparentSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
            caretAfter: ie != 8,
            range: window.getSelection && "Range" in window,
            documentMode: ie && !ie12 ? (document.documentMode || 7) : 10,
            fileApi: fileApi,
            ceFalse: (ie === false || ie > 8),
            canHaveCSP: (ie === false || ie > 11),
            desktop: !phone && !tablet,
            windowsPhone: windowsPhone
        }
    });
    define("tinymce/dom/EventUtils", ["tinymce/util/Delay", "tinymce/Env"], function (j, k) {
        "use strict";
        var m = "mce-data-";
        var n = /^(?:mouse|contextmenu)|click/;
        var o = {
            keyLocation: 1,
            layerX: 1,
            layerY: 1,
            returnValue: 1,
            webkitMovementX: 1,
            webkitMovementY: 1,
            keyIdentifier: 1
        };

        function addEvent(a, b, c, d) {
            if (a.addEventListener) {
                a.addEventListener(b, c, d || false)
            } else if (a.attachEvent) {
                a.attachEvent('on' + b, c)
            }
        }
        function removeEvent(a, b, c, d) {
            if (a.removeEventListener) {
                a.removeEventListener(b, c, d || false)
            } else if (a.detachEvent) {
                a.detachEvent('on' + b, c)
            }
        }
        function getTargetFromShadowDom(a, b) {
            var c, target = b;
            c = a.path;
            if (c && c.length > 0) {
                target = c[0]
            }
            if (a.deepPath) {
                c = a.deepPath();
                if (c && c.length > 0) {
                    target = c[0]
                }
            }
            return target
        }
        function fix(a, b) {
            var c, event = b || {},
                undef;

            function returnFalse() {
                return false
            }
            function returnTrue() {
                return true
            }
            for (c in a) {
                if (!o[c]) {
                    event[c] = a[c]
                }
            }
            if (!event.target) {
                event.target = event.srcElement || document
            }
            if (k.experimentalShadowDom) {
                event.target = getTargetFromShadowDom(a, event.target)
            }
            if (a && n.test(a.type) && a.pageX === undef && a.clientX !== undef) {
                var d = event.target.ownerDocument || document;
                var e = d.documentElement;
                var f = d.body;
                event.pageX = a.clientX + (e && e.scrollLeft || f && f.scrollLeft || 0) - (e && e.clientLeft || f && f.clientLeft || 0);
                event.pageY = a.clientY + (e && e.scrollTop || f && f.scrollTop || 0) - (e && e.clientTop || f && f.clientTop || 0)
            }
            event.preventDefault = function () {
                event.isDefaultPrevented = returnTrue;
                if (a) {
                    if (a.preventDefault) {
                        a.preventDefault()
                    } else {
                        a.returnValue = false
                    }
                }
            };
            event.stopPropagation = function () {
                event.isPropagationStopped = returnTrue;
                if (a) {
                    if (a.stopPropagation) {
                        a.stopPropagation()
                    } else {
                        a.cancelBubble = true
                    }
                }
            };
            event.stopImmediatePropagation = function () {
                event.isImmediatePropagationStopped = returnTrue;
                event.stopPropagation()
            };
            if (!event.isDefaultPrevented) {
                event.isDefaultPrevented = returnFalse;
                event.isPropagationStopped = returnFalse;
                event.isImmediatePropagationStopped = returnFalse
            }
            if (typeof event.metaKey == 'undefined') {
                event.metaKey = false
            }
            return event
        }
        function bindOnReady(a, b, c) {
            var d = a.document,
                event = {
                    type: 'ready'
                };
            if (c.domLoaded) {
                b(event);
                return
            }
            function readyHandler() {
                if (!c.domLoaded) {
                    c.domLoaded = true;
                    b(event)
                }
            }
            function waitForDomLoaded() {
                if (d.readyState === "complete" || (d.readyState === "interactive" && d.body)) {
                    removeEvent(d, "readystatechange", waitForDomLoaded);
                    readyHandler()
                }
            }
            function tryScroll() {
                try {
                    d.documentElement.doScroll("left")
                } catch (ex) {
                    j.setTimeout(tryScroll);
                    return
                }
                readyHandler()
            }
            if (d.addEventListener) {
                if (d.readyState === "complete") {
                    readyHandler()
                } else {
                    addEvent(a, 'DOMContentLoaded', readyHandler)
                }
            } else {
                addEvent(d, "readystatechange", waitForDomLoaded);
                if (d.documentElement.doScroll && a.self === a.top) {
                    tryScroll()
                }
            }
            addEvent(a, 'load', readyHandler)
        }
        function EventUtils() {
            var h = this,
                events = {},
                count, expando, hasFocusIn, hasMouseEnterLeave, mouseEnterLeave;
            expando = m + (+new Date()).toString(32);
            hasMouseEnterLeave = "onmouseenter" in document.documentElement;
            hasFocusIn = "onfocusin" in document.documentElement;
            mouseEnterLeave = {
                mouseenter: 'mouseover',
                mouseleave: 'mouseout'
            };
            count = 1;
            h.domLoaded = false;
            h.events = events;

            function executeHandlers(a, b) {
                var c, i, l, callback, container = events[b];
                c = container && container[a.type];
                if (c) {
                    for (i = 0, l = c.length; i < l; i++) {
                        callback = c[i];
                        if (callback && callback.func.call(callback.scope, a) === false) {
                            a.preventDefault()
                        }
                        if (a.isImmediatePropagationStopped()) {
                            return
                        }
                    }
                }
            }
            h.bind = function (c, d, e, f) {
                var g, callbackList, i, name, fakeName, nativeHandler, capture, win = window;

                function defaultNativeHandler(a) {
                    executeHandlers(fix(a || win.event), g)
                }
                if (!c || c.nodeType === 3 || c.nodeType === 8) {
                    return
                }
                if (!c[expando]) {
                    g = count++;
                    c[expando] = g;
                    events[g] = {}
                } else {
                    g = c[expando]
                }
                f = f || c;
                d = d.split(' ');
                i = d.length;
                while (i--) {
                    name = d[i];
                    nativeHandler = defaultNativeHandler;
                    fakeName = capture = false;
                    if (name === "DOMContentLoaded") {
                        name = "ready"
                    }
                    if (h.domLoaded && name === "ready" && c.readyState == 'complete') {
                        e.call(f, fix({
                            type: name
                        }));
                        continue
                    }
                    if (!hasMouseEnterLeave) {
                        fakeName = mouseEnterLeave[name];
                        if (fakeName) {
                            nativeHandler = function (a) {
                                var b, related;
                                b = a.currentTarget;
                                related = a.relatedTarget;
                                if (related && b.contains) {
                                    related = b.contains(related)
                                } else {
                                    while (related && related !== b) {
                                        related = related.parentNode
                                    }
                                }
                                if (!related) {
                                    a = fix(a || win.event);
                                    a.type = a.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
                                    a.target = b;
                                    executeHandlers(a, g)
                                }
                            }
                        }
                    }
                    if (!hasFocusIn && (name === "focusin" || name === "focusout")) {
                        capture = true;
                        fakeName = name === "focusin" ? "focus" : "blur";
                        nativeHandler = function (a) {
                            a = fix(a || win.event);
                            a.type = a.type === 'focus' ? 'focusin' : 'focusout';
                            executeHandlers(a, g)
                        }
                    }
                    callbackList = events[g][name];
                    if (!callbackList) {
                        events[g][name] = callbackList = [{
                            func: e,
                            scope: f
                        }];
                        callbackList.fakeName = fakeName;
                        callbackList.capture = capture;
                        callbackList.nativeHandler = nativeHandler;
                        if (name === "ready") {
                            bindOnReady(c, nativeHandler, h)
                        } else {
                            addEvent(c, fakeName || name, nativeHandler, capture)
                        }
                    } else {
                        if (name === "ready" && h.domLoaded) {
                            e({
                                type: name
                            })
                        } else {
                            callbackList.push({
                                func: e,
                                scope: f
                            })
                        }
                    }
                }
                c = callbackList = 0;
                return e
            };
            h.unbind = function (a, b, c) {
                var d, callbackList, i, ci, name, eventMap;
                if (!a || a.nodeType === 3 || a.nodeType === 8) {
                    return h
                }
                d = a[expando];
                if (d) {
                    eventMap = events[d];
                    if (b) {
                        b = b.split(' ');
                        i = b.length;
                        while (i--) {
                            name = b[i];
                            callbackList = eventMap[name];
                            if (callbackList) {
                                if (c) {
                                    ci = callbackList.length;
                                    while (ci--) {
                                        if (callbackList[ci].func === c) {
                                            var e = callbackList.nativeHandler;
                                            var f = callbackList.fakeName,
                                                capture = callbackList.capture;
                                            callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
                                            callbackList.nativeHandler = e;
                                            callbackList.fakeName = f;
                                            callbackList.capture = capture;
                                            eventMap[name] = callbackList
                                        }
                                    }
                                }
                                if (!c || callbackList.length === 0) {
                                    delete eventMap[name];
                                    removeEvent(a, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture)
                                }
                            }
                        }
                    } else {
                        for (name in eventMap) {
                            callbackList = eventMap[name];
                            removeEvent(a, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture)
                        }
                        eventMap = {}
                    }
                    for (name in eventMap) {
                        return h
                    }
                    delete events[d];
                    try {
                        delete a[expando]
                    } catch (ex) {
                        a[expando] = null
                    }
                }
                return h
            };
            h.fire = function (a, b, c) {
                var d;
                if (!a || a.nodeType === 3 || a.nodeType === 8) {
                    return h
                }
                c = fix(null, c);
                c.type = b;
                c.target = a;
                do {
                    d = a[expando];
                    if (d) {
                        executeHandlers(c, d)
                    }
                    a = a.parentNode || a.ownerDocument || a.defaultView || a.parentWindow
                } while (a && !c.isPropagationStopped());
                return h
            };
            h.clean = function (a) {
                var i, children, unbind = h.unbind;
                if (!a || a.nodeType === 3 || a.nodeType === 8) {
                    return h
                }
                if (a[expando]) {
                    unbind(a)
                }
                if (!a.getElementsByTagName) {
                    a = a.document
                }
                if (a && a.getElementsByTagName) {
                    unbind(a);
                    children = a.getElementsByTagName('*');
                    i = children.length;
                    while (i--) {
                        a = children[i];
                        if (a[expando]) {
                            unbind(a)
                        }
                    }
                }
                return h
            };
            h.destroy = function () {
                events = {}
            };
            h.cancel = function (e) {
                if (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation()
                }
                return false
            }
        }
        EventUtils.Event = new EventUtils();
        EventUtils.Event.bind(window, 'ready', function () { });
        return EventUtils
    });
    define("tinymce/dom/Sizzle", [], function () {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, expando = "sizzle" + -(new Date()),
            preferredDoc = window.document,
            dirruns = 0,
            done = 0,
            classCache = createCache(),
            tokenCache = createCache(),
            compilerCache = createCache(),
            sortOrder = function (a, b) {
                if (a === b) {
                    hasDuplicate = true
                }
                return 0
            },
            strundefined = typeof Y,
            MAX_NEGATIVE = 1 << 31,
            hasOwn = ({}).hasOwnProperty,
            arr = [],
            pop = arr.pop,
            push_native = arr.push,
            push = arr.push,
            slice = arr.slice,
            indexOf = arr.indexOf ||
                function (a) {
                    var i = 0,
                        len = this.length;
                    for (; i < len; i++) {
                        if (this[i] === a) {
                            return i
                        }
                    }
                    return -1
                }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", whitespace = "[\ \\t\\r\\n\\f]", identifier = "(?:\\\\.|[\\w-]|[^\-\ ])+", attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + "*([*^$|!~]?=)" + whitespace + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + ".*" + ")\\)|)", rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
                    "ID": new RegExp("^#(" + identifier + ")"),
                    "CLASS": new RegExp("^\\.(" + identifier + ")"),
                    "TAG": new RegExp("^(" + identifier + "|[*])"),
                    "ATTR": new RegExp("^" + attributes),
                    "PSEUDO": new RegExp("^" + pseudos),
                    "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
                    "bool": new RegExp("^(?:" + booleans + ")$", "i"),
                    "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
                }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, rescape = /'|\\/g, runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"), funescape = function (_, a, b) {
                    var c = "0x" + a - 0x10000;
                    return c !== c || b ? a : c < 0 ? String.fromCharCode(c + 0x10000) : String.fromCharCode(c >> 10 | 0xD800, c & 0x3FF | 0xDC00)
                };
        try {
            push.apply((arr = slice.call(preferredDoc.childNodes)), preferredDoc.childNodes);
            arr[preferredDoc.childNodes.length].nodeType
        } catch (e) {
            push = {
                apply: arr.length ?
                    function (a, b) {
                        push_native.apply(a, slice.call(b))
                    } : function (a, b) {
                        var j = a.length,
                            i = 0;
                        while ((a[j++] = b[i++])) { }
                        a.length = j - 1
                    }
            }
        }
        function Sizzle(a, b, c, d) {
            var e, elem, m, nodeType, i, groups, old, nid, newContext, newSelector;
            if ((b ? b.ownerDocument || b : preferredDoc) !== document) {
                setDocument(b)
            }
            b = b || document;
            c = c || [];
            if (!a || typeof a !== "string") {
                return c
            }
            if ((nodeType = b.nodeType) !== 1 && nodeType !== 9) {
                return []
            }
            if (documentIsHTML && !d) {
                if ((e = rquickExpr.exec(a))) {
                    if ((m = e[1])) {
                        if (nodeType === 9) {
                            elem = b.getElementById(m);
                            if (elem && elem.parentNode) {
                                if (elem.id === m) {
                                    c.push(elem);
                                    return c
                                }
                            } else {
                                return c
                            }
                        } else {
                            if (b.ownerDocument && (elem = b.ownerDocument.getElementById(m)) && contains(b, elem) && elem.id === m) {
                                c.push(elem);
                                return c
                            }
                        }
                    } else if (e[2]) {
                        push.apply(c, b.getElementsByTagName(a));
                        return c
                    } else if ((m = e[3]) && support.getElementsByClassName) {
                        push.apply(c, b.getElementsByClassName(m));
                        return c
                    }
                }
                if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(a))) {
                    nid = old = expando;
                    newContext = b;
                    newSelector = nodeType === 9 && a;
                    if (nodeType === 1 && b.nodeName.toLowerCase() !== "object") {
                        groups = tokenize(a);
                        if ((old = b.getAttribute("id"))) {
                            nid = old.replace(rescape, "\\$&")
                        } else {
                            b.setAttribute("id", nid)
                        }
                        nid = "[id='" + nid + "'] ";
                        i = groups.length;
                        while (i--) {
                            groups[i] = nid + toSelector(groups[i])
                        }
                        newContext = rsibling.test(a) && testContext(b.parentNode) || b;
                        newSelector = groups.join(",")
                    }
                    if (newSelector) {
                        try {
                            push.apply(c, newContext.querySelectorAll(newSelector));
                            return c
                        } catch (qsaError) { } finally {
                            if (!old) {
                                b.removeAttribute("id")
                            }
                        }
                    }
                }
            }
            return select(a.replace(rtrim, "$1"), b, c, d)
        }
        function createCache() {
            var c = [];

            function cache(a, b) {
                if (c.push(a + " ") > Expr.cacheLength) {
                    delete cache[c.shift()]
                }
                return (cache[a + " "] = b)
            }
            return cache
        }
        function markFunction(a) {
            a[expando] = true;
            return a
        }
        function assert(a) {
            var b = document.createElement("div");
            try {
                return !!a(b)
            } catch (e) {
                return false
            } finally {
                if (b.parentNode) {
                    b.parentNode.removeChild(b)
                }
                b = null
            }
        }
        function addHandle(a, b) {
            var c = a.split("|"),
                i = a.length;
            while (i--) {
                Expr.attrHandle[c[i]] = b
            }
        }
        function siblingCheck(a, b) {
            var c = b && a,
                diff = c && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
            if (diff) {
                return diff
            }
            if (c) {
                while ((c = c.nextSibling)) {
                    if (c === b) {
                        return -1
                    }
                }
            }
            return a ? 1 : -1
        }
        function createInputPseudo(c) {
            return function (a) {
                var b = a.nodeName.toLowerCase();
                return b === "input" && a.type === c
            }
        }
        function createButtonPseudo(c) {
            return function (a) {
                var b = a.nodeName.toLowerCase();
                return (b === "input" || b === "button") && a.type === c
            }
        }
        function createPositionalPseudo(d) {
            return markFunction(function (c) {
                c = +c;
                return markFunction(function (a, b) {
                    var j, matchIndexes = d([], a.length, c),
                        i = matchIndexes.length;
                    while (i--) {
                        if (a[(j = matchIndexes[i])]) {
                            a[j] = !(b[j] = a[j])
                        }
                    }
                })
            })
        }
        function testContext(a) {
            return a && typeof a.getElementsByTagName !== strundefined && a
        }
        support = Sizzle.support = {};
        isXML = Sizzle.isXML = function (a) {
            var b = a && (a.ownerDocument || a).documentElement;
            return b ? b.nodeName !== "HTML" : false
        };
        setDocument = Sizzle.setDocument = function (e) {
            var f, doc = e ? e.ownerDocument || e : preferredDoc,
                parent = doc.defaultView;

            function getTop(a) {
                try {
                    return a.top
                } catch (ex) { }
                return null
            }
            if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
                return document
            }
            document = doc;
            docElem = doc.documentElement;
            documentIsHTML = !isXML(doc);
            if (parent && parent !== getTop(parent)) {
                if (parent.addEventListener) {
                    parent.addEventListener("unload", function () {
                        setDocument()
                    }, false)
                } else if (parent.attachEvent) {
                    parent.attachEvent("onunload", function () {
                        setDocument()
                    })
                }
            }
            support.attributes = assert(function (a) {
                a.className = "i";
                return !a.getAttribute("className")
            });
            support.getElementsByTagName = assert(function (a) {
                a.appendChild(doc.createComment(""));
                return !a.getElementsByTagName("*").length
            });
            support.getElementsByClassName = rnative.test(doc.getElementsByClassName);
            support.getById = assert(function (a) {
                docElem.appendChild(a).id = expando;
                return !doc.getElementsByName || !doc.getElementsByName(expando).length
            });
            if (support.getById) {
                Expr.find["ID"] = function (a, b) {
                    if (typeof b.getElementById !== strundefined && documentIsHTML) {
                        var m = b.getElementById(a);
                        return m && m.parentNode ? [m] : []
                    }
                };
                Expr.filter["ID"] = function (b) {
                    var c = b.replace(runescape, funescape);
                    return function (a) {
                        return a.getAttribute("id") === c
                    }
                }
            } else {
                delete Expr.find["ID"];
                Expr.filter["ID"] = function (c) {
                    var d = c.replace(runescape, funescape);
                    return function (a) {
                        var b = typeof a.getAttributeNode !== strundefined && a.getAttributeNode("id");
                        return b && b.value === d
                    }
                }
            }
            Expr.find["TAG"] = support.getElementsByTagName ?
                function (a, b) {
                    if (typeof b.getElementsByTagName !== strundefined) {
                        return b.getElementsByTagName(a)
                    }
                } : function (a, b) {
                    var c, tmp = [],
                        i = 0,
                        results = b.getElementsByTagName(a);
                    if (a === "*") {
                        while ((c = results[i++])) {
                            if (c.nodeType === 1) {
                                tmp.push(c)
                            }
                        }
                        return tmp
                    }
                    return results
                };
            Expr.find["CLASS"] = support.getElementsByClassName &&
                function (a, b) {
                    if (documentIsHTML) {
                        return b.getElementsByClassName(a)
                    }
                };
            rbuggyMatches = [];
            rbuggyQSA = [];
            if ((support.qsa = rnative.test(doc.querySelectorAll))) {
                assert(function (a) {
                    a.innerHTML = "<select msallowcapture=''><option selected=''></option></select>";
                    if (a.querySelectorAll("[msallowcapture^='']").length) {
                        rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")")
                    }
                    if (!a.querySelectorAll("[selected]").length) {
                        rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")")
                    }
                    if (!a.querySelectorAll(":checked").length) {
                        rbuggyQSA.push(":checked")
                    }
                });
                assert(function (a) {
                    var b = doc.createElement("input");
                    b.setAttribute("type", "hidden");
                    a.appendChild(b).setAttribute("name", "D");
                    if (a.querySelectorAll("[name=d]").length) {
                        rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=")
                    }
                    if (!a.querySelectorAll(":enabled").length) {
                        rbuggyQSA.push(":enabled", ":disabled")
                    }
                    a.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:")
                })
            }
            if ((support.matchesSelector = rnative.test((matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)))) {
                assert(function (a) {
                    support.disconnectedMatch = matches.call(a, "div");
                    matches.call(a, "[s!='']:x");
                    rbuggyMatches.push("!=", pseudos)
                })
            }
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            f = rnative.test(docElem.compareDocumentPosition);
            contains = f || rnative.test(docElem.contains) ?
                function (a, b) {
                    var c = a.nodeType === 9 ? a.documentElement : a,
                        bup = b && b.parentNode;
                    return a === bup || !!(bup && bup.nodeType === 1 && (c.contains ? c.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16))
                } : function (a, b) {
                    if (b) {
                        while ((b = b.parentNode)) {
                            if (b === a) {
                                return true
                            }
                        }
                    }
                    return false
                };
            sortOrder = f ?
                function (a, b) {
                    if (a === b) {
                        hasDuplicate = true;
                        return 0
                    }
                    var c = !a.compareDocumentPosition - !b.compareDocumentPosition;
                    if (c) {
                        return c
                    }
                    c = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
                    if (c & 1 || (!support.sortDetached && b.compareDocumentPosition(a) === c)) {
                        if (a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
                            return -1
                        }
                        if (b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
                            return 1
                        }
                        return sortInput ? (indexOf.call(sortInput, a) - indexOf.call(sortInput, b)) : 0
                    }
                    return c & 4 ? -1 : 1
                } : function (a, b) {
                    if (a === b) {
                        hasDuplicate = true;
                        return 0
                    }
                    var c, i = 0,
                        aup = a.parentNode,
                        bup = b.parentNode,
                        ap = [a],
                        bp = [b];
                    if (!aup || !bup) {
                        return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? (indexOf.call(sortInput, a) - indexOf.call(sortInput, b)) : 0
                    } else if (aup === bup) {
                        return siblingCheck(a, b)
                    }
                    c = a;
                    while ((c = c.parentNode)) {
                        ap.unshift(c)
                    }
                    c = b;
                    while ((c = c.parentNode)) {
                        bp.unshift(c)
                    }
                    while (ap[i] === bp[i]) {
                        i++
                    }
                    return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0
                };
            return doc
        };
        Sizzle.matches = function (a, b) {
            return Sizzle(a, null, null, b)
        };
        Sizzle.matchesSelector = function (a, b) {
            if ((a.ownerDocument || a) !== document) {
                setDocument(a)
            }
            b = b.replace(rattributeQuotes, "='$1']");
            if (support.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(b)) && (!rbuggyQSA || !rbuggyQSA.test(b))) {
                try {
                    var c = matches.call(a, b);
                    if (c || support.disconnectedMatch || a.document && a.document.nodeType !== 11) {
                        return c
                    }
                } catch (e) { }
            }
            return Sizzle(b, document, null, [a]).length > 0
        };
        Sizzle.contains = function (a, b) {
            if ((a.ownerDocument || a) !== document) {
                setDocument(a)
            }
            return contains(a, b)
        };
        Sizzle.attr = function (a, b) {
            if ((a.ownerDocument || a) !== document) {
                setDocument(a)
            }
            var c = Expr.attrHandle[b.toLowerCase()],
                val = c && hasOwn.call(Expr.attrHandle, b.toLowerCase()) ? c(a, b, !documentIsHTML) : Y;
            return val !== Y ? val : support.attributes || !documentIsHTML ? a.getAttribute(b) : (val = a.getAttributeNode(b)) && val.specified ? val.value : null
        };
        Sizzle.error = function (a) {
            throw new Error("Syntax error, unrecognized expression: " + a)
        };
        Sizzle.uniqueSort = function (a) {
            var b, duplicates = [],
                j = 0,
                i = 0;
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && a.slice(0);
            a.sort(sortOrder);
            if (hasDuplicate) {
                while ((b = a[i++])) {
                    if (b === a[i]) {
                        j = duplicates.push(i)
                    }
                }
                while (j--) {
                    a.splice(duplicates[j], 1)
                }
            }
            sortInput = null;
            return a
        };
        getText = Sizzle.getText = function (a) {
            var b, ret = "",
                i = 0,
                nodeType = a.nodeType;
            if (!nodeType) {
                while ((b = a[i++])) {
                    ret += getText(b)
                }
            } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                if (typeof a.textContent === "string") {
                    return a.textContent
                } else {
                    for (a = a.firstChild; a; a = a.nextSibling) {
                        ret += getText(a)
                    }
                }
            } else if (nodeType === 3 || nodeType === 4) {
                return a.nodeValue
            }
            return ret
        };
        Expr = Sizzle.selectors = {
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function (a) {
                    a[1] = a[1].replace(runescape, funescape);
                    a[3] = (a[3] || a[4] || a[5] || "").replace(runescape, funescape);
                    if (a[2] === "~=") {
                        a[3] = " " + a[3] + " "
                    }
                    return a.slice(0, 4)
                },
                "CHILD": function (a) {
                    a[1] = a[1].toLowerCase();
                    if (a[1].slice(0, 3) === "nth") {
                        if (!a[3]) {
                            Sizzle.error(a[0])
                        }
                        a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * (a[3] === "even" || a[3] === "odd"));
                        a[5] = +((a[7] + a[8]) || a[3] === "odd")
                    } else if (a[3]) {
                        Sizzle.error(a[0])
                    }
                    return a
                },
                "PSEUDO": function (a) {
                    var b, unquoted = !a[6] && a[2];
                    if (matchExpr["CHILD"].test(a[0])) {
                        return null
                    }
                    if (a[3]) {
                        a[2] = a[4] || a[5] || ""
                    } else if (unquoted && rpseudo.test(unquoted) && (b = tokenize(unquoted, true)) && (b = unquoted.indexOf(")", unquoted.length - b) - unquoted.length)) {
                        a[0] = a[0].slice(0, b);
                        a[2] = unquoted.slice(0, b)
                    }
                    return a.slice(0, 3)
                }
            },
            filter: {
                "TAG": function (b) {
                    var c = b.replace(runescape, funescape).toLowerCase();
                    return b === "*" ?
                        function () {
                            return true
                        } : function (a) {
                            return a.nodeName && a.nodeName.toLowerCase() === c
                        }
                },
                "CLASS": function (b) {
                    var c = classCache[b + " "];
                    return c || (c = new RegExp("(^|" + whitespace + ")" + b + "(" + whitespace + "|$)")) && classCache(b, function (a) {
                        return c.test(typeof a.className === "string" && a.className || typeof a.getAttribute !== strundefined && a.getAttribute("class") || "")
                    })
                },
                "ATTR": function (c, d, e) {
                    return function (a) {
                        var b = Sizzle.attr(a, c);
                        if (b == null) {
                            return d === "!="
                        }
                        if (!d) {
                            return true
                        }
                        b += "";
                        return d === "=" ? b === e : d === "!=" ? b !== e : d === "^=" ? e && b.indexOf(e) === 0 : d === "*=" ? e && b.indexOf(e) > -1 : d === "$=" ? e && b.slice(-e.length) === e : d === "~=" ? (" " + b + " ").indexOf(e) > -1 : d === "|=" ? b === e || b.slice(0, e.length + 1) === e + "-" : false
                    }
                },
                "CHILD": function (e, f, g, h, i) {
                    var j = e.slice(0, 3) !== "nth",
                        forward = e.slice(-4) !== "last",
                        ofType = f === "of-type";
                    return h === 1 && i === 0 ?
                        function (a) {
                            return !!a.parentNode
                        } : function (a, b, c) {
                            var d, outerCache, node, diff, nodeIndex, start, dir = j !== forward ? "nextSibling" : "previousSibling",
                                parent = a.parentNode,
                                name = ofType && a.nodeName.toLowerCase(),
                                useCache = !c && !ofType;
                            if (parent) {
                                if (j) {
                                    while (dir) {
                                        node = a;
                                        while ((node = node[dir])) {
                                            if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                                                return false
                                            }
                                        }
                                        start = dir = e === "only" && !start && "nextSibling"
                                    }
                                    return true
                                }
                                start = [forward ? parent.firstChild : parent.lastChild];
                                if (forward && useCache) {
                                    outerCache = parent[expando] || (parent[expando] = {});
                                    d = outerCache[e] || [];
                                    nodeIndex = d[0] === dirruns && d[1];
                                    diff = d[0] === dirruns && d[2];
                                    node = nodeIndex && parent.childNodes[nodeIndex];
                                    while ((node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())) {
                                        if (node.nodeType === 1 && ++diff && node === a) {
                                            outerCache[e] = [dirruns, nodeIndex, diff];
                                            break
                                        }
                                    }
                                } else if (useCache && (d = (a[expando] || (a[expando] = {}))[e]) && d[0] === dirruns) {
                                    diff = d[1]
                                } else {
                                    while ((node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())) {
                                        if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                            if (useCache) {
                                                (node[expando] || (node[expando] = {}))[e] = [dirruns, diff]
                                            }
                                            if (node === a) {
                                                break
                                            }
                                        }
                                    }
                                }
                                diff -= i;
                                return diff === h || (diff % h === 0 && diff / h >= 0)
                            }
                        }
                },
                "PSEUDO": function (d, e) {
                    var f, fn = Expr.pseudos[d] || Expr.setFilters[d.toLowerCase()] || Sizzle.error("unsupported pseudo: " + d);
                    if (fn[expando]) {
                        return fn(e)
                    }
                    if (fn.length > 1) {
                        f = [d, d, "", e];
                        return Expr.setFilters.hasOwnProperty(d.toLowerCase()) ? markFunction(function (a, b) {
                            var c, matched = fn(a, e),
                                i = matched.length;
                            while (i--) {
                                c = indexOf.call(a, matched[i]);
                                a[c] = !(b[c] = matched[i])
                            }
                        }) : function (a) {
                            return fn(a, 0, f)
                        }
                    }
                    return fn
                }
            },
            pseudos: {
                "not": markFunction(function (f) {
                    var g = [],
                        results = [],
                        matcher = compile(f.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function (a, b, c, d) {
                        var e, unmatched = matcher(a, null, d, []),
                            i = a.length;
                        while (i--) {
                            if ((e = unmatched[i])) {
                                a[i] = !(b[i] = e)
                            }
                        }
                    }) : function (a, b, c) {
                        g[0] = a;
                        matcher(g, null, c, results);
                        return !results.pop()
                    }
                }),
                "has": markFunction(function (b) {
                    return function (a) {
                        return Sizzle(b, a).length > 0
                    }
                }),
                "contains": markFunction(function (b) {
                    b = b.replace(runescape, funescape);
                    return function (a) {
                        return (a.textContent || a.innerText || getText(a)).indexOf(b) > -1
                    }
                }),
                "lang": markFunction(function (c) {
                    if (!ridentifier.test(c || "")) {
                        Sizzle.error("unsupported lang: " + c)
                    }
                    c = c.replace(runescape, funescape).toLowerCase();
                    return function (a) {
                        var b;
                        do {
                            if ((b = documentIsHTML ? a.lang : a.getAttribute("xml:lang") || a.getAttribute("lang"))) {
                                b = b.toLowerCase();
                                return b === c || b.indexOf(c + "-") === 0
                            }
                        } while ((a = a.parentNode) && a.nodeType === 1);
                        return false
                    }
                }),
                "target": function (a) {
                    var b = window.location && window.location.hash;
                    return b && b.slice(1) === a.id
                },
                "root": function (a) {
                    return a === docElem
                },
                "focus": function (a) {
                    return a === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(a.type || a.href || ~a.tabIndex)
                },
                "enabled": function (a) {
                    return a.disabled === false
                },
                "disabled": function (a) {
                    return a.disabled === true
                },
                "checked": function (a) {
                    var b = a.nodeName.toLowerCase();
                    return (b === "input" && !!a.checked) || (b === "option" && !!a.selected)
                },
                "selected": function (a) {
                    if (a.parentNode) {
                        a.parentNode.selectedIndex
                    }
                    return a.selected === true
                },
                "empty": function (a) {
                    for (a = a.firstChild; a; a = a.nextSibling) {
                        if (a.nodeType < 6) {
                            return false
                        }
                    }
                    return true
                },
                "parent": function (a) {
                    return !Expr.pseudos["empty"](a)
                },
                "header": function (a) {
                    return rheader.test(a.nodeName)
                },
                "input": function (a) {
                    return rinputs.test(a.nodeName)
                },
                "button": function (a) {
                    var b = a.nodeName.toLowerCase();
                    return b === "input" && a.type === "button" || b === "button"
                },
                "text": function (a) {
                    var b;
                    return a.nodeName.toLowerCase() === "input" && a.type === "text" && ((b = a.getAttribute("type")) == null || b.toLowerCase() === "text")
                },
                "first": createPositionalPseudo(function () {
                    return [0]
                }),
                "last": createPositionalPseudo(function (a, b) {
                    return [b - 1]
                }),
                "eq": createPositionalPseudo(function (a, b, c) {
                    return [c < 0 ? c + b : c]
                }),
                "even": createPositionalPseudo(function (a, b) {
                    var i = 0;
                    for (; i < b; i += 2) {
                        a.push(i)
                    }
                    return a
                }),
                "odd": createPositionalPseudo(function (a, b) {
                    var i = 1;
                    for (; i < b; i += 2) {
                        a.push(i)
                    }
                    return a
                }),
                "lt": createPositionalPseudo(function (a, b, c) {
                    var i = c < 0 ? c + b : c;
                    for (; --i >= 0;) {
                        a.push(i)
                    }
                    return a
                }),
                "gt": createPositionalPseudo(function (a, b, c) {
                    var i = c < 0 ? c + b : c;
                    for (; ++i < b;) {
                        a.push(i)
                    }
                    return a
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        for (i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        }) {
            Expr.pseudos[i] = createInputPseudo(i)
        }
        for (i in {
            submit: true,
            reset: true
        }) {
            Expr.pseudos[i] = createButtonPseudo(i)
        }
        function setFilters() { }
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function (a, b) {
            var c, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[a + " "];
            if (cached) {
                return b ? 0 : cached.slice(0)
            }
            soFar = a;
            groups = [];
            preFilters = Expr.preFilter;
            while (soFar) {
                if (!c || (match = rcomma.exec(soFar))) {
                    if (match) {
                        soFar = soFar.slice(match[0].length) || soFar
                    }
                    groups.push((tokens = []))
                }
                c = false;
                if ((match = rcombinators.exec(soFar))) {
                    c = match.shift();
                    tokens.push({
                        value: c,
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(c.length)
                }
                for (type in Expr.filter) {
                    if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                        c = match.shift();
                        tokens.push({
                            value: c,
                            type: type,
                            matches: match
                        });
                        soFar = soFar.slice(c.length)
                    }
                }
                if (!c) {
                    break
                }
            }
            return b ? soFar.length : soFar ? Sizzle.error(a) : tokenCache(a, groups).slice(0)
        };

        function toSelector(a) {
            var i = 0,
                len = a.length,
                selector = "";
            for (; i < len; i++) {
                selector += a[i].value
            }
            return selector
        }
        function addCombinator(e, f, g) {
            var h = f.dir,
                checkNonElements = g && h === "parentNode",
                doneName = done++;
            return f.first ?
                function (a, b, c) {
                    while ((a = a[h])) {
                        if (a.nodeType === 1 || checkNonElements) {
                            return e(a, b, c)
                        }
                    }
                } : function (a, b, c) {
                    var d, outerCache, newCache = [dirruns, doneName];
                    if (c) {
                        while ((a = a[h])) {
                            if (a.nodeType === 1 || checkNonElements) {
                                if (e(a, b, c)) {
                                    return true
                                }
                            }
                        }
                    } else {
                        while ((a = a[h])) {
                            if (a.nodeType === 1 || checkNonElements) {
                                outerCache = a[expando] || (a[expando] = {});
                                if ((d = outerCache[h]) && d[0] === dirruns && d[1] === doneName) {
                                    return (newCache[2] = d[2])
                                } else {
                                    outerCache[h] = newCache;
                                    if ((newCache[2] = e(a, b, c))) {
                                        return true
                                    }
                                }
                            }
                        }
                    }
                }
        }
        function elementMatcher(d) {
            return d.length > 1 ?
                function (a, b, c) {
                    var i = d.length;
                    while (i--) {
                        if (!d[i](a, b, c)) {
                            return false
                        }
                    }
                    return true
                } : d[0]
        }
        function multipleContexts(a, b, c) {
            var i = 0,
                len = b.length;
            for (; i < len; i++) {
                Sizzle(a, b[i], c)
            }
            return c
        }
        function condense(a, b, c, d, e) {
            var f, newUnmatched = [],
                i = 0,
                len = a.length,
                mapped = b != null;
            for (; i < len; i++) {
                if ((f = a[i])) {
                    if (!c || c(f, d, e)) {
                        newUnmatched.push(f);
                        if (mapped) {
                            b.push(i)
                        }
                    }
                }
            }
            return newUnmatched
        }
        function setMatcher(f, g, h, j, k, l) {
            if (j && !j[expando]) {
                j = setMatcher(j)
            }
            if (k && !k[expando]) {
                k = setMatcher(k, l)
            }
            return markFunction(function (a, b, c, d) {
                var e, i, elem, preMap = [],
                    postMap = [],
                    preexisting = b.length,
                    elems = a || multipleContexts(g || "*", c.nodeType ? [c] : c, []),
                    matcherIn = f && (a || !g) ? condense(elems, preMap, f, c, d) : elems,
                    matcherOut = h ? k || (a ? f : preexisting || j) ? [] : b : matcherIn;
                if (h) {
                    h(matcherIn, matcherOut, c, d)
                }
                if (j) {
                    e = condense(matcherOut, postMap);
                    j(e, [], c, d);
                    i = e.length;
                    while (i--) {
                        if ((elem = e[i])) {
                            matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem)
                        }
                    }
                }
                if (a) {
                    if (k || f) {
                        if (k) {
                            e = [];
                            i = matcherOut.length;
                            while (i--) {
                                if ((elem = matcherOut[i])) {
                                    e.push((matcherIn[i] = elem))
                                }
                            }
                            k(null, (matcherOut = []), e, d)
                        }
                        i = matcherOut.length;
                        while (i--) {
                            if ((elem = matcherOut[i]) && (e = k ? indexOf.call(a, elem) : preMap[i]) > -1) {
                                a[e] = !(b[e] = elem)
                            }
                        }
                    }
                } else {
                    matcherOut = condense(matcherOut === b ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (k) {
                        k(null, b, matcherOut, d)
                    } else {
                        push.apply(b, matcherOut)
                    }
                }
            })
        }
        function matcherFromTokens(d) {
            var e, matcher, j, len = d.length,
                leadingRelative = Expr.relative[d[0].type],
                implicitRelative = leadingRelative || Expr.relative[" "],
                i = leadingRelative ? 1 : 0,
                matchContext = addCombinator(function (a) {
                    return a === e
                }, implicitRelative, true),
                matchAnyContext = addCombinator(function (a) {
                    return indexOf.call(e, a) > -1
                }, implicitRelative, true),
                matchers = [function (a, b, c) {
                    return (!leadingRelative && (c || b !== outermostContext)) || ((e = b).nodeType ? matchContext(a, b, c) : matchAnyContext(a, b, c))
                }];
            for (; i < len; i++) {
                if ((matcher = Expr.relative[d[i].type])) {
                    matchers = [addCombinator(elementMatcher(matchers), matcher)]
                } else {
                    matcher = Expr.filter[d[i].type].apply(null, d[i].matches);
                    if (matcher[expando]) {
                        j = ++i;
                        for (; j < len; j++) {
                            if (Expr.relative[d[j].type]) {
                                break
                            }
                        }
                        return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(d.slice(0, i - 1).concat({
                            value: d[i - 2].type === " " ? "*" : ""
                        })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(d.slice(i, j)), j < len && matcherFromTokens((d = d.slice(j))), j < len && toSelector(d))
                    }
                    matchers.push(matcher)
                }
            }
            return elementMatcher(matchers)
        }
        function matcherFromGroupMatchers(g, h) {
            var k = h.length > 0,
                byElement = g.length > 0,
                superMatcher = function (a, b, c, d, e) {
                    var f, j, matcher, matchedCount = 0,
                        i = "0",
                        unmatched = a && [],
                        setMatched = [],
                        contextBackup = outermostContext,
                        elems = a || byElement && Expr.find["TAG"]("*", e),
                        dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                        len = elems.length;
                    if (e) {
                        outermostContext = b !== document && b
                    }
                    for (; i !== len && (f = elems[i]) != null; i++) {
                        if (byElement && f) {
                            j = 0;
                            while ((matcher = g[j++])) {
                                if (matcher(f, b, c)) {
                                    d.push(f);
                                    break
                                }
                            }
                            if (e) {
                                dirruns = dirrunsUnique
                            }
                        }
                        if (k) {
                            if ((f = !matcher && f)) {
                                matchedCount--
                            }
                            if (a) {
                                unmatched.push(f)
                            }
                        }
                    }
                    matchedCount += i;
                    if (k && i !== matchedCount) {
                        j = 0;
                        while ((matcher = h[j++])) {
                            matcher(unmatched, setMatched, b, c)
                        }
                        if (a) {
                            if (matchedCount > 0) {
                                while (i--) {
                                    if (!(unmatched[i] || setMatched[i])) {
                                        setMatched[i] = pop.call(d)
                                    }
                                }
                            }
                            setMatched = condense(setMatched)
                        }
                        push.apply(d, setMatched);
                        if (e && !a && setMatched.length > 0 && (matchedCount + h.length) > 1) {
                            Sizzle.uniqueSort(d)
                        }
                    }
                    if (e) {
                        dirruns = dirrunsUnique;
                        outermostContext = contextBackup
                    }
                    return unmatched
                };
            return k ? markFunction(superMatcher) : superMatcher
        }
        compile = Sizzle.compile = function (a, b) {
            var i, setMatchers = [],
                elementMatchers = [],
                cached = compilerCache[a + " "];
            if (!cached) {
                if (!b) {
                    b = tokenize(a)
                }
                i = b.length;
                while (i--) {
                    cached = matcherFromTokens(b[i]);
                    if (cached[expando]) {
                        setMatchers.push(cached)
                    } else {
                        elementMatchers.push(cached)
                    }
                }
                cached = compilerCache(a, matcherFromGroupMatchers(elementMatchers, setMatchers));
                cached.selector = a
            }
            return cached
        };
        select = Sizzle.select = function (a, b, c, d) {
            var i, tokens, token, type, find, compiled = typeof a === "function" && a,
                match = !d && tokenize((a = compiled.selector || a));
            c = c || [];
            if (match.length === 1) {
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && support.getById && b.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    b = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), b) || [])[0];
                    if (!b) {
                        return c
                    } else if (compiled) {
                        b = b.parentNode
                    }
                    a = a.slice(tokens.shift().value.length)
                }
                i = matchExpr["needsContext"].test(a) ? 0 : tokens.length;
                while (i--) {
                    token = tokens[i];
                    if (Expr.relative[(type = token.type)]) {
                        break
                    }
                    if ((find = Expr.find[type])) {
                        if ((d = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(b.parentNode) || b))) {
                            tokens.splice(i, 1);
                            a = d.length && toSelector(tokens);
                            if (!a) {
                                push.apply(c, d);
                                return c
                            }
                            break
                        }
                    }
                }
            } (compiled || compile(a, match))(d, b, !documentIsHTML, c, rsibling.test(a) && testContext(b.parentNode) || b);
            return c
        };
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        support.detectDuplicates = !!hasDuplicate;
        setDocument();
        support.sortDetached = assert(function (a) {
            return a.compareDocumentPosition(document.createElement("div")) & 1
        });
        if (!assert(function (a) {
            a.innerHTML = "<a href='#'></a>";
            return a.firstChild.getAttribute("href") === "#"
        })) {
            addHandle("type|href|height|width", function (a, b, c) {
                if (!c) {
                    return a.getAttribute(b, b.toLowerCase() === "type" ? 1 : 2)
                }
            })
        }
        if (!support.attributes || !assert(function (a) {
            a.innerHTML = "<input/>";
            a.firstChild.setAttribute("value", "");
            return a.firstChild.getAttribute("value") === ""
        })) {
            addHandle("value", function (a, b, c) {
                if (!c && a.nodeName.toLowerCase() === "input") {
                    return a.defaultValue
                }
            })
        }
        if (!assert(function (a) {
            return a.getAttribute("disabled") == null
        })) {
            addHandle(booleans, function (a, b, c) {
                var d;
                if (!c) {
                    return a[b] === true ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null
                }
            })
        }
        return Sizzle
    });
    define("tinymce/util/Arr", [], function () {
        var g = Array.isArray ||
            function (a) {
                return Object.prototype.toString.call(a) === "[object Array]"
            };

        function toArray(a) {
            var b = a,
                i, l;
            if (!g(a)) {
                b = [];
                for (i = 0, l = a.length; i < l; i++) {
                    b[i] = a[i]
                }
            }
            return b
        }
        function each(o, a, s) {
            var n, l;
            if (!o) {
                return 0
            }
            s = s || o;
            if (o.length !== Y) {
                for (n = 0, l = o.length; n < l; n++) {
                    if (a.call(s, o[n], n, o) === false) {
                        return 0
                    }
                }
            } else {
                for (n in o) {
                    if (o.hasOwnProperty(n)) {
                        if (a.call(s, o[n], n, o) === false) {
                            return 0
                        }
                    }
                }
            }
            return 1
        }
        function map(c, d) {
            var e = [];
            each(c, function (a, b) {
                e.push(d(a, b, c))
            });
            return e
        }
        function filter(a, f) {
            var o = [];
            each(a, function (v, b) {
                if (!f || f(v, b, a)) {
                    o.push(v)
                }
            });
            return o
        }
        function indexOf(a, v) {
            var i, l;
            if (a) {
                for (i = 0, l = a.length; i < l; i++) {
                    if (a[i] === v) {
                        return i
                    }
                }
            }
            return -1
        }
        function reduce(a, b, c, d) {
            var i = 0;
            if (arguments.length < 3) {
                c = a[0]
            }
            for (; i < a.length; i++) {
                c = b.call(d, c, a[i], i)
            }
            return c
        }
        function findIndex(a, b, c) {
            var i, l;
            for (i = 0, l = a.length; i < l; i++) {
                if (b.call(c, a[i], i, a)) {
                    return i
                }
            }
            return -1
        }
        function find(a, b, c) {
            var d = findIndex(a, b, c);
            if (d !== -1) {
                return a[d]
            }
            return Y
        }
        function last(a) {
            return a[a.length - 1]
        }
        return {
            isArray: g,
            toArray: toArray,
            each: each,
            map: map,
            filter: filter,
            indexOf: indexOf,
            reduce: reduce,
            findIndex: findIndex,
            find: find,
            last: last
        }
    });
    define("tinymce/util/Tools", ["tinymce/Env", "tinymce/util/Arr"], function (e, g) {
        var h = /^\s*|\s*$/g;

        function trim(a) {
            return (a === null || a === Y) ? '' : ("" + a).replace(h, '')
        }
        function is(a, b) {
            if (!b) {
                return a !== Y
            }
            if (b == 'array' && g.isArray(a)) {
                return true
            }
            return typeof a == b
        }
        function makeMap(a, b, c) {
            var i;
            a = a || [];
            b = b || ',';
            if (typeof a == "string") {
                a = a.split(b)
            }
            c = c || {};
            i = a.length;
            while (i--) {
                c[a[i]] = {}
            }
            return c
        }
        function create(s, p, a) {
            var b = this,
                sp, ns, cn, scn, c, de = 0;
            s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
            cn = s[3].match(/(^|\.)(\w+)$/i)[2];
            ns = b.createNS(s[3].replace(/\.\w+$/, ''), a);
            if (ns[cn]) {
                return
            }
            if (s[2] == 'static') {
                ns[cn] = p;
                if (this.onCreate) {
                    this.onCreate(s[2], s[3], ns[cn])
                }
                return
            }
            if (!p[cn]) {
                p[cn] = function () { };
                de = 1
            }
            ns[cn] = p[cn];
            b.extend(ns[cn].prototype, p);
            if (s[5]) {
                sp = b.resolve(s[5]).prototype;
                scn = s[5].match(/\.(\w+)$/i)[1];
                c = ns[cn];
                if (de) {
                    ns[cn] = function () {
                        return sp[scn].apply(this, arguments)
                    }
                } else {
                    ns[cn] = function () {
                        this.parent = sp[scn];
                        return c.apply(this, arguments)
                    }
                }
                ns[cn].prototype[cn] = ns[cn];
                b.each(sp, function (f, n) {
                    ns[cn].prototype[n] = sp[n]
                });
                b.each(p, function (f, n) {
                    if (sp[n]) {
                        ns[cn].prototype[n] = function () {
                            this.parent = sp[n];
                            return f.apply(this, arguments)
                        }
                    } else {
                        if (n != cn) {
                            ns[cn].prototype[n] = f
                        }
                    }
                })
            }
            b.each(p['static'], function (f, n) {
                ns[cn][n] = f
            })
        }
        function extend(a, b) {
            var i, l, name, args = arguments,
                value;
            for (i = 1, l = args.length; i < l; i++) {
                b = args[i];
                for (name in b) {
                    if (b.hasOwnProperty(name)) {
                        value = b[name];
                        if (value !== Y) {
                            a[name] = value
                        }
                    }
                }
            }
            return a
        }
        function walk(o, f, n, s) {
            s = s || this;
            if (o) {
                if (n) {
                    o = o[n]
                }
                g.each(o, function (o, i) {
                    if (f.call(s, o, i, n) === false) {
                        return false
                    }
                    walk(o, f, n, s)
                })
            }
        }
        function createNS(n, o) {
            var i, v;
            o = o || window;
            n = n.split('.');
            for (i = 0; i < n.length; i++) {
                v = n[i];
                if (!o[v]) {
                    o[v] = {}
                }
                o = o[v]
            }
            return o
        }
        function resolve(n, o) {
            var i, l;
            o = o || window;
            n = n.split('.');
            for (i = 0, l = n.length; i < l; i++) {
                o = o[n[i]];
                if (!o) {
                    break
                }
            }
            return o
        }
        function explode(s, d) {
            if (!s || is(s, 'array')) {
                return s
            }
            return g.map(s.split(d || ','), trim)
        }
        function _addCacheSuffix(a) {
            var b = e.cacheSuffix;
            if (b) {
                a += (a.indexOf('?') === -1 ? '?' : '&') + b
            }
            return a
        }
        return {
            trim: trim,
            isArray: g.isArray,
            is: is,
            toArray: g.toArray,
            makeMap: makeMap,
            each: g.each,
            map: g.map,
            grep: g.filter,
            inArray: g.indexOf,
            extend: extend,
            create: create,
            walk: walk,
            createNS: createNS,
            resolve: resolve,
            explode: explode,
            _addCacheSuffix: _addCacheSuffix
        }
    });
    define("tinymce/dom/DomQuery", ["tinymce/dom/EventUtils", "tinymce/dom/Sizzle", "tinymce/util/Tools", "tinymce/Env"], function (g, h, j, k) {
        var m = document,
            push = Array.prototype.push,
            slice = Array.prototype.slice;
        var n = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
        var o = g.Event,
            undef;
        var p = j.makeMap('children,contents,next,prev');

        function isDefined(a) {
            return typeof a !== 'undefined'
        }
        function isString(a) {
            return typeof a === 'string'
        }
        function isWindow(a) {
            return a && a == a.window
        }
        function createFragment(a, b) {
            var c, node, container;
            b = b || m;
            container = b.createElement('div');
            c = b.createDocumentFragment();
            container.innerHTML = a;
            while ((node = container.firstChild)) {
                c.appendChild(node)
            }
            return c
        }
        function domManipulate(a, b, c, d) {
            var i;
            if (isString(b)) {
                b = createFragment(b, getElementDocument(a[0]))
            } else if (b.length && !b.nodeType) {
                b = DomQuery.makeArray(b);
                if (d) {
                    for (i = b.length - 1; i >= 0; i--) {
                        domManipulate(a, b[i], c, d)
                    }
                } else {
                    for (i = 0; i < b.length; i++) {
                        domManipulate(a, b[i], c, d)
                    }
                }
                return a
            }
            if (b.nodeType) {
                i = a.length;
                while (i--) {
                    c.call(a[i], b)
                }
            }
            return a
        }
        function hasClass(a, b) {
            return a && b && (' ' + a.className + ' ').indexOf(' ' + b + ' ') !== -1
        }
        function wrap(b, c, d) {
            var e, newWrapper;
            c = DomQuery(c)[0];
            b.each(function () {
                var a = this;
                if (!d || e != a.parentNode) {
                    e = a.parentNode;
                    newWrapper = c.cloneNode(false);
                    a.parentNode.insertBefore(newWrapper, a);
                    newWrapper.appendChild(a)
                } else {
                    newWrapper.appendChild(a)
                }
            });
            return b
        }
        var q = j.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
        var r = j.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
        var s = {
            'for': 'htmlFor',
            'class': 'className',
            'readonly': 'readOnly'
        };
        var t = {
            'float': 'cssFloat'
        };
        var u = {},
            cssHooks = {};

        function DomQuery(a, b) {
            return new DomQuery.fn.init(a, b)
        }
        function inArray(a, b) {
            var i;
            if (b.indexOf) {
                return b.indexOf(a)
            }
            i = b.length;
            while (i--) {
                if (b[i] === a) {
                    return i
                }
            }
            return -1
        }
        var v = /^\s*|\s*$/g;

        function trim(a) {
            return (a === null || a === undef) ? '' : ("" + a).replace(v, '')
        }
        function each(a, b) {
            var c, key, i, undef, value;
            if (a) {
                c = a.length;
                if (c === undef) {
                    for (key in a) {
                        if (a.hasOwnProperty(key)) {
                            value = a[key];
                            if (b.call(value, key, value) === false) {
                                break
                            }
                        }
                    }
                } else {
                    for (i = 0; i < c; i++) {
                        value = a[i];
                        if (b.call(value, i, value) === false) {
                            break
                        }
                    }
                }
            }
            return a
        }
        function grep(b, c) {
            var d = [];
            each(b, function (i, a) {
                if (c(a, i)) {
                    d.push(a)
                }
            });
            return d
        }
        function getElementDocument(a) {
            if (!a) {
                return m
            }
            if (a.nodeType == 9) {
                return a
            }
            return a.ownerDocument
        }
        DomQuery.fn = DomQuery.prototype = {
            constructor: DomQuery,
            selector: "",
            context: null,
            length: 0,
            init: function (a, b) {
                var c = this,
                    match, node;
                if (!a) {
                    return c
                }
                if (a.nodeType) {
                    c.context = c[0] = a;
                    c.length = 1;
                    return c
                }
                if (b && b.nodeType) {
                    c.context = b
                } else {
                    if (b) {
                        return DomQuery(a).attr(b)
                    }
                    c.context = b = document
                }
                if (isString(a)) {
                    c.selector = a;
                    if (a.charAt(0) === "<" && a.charAt(a.length - 1) === ">" && a.length >= 3) {
                        match = [null, a, null]
                    } else {
                        match = n.exec(a)
                    }
                    if (match) {
                        if (match[1]) {
                            node = createFragment(a, getElementDocument(b)).firstChild;
                            while (node) {
                                push.call(c, node);
                                node = node.nextSibling
                            }
                        } else {
                            node = getElementDocument(b).getElementById(match[2]);
                            if (!node) {
                                return c
                            }
                            if (node.id !== match[2]) {
                                return c.find(a)
                            }
                            c.length = 1;
                            c[0] = node
                        }
                    } else {
                        return DomQuery(b).find(a)
                    }
                } else {
                    this.add(a, false)
                }
                return c
            },
            toArray: function () {
                return j.toArray(this)
            },
            add: function (a, b) {
                var c = this,
                    nodes, i;
                if (isString(a)) {
                    return c.add(DomQuery(a))
                }
                if (b !== false) {
                    nodes = DomQuery.unique(c.toArray().concat(DomQuery.makeArray(a)));
                    c.length = nodes.length;
                    for (i = 0; i < nodes.length; i++) {
                        c[i] = nodes[i]
                    }
                } else {
                    push.apply(c, DomQuery.makeArray(a))
                }
                return c
            },
            attr: function (c, d) {
                var e = this,
                    hook;
                if (typeof c === "object") {
                    each(c, function (a, b) {
                        e.attr(a, b)
                    })
                } else if (isDefined(d)) {
                    this.each(function () {
                        var a;
                        if (this.nodeType === 1) {
                            a = u[c];
                            if (a && a.set) {
                                a.set(this, d);
                                return
                            }
                            if (d === null) {
                                this.removeAttribute(c, 2)
                            } else {
                                this.setAttribute(c, d, 2)
                            }
                        }
                    })
                } else {
                    if (e[0] && e[0].nodeType === 1) {
                        hook = u[c];
                        if (hook && hook.get) {
                            return hook.get(e[0], c)
                        }
                        if (r[c]) {
                            return e.prop(c) ? c : undef
                        }
                        d = e[0].getAttribute(c, 2);
                        if (d === null) {
                            d = undef
                        }
                    }
                    return d
                }
                return e
            },
            removeAttr: function (a) {
                return this.attr(a, null)
            },
            prop: function (c, d) {
                var e = this;
                c = s[c] || c;
                if (typeof c === "object") {
                    each(c, function (a, b) {
                        e.prop(a, b)
                    })
                } else if (isDefined(d)) {
                    this.each(function () {
                        if (this.nodeType == 1) {
                            this[c] = d
                        }
                    })
                } else {
                    if (e[0] && e[0].nodeType && c in e[0]) {
                        return e[0][c]
                    }
                    return d
                }
                return e
            },
            css: function (d, e) {
                var f = this,
                    elm, hook;

                function camel(c) {
                    return c.replace(/-(\D)/g, function (a, b) {
                        return b.toUpperCase()
                    })
                }
                function dashed(b) {
                    return b.replace(/[A-Z]/g, function (a) {
                        return '-' + a
                    })
                }
                if (typeof d === "object") {
                    each(d, function (a, b) {
                        f.css(a, b)
                    })
                } else {
                    if (isDefined(e)) {
                        d = camel(d);
                        if (typeof e === 'number' && !q[d]) {
                            e += 'px'
                        }
                        f.each(function () {
                            var a = this.style;
                            hook = cssHooks[d];
                            if (hook && hook.set) {
                                hook.set(this, e);
                                return
                            }
                            try {
                                this.style[t[d] || d] = e
                            } catch (ex) { }
                            if (e === null || e === '') {
                                if (a.removeProperty) {
                                    a.removeProperty(dashed(d))
                                } else {
                                    a.removeAttribute(d)
                                }
                            }
                        })
                    } else {
                        elm = f[0];
                        hook = cssHooks[d];
                        if (hook && hook.get) {
                            return hook.get(elm)
                        }
                        if (elm.ownerDocument.defaultView) {
                            try {
                                return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(d))
                            } catch (ex) {
                                return undef
                            }
                        } else if (elm.currentStyle) {
                            return elm.currentStyle[camel(d)]
                        }
                    }
                }
                return f
            },
            remove: function () {
                var a = this,
                    node, i = this.length;
                while (i--) {
                    node = a[i];
                    o.clean(node);
                    if (node.parentNode) {
                        node.parentNode.removeChild(node)
                    }
                }
                return this
            },
            empty: function () {
                var a = this,
                    node, i = this.length;
                while (i--) {
                    node = a[i];
                    while (node.firstChild) {
                        node.removeChild(node.firstChild)
                    }
                }
                return this
            },
            html: function (a) {
                var b = this,
                    i;
                if (isDefined(a)) {
                    i = b.length;
                    try {
                        while (i--) {
                            b[i].innerHTML = a
                        }
                    } catch (ex) {
                        DomQuery(b[i]).empty().append(a)
                    }
                    return b
                }
                return b[0] ? b[0].innerHTML : ''
            },
            text: function (a) {
                var b = this,
                    i;
                if (isDefined(a)) {
                    i = b.length;
                    while (i--) {
                        if ("innerText" in b[i]) {
                            b[i].innerText = a
                        } else {
                            b[0].textContent = a
                        }
                    }
                    return b
                }
                return b[0] ? (b[0].innerText || b[0].textContent) : ''
            },
            append: function () {
                return domManipulate(this, arguments, function (a) {
                    if (this.nodeType === 1 || (this.host && this.host.nodeType === 1)) {
                        this.appendChild(a)
                    }
                })
            },
            prepend: function () {
                return domManipulate(this, arguments, function (a) {
                    if (this.nodeType === 1 || (this.host && this.host.nodeType === 1)) {
                        this.insertBefore(a, this.firstChild)
                    }
                }, true)
            },
            before: function () {
                var b = this;
                if (b[0] && b[0].parentNode) {
                    return domManipulate(b, arguments, function (a) {
                        this.parentNode.insertBefore(a, this)
                    })
                }
                return b
            },
            after: function () {
                var b = this;
                if (b[0] && b[0].parentNode) {
                    return domManipulate(b, arguments, function (a) {
                        this.parentNode.insertBefore(a, this.nextSibling)
                    }, true)
                }
                return b
            },
            appendTo: function (a) {
                DomQuery(a).append(this);
                return this
            },
            prependTo: function (a) {
                DomQuery(a).prepend(this);
                return this
            },
            replaceWith: function (a) {
                return this.before(a).remove()
            },
            wrap: function (a) {
                return wrap(this, a)
            },
            wrapAll: function (a) {
                return wrap(this, a, true)
            },
            wrapInner: function (a) {
                this.each(function () {
                    DomQuery(this).contents().wrapAll(a)
                });
                return this
            },
            unwrap: function () {
                return this.parent().each(function () {
                    DomQuery(this).replaceWith(this.childNodes)
                })
            },
            clone: function () {
                var a = [];
                this.each(function () {
                    a.push(this.cloneNode(true))
                });
                return DomQuery(a)
            },
            addClass: function (a) {
                return this.toggleClass(a, true)
            },
            removeClass: function (a) {
                return this.toggleClass(a, false)
            },
            toggleClass: function (d, e) {
                var f = this;
                if (typeof d != 'string') {
                    return f
                }
                if (d.indexOf(' ') !== -1) {
                    each(d.split(' '), function () {
                        f.toggleClass(this, e)
                    })
                } else {
                    f.each(function (a, b) {
                        var c, classState;
                        classState = hasClass(b, d);
                        if (classState !== e) {
                            c = b.className;
                            if (classState) {
                                b.className = trim((" " + c + " ").replace(' ' + d + ' ', ' '))
                            } else {
                                b.className += c ? ' ' + d : d
                            }
                        }
                    })
                }
                return f
            },
            hasClass: function (a) {
                return hasClass(this[0], a)
            },
            each: function (a) {
                return each(this, a)
            },
            on: function (a, b) {
                return this.each(function () {
                    o.bind(this, a, b)
                })
            },
            off: function (a, b) {
                return this.each(function () {
                    o.unbind(this, a, b)
                })
            },
            trigger: function (a) {
                return this.each(function () {
                    if (typeof a == 'object') {
                        o.fire(this, a.type, a)
                    } else {
                        o.fire(this, a)
                    }
                })
            },
            show: function () {
                return this.css('display', '')
            },
            hide: function () {
                return this.css('display', 'none')
            },
            slice: function () {
                return new DomQuery(slice.apply(this, arguments))
            },
            eq: function (a) {
                return a === -1 ? this.slice(a) : this.slice(a, +a + 1)
            },
            first: function () {
                return this.eq(0)
            },
            last: function () {
                return this.eq(-1)
            },
            find: function (a) {
                var i, l, ret = [];
                for (i = 0, l = this.length; i < l; i++) {
                    DomQuery.find(a, this[i], ret)
                }
                return DomQuery(ret)
            },
            filter: function (b) {
                if (typeof b == 'function') {
                    return DomQuery(grep(this.toArray(), function (a, i) {
                        return b(i, a)
                    }))
                }
                return DomQuery(DomQuery.filter(b, this.toArray()))
            },
            closest: function (b) {
                var c = [];
                if (b instanceof DomQuery) {
                    b = b[0]
                }
                this.each(function (i, a) {
                    while (a) {
                        if (typeof b == 'string' && DomQuery(a).is(b)) {
                            c.push(a);
                            break
                        } else if (a == b) {
                            c.push(a);
                            break
                        }
                        a = a.parentNode
                    }
                });
                return DomQuery(c)
            },
            offset: function (a) {
                var b, m, docElm;
                var x = 0,
                    y = 0,
                    pos;
                if (!a) {
                    b = this[0];
                    if (b) {
                        m = b.ownerDocument;
                        docElm = m.documentElement;
                        if (b.getBoundingClientRect) {
                            pos = b.getBoundingClientRect();
                            x = pos.left + (docElm.scrollLeft || m.body.scrollLeft) - docElm.clientLeft;
                            y = pos.top + (docElm.scrollTop || m.body.scrollTop) - docElm.clientTop
                        }
                    }
                    return {
                        left: x,
                        top: y
                    }
                }
                return this.css(a)
            },
            push: push,
            sort: [].sort,
            splice: [].splice
        };
        j.extend(DomQuery, {
            extend: j.extend,
            makeArray: function (a) {
                if (isWindow(a) || a.nodeType) {
                    return [a]
                }
                return j.toArray(a)
            },
            inArray: inArray,
            isArray: j.isArray,
            each: each,
            trim: trim,
            grep: grep,
            find: h,
            expr: h.selectors,
            unique: h.uniqueSort,
            text: h.getText,
            contains: h.contains,
            filter: function (a, b, c) {
                var i = b.length;
                if (c) {
                    a = ":not(" + a + ")"
                }
                while (i--) {
                    if (b[i].nodeType != 1) {
                        b.splice(i, 1)
                    }
                }
                if (b.length === 1) {
                    b = DomQuery.find.matchesSelector(b[0], a) ? [b[0]] : []
                } else {
                    b = DomQuery.find.matches(a, b)
                }
                return b
            }
        });

        function dir(a, b, c) {
            var d = [],
                cur = a[b];
            if (typeof c != 'string' && c instanceof DomQuery) {
                c = c[0]
            }
            while (cur && cur.nodeType !== 9) {
                if (c !== Y) {
                    if (cur === c) {
                        break
                    }
                    if (typeof c == 'string' && DomQuery(cur).is(c)) {
                        break
                    }
                }
                if (cur.nodeType === 1) {
                    d.push(cur)
                }
                cur = cur[b]
            }
            return d
        }
        function sibling(a, b, c, d) {
            var e = [];
            if (d instanceof DomQuery) {
                d = d[0]
            }
            for (; a; a = a[b]) {
                if (c && a.nodeType !== c) {
                    continue
                }
                if (d !== Y) {
                    if (a === d) {
                        break
                    }
                    if (typeof d == 'string' && DomQuery(a).is(d)) {
                        break
                    }
                }
                e.push(a)
            }
            return e
        }
        function firstSibling(a, b, c) {
            for (a = a[b]; a; a = a[b]) {
                if (a.nodeType == c) {
                    return a
                }
            }
            return null
        }
        each({
            parent: function (a) {
                var b = a.parentNode;
                return b && b.nodeType !== 11 ? b : null
            },
            parents: function (a) {
                return dir(a, "parentNode")
            },
            next: function (a) {
                return firstSibling(a, 'nextSibling', 1)
            },
            prev: function (a) {
                return firstSibling(a, 'previousSibling', 1)
            },
            children: function (a) {
                return sibling(a.firstChild, 'nextSibling', 1)
            },
            contents: function (a) {
                return j.toArray((a.nodeName === "iframe" ? a.contentDocument || a.contentWindow.document : a).childNodes)
            }
        }, function (d, e) {
            DomQuery.fn[d] = function (b) {
                var c = this,
                    result = [];
                c.each(function () {
                    var a = e.call(result, this, b, result);
                    if (a) {
                        if (DomQuery.isArray(a)) {
                            result.push.apply(result, a)
                        } else {
                            result.push(a)
                        }
                    }
                });
                if (this.length > 1) {
                    if (!p[d]) {
                        result = DomQuery.unique(result)
                    }
                    if (d.indexOf('parents') === 0) {
                        result = result.reverse()
                    }
                }
                result = DomQuery(result);
                if (b) {
                    return result.filter(b)
                }
                return result
            }
        });
        each({
            parentsUntil: function (a, b) {
                return dir(a, "parentNode", b)
            },
            nextUntil: function (a, b) {
                return sibling(a, 'nextSibling', 1, b).slice(1)
            },
            prevUntil: function (a, b) {
                return sibling(a, 'previousSibling', 1, b).slice(1)
            }
        }, function (e, f) {
            DomQuery.fn[e] = function (b, c) {
                var d = this,
                    result = [];
                d.each(function () {
                    var a = f.call(result, this, b, result);
                    if (a) {
                        if (DomQuery.isArray(a)) {
                            result.push.apply(result, a)
                        } else {
                            result.push(a)
                        }
                    }
                });
                if (this.length > 1) {
                    result = DomQuery.unique(result);
                    if (e.indexOf('parents') === 0 || e === 'prevUntil') {
                        result = result.reverse()
                    }
                }
                result = DomQuery(result);
                if (c) {
                    return result.filter(c)
                }
                return result
            }
        });
        DomQuery.fn.is = function (a) {
            return !!a && this.filter(a).length > 0
        };
        DomQuery.fn.init.prototype = DomQuery.fn;
        DomQuery.overrideDefaults = function (c) {
            var d;

            function sub(a, b) {
                d = d || c();
                if (arguments.length === 0) {
                    a = d.element
                }
                if (!b) {
                    b = d.context
                }
                return new sub.fn.init(a, b)
            }
            DomQuery.extend(sub, this);
            return sub
        };

        function appendHooks(c, d, e) {
            each(e, function (a, b) {
                c[a] = c[a] || {};
                c[a][d] = b
            })
        }
        if (k.ie && k.ie < 8) {
            appendHooks(u, 'get', {
                maxlength: function (a) {
                    var b = a.maxLength;
                    if (b === 0x7fffffff) {
                        return undef
                    }
                    return b
                },
                size: function (a) {
                    var b = a.size;
                    if (b === 20) {
                        return undef
                    }
                    return b
                },
                'class': function (a) {
                    return a.className
                },
                style: function (a) {
                    var b = a.style.cssText;
                    if (b.length === 0) {
                        return undef
                    }
                    return b
                }
            });
            appendHooks(u, 'set', {
                'class': function (a, b) {
                    a.className = b
                },
                style: function (a, b) {
                    a.style.cssText = b
                }
            })
        }
        if (k.ie && k.ie < 9) {
            t['float'] = 'styleFloat';
            appendHooks(cssHooks, 'set', {
                opacity: function (a, b) {
                    var c = a.style;
                    if (b === null || b === '') {
                        c.removeAttribute('filter')
                    } else {
                        c.zoom = 1;
                        c.filter = 'alpha(opacity=' + (b * 100) + ')'
                    }
                }
            })
        }
        DomQuery.attrHooks = u;
        DomQuery.cssHooks = cssHooks;
        return DomQuery
    });
    define("tinymce/html/Styles", [], function () {
        return function (m, n) {
            var o = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi,
                urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi,
                styleRegExp = /\s*([^:]+):\s*([^;]+);?/g,
                trimRightRegExp = /\s+$/,
                undef, i, encodingLookup = {},
                encodingItems, validStyles, invalidStyles, invisibleChar = '\uFEFF';
            m = m || {};
            if (n) {
                validStyles = n.getValidStyles();
                invalidStyles = n.getInvalidStyles()
            }
            encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
            for (i = 0; i < encodingItems.length; i++) {
                encodingLookup[encodingItems[i]] = invisibleChar + i;
                encodingLookup[invisibleChar + i] = encodingItems[i]
            }
            function toHex(c, r, g, b) {
                function hex(a) {
                    a = parseInt(a, 10).toString(16);
                    return a.length > 1 ? a : '0' + a
                }
                return '#' + hex(r) + hex(g) + hex(b)
            }
            return {
                toHex: function (a) {
                    return a.replace(o, toHex)
                },
                parse: function (h) {
                    var j = {},
                        matches, name, value, isEncoded, urlConverter = m.url_converter;
                    var k = m.url_converter_scope || this;

                    function compress(a, b, c) {
                        var d, right, bottom, left;
                        d = j[a + '-top' + b];
                        if (!d) {
                            return
                        }
                        right = j[a + '-right' + b];
                        if (!right) {
                            return
                        }
                        bottom = j[a + '-bottom' + b];
                        if (!bottom) {
                            return
                        }
                        left = j[a + '-left' + b];
                        if (!left) {
                            return
                        }
                        var e = [d, right, bottom, left];
                        i = e.length - 1;
                        while (i--) {
                            if (e[i] !== e[i + 1]) {
                                break
                            }
                        }
                        if (i > -1 && c) {
                            return
                        }
                        j[a + b] = i == -1 ? e[0] : e.join(' ');
                        delete j[a + '-top' + b];
                        delete j[a + '-right' + b];
                        delete j[a + '-bottom' + b];
                        delete j[a + '-left' + b]
                    }
                    function canCompress(a) {
                        var b = j[a],
                            i;
                        if (!b) {
                            return
                        }
                        b = b.split(' ');
                        i = b.length;
                        while (i--) {
                            if (b[i] !== b[0]) {
                                return false
                            }
                        }
                        j[a] = b[0];
                        return true
                    }
                    function compress2(d, a, b, c) {
                        if (!canCompress(a)) {
                            return
                        }
                        if (!canCompress(b)) {
                            return
                        }
                        if (!canCompress(c)) {
                            return
                        }
                        j[d] = j[a] + ' ' + j[b] + ' ' + j[c];
                        delete j[a];
                        delete j[b];
                        delete j[c]
                    }
                    function encode(a) {
                        isEncoded = true;
                        return encodingLookup[a]
                    }
                    function decode(b, c) {
                        if (isEncoded) {
                            b = b.replace(/\uFEFF[0-9]/g, function (a) {
                                return encodingLookup[a]
                            })
                        }
                        if (!c) {
                            b = b.replace(/\\([\'\";:])/g, "$1")
                        }
                        return b
                    }
                    function processUrl(a, b, c, d, e, f) {
                        e = e || f;
                        if (e) {
                            e = decode(e);
                            return "'" + e.replace(/\'/g, "\\'") + "'"
                        }
                        b = decode(b || c || d);
                        if (!m.allow_script_urls) {
                            var g = b.replace(/[\s\r\n]+/, '');
                            if (/(java|vb)script:/i.test(g)) {
                                return ""
                            }
                            if (!m.allow_svg_data_urls && /^data:image\/svg/i.test(g)) {
                                return ""
                            }
                        }
                        if (urlConverter) {
                            b = urlConverter.call(k, b, 'style')
                        }
                        return "url('" + b.replace(/\'/g, "\\'") + "')"
                    }
                    if (h) {
                        h = h.replace(/[\u0000-\u001F]/g, '');
                        h = h.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function (a) {
                            return a.replace(/[;:]/g, encode)
                        });
                        while ((matches = styleRegExp.exec(h))) {
                            name = matches[1].replace(trimRightRegExp, '').toLowerCase();
                            value = matches[2].replace(trimRightRegExp, '');
                            value = value.replace(/\\[0-9a-f]+/g, function (e) {
                                return String.fromCharCode(parseInt(e.substr(1), 16))
                            });
                            if (name && value.length > 0) {
                                if (!m.allow_script_urls && (name == "behavior" || /expression\s*\(|\/\*|\*\//.test(value))) {
                                    continue
                                }
                                if (name === 'font-weight' && value === '700') {
                                    value = 'bold'
                                } else if (name === 'color' || name === 'background-color') {
                                    value = value.toLowerCase()
                                }
                                value = value.replace(o, toHex);
                                value = value.replace(urlOrStrRegExp, processUrl);
                                j[name] = isEncoded ? decode(value, true) : value
                            }
                            styleRegExp.lastIndex = matches.index + matches[0].length
                        }
                        compress("border", "", true);
                        compress("border", "-width");
                        compress("border", "-color");
                        compress("border", "-style");
                        compress("padding", "");
                        compress("margin", "");
                        compress2('border', 'border-width', 'border-style', 'border-color');
                        if (j.border === 'medium none') {
                            delete j.border
                        }
                        if (j['border-image'] === 'none') {
                            delete j['border-image']
                        }
                    }
                    return j
                },
                serialize: function (d, e) {
                    var f = '',
                        name, value;

                    function serializeStyles(a) {
                        var b, i, l, value;
                        b = validStyles[a];
                        if (b) {
                            for (i = 0, l = b.length; i < l; i++) {
                                a = b[i];
                                value = d[a];
                                if (value !== undef && value.length > 0) {
                                    f += (f.length > 0 ? ' ' : '') + a + ': ' + value + ';'
                                }
                            }
                        }
                    }
                    function isValid(a, b) {
                        var c;
                        c = invalidStyles['*'];
                        if (c && c[a]) {
                            return false
                        }
                        c = invalidStyles[b];
                        if (c && c[a]) {
                            return false
                        }
                        return true
                    }
                    if (e && validStyles) {
                        serializeStyles('*');
                        serializeStyles(e)
                    } else {
                        for (name in d) {
                            value = d[name];
                            if (value !== undef && value.length > 0) {
                                if (!invalidStyles || isValid(name, e)) {
                                    f += (f.length > 0 ? ' ' : '') + name + ': ' + value + ';'
                                }
                            }
                        }
                    }
                    return f
                }
            }
        }
    });
    define("tinymce/dom/TreeWalker", [], function () {
        return function (f, g) {
            var h = f;

            function findSibling(a, b, c, d) {
                var e, parent;
                if (a) {
                    if (!d && a[b]) {
                        return a[b]
                    }
                    if (a != g) {
                        e = a[c];
                        if (e) {
                            return e
                        }
                        for (parent = a.parentNode; parent && parent != g; parent = parent.parentNode) {
                            e = parent[c];
                            if (e) {
                                return e
                            }
                        }
                    }
                }
            }
            function findPreviousNode(a, b, c, d) {
                var e, parent, child;
                if (a) {
                    e = a[c];
                    if (g && e === g) {
                        return
                    }
                    if (e) {
                        if (!d) {
                            for (child = e[b]; child; child = child[b]) {
                                if (!child[b]) {
                                    return child
                                }
                            }
                        }
                        return e
                    }
                    parent = a.parentNode;
                    if (parent && parent !== g) {
                        return parent
                    }
                }
            }
            this.current = function () {
                return h
            };
            this.next = function (a) {
                h = findSibling(h, 'firstChild', 'nextSibling', a);
                return h
            };
            this.prev = function (a) {
                h = findSibling(h, 'lastChild', 'previousSibling', a);
                return h
            };
            this.prev2 = function (a) {
                h = findPreviousNode(h, 'lastChild', 'previousSibling', a);
                return h
            }
        }
    });
    define("tinymce/dom/Range", ["tinymce/util/Tools"], function (j) {
        function Range(g) {
            var i = this,
                doc = g.doc,
                EXTRACT = 0,
                CLONE = 1,
                DELETE = 2,
                TRUE = true,
                FALSE = false,
                START_OFFSET = 'startOffset',
                START_CONTAINER = 'startContainer',
                END_CONTAINER = 'endContainer',
                END_OFFSET = 'endOffset',
                extend = j.extend,
                nodeIndex = g.nodeIndex;

            function createDocumentFragment() {
                return doc.createDocumentFragment()
            }
            function setStart(n, o) {
                _setEndPoint(TRUE, n, o)
            }
            function setEnd(n, o) {
                _setEndPoint(FALSE, n, o)
            }
            function setStartBefore(n) {
                setStart(n.parentNode, nodeIndex(n))
            }
            function setStartAfter(n) {
                setStart(n.parentNode, nodeIndex(n) + 1)
            }
            function setEndBefore(n) {
                setEnd(n.parentNode, nodeIndex(n))
            }
            function setEndAfter(n) {
                setEnd(n.parentNode, nodeIndex(n) + 1)
            }
            function collapse(a) {
                if (a) {
                    i[END_CONTAINER] = i[START_CONTAINER];
                    i[END_OFFSET] = i[START_OFFSET]
                } else {
                    i[START_CONTAINER] = i[END_CONTAINER];
                    i[START_OFFSET] = i[END_OFFSET]
                }
                i.collapsed = TRUE
            }
            function selectNode(n) {
                setStartBefore(n);
                setEndAfter(n)
            }
            function selectNodeContents(n) {
                setStart(n, 0);
                setEnd(n, n.nodeType === 1 ? n.childNodes.length : n.nodeValue.length)
            }
            function compareBoundaryPoints(h, r) {
                var a = i[START_CONTAINER],
                    so = i[START_OFFSET],
                    ec = i[END_CONTAINER],
                    eo = i[END_OFFSET],
                    rsc = r.startContainer,
                    rso = r.startOffset,
                    rec = r.endContainer,
                    reo = r.endOffset;
                if (h === 0) {
                    return _compareBoundaryPoints(a, so, rsc, rso)
                }
                if (h === 1) {
                    return _compareBoundaryPoints(ec, eo, rsc, rso)
                }
                if (h === 2) {
                    return _compareBoundaryPoints(ec, eo, rec, reo)
                }
                if (h === 3) {
                    return _compareBoundaryPoints(a, so, rec, reo)
                }
            }
            function deleteContents() {
                _traverse(DELETE)
            }
            function extractContents() {
                return _traverse(EXTRACT)
            }
            function cloneContents() {
                return _traverse(CLONE)
            }
            function insertNode(n) {
                var a = this[START_CONTAINER],
                    startOffset = this[START_OFFSET],
                    nn, o;
                if ((a.nodeType === 3 || a.nodeType === 4) && a.nodeValue) {
                    if (!startOffset) {
                        a.parentNode.insertBefore(n, a)
                    } else if (startOffset >= a.nodeValue.length) {
                        g.insertAfter(n, a)
                    } else {
                        nn = a.splitText(startOffset);
                        a.parentNode.insertBefore(n, nn)
                    }
                } else {
                    if (a.childNodes.length > 0) {
                        o = a.childNodes[startOffset]
                    }
                    if (o) {
                        a.insertBefore(n, o)
                    } else {
                        if (a.nodeType == 3) {
                            g.insertAfter(n, a)
                        } else {
                            a.appendChild(n)
                        }
                    }
                }
            }
            function surroundContents(n) {
                var f = i.extractContents();
                i.insertNode(n);
                n.appendChild(f);
                i.selectNode(n)
            }
            function cloneRange() {
                return extend(new Range(g), {
                    startContainer: i[START_CONTAINER],
                    startOffset: i[START_OFFSET],
                    endContainer: i[END_CONTAINER],
                    endOffset: i[END_OFFSET],
                    collapsed: i.collapsed,
                    commonAncestorContainer: i.commonAncestorContainer
                })
            }
            function _getSelectedNode(a, b) {
                var c;
                if (a.nodeType == 3) {
                    return a
                }
                if (b < 0) {
                    return a
                }
                c = a.firstChild;
                while (c && b > 0) {
                    --b;
                    c = c.nextSibling
                }
                if (c) {
                    return c
                }
                return a
            }
            function _isCollapsed() {
                return (i[START_CONTAINER] == i[END_CONTAINER] && i[START_OFFSET] == i[END_OFFSET])
            }
            function _compareBoundaryPoints(a, b, d, e) {
                var c, offsetC, n, cmnRoot, childA, childB;
                if (a == d) {
                    if (b == e) {
                        return 0
                    }
                    if (b < e) {
                        return -1
                    }
                    return 1
                }
                c = d;
                while (c && c.parentNode != a) {
                    c = c.parentNode
                }
                if (c) {
                    offsetC = 0;
                    n = a.firstChild;
                    while (n != c && offsetC < b) {
                        offsetC++;
                        n = n.nextSibling
                    }
                    if (b <= offsetC) {
                        return -1
                    }
                    return 1
                }
                c = a;
                while (c && c.parentNode != d) {
                    c = c.parentNode
                }
                if (c) {
                    offsetC = 0;
                    n = d.firstChild;
                    while (n != c && offsetC < e) {
                        offsetC++;
                        n = n.nextSibling
                    }
                    if (offsetC < e) {
                        return -1
                    }
                    return 1
                }
                cmnRoot = g.findCommonAncestor(a, d);
                childA = a;
                while (childA && childA.parentNode != cmnRoot) {
                    childA = childA.parentNode
                }
                if (!childA) {
                    childA = cmnRoot
                }
                childB = d;
                while (childB && childB.parentNode != cmnRoot) {
                    childB = childB.parentNode
                }
                if (!childB) {
                    childB = cmnRoot
                }
                if (childA == childB) {
                    return 0
                }
                n = cmnRoot.firstChild;
                while (n) {
                    if (n == childA) {
                        return -1
                    }
                    if (n == childB) {
                        return 1
                    }
                    n = n.nextSibling
                }
            }
            function _setEndPoint(a, n, o) {
                var b, sc;
                if (a) {
                    i[START_CONTAINER] = n;
                    i[START_OFFSET] = o
                } else {
                    i[END_CONTAINER] = n;
                    i[END_OFFSET] = o
                }
                b = i[END_CONTAINER];
                while (b.parentNode) {
                    b = b.parentNode
                }
                sc = i[START_CONTAINER];
                while (sc.parentNode) {
                    sc = sc.parentNode
                }
                if (sc == b) {
                    if (_compareBoundaryPoints(i[START_CONTAINER], i[START_OFFSET], i[END_CONTAINER], i[END_OFFSET]) > 0) {
                        i.collapse(a)
                    }
                } else {
                    i.collapse(a)
                }
                i.collapsed = _isCollapsed();
                i.commonAncestorContainer = g.findCommonAncestor(i[START_CONTAINER], i[END_CONTAINER])
            }
            function _traverse(a) {
                var c, endContainerDepth = 0,
                    startContainerDepth = 0,
                    p, depthDiff, startNode, endNode, sp, ep;
                if (i[START_CONTAINER] == i[END_CONTAINER]) {
                    return _traverseSameContainer(a)
                }
                for (c = i[END_CONTAINER], p = c.parentNode; p; c = p, p = p.parentNode) {
                    if (p == i[START_CONTAINER]) {
                        return _traverseCommonStartContainer(c, a)
                    } ++endContainerDepth
                }
                for (c = i[START_CONTAINER], p = c.parentNode; p; c = p, p = p.parentNode) {
                    if (p == i[END_CONTAINER]) {
                        return _traverseCommonEndContainer(c, a)
                    } ++startContainerDepth
                }
                depthDiff = startContainerDepth - endContainerDepth;
                startNode = i[START_CONTAINER];
                while (depthDiff > 0) {
                    startNode = startNode.parentNode;
                    depthDiff--
                }
                endNode = i[END_CONTAINER];
                while (depthDiff < 0) {
                    endNode = endNode.parentNode;
                    depthDiff++
                }
                for (sp = startNode.parentNode, ep = endNode.parentNode; sp != ep; sp = sp.parentNode, ep = ep.parentNode) {
                    startNode = sp;
                    endNode = ep
                }
                return _traverseCommonAncestors(startNode, endNode, a)
            }
            function _traverseSameContainer(a) {
                var b, s, sub, n, cnt, sibling, xferNode, start, len;
                if (a != DELETE) {
                    b = createDocumentFragment()
                }
                if (i[START_OFFSET] == i[END_OFFSET]) {
                    return b
                }
                if (i[START_CONTAINER].nodeType == 3) {
                    s = i[START_CONTAINER].nodeValue;
                    sub = s.substring(i[START_OFFSET], i[END_OFFSET]);
                    if (a != CLONE) {
                        n = i[START_CONTAINER];
                        start = i[START_OFFSET];
                        len = i[END_OFFSET] - i[START_OFFSET];
                        if (start === 0 && len >= n.nodeValue.length - 1) {
                            n.parentNode.removeChild(n)
                        } else {
                            n.deleteData(start, len)
                        }
                        i.collapse(TRUE)
                    }
                    if (a == DELETE) {
                        return
                    }
                    if (sub.length > 0) {
                        b.appendChild(doc.createTextNode(sub))
                    }
                    return b
                }
                n = _getSelectedNode(i[START_CONTAINER], i[START_OFFSET]);
                cnt = i[END_OFFSET] - i[START_OFFSET];
                while (n && cnt > 0) {
                    sibling = n.nextSibling;
                    xferNode = _traverseFullySelected(n, a);
                    if (b) {
                        b.appendChild(xferNode)
                    } --cnt;
                    n = sibling
                }
                if (a != CLONE) {
                    i.collapse(TRUE)
                }
                return b
            }
            function _traverseCommonStartContainer(a, b) {
                var c, n, endIdx, cnt, sibling, xferNode;
                if (b != DELETE) {
                    c = createDocumentFragment()
                }
                n = _traverseRightBoundary(a, b);
                if (c) {
                    c.appendChild(n)
                }
                endIdx = nodeIndex(a);
                cnt = endIdx - i[START_OFFSET];
                if (cnt <= 0) {
                    if (b != CLONE) {
                        i.setEndBefore(a);
                        i.collapse(FALSE)
                    }
                    return c
                }
                n = a.previousSibling;
                while (cnt > 0) {
                    sibling = n.previousSibling;
                    xferNode = _traverseFullySelected(n, b);
                    if (c) {
                        c.insertBefore(xferNode, c.firstChild)
                    } --cnt;
                    n = sibling
                }
                if (b != CLONE) {
                    i.setEndBefore(a);
                    i.collapse(FALSE)
                }
                return c
            }
            function _traverseCommonEndContainer(a, b) {
                var c, startIdx, n, cnt, sibling, xferNode;
                if (b != DELETE) {
                    c = createDocumentFragment()
                }
                n = _traverseLeftBoundary(a, b);
                if (c) {
                    c.appendChild(n)
                }
                startIdx = nodeIndex(a);
                ++startIdx;
                cnt = i[END_OFFSET] - startIdx;
                n = a.nextSibling;
                while (n && cnt > 0) {
                    sibling = n.nextSibling;
                    xferNode = _traverseFullySelected(n, b);
                    if (c) {
                        c.appendChild(xferNode)
                    } --cnt;
                    n = sibling
                }
                if (b != CLONE) {
                    i.setStartAfter(a);
                    i.collapse(TRUE)
                }
                return c
            }
            function _traverseCommonAncestors(a, b, c) {
                var n, frag, startOffset, endOffset, cnt, sibling, nextSibling;
                if (c != DELETE) {
                    frag = createDocumentFragment()
                }
                n = _traverseLeftBoundary(a, c);
                if (frag) {
                    frag.appendChild(n)
                }
                startOffset = nodeIndex(a);
                endOffset = nodeIndex(b);
                ++startOffset;
                cnt = endOffset - startOffset;
                sibling = a.nextSibling;
                while (cnt > 0) {
                    nextSibling = sibling.nextSibling;
                    n = _traverseFullySelected(sibling, c);
                    if (frag) {
                        frag.appendChild(n)
                    }
                    sibling = nextSibling;
                    --cnt
                }
                n = _traverseRightBoundary(b, c);
                if (frag) {
                    frag.appendChild(n)
                }
                if (c != CLONE) {
                    i.setStartAfter(a);
                    i.collapse(TRUE)
                }
                return frag
            }
            function _traverseRightBoundary(a, b) {
                var c = _getSelectedNode(i[END_CONTAINER], i[END_OFFSET] - 1),
                    parent, clonedParent;
                var d, clonedChild, clonedGrandParent, isFullySelected = c != i[END_CONTAINER];
                if (c == a) {
                    return _traverseNode(c, isFullySelected, FALSE, b)
                }
                parent = c.parentNode;
                clonedParent = _traverseNode(parent, FALSE, FALSE, b);
                while (parent) {
                    while (c) {
                        d = c.previousSibling;
                        clonedChild = _traverseNode(c, isFullySelected, FALSE, b);
                        if (b != DELETE) {
                            clonedParent.insertBefore(clonedChild, clonedParent.firstChild)
                        }
                        isFullySelected = TRUE;
                        c = d
                    }
                    if (parent == a) {
                        return clonedParent
                    }
                    c = parent.previousSibling;
                    parent = parent.parentNode;
                    clonedGrandParent = _traverseNode(parent, FALSE, FALSE, b);
                    if (b != DELETE) {
                        clonedGrandParent.appendChild(clonedParent)
                    }
                    clonedParent = clonedGrandParent
                }
            }
            function _traverseLeftBoundary(a, b) {
                var c = _getSelectedNode(i[START_CONTAINER], i[START_OFFSET]),
                    isFullySelected = c != i[START_CONTAINER];
                var d, clonedParent, nextSibling, clonedChild, clonedGrandParent;
                if (c == a) {
                    return _traverseNode(c, isFullySelected, TRUE, b)
                }
                d = c.parentNode;
                clonedParent = _traverseNode(d, FALSE, TRUE, b);
                while (d) {
                    while (c) {
                        nextSibling = c.nextSibling;
                        clonedChild = _traverseNode(c, isFullySelected, TRUE, b);
                        if (b != DELETE) {
                            clonedParent.appendChild(clonedChild)
                        }
                        isFullySelected = TRUE;
                        c = nextSibling
                    }
                    if (d == a) {
                        return clonedParent
                    }
                    c = d.nextSibling;
                    d = d.parentNode;
                    clonedGrandParent = _traverseNode(d, FALSE, TRUE, b);
                    if (b != DELETE) {
                        clonedGrandParent.appendChild(clonedParent)
                    }
                    clonedParent = clonedGrandParent
                }
            }
            function _traverseNode(n, a, b, c) {
                var d, newNodeValue, oldNodeValue, offset, newNode;
                if (a) {
                    return _traverseFullySelected(n, c)
                }
                if (n.nodeType == 3) {
                    d = n.nodeValue;
                    if (b) {
                        offset = i[START_OFFSET];
                        newNodeValue = d.substring(offset);
                        oldNodeValue = d.substring(0, offset)
                    } else {
                        offset = i[END_OFFSET];
                        newNodeValue = d.substring(0, offset);
                        oldNodeValue = d.substring(offset)
                    }
                    if (c != CLONE) {
                        n.nodeValue = oldNodeValue
                    }
                    if (c == DELETE) {
                        return
                    }
                    newNode = g.clone(n, FALSE);
                    newNode.nodeValue = newNodeValue;
                    return newNode
                }
                if (c == DELETE) {
                    return
                }
                return g.clone(n, FALSE)
            }
            function _traverseFullySelected(n, a) {
                if (a != DELETE) {
                    return a == CLONE ? g.clone(n, TRUE) : n
                }
                n.parentNode.removeChild(n)
            }
            function toStringIE() {
                return g.create('body', null, cloneContents()).outerText
            }
            extend(i, {
                startContainer: doc,
                startOffset: 0,
                endContainer: doc,
                endOffset: 0,
                collapsed: TRUE,
                commonAncestorContainer: doc,
                START_TO_START: 0,
                START_TO_END: 1,
                END_TO_END: 2,
                END_TO_START: 3,
                setStart: setStart,
                setEnd: setEnd,
                setStartBefore: setStartBefore,
                setStartAfter: setStartAfter,
                setEndBefore: setEndBefore,
                setEndAfter: setEndAfter,
                collapse: collapse,
                selectNode: selectNode,
                selectNodeContents: selectNodeContents,
                compareBoundaryPoints: compareBoundaryPoints,
                deleteContents: deleteContents,
                extractContents: extractContents,
                cloneContents: cloneContents,
                insertNode: insertNode,
                surroundContents: surroundContents,
                cloneRange: cloneRange,
                toStringIE: toStringIE
            });
            return i
        }
        Range.prototype.toString = function () {
            return this.toStringIE()
        };
        return Range
    });
    define("tinymce/html/Entities", ["tinymce/util/Tools"], function (f) {
        var g = f.makeMap;
        var h, baseEntities, reverseEntities, attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
            textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
            rawCharsRegExp = /[<>&\"\']/g,
            entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi,
            asciiMap = {
                128: "\u20AC", 130: "\u201A", 131: "\u0192", 132: "\u201E", 133: "\u2026", 134: "\u2020",
                135: "\u2021", 136: "\u02C6", 137: "\u2030", 138: "\u0160", 139: "\u2039", 140: "\u0152",
                142: "\u017D", 145: "\u2018", 146: "\u2019", 147: "\u201C", 148: "\u201D", 149: "\u2022",
                150: "\u2013", 151: "\u2014", 152: "\u02DC", 153: "\u2122", 154: "\u0161", 155: "\u203A",
                156: "\u0153", 158: "\u017E", 159: "\u0178"
            };
        baseEntities = {
            '\"': '&quot;',
            "'": '&#39;',
            '<': '&lt;',
            '>': '&gt;',
            '&': '&amp;',
            '\u0060': '&#96;'
        };
        reverseEntities = {
            '&lt;': '<',
            '&gt;': '>',
            '&amp;': '&',
            '&quot;': '"',
            '&apos;': "'"
        };

        function nativeDecode(a) {
            var b;
            b = document.createElement("div");
            b.innerHTML = a;
            return b.textContent || b.innerText || a
        }
        function buildEntitiesLookup(a, b) {
            var i, chr, entity, lookup = {};
            if (a) {
                a = a.split(',');
                b = b || 10;
                for (i = 0; i < a.length; i += 2) {
                    chr = String.fromCharCode(parseInt(a[i], b));
                    if (!baseEntities[chr]) {
                        entity = '&' + a[i + 1] + ';';
                        lookup[chr] = entity;
                        lookup[entity] = chr
                    }
                }
                return lookup
            }
        }
        h = buildEntitiesLookup('50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' + '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' + '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' + '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' + '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' + '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' + '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' + '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' + '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' + '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' + 'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' + 'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' + 't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' + 'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' + 'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' + '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' + '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' + '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' + '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' + '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' + 'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' + 'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' + 'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' + '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' + '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
        var j = {
            encodeRaw: function (b, c) {
                return b.replace(c ? attrsCharsRegExp : textCharsRegExp, function (a) {
                    return baseEntities[a] || a
                })
            },
            encodeAllRaw: function (b) {
                return ('' + b).replace(rawCharsRegExp, function (a) {
                    return baseEntities[a] || a
                })
            },
            encodeNumeric: function (b, c) {
                return b.replace(c ? attrsCharsRegExp : textCharsRegExp, function (a) {
                    if (a.length > 1) {
                        return '&#' + (((a.charCodeAt(0) - 0xD800) * 0x400) + (a.charCodeAt(1) - 0xDC00) + 0x10000) + ';'
                    }
                    return baseEntities[a] || '&#' + a.charCodeAt(0) + ';'
                })
            },
            encodeNamed: function (b, c, d) {
                d = d || h;
                return b.replace(c ? attrsCharsRegExp : textCharsRegExp, function (a) {
                    return baseEntities[a] || d[a] || a
                })
            },
            getEncodeFunc: function (d, e) {
                e = buildEntitiesLookup(e) || h;

                function encodeNamedAndNumeric(b, c) {
                    return b.replace(c ? attrsCharsRegExp : textCharsRegExp, function (a) {
                        return baseEntities[a] || e[a] || '&#' + a.charCodeAt(0) + ';' || a
                    })
                }
                function encodeCustomNamed(a, b) {
                    return j.encodeNamed(a, b, e)
                }
                d = g(d.replace(/\+/g, ','));
                if (d.named && d.numeric) {
                    return encodeNamedAndNumeric
                }
                if (d.named) {
                    if (e) {
                        return encodeCustomNamed
                    }
                    return j.encodeNamed
                }
                if (d.numeric) {
                    return j.encodeNumeric
                }
                return j.encodeRaw
            },
            decode: function (c) {
                return c.replace(entityRegExp, function (a, b) {
                    if (b) {
                        if (b.charAt(0).toLowerCase() === 'x') {
                            b = parseInt(b.substr(1), 16)
                        } else {
                            b = parseInt(b, 10)
                        }
                        if (b > 0xFFFF) {
                            b -= 0x10000;
                            return String.fromCharCode(0xD800 + (b >> 10), 0xDC00 + (b & 0x3FF))
                        }
                        return asciiMap[b] || String.fromCharCode(b)
                    }
                    return reverseEntities[a] || h[a] || nativeDecode(a)
                })
            }
        };
        return j
    });
    define("tinymce/dom/StyleSheetLoader", ["tinymce/util/Tools", "tinymce/util/Delay"], function (k, l) {
        "use strict";
        return function (g, h) {
            var j = 0,
                loadedStates = {},
                maxLoadTime;
            h = h || {};
            maxLoadTime = h.maxLoadTime || 5000;

            function appendToHead(a) {
                g.getElementsByTagName('head')[0].appendChild(a)
            }
            function load(c, d, e) {
                var f, style, startTime, state;

                function passed() {
                    var a = state.passed,
                        i = a.length;
                    while (i--) {
                        a[i]()
                    }
                    state.status = 2;
                    state.passed = [];
                    state.failed = []
                }
                function failed() {
                    var a = state.failed,
                        i = a.length;
                    while (i--) {
                        a[i]()
                    }
                    state.status = 3;
                    state.passed = [];
                    state.failed = []
                }
                function isOldWebKit() {
                    var a = navigator.userAgent.match(/WebKit\/(\d*)/);
                    return !!(a && a[1] < 536)
                }
                function wait(a, b) {
                    if (!a()) {
                        if ((new Date().getTime()) - startTime < maxLoadTime) {
                            l.setTimeout(b)
                        } else {
                            failed()
                        }
                    }
                }
                function waitForWebKitLinkLoaded() {
                    wait(function () {
                        var a = g.styleSheets,
                            styleSheet, i = a.length,
                            owner;
                        while (i--) {
                            styleSheet = a[i];
                            owner = styleSheet.ownerNode ? styleSheet.ownerNode : styleSheet.owningElement;
                            if (owner && owner.id === f.id) {
                                passed();
                                return true
                            }
                        }
                    }, waitForWebKitLinkLoaded)
                }
                function waitForGeckoLinkLoaded() {
                    wait(function () {
                        try {
                            var a = style.sheet.cssRules;
                            passed();
                            return !!a
                        } catch (ex) { }
                    }, waitForGeckoLinkLoaded)
                }
                c = k._addCacheSuffix(c);
                if (!loadedStates[c]) {
                    state = {
                        passed: [],
                        failed: []
                    };
                    loadedStates[c] = state
                } else {
                    state = loadedStates[c]
                }
                if (d) {
                    state.passed.push(d)
                }
                if (e) {
                    state.failed.push(e)
                }
                if (state.status == 1) {
                    return
                }
                if (state.status == 2) {
                    passed();
                    return
                }
                if (state.status == 3) {
                    failed();
                    return
                }
                state.status = 1;
                f = g.createElement('link');
                f.rel = 'stylesheet';
                f.type = 'text/css';
                f.id = 'u' + (j++);
                f.async = false;
                f.defer = false;
                startTime = new Date().getTime();
                if ("onload" in f && !isOldWebKit()) {
                    f.onload = waitForWebKitLinkLoaded;
                    f.onerror = failed
                } else {
                    if (navigator.userAgent.indexOf("Firefox") > 0) {
                        style = g.createElement('style');
                        style.textContent = '@import "' + c + '"';
                        waitForGeckoLinkLoaded();
                        appendToHead(style);
                        return
                    }
                    waitForWebKitLinkLoaded()
                }
                appendToHead(f);
                f.href = c
            }
            this.load = load
        }
    });
    define("tinymce/dom/DOMUtils", ["tinymce/dom/Sizzle", "tinymce/dom/DomQuery", "tinymce/html/Styles", "tinymce/dom/EventUtils", "tinymce/dom/TreeWalker", "tinymce/dom/Range", "tinymce/html/Entities", "tinymce/Env", "tinymce/util/Tools", "tinymce/dom/StyleSheetLoader"], function (k, $, l, m, n, o, p, q, s, t) {
        var u = s.each,
            is = s.is,
            grep = s.grep,
            trim = s.trim;
        var v = q.ie;
        var z = /^([a-z0-9],?)+$/i;
        var A = /^[ \t\r\n]*$/;

        function setupAttrHooks(d, e) {
            var f = {},
                keepValues = e.keep_values,
                keepUrlHook;
            keepUrlHook = {
                set: function (a, b, c) {
                    if (e.url_converter) {
                        b = e.url_converter.call(e.url_converter_scope || d, b, c, a[0])
                    }
                    a.attr('data-mce-' + c, b).attr(c, b)
                },
                get: function (a, b) {
                    return a.attr('data-mce-' + b) || a.attr(b)
                }
            };
            f = {
                style: {
                    set: function (a, b) {
                        if (b !== null && typeof b === 'object') {
                            a.css(b);
                            return
                        }
                        if (keepValues) {
                            a.attr('data-mce-style', b)
                        }
                        a.attr('style', b)
                    },
                    get: function (a) {
                        var b = a.attr('data-mce-style') || a.attr('style');
                        b = d.serializeStyle(d.parseStyle(b), a[0].nodeName);
                        return b
                    }
                }
            };
            if (keepValues) {
                f.href = f.src = keepUrlHook
            }
            return f
        }
        function updateInternalStyleAttr(a, b) {
            var c = b.attr('style');
            c = a.serializeStyle(a.parseStyle(c), b[0].nodeName);
            if (!c) {
                c = null
            }
            b.attr('data-mce-style', c)
        }
        function nodeIndex(a, b) {
            var c = 0,
                lastNodeType, nodeType;
            if (a) {
                for (lastNodeType = a.nodeType, a = a.previousSibling; a; a = a.previousSibling) {
                    nodeType = a.nodeType;
                    if (b && nodeType == 3) {
                        if (nodeType == lastNodeType || !a.nodeValue.length) {
                            continue
                        }
                    }
                    c++;
                    lastNodeType = nodeType
                }
            }
            return c
        }
        function DOMUtils(c, d) {
            var e = this,
                blockElementsMap;
            e.doc = c;
            e.win = window;
            e.files = {};
            e.counter = 0;
            e.stdMode = !v || c.documentMode >= 8;
            e.boxModel = !v || c.compatMode == "CSS1Compat" || e.stdMode;
            e.styleSheetLoader = new t(c);
            e.boundEvents = [];
            e.settings = d = d || {};
            e.schema = d.schema;
            e.styles = new l({
                url_converter: d.url_converter,
                url_converter_scope: d.url_converter_scope
            }, d.schema);
            e.fixDoc(c);
            e.events = d.ownEvents ? new m(d.proxy) : m.Event;
            e.attrHooks = setupAttrHooks(e, d);
            blockElementsMap = d.schema ? d.schema.getBlockElements() : {};
            e.$ = $.overrideDefaults(function () {
                return {
                    context: c,
                    element: e.getRoot()
                }
            });
            e.isBlock = function (a) {
                if (!a) {
                    return false
                }
                var b = a.nodeType;
                if (b) {
                    return !!(b === 1 && blockElementsMap[a.nodeName])
                }
                return !!blockElementsMap[a]
            }
        }
        DOMUtils.prototype = {
            $$: function (a) {
                if (typeof a == 'string') {
                    a = this.get(a)
                }
                return this.$(a)
            },
            root: null,
            fixDoc: function (b) {
                var c = this.settings,
                    name;
                if (v && c.schema) {
                    ('abbr article aside audio canvas ' + 'details figcaption figure footer ' + 'header hgroup mark menu meter nav ' + 'output progress section summary ' + 'time video').replace(/\w+/g, function (a) {
                        b.createElement(a)
                    });
                    for (name in c.schema.getCustomElements()) {
                        b.createElement(name)
                    }
                }
            },
            clone: function (b, c) {
                var d = this,
                    clone, doc;
                if (!v || b.nodeType !== 1 || c) {
                    return b.cloneNode(c)
                }
                doc = d.doc;
                if (!c) {
                    clone = doc.createElement(b.nodeName);
                    u(d.getAttribs(b), function (a) {
                        d.setAttrib(clone, a.nodeName, d.getAttrib(b, a.nodeName))
                    });
                    return clone
                }
                return clone.firstChild
            },
            getRoot: function () {
                var a = this;
                return a.settings.root_element || a.doc.body
            },
            getViewPort: function (a) {
                var b, rootElm;
                a = !a ? this.win : a;
                b = a.document;
                rootElm = this.boxModel ? b.documentElement : b.body;
                return {
                    x: a.pageXOffset || rootElm.scrollLeft,
                    y: a.pageYOffset || rootElm.scrollTop,
                    w: a.innerWidth || rootElm.clientWidth,
                    h: a.innerHeight || rootElm.clientHeight
                }
            },
            getRect: function (a) {
                var b = this,
                    pos, size;
                a = b.get(a);
                pos = b.getPos(a);
                size = b.getSize(a);
                return {
                    x: pos.x,
                    y: pos.y,
                    w: size.w,
                    h: size.h
                }
            },
            getSize: function (a) {
                var b = this,
                    w, h;
                a = b.get(a);
                w = b.getStyle(a, 'width');
                h = b.getStyle(a, 'height');
                if (w.indexOf('px') === -1) {
                    w = 0
                }
                if (h.indexOf('px') === -1) {
                    h = 0
                }
                return {
                    w: parseInt(w, 10) || a.offsetWidth || a.clientWidth,
                    h: parseInt(h, 10) || a.offsetHeight || a.clientHeight
                }
            },
            getParent: function (a, b, c) {
                return this.getParents(a, b, c, false)
            },
            getParents: function (b, c, d, e) {
                var f = this,
                    selectorVal, result = [];
                b = f.get(b);
                e = e === Y;
                d = d || (f.getRoot().nodeName != 'BODY' ? f.getRoot().parentNode : null);
                if (is(c, 'string')) {
                    selectorVal = c;
                    if (c === '*') {
                        c = function (a) {
                            return a.nodeType == 1
                        }
                    } else {
                        c = function (a) {
                            return f.is(a, selectorVal)
                        }
                    }
                }
                while (b) {
                    if (b == d || !b.nodeType || b.nodeType === 9) {
                        break
                    }
                    if (!c || c(b)) {
                        if (e) {
                            result.push(b)
                        } else {
                            return b
                        }
                    }
                    b = b.parentNode
                }
                return e ? result : null
            },
            get: function (a) {
                var b;
                if (a && this.doc && typeof a == 'string') {
                    b = a;
                    a = this.doc.getElementById(a);
                    if (a && a.id !== b) {
                        return this.doc.getElementsByName(b)[1]
                    }
                }
                return a
            },
            getNext: function (a, b) {
                return this._findSib(a, b, 'nextSibling')
            },
            getPrev: function (a, b) {
                return this._findSib(a, b, 'previousSibling')
            },
            select: function (a, b) {
                var c = this;
                return k(a, c.get(b) || c.settings.root_element || c.doc, [])
            },
            is: function (a, b) {
                var i;
                if (a.length === Y) {
                    if (b === '*') {
                        return a.nodeType == 1
                    }
                    if (z.test(b)) {
                        b = b.toLowerCase().split(/,/);
                        a = a.nodeName.toLowerCase();
                        for (i = b.length - 1; i >= 0; i--) {
                            if (b[i] == a) {
                                return true
                            }
                        }
                        return false
                    }
                }
                if (a.nodeType && a.nodeType != 1) {
                    return false
                }
                var c = a.nodeType ? [a] : a;
                return k(b, c[0].ownerDocument || c[0], null, c).length > 0
            },
            add: function (c, d, e, f, g) {
                var h = this;
                return this.run(c, function (a) {
                    var b;
                    b = is(d, 'string') ? h.doc.createElement(d) : d;
                    h.setAttribs(b, e);
                    if (f) {
                        if (f.nodeType) {
                            b.appendChild(f)
                        } else {
                            h.setHTML(b, f)
                        }
                    }
                    return !g ? a.appendChild(b) : b
                })
            },
            create: function (a, b, c) {
                return this.add(this.doc.createElement(a), a, b, c, 1)
            },
            createHTML: function (a, b, c) {
                var d = '',
                    key;
                d += '<' + a;
                for (key in b) {
                    if (b.hasOwnProperty(key) && b[key] !== null && typeof b[key] != 'undefined') {
                        d += ' ' + key + '="' + this.encode(b[key]) + '"'
                    }
                }
                if (typeof c != "undefined") {
                    return d + '>' + c + '</' + a + '>'
                }
                return d + ' />'
            },
            createFragment: function (a) {
                var b, node, doc = this.doc,
                    container;
                container = doc.createElement("div");
                b = doc.createDocumentFragment();
                if (a) {
                    container.innerHTML = a
                }
                while ((node = container.firstChild)) {
                    b.appendChild(node)
                }
                return b
            },
            remove: function (b, c) {
                b = this.$$(b);
                if (c) {
                    b.each(function () {
                        var a;
                        while ((a = this.firstChild)) {
                            if (a.nodeType == 3 && a.data.length === 0) {
                                this.removeChild(a)
                            } else {
                                this.parentNode.insertBefore(a, this)
                            }
                        }
                    }).remove()
                } else {
                    b.remove()
                }
                return b.length > 1 ? b.toArray() : b[0]
            },
            setStyle: function (a, b, c) {
                a = this.$$(a).css(b, c);
                if (this.settings.update_styles) {
                    updateInternalStyleAttr(this, a)
                }
            },
            getStyle: function (c, d, e) {
                c = this.$$(c);
                if (e) {
                    return c.css(d)
                }
                d = d.replace(/-(\D)/g, function (a, b) {
                    return b.toUpperCase()
                });
                if (d == 'float') {
                    d = q.ie && q.ie < 12 ? 'styleFloat' : 'cssFloat'
                }
                return c[0] && c[0].style ? c[0].style[d] : Y
            },
            setStyles: function (a, b) {
                a = this.$$(a).css(b);
                if (this.settings.update_styles) {
                    updateInternalStyleAttr(this, a)
                }
            },
            removeAllAttribs: function (e) {
                return this.run(e, function (e) {
                    var i, attrs = e.attributes;
                    for (i = attrs.length - 1; i >= 0; i--) {
                        e.removeAttributeNode(attrs.item(i))
                    }
                })
            },
            setAttrib: function (a, b, c) {
                var d = this,
                    originalValue, hook, settings = d.settings;
                if (c === '') {
                    c = null
                }
                a = d.$$(a);
                originalValue = a.attr(b);
                if (!a.length) {
                    return
                }
                hook = d.attrHooks[b];
                if (hook && hook.set) {
                    hook.set(a, c, b)
                } else {
                    a.attr(b, c)
                }
                if (originalValue != c && settings.onSetAttrib) {
                    settings.onSetAttrib({
                        attrElm: a,
                        attrName: b,
                        attrValue: c
                    })
                }
            },
            setAttribs: function (d, e) {
                var f = this;
                f.$$(d).each(function (i, c) {
                    u(e, function (a, b) {
                        f.setAttrib(c, b, a)
                    })
                })
            },
            getAttrib: function (a, b, c) {
                var d = this,
                    hook, value;
                a = d.$$(a);
                if (a.length) {
                    hook = d.attrHooks[b];
                    if (hook && hook.get) {
                        value = hook.get(a, b)
                    } else {
                        value = a.attr(b)
                    }
                }
                if (typeof value == 'undefined') {
                    value = c || ''
                }
                return value
            },
            getPos: function (a, b) {
                var c = this,
                    x = 0,
                    y = 0,
                    offsetParent, doc = c.doc,
                    body = doc.body,
                    pos;
                a = c.get(a);
                b = b || body;
                if (a) {
                    if (b === body && a.getBoundingClientRect && $(body).css('position') === 'static') {
                        pos = a.getBoundingClientRect();
                        b = c.boxModel ? doc.documentElement : body;
                        x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - b.clientLeft;
                        y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - b.clientTop;
                        return {
                            x: x,
                            y: y
                        }
                    }
                    offsetParent = a;
                    while (offsetParent && offsetParent != b && offsetParent.nodeType) {
                        x += offsetParent.offsetLeft || 0;
                        y += offsetParent.offsetTop || 0;
                        offsetParent = offsetParent.offsetParent
                    }
                    offsetParent = a.parentNode;
                    while (offsetParent && offsetParent != b && offsetParent.nodeType) {
                        x -= offsetParent.scrollLeft || 0;
                        y -= offsetParent.scrollTop || 0;
                        offsetParent = offsetParent.parentNode
                    }
                }
                return {
                    x: x,
                    y: y
                }
            },
            parseStyle: function (a) {
                return this.styles.parse(a)
            },
            serializeStyle: function (a, b) {
                return this.styles.serialize(a, b)
            },
            addStyle: function (a) {
                var b = this,
                    doc = b.doc,
                    head, styleElm;
                if (b !== DOMUtils.DOM && doc === document) {
                    var c = DOMUtils.DOM.addedStyles;
                    c = c || [];
                    if (c[a]) {
                        return
                    }
                    c[a] = true;
                    DOMUtils.DOM.addedStyles = c
                }
                styleElm = doc.getElementById('mceDefaultStyles');
                if (!styleElm) {
                    styleElm = doc.createElement('style');
                    styleElm.id = 'mceDefaultStyles';
                    styleElm.type = 'text/css';
                    head = doc.getElementsByTagName('head')[0];
                    if (head.firstChild) {
                        head.insertBefore(styleElm, head.firstChild)
                    } else {
                        head.appendChild(styleElm)
                    }
                }
                if (styleElm.styleSheet) {
                    styleElm.styleSheet.cssText += a
                } else {
                    styleElm.appendChild(doc.createTextNode(a))
                }
            },
            loadCSS: function (c) {
                var d = this,
                    doc = d.doc,
                    head;
                if (d !== DOMUtils.DOM && doc === document) {
                    DOMUtils.DOM.loadCSS(c);
                    return
                }
                if (!c) {
                    c = ''
                }
                head = doc.getElementsByTagName('head')[0];
                u(c.split(','), function (a) {
                    var b;
                    a = s._addCacheSuffix(a);
                    if (d.files[a]) {
                        return
                    }
                    d.files[a] = true;
                    b = d.create('link', {
                        rel: 'stylesheet',
                        href: a
                    });
                    if (v && doc.documentMode && doc.recalc) {
                        b.onload = function () {
                            if (doc.recalc) {
                                doc.recalc()
                            }
                            b.onload = null
                        }
                    }
                    head.appendChild(b)
                })
            },
            addClass: function (a, b) {
                this.$$(a).addClass(b)
            },
            removeClass: function (a, b) {
                this.toggleClass(a, b, false)
            },
            hasClass: function (a, b) {
                return this.$$(a).hasClass(b)
            },
            toggleClass: function (a, b, c) {
                this.$$(a).toggleClass(b, c).each(function () {
                    if (this.className === '') {
                        $(this).attr('class', null)
                    }
                })
            },
            show: function (a) {
                this.$$(a).show()
            },
            hide: function (a) {
                this.$$(a).hide()
            },
            isHidden: function (a) {
                return this.$$(a).css('display') == 'none'
            },
            uniqueId: function (a) {
                return (!a ? 'mce_' : a) + (this.counter++)
            },
            setHTML: function (b, c) {
                b = this.$$(b);
                if (v) {
                    b.each(function (i, a) {
                        if (a.canHaveHTML === false) {
                            return
                        }
                        while (a.firstChild) {
                            a.removeChild(a.firstChild)
                        }
                        try {
                            a.innerHTML = '<br>' + c;
                            a.removeChild(a.firstChild)
                        } catch (ex) {
                            $('<div>').html('<br>' + c).contents().slice(1).appendTo(a)
                        }
                        return c
                    })
                } else {
                    b.html(c)
                }
            },
            getOuterHTML: function (a) {
                a = this.get(a);
                return a.nodeType == 1 && "outerHTML" in a ? a.outerHTML : $('<div>').append($(a).clone()).html()
            },
            setOuterHTML: function (a, b) {
                var c = this;
                c.$$(a).each(function () {
                    try {
                        if ("outerHTML" in this) {
                            this.outerHTML = b;
                            return
                        }
                    } catch (ex) { }
                    c.remove($(this).html(b), true)
                })
            },
            decode: p.decode,
            encode: p.encodeAllRaw,
            insertAfter: function (c, d) {
                d = this.get(d);
                return this.run(c, function (a) {
                    var b, nextSibling;
                    b = d.parentNode;
                    nextSibling = d.nextSibling;
                    if (nextSibling) {
                        b.insertBefore(a, nextSibling)
                    } else {
                        b.appendChild(a)
                    }
                    return a
                })
            },
            replace: function (c, d, e) {
                var f = this;
                return f.run(d, function (b) {
                    if (is(b, 'array')) {
                        c = c.cloneNode(true)
                    }
                    if (e) {
                        u(grep(b.childNodes), function (a) {
                            c.appendChild(a)
                        })
                    }
                    return b.parentNode.replaceChild(c, b)
                })
            },
            rename: function (b, c) {
                var d = this,
                    newElm;
                if (b.nodeName != c.toUpperCase()) {
                    newElm = d.create(c);
                    u(d.getAttribs(b), function (a) {
                        d.setAttrib(newElm, a.nodeName, d.getAttrib(b, a.nodeName))
                    });
                    d.replace(newElm, b, 1)
                }
                return newElm || b
            },
            findCommonAncestor: function (a, b) {
                var c = a,
                    pe;
                while (c) {
                    pe = b;
                    while (pe && c != pe) {
                        pe = pe.parentNode
                    }
                    if (c == pe) {
                        break
                    }
                    c = c.parentNode
                }
                if (!c && a.ownerDocument) {
                    return a.ownerDocument.documentElement
                }
                return c
            },
            toHex: function (a) {
                return this.styles.toHex(s.trim(a))
            },
            run: function (b, c, d) {
                var e = this,
                    result;
                if (typeof b === 'string') {
                    b = e.get(b)
                }
                if (!b) {
                    return false
                }
                d = d || this;
                if (!b.nodeType && (b.length || b.length === 0)) {
                    result = [];
                    u(b, function (a, i) {
                        if (a) {
                            if (typeof a == 'string') {
                                a = e.get(a)
                            }
                            result.push(c.call(d, a, i))
                        }
                    });
                    return result
                }
                return c.call(d, b)
            },
            getAttribs: function (b) {
                var c;
                b = this.get(b);
                if (!b) {
                    return []
                }
                if (v) {
                    c = [];
                    if (b.nodeName == 'OBJECT') {
                        return b.attributes
                    }
                    if (b.nodeName === 'OPTION' && this.getAttrib(b, 'selected')) {
                        c.push({
                            specified: 1,
                            nodeName: 'selected'
                        })
                    }
                    var d = /<\/?[\w:\-]+ ?|=[\"][^\"]+\"|=\'[^\']+\'|=[\w\-]+|>/gi;
                    b.cloneNode(false).outerHTML.replace(d, '').replace(/[\w:\-]+/gi, function (a) {
                        c.push({
                            specified: 1,
                            nodeName: a
                        })
                    });
                    return c
                }
                return b.attributes
            },
            isEmpty: function (a, b) {
                var c = this,
                    i, attributes, type, walker, name, brCount = 0;
                a = a.firstChild;
                if (a) {
                    walker = new n(a, a.parentNode);
                    b = b || (c.schema ? c.schema.getNonEmptyElements() : null);
                    do {
                        type = a.nodeType;
                        if (type === 1) {
                            if (a.getAttribute('data-mce-bogus')) {
                                continue
                            }
                            name = a.nodeName.toLowerCase();
                            if (b && b[name]) {
                                if (name === 'br') {
                                    brCount++;
                                    continue
                                }
                                return false
                            }
                            attributes = c.getAttribs(a);
                            i = attributes.length;
                            while (i--) {
                                name = attributes[i].nodeName;
                                if (name === "name" || name === 'data-mce-bookmark') {
                                    return false
                                }
                            }
                        }
                        if (type == 8) {
                            return false
                        }
                        if ((type === 3 && !A.test(a.nodeValue))) {
                            return false
                        }
                    } while ((a = walker.next()))
                }
                return brCount <= 1
            },
            createRng: function () {
                var a = this.doc;
                return a.createRange ? a.createRange() : new o(this)
            },
            nodeIndex: nodeIndex,
            split: function (f, g, h) {
                var j = this,
                    r = j.createRng(),
                    bef, aft, pa;

                function trimNode(d) {
                    var i, children = d.childNodes,
                        type = d.nodeType;

                    function surroundedBySpans(a) {
                        var b = a.previousSibling && a.previousSibling.nodeName == 'SPAN';
                        var c = a.nextSibling && a.nextSibling.nodeName == 'SPAN';
                        return b && c
                    }
                    if (type == 1 && d.getAttribute('data-mce-type') == 'bookmark') {
                        return
                    }
                    for (i = children.length - 1; i >= 0; i--) {
                        trimNode(children[i])
                    }
                    if (type != 9) {
                        if (type == 3 && d.nodeValue.length > 0) {
                            var e = trim(d.nodeValue).length;
                            if (!j.isBlock(d.parentNode) || e > 0 || e === 0 && surroundedBySpans(d)) {
                                return
                            }
                        } else if (type == 1) {
                            children = d.childNodes;
                            if (children.length == 1 && children[0] && children[0].nodeType == 1 && children[0].getAttribute('data-mce-type') == 'bookmark') {
                                d.parentNode.insertBefore(children[0], d)
                            }
                            if (children.length || /^(br|hr|input|img)$/i.test(d.nodeName)) {
                                return
                            }
                        }
                        j.remove(d)
                    }
                    return d
                }
                if (f && g) {
                    r.setStart(f.parentNode, j.nodeIndex(f));
                    r.setEnd(g.parentNode, j.nodeIndex(g));
                    bef = r.extractContents();
                    r = j.createRng();
                    r.setStart(g.parentNode, j.nodeIndex(g) + 1);
                    r.setEnd(f.parentNode, j.nodeIndex(f) + 1);
                    aft = r.extractContents();
                    pa = f.parentNode;
                    pa.insertBefore(trimNode(bef), f);
                    if (h) {
                        pa.insertBefore(h, f)
                    } else {
                        pa.insertBefore(g, f)
                    }
                    pa.insertBefore(trimNode(aft), f);
                    j.remove(f);
                    return h || g
                }
            },
            bind: function (a, b, c, d) {
                var e = this;
                if (s.isArray(a)) {
                    var i = a.length;
                    while (i--) {
                        a[i] = e.bind(a[i], b, c, d)
                    }
                    return a
                }
                if (e.settings.collect && (a === e.doc || a === e.win)) {
                    e.boundEvents.push([a, b, c, d])
                }
                return e.events.bind(a, b, c, d || e)
            },
            unbind: function (a, b, c) {
                var d = this,
                    i;
                if (s.isArray(a)) {
                    i = a.length;
                    while (i--) {
                        a[i] = d.unbind(a[i], b, c)
                    }
                    return a
                }
                if (d.boundEvents && (a === d.doc || a === d.win)) {
                    i = d.boundEvents.length;
                    while (i--) {
                        var e = d.boundEvents[i];
                        if (a == e[0] && (!b || b == e[1]) && (!c || c == e[2])) {
                            this.events.unbind(e[0], e[1], e[2])
                        }
                    }
                }
                return this.events.unbind(a, b, c)
            },
            fire: function (a, b, c) {
                return this.events.fire(a, b, c)
            },
            getContentEditable: function (a) {
                var b;
                if (!a || a.nodeType != 1) {
                    return null
                }
                b = a.getAttribute("data-mce-contenteditable");
                if (b && b !== "inherit") {
                    return b
                }
                return a.contentEditable !== "inherit" ? a.contentEditable : null
            },
            getContentEditableParent: function (a) {
                var b = this.getRoot(),
                    state = null;
                for (; a && a !== b; a = a.parentNode) {
                    state = this.getContentEditable(a);
                    if (state !== null) {
                        break
                    }
                }
                return state
            },
            destroy: function () {
                var a = this;
                if (a.boundEvents) {
                    var i = a.boundEvents.length;
                    while (i--) {
                        var b = a.boundEvents[i];
                        this.events.unbind(b[0], b[1], b[2])
                    }
                    a.boundEvents = null
                }
                if (k.setDocument) {
                    k.setDocument()
                }
                a.win = a.doc = a.root = a.events = a.frag = null
            },
            isChildOf: function (a, b) {
                while (a) {
                    if (b === a) {
                        return true
                    }
                    a = a.parentNode
                }
                return false
            },
            dumpRng: function (r) {
                return ('startContainer: ' + r.startContainer.nodeName + ', startOffset: ' + r.startOffset + ', endContainer: ' + r.endContainer.nodeName + ', endOffset: ' + r.endOffset)
            },
            _findSib: function (b, c, d) {
                var e = this,
                    func = c;
                if (b) {
                    if (typeof func == 'string') {
                        func = function (a) {
                            return e.is(a, c)
                        }
                    }
                    for (b = b[d]; b; b = b[d]) {
                        if (func(b)) {
                            return b
                        }
                    }
                }
                return null
            }
        };
        DOMUtils.DOM = new DOMUtils(document);
        DOMUtils.nodeIndex = nodeIndex;
        return DOMUtils
    });
    define("tinymce/dom/ScriptLoader", ["tinymce/dom/DOMUtils", "tinymce/util/Tools"], function (h, i) {
        var j = h.DOM;
        var k = i.each,
            grep = i.grep;

        function ScriptLoader() {
            var g = 0,
                LOADING = 1,
                LOADED = 2,
                states = {},
                queue = [],
                scriptLoadedCallbacks = {},
                queueLoadedCallbacks = [],
                loading = 0,
                undef;

            function loadScript(a, b) {
                var c = j,
                    elm, id;

                function done() {
                    c.remove(id);
                    if (elm) {
                        elm.onreadystatechange = elm.onload = elm = null
                    }
                    b()
                }
                function error() {
                    if (typeof console !== "undefined" && console.log) {
                        console.log("Failed to load: " + a)
                    }
                }
                id = c.uniqueId();
                elm = document.createElement('script');
                elm.id = id;
                elm.type = 'text/javascript';
                elm.src = i._addCacheSuffix(a);
                if ("onreadystatechange" in elm) {
                    elm.onreadystatechange = function () {
                        if (/loaded|complete/.test(elm.readyState)) {
                            done()
                        }
                    }
                } else {
                    elm.onload = done
                }
                elm.onerror = error;
                (document.getElementsByTagName('head')[0] || document.body).appendChild(elm)
            }
            this.isDone = function (a) {
                return states[a] == LOADED
            };
            this.markDone = function (a) {
                states[a] = LOADED
            };
            this.add = this.load = function (a, b, c) {
                var d = states[a];
                if (d == undef) {
                    queue.push(a);
                    states[a] = g
                }
                if (b) {
                    if (!scriptLoadedCallbacks[a]) {
                        scriptLoadedCallbacks[a] = []
                    }
                    scriptLoadedCallbacks[a].push({
                        func: b,
                        scope: c || this
                    })
                }
            };
            this.remove = function (a) {
                delete states[a];
                delete scriptLoadedCallbacks[a]
            };
            this.loadQueue = function (a, b) {
                this.loadScripts(queue, a, b)
            };
            this.loadScripts = function (c, d, e) {
                var f;

                function execScriptLoadedCallbacks(b) {
                    k(scriptLoadedCallbacks[b], function (a) {
                        a.func.call(a.scope)
                    });
                    scriptLoadedCallbacks[b] = undef
                }
                queueLoadedCallbacks.push({
                    func: d,
                    scope: e || this
                });
                f = function () {
                    var b = grep(c);
                    c.length = 0;
                    k(b, function (a) {
                        if (states[a] == LOADED) {
                            execScriptLoadedCallbacks(a);
                            return
                        }
                        if (states[a] != LOADING) {
                            states[a] = LOADING;
                            loading++;
                            loadScript(a, function () {
                                states[a] = LOADED;
                                loading--;
                                execScriptLoadedCallbacks(a);
                                f()
                            })
                        }
                    });
                    if (!loading) {
                        k(queueLoadedCallbacks, function (a) {
                            a.func.call(a.scope)
                        });
                        queueLoadedCallbacks.length = 0
                    }
                };
                f()
            }
        }
        ScriptLoader.ScriptLoader = new ScriptLoader();
        return ScriptLoader
    });
    define("tinymce/AddOnManager", ["tinymce/dom/ScriptLoader", "tinymce/util/Tools"], function (i, j) {
        var k = j.each;

        function AddOnManager() {
            var a = this;
            a.items = [];
            a.urls = {};
            a.lookup = {}
        }
        AddOnManager.prototype = {
            get: function (a) {
                if (this.lookup[a]) {
                    return this.lookup[a].instance
                }
                return Y
            },
            dependencies: function (a) {
                var b;
                if (this.lookup[a]) {
                    b = this.lookup[a].dependencies
                }
                return b || []
            },
            requireLangPack: function (a, b) {
                var c = AddOnManager.language;
                if (c && AddOnManager.languageLoad !== false) {
                    if (b) {
                        b = ',' + b + ',';
                        if (b.indexOf(',' + c.substr(0, 2) + ',') != -1) {
                            c = c.substr(0, 2)
                        } else if (b.indexOf(',' + c + ',') == -1) {
                            return
                        }
                    }
                    i.ScriptLoader.add(this.urls[a] + '/langs/' + c + '.js')
                }
            },
            add: function (a, b, c) {
                this.items.push(b);
                this.lookup[a] = {
                    instance: b,
                    dependencies: c
                };
                return b
            },
            remove: function (a) {
                delete this.urls[a];
                delete this.lookup[a]
            },
            createUrl: function (a, b) {
                if (typeof b === "object") {
                    return b
                }
                return {
                    prefix: a.prefix,
                    resource: b,
                    suffix: a.suffix
                }
            },
            addComponents: function (b, c) {
                var d = this.urls[b];
                k(c, function (a) {
                    i.ScriptLoader.add(d + "/" + a)
                })
            },
            load: function (d, e, f, g) {
                var h = this,
                    url = e;

                function loadDependencies() {
                    var c = h.dependencies(d);
                    k(c, function (a) {
                        var b = h.createUrl(e, a);
                        h.load(b.resource, b, Y, Y)
                    });
                    if (f) {
                        if (g) {
                            f.call(g)
                        } else {
                            f.call(i)
                        }
                    }
                }
                if (h.urls[d]) {
                    return
                }
                if (typeof e === "object") {
                    url = e.prefix + e.resource + e.suffix
                }
                if (url.indexOf('/') !== 0 && url.indexOf('://') == -1) {
                    url = AddOnManager.baseURL + '/' + url
                }
                h.urls[d] = url.substring(0, url.lastIndexOf('/'));
                if (h.lookup[d]) {
                    loadDependencies()
                } else {
                    i.ScriptLoader.add(url, loadDependencies, g)
                }
            }
        };
        AddOnManager.PluginManager = new AddOnManager();
        AddOnManager.ThemeManager = new AddOnManager();
        return AddOnManager
    });
    define("tinymce/dom/NodeType", [], function () {
        function isNodeType(b) {
            return function (a) {
                return !!a && a.nodeType == b
            }
        }
        var d = isNodeType(1);

        function matchNodeNames(b) {
            b = b.toLowerCase().split(' ');
            return function (a) {
                var i, name;
                if (a && a.nodeType) {
                    name = a.nodeName.toLowerCase();
                    for (i = 0; i < b.length; i++) {
                        if (name === b[i]) {
                            return true
                        }
                    }
                }
                return false
            }
        }
        function matchStyleValues(b, c) {
            c = c.toLowerCase().split(' ');
            return function (a) {
                var i, cssValue;
                if (d(a)) {
                    for (i = 0; i < c.length; i++) {
                        cssValue = getComputedStyle(a, null).getPropertyValue(b);
                        if (cssValue === c[i]) {
                            return true
                        }
                    }
                }
                return false
            }
        }
        function hasPropValue(b, c) {
            return function (a) {
                return d(a) && a[b] === c
            }
        }
        function hasAttributeValue(b, c) {
            return function (a) {
                return d(a) && a.getAttribute(b) === c
            }
        }
        function isBogus(a) {
            return d(a) && a.hasAttribute('data-mce-bogus')
        }
        function hasContentEditableState(b) {
            return function (a) {
                if (d(a)) {
                    if (a.contentEditable === b) {
                        return true
                    }
                    if (a.getAttribute('data-mce-contenteditable') === b) {
                        return true
                    }
                }
                return false
            }
        }
        return {
            isText: isNodeType(3),
            isElement: d,
            isComment: isNodeType(8),
            isBr: matchNodeNames('br'),
            isContentEditableTrue: hasContentEditableState('true'),
            isContentEditableFalse: hasContentEditableState('false'),
            matchNodeNames: matchNodeNames,
            hasPropValue: hasPropValue,
            hasAttributeValue: hasAttributeValue,
            matchStyleValues: matchStyleValues,
            isBogus: isBogus
        }
    });
    define("tinymce/text/Zwsp", [], function () {
        var b = '\u200b';

        function isZwsp(a) {
            return a == b
        }
        function trim(a) {
            return a.replace(new RegExp(b, 'g'), '')
        }
        return {
            isZwsp: isZwsp,
            ZWSP: b,
            trim: trim
        }
    });
    define("tinymce/caret/CaretContainer", ["tinymce/dom/NodeType", "tinymce/text/Zwsp"], function (e, f) {
        var g = e.isElement,
            isText = e.isText;

        function isCaretContainerBlock(a) {
            if (isText(a)) {
                a = a.parentNode
            }
            return g(a) && a.hasAttribute('data-mce-caret')
        }
        function isCaretContainerInline(a) {
            return isText(a) && f.isZwsp(a.data)
        }
        function isCaretContainer(a) {
            return isCaretContainerBlock(a) || isCaretContainerInline(a)
        }
        function removeNode(a) {
            var b = a.parentNode;
            if (b) {
                b.removeChild(a)
            }
        }
        function getNodeValue(a) {
            try {
                return a.nodeValue
            } catch (ex) {
                return ""
            }
        }
        function setNodeValue(a, b) {
            if (b.length === 0) {
                removeNode(a)
            } else {
                a.nodeValue = b
            }
        }
        function insertInline(a, b) {
            var c, sibling, textNode, parentNode;
            c = a.ownerDocument;
            textNode = c.createTextNode(f.ZWSP);
            parentNode = a.parentNode;
            if (!b) {
                sibling = a.nextSibling;
                if (isText(sibling)) {
                    if (isCaretContainer(sibling)) {
                        return sibling
                    }
                    if (startsWithCaretContainer(sibling)) {
                        sibling.splitText(1);
                        return sibling
                    }
                }
                if (a.nextSibling) {
                    parentNode.insertBefore(textNode, a.nextSibling)
                } else {
                    parentNode.appendChild(textNode)
                }
            } else {
                sibling = a.previousSibling;
                if (isText(sibling)) {
                    if (isCaretContainer(sibling)) {
                        return sibling
                    }
                    if (endsWithCaretContainer(sibling)) {
                        return sibling.splitText(sibling.data.length - 1)
                    }
                }
                parentNode.insertBefore(textNode, a)
            }
            return textNode
        }
        function insertBlock(a, b, c) {
            var d, blockNode, parentNode;
            d = b.ownerDocument;
            blockNode = d.createElement(a);
            blockNode.setAttribute('data-mce-caret', c ? 'before' : 'after');
            blockNode.setAttribute('data-mce-bogus', 'all');
            blockNode.appendChild(d.createTextNode(' '));
            parentNode = b.parentNode;
            if (!c) {
                if (b.nextSibling) {
                    parentNode.insertBefore(blockNode, b.nextSibling)
                } else {
                    parentNode.appendChild(blockNode)
                }
            } else {
                parentNode.insertBefore(blockNode, b)
            }
            return blockNode
        }
        function remove(a) {
            if (g(a) && isCaretContainer(a)) {
                if (a.innerHTML != '&nbsp;') {
                    a.removeAttribute('data-mce-caret')
                } else {
                    removeNode(a)
                }
            }
            if (isText(a)) {
                var b = f.trim(getNodeValue(a));
                setNodeValue(a, b)
            }
        }
        function startsWithCaretContainer(a) {
            return isText(a) && a.data[0] == f.ZWSP
        }
        function endsWithCaretContainer(a) {
            return isText(a) && a.data[a.data.length - 1] == f.ZWSP
        }
        return {
            isCaretContainer: isCaretContainer,
            isCaretContainerBlock: isCaretContainerBlock,
            isCaretContainerInline: isCaretContainerInline,
            insertInline: insertInline,
            insertBlock: insertBlock,
            remove: remove,
            startsWithCaretContainer: startsWithCaretContainer,
            endsWithCaretContainer: endsWithCaretContainer
        }
    });
    define("tinymce/dom/RangeUtils", ["tinymce/util/Tools", "tinymce/dom/TreeWalker", "tinymce/dom/NodeType", "tinymce/dom/Range", "tinymce/caret/CaretContainer"], function (j, k, l, m, n) {
        var o = j.each,
            isContentEditableFalse = l.isContentEditableFalse,
            isCaretContainer = n.isCaretContainer;

        function getEndChild(a, b) {
            var c = a.childNodes;
            b--;
            if (b > c.length - 1) {
                b = c.length - 1
            } else if (b < 0) {
                b = 0
            }
            return c[b] || a
        }
        function RangeUtils(i) {
            this.walk = function (e, f) {
                var g = e.startContainer,
                    startOffset = e.startOffset,
                    endContainer = e.endContainer,
                    endOffset = e.endOffset,
                    ancestor, startPoint, endPoint, node, parent, siblings, nodes;
                nodes = i.select('td[data-mce-selected],th[data-mce-selected]');
                if (nodes.length > 0) {
                    o(nodes, function (a) {
                        f([a])
                    });
                    return
                }
                function exclude(a) {
                    var b;
                    b = a[0];
                    if (b.nodeType === 3 && b === g && startOffset >= b.nodeValue.length) {
                        a.splice(0, 1)
                    }
                    b = a[a.length - 1];
                    if (endOffset === 0 && a.length > 0 && b === endContainer && b.nodeType === 3) {
                        a.splice(a.length - 1, 1)
                    }
                    return a
                }
                function collectSiblings(a, b, c) {
                    var d = [];
                    for (; a && a != c; a = a[b]) {
                        d.push(a)
                    }
                    return d
                }
                function findEndPoint(a, b) {
                    do {
                        if (a.parentNode == b) {
                            return a
                        }
                        a = a.parentNode
                    } while (a)
                }
                function walkBoundary(a, b, c) {
                    var d = c ? 'nextSibling' : 'previousSibling';
                    for (node = a, parent = node.parentNode; node && node != b; node = parent) {
                        parent = node.parentNode;
                        siblings = collectSiblings(node == a ? node : node[d], d);
                        if (siblings.length) {
                            if (!c) {
                                siblings.reverse()
                            }
                            f(exclude(siblings))
                        }
                    }
                }
                if (g.nodeType == 1 && g.hasChildNodes()) {
                    g = g.childNodes[startOffset]
                }
                if (endContainer.nodeType == 1 && endContainer.hasChildNodes()) {
                    endContainer = getEndChild(endContainer, endOffset)
                }
                if (g == endContainer) {
                    return f(exclude([g]))
                }
                ancestor = i.findCommonAncestor(g, endContainer);
                for (node = g; node; node = node.parentNode) {
                    if (node === endContainer) {
                        return walkBoundary(g, ancestor, true)
                    }
                    if (node === ancestor) {
                        break
                    }
                }
                for (node = endContainer; node; node = node.parentNode) {
                    if (node === g) {
                        return walkBoundary(endContainer, ancestor)
                    }
                    if (node === ancestor) {
                        break
                    }
                }
                startPoint = findEndPoint(g, ancestor) || g;
                endPoint = findEndPoint(endContainer, ancestor) || endContainer;
                walkBoundary(g, startPoint, true);
                siblings = collectSiblings(startPoint == g ? startPoint : startPoint.nextSibling, 'nextSibling', endPoint == endContainer ? endPoint.nextSibling : endPoint);
                if (siblings.length) {
                    f(exclude(siblings))
                }
                walkBoundary(endContainer, endPoint)
            };
            this.split = function (c) {
                var d = c.startContainer,
                    startOffset = c.startOffset,
                    endContainer = c.endContainer,
                    endOffset = c.endOffset;

                function splitText(a, b) {
                    return a.splitText(b)
                }
                if (d == endContainer && d.nodeType == 3) {
                    if (startOffset > 0 && startOffset < d.nodeValue.length) {
                        endContainer = splitText(d, startOffset);
                        d = endContainer.previousSibling;
                        if (endOffset > startOffset) {
                            endOffset = endOffset - startOffset;
                            d = endContainer = splitText(endContainer, endOffset).previousSibling;
                            endOffset = endContainer.nodeValue.length;
                            startOffset = 0
                        } else {
                            endOffset = 0
                        }
                    }
                } else {
                    if (d.nodeType == 3 && startOffset > 0 && startOffset < d.nodeValue.length) {
                        d = splitText(d, startOffset);
                        startOffset = 0
                    }
                    if (endContainer.nodeType == 3 && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
                        endContainer = splitText(endContainer, endOffset).previousSibling;
                        endOffset = endContainer.nodeValue.length
                    }
                }
                return {
                    startContainer: d,
                    startOffset: startOffset,
                    endContainer: endContainer,
                    endOffset: endOffset
                }
            };
            this.normalize = function (g) {
                var h, collapsed;

                function normalizeEndPoint(d) {
                    var e, offset, walker, body = i.getRoot(),
                        node, nonEmptyElementsMap;
                    var f, isAfterNode;

                    function isTableCell(a) {
                        return a && /^(TD|TH|CAPTION)$/.test(a.nodeName)
                    }
                    function hasBrBeforeAfter(a, b) {
                        var c = new k(a, i.getParent(a.parentNode, i.isBlock) || body);
                        while ((a = c[b ? 'prev' : 'next']())) {
                            if (a.nodeName === "BR") {
                                return true
                            }
                        }
                    }
                    function hasContentEditableFalseParent(a) {
                        while (a && a != body) {
                            if (isContentEditableFalse(a)) {
                                return true
                            }
                            a = a.parentNode
                        }
                        return false
                    }
                    function isPrevNode(a, b) {
                        return a.previousSibling && a.previousSibling.nodeName == b
                    }
                    function findTextNodeRelative(a, b) {
                        var c, lastInlineElement, parentBlockContainer;
                        b = b || e;
                        parentBlockContainer = i.getParent(b.parentNode, i.isBlock) || body;
                        if (a && b.nodeName == 'BR' && isAfterNode && i.isEmpty(parentBlockContainer)) {
                            e = b.parentNode;
                            offset = i.nodeIndex(b);
                            h = true;
                            return
                        }
                        c = new k(b, parentBlockContainer);
                        while ((node = c[a ? 'prev' : 'next']())) {
                            if (i.getContentEditableParent(node) === "false" || isCaretContainer(node)) {
                                return
                            }
                            if (node.nodeType === 3 && node.nodeValue.length > 0) {
                                e = node;
                                offset = a ? node.nodeValue.length : 0;
                                h = true;
                                return
                            }
                            if (i.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
                                return
                            }
                            lastInlineElement = node
                        }
                        if (collapsed && lastInlineElement) {
                            e = lastInlineElement;
                            h = true;
                            offset = 0
                        }
                    }
                    e = g[(d ? 'start' : 'end') + 'Container'];
                    offset = g[(d ? 'start' : 'end') + 'Offset'];
                    isAfterNode = e.nodeType == 1 && offset === e.childNodes.length;
                    nonEmptyElementsMap = i.schema.getNonEmptyElements();
                    f = d;
                    if (isCaretContainer(e)) {
                        return
                    }
                    if (e.nodeType == 1 && offset > e.childNodes.length - 1) {
                        f = false
                    }
                    if (e.nodeType === 9) {
                        e = i.getRoot();
                        offset = 0
                    }
                    if (e === body) {
                        if (f) {
                            node = e.childNodes[offset > 0 ? offset - 1 : 0];
                            if (node) {
                                if (isCaretContainer(node)) {
                                    return
                                }
                                if (nonEmptyElementsMap[node.nodeName] || node.nodeName == "TABLE") {
                                    return
                                }
                            }
                        }
                        if (e.hasChildNodes()) {
                            offset = Math.min(!f && offset > 0 ? offset - 1 : offset, e.childNodes.length - 1);
                            e = e.childNodes[offset];
                            offset = 0;
                            if (!collapsed && e === body.lastChild && e.nodeName === 'TABLE') {
                                return
                            }
                            if (hasContentEditableFalseParent(e) || isCaretContainer(e)) {
                                return
                            }
                            if (e.hasChildNodes() && !/TABLE/.test(e.nodeName)) {
                                node = e;
                                walker = new k(e, body);
                                do {
                                    if (isContentEditableFalse(node) || isCaretContainer(node)) {
                                        h = false;
                                        break
                                    }
                                    if (node.nodeType === 3 && node.nodeValue.length > 0) {
                                        offset = f ? 0 : node.nodeValue.length;
                                        e = node;
                                        h = true;
                                        break
                                    }
                                    if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell(node)) {
                                        offset = i.nodeIndex(node);
                                        e = node.parentNode;
                                        if (node.nodeName == "IMG" && !f) {
                                            offset++
                                        }
                                        h = true;
                                        break
                                    }
                                } while ((node = (f ? walker.next() : walker.prev())))
                            }
                        }
                    }
                    if (collapsed) {
                        if (e.nodeType === 3 && offset === 0) {
                            findTextNodeRelative(true)
                        }
                        if (e.nodeType === 1) {
                            node = e.childNodes[offset];
                            if (!node) {
                                node = e.childNodes[offset - 1]
                            }
                            if (node && node.nodeName === 'BR' && !isPrevNode(node, 'A') && !hasBrBeforeAfter(node) && !hasBrBeforeAfter(node, true)) {
                                findTextNodeRelative(true, node)
                            }
                        }
                    }
                    if (f && !collapsed && e.nodeType === 3 && offset === e.nodeValue.length) {
                        findTextNodeRelative(false)
                    }
                    if (h) {
                        g['set' + (d ? 'Start' : 'End')](e, offset)
                    }
                }
                collapsed = g.collapsed;
                normalizeEndPoint(true);
                if (!collapsed) {
                    normalizeEndPoint()
                }
                if (h && collapsed) {
                    g.collapse(true)
                }
                return h
            }
        }
        RangeUtils.compareRanges = function (a, b) {
            if (a && b) {
                if (a.item || a.duplicate) {
                    if (a.item && b.item && a.item(0) === b.item(0)) {
                        return true
                    }
                    if (a.isEqual && b.isEqual && b.isEqual(a)) {
                        return true
                    }
                } else {
                    return a.startContainer == b.startContainer && a.startOffset == b.startOffset
                }
            }
            return false
        };

        function findClosestIeRange(c, d, e) {
            var f, rng, rects;
            f = e.elementFromPoint(c, d);
            rng = e.body.createTextRange();
            if (!f || f.tagName == 'HTML') {
                f = e.body
            }
            rng.moveToElementText(f);
            rects = j.toArray(rng.getClientRects());
            rects = rects.sort(function (a, b) {
                a = Math.abs(Math.max(a.top - d, a.bottom - d));
                b = Math.abs(Math.max(b.top - d, b.bottom - d));
                return a - b
            });
            if (rects.length > 0) {
                d = (rects[0].bottom + rects[0].top) / 2;
                try {
                    rng.moveToPoint(c, d);
                    rng.collapse(true);
                    return rng
                } catch (ex) { }
            }
            return null
        }
        RangeUtils.getCaretRangeFromPoint = function (a, b, c) {
            var d, point;
            if (c.caretPositionFromPoint) {
                point = c.caretPositionFromPoint(a, b);
                d = c.createRange();
                d.setStart(point.offsetNode, point.offset);
                d.collapse(true)
            } else if (c.caretRangeFromPoint) {
                d = c.caretRangeFromPoint(a, b)
            } else if (c.body.createTextRange) {
                d = c.body.createTextRange();
                try {
                    d.moveToPoint(a, b);
                    d.collapse(true)
                } catch (ex) {
                    d = findClosestIeRange(a, b, c)
                }
            }
            return d
        };
        RangeUtils.getSelectedNode = function (a) {
            var b = a.startContainer,
                startOffset = a.startOffset;
            if (b.hasChildNodes() && a.endOffset == startOffset + 1) {
                return b.childNodes[startOffset]
            }
            return null
        };
        RangeUtils.getNode = function (a, b) {
            if (a.nodeType == 1 && a.hasChildNodes()) {
                if (b >= a.childNodes.length) {
                    b = a.childNodes.length - 1
                }
                a = a.childNodes[b]
            }
            return a
        };
        return RangeUtils
    });
    define("tinymce/NodeChange", ["tinymce/dom/RangeUtils", "tinymce/Env", "tinymce/util/Delay"], function (g, h, j) {
        return function (d) {
            var f, lastPath = [];

            function isSameElementPath(a) {
                var i, currentPath;
                currentPath = d.$(a).parentsUntil(d.getBody()).add(a);
                if (currentPath.length === lastPath.length) {
                    for (i = currentPath.length; i >= 0; i--) {
                        if (currentPath[i] !== lastPath[i]) {
                            break
                        }
                    }
                    if (i === -1) {
                        lastPath = currentPath;
                        return true
                    }
                }
                lastPath = currentPath;
                return false
            }
            if (!('onselectionchange' in d.getDoc())) {
                d.on('NodeChange Click MouseUp KeyUp Focus', function (e) {
                    var a, fakeRng;
                    a = d.selection.getRng();
                    fakeRng = {
                        startContainer: a.startContainer,
                        startOffset: a.startOffset,
                        endContainer: a.endContainer,
                        endOffset: a.endOffset
                    };
                    if (e.type == 'nodechange' || !g.compareRanges(fakeRng, f)) {
                        d.fire('SelectionChange')
                    }
                    f = fakeRng
                })
            }
            d.on('contextmenu', function () {
                d.fire('SelectionChange')
            });
            d.on('SelectionChange', function () {
                var a = d.selection.getStart(true);
                if (!h.range && d.selection.isCollapsed()) {
                    return
                }
                if (!isSameElementPath(a) && d.dom.isChildOf(a, d.getBody())) {
                    d.nodeChanged({
                        selectionChange: true
                    })
                }
            });
            d.on('MouseUp', function (e) {
                if (!e.isDefaultPrevented()) {
                    if (d.selection.getNode().nodeName == 'IMG') {
                        j.setEditorTimeout(d, function () {
                            d.nodeChanged()
                        })
                    } else {
                        d.nodeChanged()
                    }
                }
            });
            this.nodeChanged = function (b) {
                var c = d.selection,
                    node, parents, root;
                if (d.initialized && c && !d.settings.disable_nodechange && !d.readonly) {
                    root = d.getBody();
                    node = c.getStart() || root;
                    if (node.ownerDocument != d.getDoc() || !d.dom.isChildOf(node, root)) {
                        node = root
                    }
                    if (node.nodeName == 'IMG' && c.isCollapsed()) {
                        node = node.parentNode
                    }
                    parents = [];
                    d.dom.getParent(node, function (a) {
                        if (a === root) {
                            return true
                        }
                        parents.push(a)
                    });
                    b = b || {};
                    b.element = node;
                    b.parents = parents;
                    d.fire('NodeChange', b)
                }
            }
        }
    });
    define("tinymce/html/Node", [], function () {
        var e = /^[ \t\r\n]*$/,
            typeLookup = {
                '#text': 3,
                '#comment': 8,
                '#cdata': 4,
                '#pi': 7,
                '#doctype': 10,
                '#document-fragment': 11
            };

        function walk(a, b, c) {
            var d, parent, startName = c ? 'lastChild' : 'firstChild',
                siblingName = c ? 'prev' : 'next';
            if (a[startName]) {
                return a[startName]
            }
            if (a !== b) {
                d = a[siblingName];
                if (d) {
                    return d
                }
                for (parent = a.parent; parent && parent !== b; parent = parent.parent) {
                    d = parent[siblingName];
                    if (d) {
                        return d
                    }
                }
            }
        }
        function Node(a, b) {
            this.name = a;
            this.type = b;
            if (b === 1) {
                this.attributes = [];
                this.attributes.map = {}
            }
        }
        Node.prototype = {
            replace: function (a) {
                var b = this;
                if (a.parent) {
                    a.remove()
                }
                b.insert(a, b);
                b.remove();
                return b
            },
            attr: function (a, b) {
                var c = this,
                    attrs, i, undef;
                if (typeof a !== "string") {
                    for (i in a) {
                        c.attr(i, a[i])
                    }
                    return c
                }
                if ((attrs = c.attributes)) {
                    if (b !== undef) {
                        if (b === null) {
                            if (a in attrs.map) {
                                delete attrs.map[a];
                                i = attrs.length;
                                while (i--) {
                                    if (attrs[i].name === a) {
                                        attrs = attrs.splice(i, 1);
                                        return c
                                    }
                                }
                            }
                            return c
                        }
                        if (a in attrs.map) {
                            i = attrs.length;
                            while (i--) {
                                if (attrs[i].name === a) {
                                    attrs[i].value = b;
                                    break
                                }
                            }
                        } else {
                            attrs.push({
                                name: a,
                                value: b
                            })
                        }
                        attrs.map[a] = b;
                        return c
                    }
                    return attrs.map[a]
                }
            },
            clone: function () {
                var a = this,
                    clone = new Node(a.name, a.type),
                    i, l, selfAttrs, selfAttr, cloneAttrs;
                if ((selfAttrs = a.attributes)) {
                    cloneAttrs = [];
                    cloneAttrs.map = {};
                    for (i = 0, l = selfAttrs.length; i < l; i++) {
                        selfAttr = selfAttrs[i];
                        if (selfAttr.name !== 'id') {
                            cloneAttrs[cloneAttrs.length] = {
                                name: selfAttr.name,
                                value: selfAttr.value
                            };
                            cloneAttrs.map[selfAttr.name] = selfAttr.value
                        }
                    }
                    clone.attributes = cloneAttrs
                }
                clone.value = a.value;
                clone.shortEnded = a.shortEnded;
                return clone
            },
            wrap: function (a) {
                var b = this;
                b.parent.insert(a, b);
                a.append(b);
                return b
            },
            unwrap: function () {
                var a = this,
                    node, next;
                for (node = a.firstChild; node;) {
                    next = node.next;
                    a.insert(node, a, true);
                    node = next
                }
                a.remove()
            },
            remove: function () {
                var a = this,
                    parent = a.parent,
                    next = a.next,
                    prev = a.prev;
                if (parent) {
                    if (parent.firstChild === a) {
                        parent.firstChild = next;
                        if (next) {
                            next.prev = null
                        }
                    } else {
                        prev.next = next
                    }
                    if (parent.lastChild === a) {
                        parent.lastChild = prev;
                        if (prev) {
                            prev.next = null
                        }
                    } else {
                        next.prev = prev
                    }
                    a.parent = a.next = a.prev = null
                }
                return a
            },
            append: function (a) {
                var b = this,
                    last;
                if (a.parent) {
                    a.remove()
                }
                last = b.lastChild;
                if (last) {
                    last.next = a;
                    a.prev = last;
                    b.lastChild = a
                } else {
                    b.lastChild = b.firstChild = a
                }
                a.parent = b;
                return a
            },
            insert: function (a, b, c) {
                var d;
                if (a.parent) {
                    a.remove()
                }
                d = b.parent || this;
                if (c) {
                    if (b === d.firstChild) {
                        d.firstChild = a
                    } else {
                        b.prev.next = a
                    }
                    a.prev = b.prev;
                    a.next = b;
                    b.prev = a
                } else {
                    if (b === d.lastChild) {
                        d.lastChild = a
                    } else {
                        b.next.prev = a
                    }
                    a.next = b.next;
                    a.prev = b;
                    b.next = a
                }
                a.parent = d;
                return a
            },
            getAll: function (a) {
                var b = this,
                    node, collection = [];
                for (node = b.firstChild; node; node = walk(node, b)) {
                    if (node.name === a) {
                        collection.push(node)
                    }
                }
                return collection
            },
            empty: function () {
                var a = this,
                    nodes, i, node;
                if (a.firstChild) {
                    nodes = [];
                    for (node = a.firstChild; node; node = walk(node, a)) {
                        nodes.push(node)
                    }
                    i = nodes.length;
                    while (i--) {
                        node = nodes[i];
                        node.parent = node.firstChild = node.lastChild = node.next = node.prev = null
                    }
                }
                a.firstChild = a.lastChild = null;
                return a
            },
            isEmpty: function (a) {
                var b = this,
                    node = b.firstChild,
                    i, name;
                if (node) {
                    do {
                        if (node.type === 1) {
                            if (node.attributes.map['data-mce-bogus']) {
                                continue
                            }
                            if (a[node.name]) {
                                return false
                            }
                            i = node.attributes.length;
                            while (i--) {
                                name = node.attributes[i].name;
                                if (name === "name" || name.indexOf('data-mce-bookmark') === 0) {
                                    return false
                                }
                            }
                        }
                        if (node.type === 8) {
                            return false
                        }
                        if ((node.type === 3 && !e.test(node.value))) {
                            return false
                        }
                    } while ((node = walk(node, b)))
                }
                return true
            },
            walk: function (a) {
                return walk(this, null, a)
            }
        };
        Node.create = function (a, b) {
            var c, attrName;
            c = new Node(a, typeLookup[a] || 1);
            if (b) {
                for (attrName in b) {
                    c.attr(attrName, b[attrName])
                }
            }
            return c
        };
        return Node
    });
    define("tinymce/html/Schema", ["tinymce/util/Tools"], function (n) {
        var o = {},
            dummyObj = {};
        var p = n.makeMap,
            each = n.each,
            extend = n.extend,
            explode = n.explode,
            inArray = n.inArray;

        function split(a, b) {
            return a ? a.split(b || ' ') : []
        }
        function compileSchema(h) {
            var j = {},
                globalAttributes, blockContent;
            var k, flowContent, html4BlockContent, html4PhrasingContent;

            function add(d, e, f) {
                var g, i, attributesOrder, args = arguments;

                function arrayToMap(a, b) {
                    var c = {},
                        i, l;
                    for (i = 0, l = a.length; i < l; i++) {
                        c[a[i]] = b || {}
                    }
                    return c
                }
                f = f || [];
                e = e || "";
                if (typeof f === "string") {
                    f = split(f)
                }
                for (i = 3; i < args.length; i++) {
                    if (typeof args[i] === "string") {
                        args[i] = split(args[i])
                    }
                    f.push.apply(f, args[i])
                }
                d = split(d);
                g = d.length;
                while (g--) {
                    attributesOrder = [].concat(globalAttributes, split(e));
                    j[d[g]] = {
                        attributes: arrayToMap(attributesOrder),
                        attributesOrder: attributesOrder,
                        children: arrayToMap(f, dummyObj)
                    }
                }
            }
            function addAttrs(a, b) {
                var c, schemaItem, i, l;
                a = split(a);
                c = a.length;
                b = split(b);
                while (c--) {
                    schemaItem = j[a[c]];
                    for (i = 0, l = b.length; i < l; i++) {
                        schemaItem.attributes[b[i]] = {};
                        schemaItem.attributesOrder.push(b[i])
                    }
                }
            }
            if (o[h]) {
                return o[h]
            }
            globalAttributes = split("id accesskey class dir lang style tabindex title");
            blockContent = split("address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul");
            k = split("a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd " + "label map noscript object q s samp script select small span strong sub sup " + "textarea u var #text #comment");
            if (h != "html4") {
                globalAttributes.push.apply(globalAttributes, split("contenteditable contextmenu draggable dropzone " + "hidden spellcheck translate"));
                blockContent.push.apply(blockContent, split("article aside details dialog figure header footer hgroup section nav"));
                k.push.apply(k, split("audio canvas command datalist mark meter output picture " + "progress time wbr video ruby bdi keygen"))
            }
            if (h != "html5-strict") {
                globalAttributes.push("xml:lang");
                html4PhrasingContent = split("acronym applet basefont big font strike tt");
                k.push.apply(k, html4PhrasingContent);
                each(html4PhrasingContent, function (a) {
                    add(a, "", k)
                });
                html4BlockContent = split("center dir isindex noframes");
                blockContent.push.apply(blockContent, html4BlockContent);
                flowContent = [].concat(blockContent, k);
                each(html4BlockContent, function (a) {
                    add(a, "", flowContent)
                })
            }
            flowContent = flowContent || [].concat(blockContent, k);
            add("html", "manifest", "head body");
            add("head", "", "base command link meta noscript script style title");
            add("title hr noscript br");
            add("base", "href target");
            add("link", "href rel media hreflang type sizes hreflang");
            add("meta", "name http-equiv content charset");
            add("style", "media type scoped");
            add("script", "src async defer type charset");
            add("body", "onafterprint onbeforeprint onbeforeunload onblur onerror onfocus " + "onhashchange onload onmessage onoffline ononline onpagehide onpageshow " + "onpopstate onresize onscroll onstorage onunload", flowContent);
            add("address dt dd div caption", "", flowContent);
            add("h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn", "", k);
            add("blockquote", "cite", flowContent);
            add("ol", "reversed start type", "li");
            add("ul", "", "li");
            add("li", "value", flowContent);
            add("dl", "", "dt dd");
            add("a", "href target rel media hreflang type", k);
            add("q", "cite", k);
            add("ins del", "cite datetime", flowContent);
            add("img", "src sizes srcset alt usemap ismap width height");
            add("iframe", "src name width height", flowContent);
            add("embed", "src type width height");
            add("object", "data type typemustmatch name usemap form width height", flowContent, "param");
            add("param", "name value");
            add("map", "name", flowContent, "area");
            add("area", "alt coords shape href target rel media hreflang type");
            add("table", "border", "caption colgroup thead tfoot tbody tr" + (h == "html4" ? " col" : ""));
            add("colgroup", "span", "col");
            add("col", "span");
            add("tbody thead tfoot", "", "tr");
            add("tr", "", "td th");
            add("td", "colspan rowspan headers", flowContent);
            add("th", "colspan rowspan headers scope abbr", flowContent);
            add("form", "accept-charset action autocomplete enctype method name novalidate target", flowContent);
            add("fieldset", "disabled form name", flowContent, "legend");
            add("label", "form for", k);
            add("input", "accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate " + "formtarget height list max maxlength min multiple name pattern readonly required size src step type value width");
            add("button", "disabled form formaction formenctype formmethod formnovalidate formtarget name type value", h == "html4" ? flowContent : k);
            add("select", "disabled form multiple name required size", "option optgroup");
            add("optgroup", "disabled label", "option");
            add("option", "disabled label selected value");
            add("textarea", "cols dirname disabled form maxlength name readonly required rows wrap");
            add("menu", "type label", flowContent, "li");
            add("noscript", "", flowContent);
            if (h != "html4") {
                add("wbr");
                add("ruby", "", k, "rt rp");
                add("figcaption", "", flowContent);
                add("mark rt rp summary bdi", "", k);
                add("canvas", "width height", flowContent);
                add("video", "src crossorigin poster preload autoplay mediagroup loop " + "muted controls width height buffered", flowContent, "track source");
                add("audio", "src crossorigin preload autoplay mediagroup loop muted controls buffered volume", flowContent, "track source");
                add("picture", "", "img source");
                add("source", "src srcset type media sizes");
                add("track", "kind src srclang label default");
                add("datalist", "", k, "option");
                add("article section nav aside header footer", "", flowContent);
                add("hgroup", "", "h1 h2 h3 h4 h5 h6");
                add("figure", "", flowContent, "figcaption");
                add("time", "datetime", k);
                add("dialog", "open", flowContent);
                add("command", "type label icon disabled checked radiogroup command");
                add("output", "for form name", k);
                add("progress", "value max", k);
                add("meter", "value min max low high optimum", k);
                add("details", "open", flowContent, "summary");
                add("keygen", "autofocus challenge disabled form keytype name")
            }
            if (h != "html5-strict") {
                addAttrs("script", "language xml:space");
                addAttrs("style", "xml:space");
                addAttrs("object", "declare classid code codebase codetype archive standby align border hspace vspace");
                addAttrs("embed", "align name hspace vspace");
                addAttrs("param", "valuetype type");
                addAttrs("a", "charset name rev shape coords");
                addAttrs("br", "clear");
                addAttrs("applet", "codebase archive code object alt name width height align hspace vspace");
                addAttrs("img", "name longdesc align border hspace vspace");
                addAttrs("iframe", "longdesc frameborder marginwidth marginheight scrolling align");
                addAttrs("font basefont", "size color face");
                addAttrs("input", "usemap align");
                addAttrs("select", "onchange");
                addAttrs("textarea");
                addAttrs("h1 h2 h3 h4 h5 h6 div p legend caption", "align");
                addAttrs("ul", "type compact");
                addAttrs("li", "type");
                addAttrs("ol dl menu dir", "compact");
                addAttrs("pre", "width xml:space");
                addAttrs("hr", "align noshade size width");
                addAttrs("isindex", "prompt");
                addAttrs("table", "summary width frame rules cellspacing cellpadding align bgcolor");
                addAttrs("col", "width align char charoff valign");
                addAttrs("colgroup", "width align char charoff valign");
                addAttrs("thead", "align char charoff valign");
                addAttrs("tr", "align char charoff valign bgcolor");
                addAttrs("th", "axis align char charoff valign nowrap bgcolor width height");
                addAttrs("form", "accept");
                addAttrs("td", "abbr axis scope align char charoff valign nowrap bgcolor width height");
                addAttrs("tfoot", "align char charoff valign");
                addAttrs("tbody", "align char charoff valign");
                addAttrs("area", "nohref");
                addAttrs("body", "background bgcolor text link vlink alink")
            }
            if (h != "html4") {
                addAttrs("input button select textarea", "autofocus");
                addAttrs("input textarea", "placeholder");
                addAttrs("a", "download");
                addAttrs("link script img", "crossorigin");
                addAttrs("iframe", "sandbox seamless allowfullscreen")
            }
            each(split('a form meter progress dfn'), function (a) {
                if (j[a]) {
                    delete j[a].children[a]
                }
            });
            delete j.caption.children.table;
            delete j.script;
            o[h] = j;
            return j
        }
        function compileElementMap(c, d) {
            var e;
            if (c) {
                e = {};
                if (typeof c == 'string') {
                    c = {
                        '*': c
                    }
                }
                each(c, function (a, b) {
                    e[b] = e[b.toUpperCase()] = d == 'map' ? p(a, /[, ]/) : explode(a, /[, ]/)
                })
            }
            return e
        }
        return function (h) {
            var j = this,
                elements = {},
                children = {},
                patternElements = [],
                validStyles, invalidStyles, schemaItems;
            var k, selfClosingElementsMap, shortEndedElementsMap, boolAttrMap, validClasses;
            var l, nonEmptyElementsMap, moveCaretBeforeOnEnterElementsMap, textBlockElementsMap, textInlineElementsMap;
            var m = {},
                specialElements = {};

            function createLookupTable(a, b, c) {
                var d = h[a];
                if (!d) {
                    d = o[a];
                    if (!d) {
                        d = p(b, ' ', p(b.toUpperCase(), ' '));
                        d = extend(d, c);
                        o[a] = d
                    }
                } else {
                    d = p(d, /[, ]/, p(d.toUpperCase(), /[, ]/))
                }
                return d
            }
            h = h || {};
            schemaItems = compileSchema(h.schema);
            if (h.verify_html === false) {
                h.valid_elements = '*[*]'
            }
            validStyles = compileElementMap(h.valid_styles);
            invalidStyles = compileElementMap(h.invalid_styles, 'map');
            validClasses = compileElementMap(h.valid_classes, 'map');
            k = createLookupTable('whitespace_elements', 'pre script noscript style textarea video audio iframe object');
            selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
            shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' + 'meta param embed source wbr track');
            boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' + 'noshade nowrap readonly selected autoplay loop controls');
            nonEmptyElementsMap = createLookupTable('non_empty_elements', 'td th iframe video audio object script', shortEndedElementsMap);
            moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', 'table', nonEmptyElementsMap);
            textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' + 'blockquote center dir fieldset header footer article section hgroup aside nav figure');
            l = createLookupTable('block_elements', 'hr table tbody thead tfoot ' + 'th tr td li ol ul caption dl dt dd noscript menu isindex option ' + 'datalist select optgroup figcaption', textBlockElementsMap);
            textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font strike u var cite ' + 'dfn code mark q sup sub samp');
            each((h.special || 'script noscript style textarea').split(' '), function (a) {
                specialElements[a] = new RegExp('<\/' + a + '[^>]*>', 'gi')
            });

            function patternToRegExp(a) {
                return new RegExp('^' + a.replace(/([?+*])/g, '.$1') + '$')
            }
            function addValidElements(a) {
                var b, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder, prefix, outputName, globalAttributes, globalAttributesOrder, key, value, elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)\])?$/,
                    attrRuleRegExp = /^([!\-])?(\w+::\w+|[^=:<]+)?(?:([=:<])(.*))?$/,
                    hasPatternsRegExp = /[*?+]/;
                if (a) {
                    a = split(a, ',');
                    if (elements['@']) {
                        globalAttributes = elements['@'].attributes;
                        globalAttributesOrder = elements['@'].attributesOrder
                    }
                    for (b = 0, el = a.length; b < el; b++) {
                        matches = elementRuleRegExp.exec(a[b]);
                        if (matches) {
                            prefix = matches[1];
                            elementName = matches[2];
                            outputName = matches[3];
                            attrData = matches[5];
                            attributes = {};
                            attributesOrder = [];
                            element = {
                                attributes: attributes,
                                attributesOrder: attributesOrder
                            };
                            if (prefix === '#') {
                                element.paddEmpty = true
                            }
                            if (prefix === '-') {
                                element.removeEmpty = true
                            }
                            if (matches[4] === '!') {
                                element.removeEmptyAttrs = true
                            }
                            if (globalAttributes) {
                                for (key in globalAttributes) {
                                    attributes[key] = globalAttributes[key]
                                }
                                attributesOrder.push.apply(attributesOrder, globalAttributesOrder)
                            }
                            if (attrData) {
                                attrData = split(attrData, '|');
                                for (ai = 0, al = attrData.length; ai < al; ai++) {
                                    matches = attrRuleRegExp.exec(attrData[ai]);
                                    if (matches) {
                                        attr = {};
                                        attrType = matches[1];
                                        attrName = matches[2].replace(/::/g, ':');
                                        prefix = matches[3];
                                        value = matches[4];
                                        if (attrType === '!') {
                                            element.attributesRequired = element.attributesRequired || [];
                                            element.attributesRequired.push(attrName);
                                            attr.required = true
                                        }
                                        if (attrType === '-') {
                                            delete attributes[attrName];
                                            attributesOrder.splice(inArray(attributesOrder, attrName), 1);
                                            continue
                                        }
                                        if (prefix) {
                                            if (prefix === '=') {
                                                element.attributesDefault = element.attributesDefault || [];
                                                element.attributesDefault.push({
                                                    name: attrName,
                                                    value: value
                                                });
                                                attr.defaultValue = value
                                            }
                                            if (prefix === ':') {
                                                element.attributesForced = element.attributesForced || [];
                                                element.attributesForced.push({
                                                    name: attrName,
                                                    value: value
                                                });
                                                attr.forcedValue = value
                                            }
                                            if (prefix === '<') {
                                                attr.validValues = p(value, '?')
                                            }
                                        }
                                        if (hasPatternsRegExp.test(attrName)) {
                                            element.attributePatterns = element.attributePatterns || [];
                                            attr.pattern = patternToRegExp(attrName);
                                            element.attributePatterns.push(attr)
                                        } else {
                                            if (!attributes[attrName]) {
                                                attributesOrder.push(attrName)
                                            }
                                            attributes[attrName] = attr
                                        }
                                    }
                                }
                            }
                            if (!globalAttributes && elementName == '@') {
                                globalAttributes = attributes;
                                globalAttributesOrder = attributesOrder
                            }
                            if (outputName) {
                                element.outputName = elementName;
                                elements[outputName] = element
                            }
                            if (hasPatternsRegExp.test(elementName)) {
                                element.pattern = patternToRegExp(elementName);
                                patternElements.push(element)
                            } else {
                                elements[elementName] = element
                            }
                        }
                    }
                }
            }
            function setValidElements(c) {
                elements = {};
                patternElements = [];
                addValidElements(c);
                each(schemaItems, function (a, b) {
                    children[b] = a.children
                })
            }
            function addCustomElements(f) {
                var g = /^(~)?(.+)$/;
                if (f) {
                    o.text_block_elements = o.block_elements = null;
                    each(split(f, ','), function (c) {
                        var d = g.exec(c),
                            inline = d[1] === '~',
                            cloneName = inline ? 'span' : 'div',
                            name = d[2];
                        children[name] = children[cloneName];
                        m[name] = cloneName;
                        if (!inline) {
                            l[name.toUpperCase()] = {};
                            l[name] = {}
                        }
                        if (!elements[name]) {
                            var e = elements[cloneName];
                            e = extend({}, e);
                            delete e.removeEmptyAttrs;
                            delete e.removeEmpty;
                            elements[name] = e
                        }
                        each(children, function (a, b) {
                            if (a[cloneName]) {
                                children[b] = a = extend({}, children[b]);
                                a[name] = a[cloneName]
                            }
                        })
                    })
                }
            }
            function addValidChildren(d) {
                var e = /^([+\-]?)(\w+)\[([^\]]+)\]$/;
                o[h.schema] = null;
                if (d) {
                    each(split(d, ','), function (b) {
                        var c = e.exec(b),
                            parent, prefix;
                        if (c) {
                            prefix = c[1];
                            if (prefix) {
                                parent = children[c[2]]
                            } else {
                                parent = children[c[2]] = {
                                    '#comment': {}
                                }
                            }
                            parent = children[c[2]];
                            each(split(c[3], '|'), function (a) {
                                if (prefix === '-') {
                                    delete parent[a]
                                } else {
                                    parent[a] = {}
                                }
                            })
                        }
                    })
                }
            }
            function getElementRule(a) {
                var b = elements[a],
                    i;
                if (b) {
                    return b
                }
                i = patternElements.length;
                while (i--) {
                    b = patternElements[i];
                    if (b.pattern.test(a)) {
                        return b
                    }
                }
            }
            if (!h.valid_elements) {
                each(schemaItems, function (a, b) {
                    elements[b] = {
                        attributes: a.attributes,
                        attributesOrder: a.attributesOrder
                    };
                    children[b] = a.children
                });
                if (h.schema != "html5") {
                    each(split('strong/b em/i'), function (a) {
                        a = split(a, '/');
                        elements[a[1]].outputName = a[0]
                    })
                }
                each(split('ol ul sub sup blockquote span font a table tbody tr strong em b i'), function (a) {
                    if (elements[a]) {
                        elements[a].removeEmpty = true
                    }
                });
                each(split('p h1 h2 h3 h4 h5 h6 th td pre div address caption'), function (a) {
                    elements[a].paddEmpty = true
                });
                each(split('span'), function (a) {
                    elements[a].removeEmptyAttrs = true
                })
            } else {
                setValidElements(h.valid_elements)
            }
            addCustomElements(h.custom_elements);
            addValidChildren(h.valid_children);
            addValidElements(h.extended_valid_elements);
            addValidChildren('+ol[ul|ol],+ul[ul|ol]');
            if (h.invalid_elements) {
                each(explode(h.invalid_elements), function (a) {
                    if (elements[a]) {
                        delete elements[a]
                    }
                })
            }
            if (!getElementRule('span')) {
                addValidElements('span[!data-mce-type|*]')
            }
            j.children = children;
            j.getValidStyles = function () {
                return validStyles
            };
            j.getInvalidStyles = function () {
                return invalidStyles
            };
            j.getValidClasses = function () {
                return validClasses
            };
            j.getBoolAttrs = function () {
                return boolAttrMap
            };
            j.getBlockElements = function () {
                return l
            };
            j.getTextBlockElements = function () {
                return textBlockElementsMap
            };
            j.getTextInlineElements = function () {
                return textInlineElementsMap
            };
            j.getShortEndedElements = function () {
                return shortEndedElementsMap
            };
            j.getSelfClosingElements = function () {
                return selfClosingElementsMap
            };
            j.getNonEmptyElements = function () {
                return nonEmptyElementsMap
            };
            j.getMoveCaretBeforeOnEnterElements = function () {
                return moveCaretBeforeOnEnterElementsMap
            };
            j.getWhiteSpaceElements = function () {
                return k
            };
            j.getSpecialElements = function () {
                return specialElements
            };
            j.isValidChild = function (a, b) {
                var c = children[a];
                return !!(c && c[b])
            };
            j.isValid = function (a, b) {
                var c, i, rule = getElementRule(a);
                if (rule) {
                    if (b) {
                        if (rule.attributes[b]) {
                            return true
                        }
                        c = rule.attributePatterns;
                        if (c) {
                            i = c.length;
                            while (i--) {
                                if (c[i].pattern.test(a)) {
                                    return true
                                }
                            }
                        }
                    } else {
                        return true
                    }
                }
                return false
            };
            j.getElementRule = getElementRule;
            j.getCustomElements = function () {
                return m
            };
            j.addValidElements = addValidElements;
            j.setValidElements = setValidElements;
            j.addCustomElements = addCustomElements;
            j.addValidChildren = addValidChildren;
            j.elements = elements
        }
    });
    define("tinymce/html/SaxParser", ["tinymce/html/Schema", "tinymce/html/Entities", "tinymce/util/Tools"], function (t, u, v) {
        var w = v.each;

        function findEndTag(a, b, c) {
            var d = 1,
                index, matches, tokenRegExp, shortEndedElements;
            shortEndedElements = a.getShortEndedElements();
            tokenRegExp = /<([!?\/])?([A-Za-z0-9\-_\:\.]+)((?:\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\/|\s+)>/g;
            tokenRegExp.lastIndex = index = c;
            while ((matches = tokenRegExp.exec(b))) {
                index = tokenRegExp.lastIndex;
                if (matches[1] === '/') {
                    d--
                } else if (!matches[1]) {
                    if (matches[2] in shortEndedElements) {
                        continue
                    }
                    d++
                }
                if (d === 0) {
                    break
                }
            }
            return index
        }
        function SaxParser(q, r) {
            var s = this;

            function noop() { }
            q = q || {};
            s.schema = r = r || new t();
            if (q.fix_self_closing !== false) {
                q.fix_self_closing = true
            }
            w('comment cdata text start end pi doctype'.split(' '), function (a) {
                if (a) {
                    s[a] = q[a] || noop
                }
            });
            s.parse = function (h) {
                var j = this,
                    matches, index = 0,
                    value, endRegExp, stack = [],
                    attrList, i, text, name;
                var k, removeInternalElements, shortEndedElements, fillAttrsMap, isShortEnded;
                var l, elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
                var m, attributesDefault, attributesForced;
                var n, selfClosing, tokenRegExp, attrRegExp, specialElements, attrValue, idCount = 0;
                var o = u.decode,
                    fixSelfClosing, filteredUrlAttrs = v.makeMap('src,href,data,background,formaction,poster');
                var p = /((java|vb)script|mhtml):/i,
                    dataUriRegExp = /^data:/i;

                function processEndTag(a) {
                    var b, i;
                    b = stack.length;
                    while (b--) {
                        if (stack[b].name === a) {
                            break
                        }
                    }
                    if (b >= 0) {
                        for (i = stack.length - 1; i >= b; i--) {
                            a = stack[i];
                            if (a.valid) {
                                j.end(a.name)
                            }
                        }
                        stack.length = b
                    }
                }
                function parseAttribute(a, b, c, d, e) {
                    var f, i, trimRegExp = /[\s\u0000-\u001F]+/g;
                    b = b.toLowerCase();
                    c = b in fillAttrsMap ? b : o(c || d || e || '');
                    if (l && !k && b.indexOf('data-') !== 0) {
                        f = validAttributesMap[b];
                        if (!f && validAttributePatterns) {
                            i = validAttributePatterns.length;
                            while (i--) {
                                f = validAttributePatterns[i];
                                if (f.pattern.test(b)) {
                                    break
                                }
                            }
                            if (i === -1) {
                                f = null
                            }
                        }
                        if (!f) {
                            return
                        }
                        if (f.validValues && !(c in f.validValues)) {
                            return
                        }
                    }
                    if (filteredUrlAttrs[b] && !q.allow_script_urls) {
                        var g = c.replace(trimRegExp, '');
                        try {
                            g = decodeURIComponent(g)
                        } catch (ex) {
                            g = unescape(g)
                        }
                        if (p.test(g)) {
                            return
                        }
                        if (!q.allow_html_data_urls && dataUriRegExp.test(g) && !/^data:image\//i.test(g)) {
                            return
                        }
                    }
                    attrList.map[b] = c;
                    attrList.push({
                        name: b,
                        value: c
                    })
                }
                tokenRegExp = new RegExp('<(?:' + '(?:!--([\\w\\W]*?)-->)|' + '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + '(?:!DOCTYPE([\\w\\W]*?)>)|' + '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + '(?:\\/([^>]+)>)|' + '(?:([A-Za-z0-9\\-_\\:\\.]+)((?:\\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\\/|\\s+)>)' + ')', 'g');
                attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
                shortEndedElements = r.getShortEndedElements();
                selfClosing = q.self_closing_elements || r.getSelfClosingElements();
                fillAttrsMap = r.getBoolAttrs();
                l = q.validate;
                removeInternalElements = q.remove_internals;
                fixSelfClosing = q.fix_self_closing;
                specialElements = r.getSpecialElements();
                while ((matches = tokenRegExp.exec(h))) {
                    if (index < matches.index) {
                        j.text(o(h.substr(index, matches.index - index)))
                    }
                    if ((value = matches[6])) {
                        value = value.toLowerCase();
                        if (value.charAt(0) === ':') {
                            value = value.substr(1)
                        }
                        processEndTag(value)
                    } else if ((value = matches[7])) {
                        value = value.toLowerCase();
                        if (value.charAt(0) === ':') {
                            value = value.substr(1)
                        }
                        isShortEnded = value in shortEndedElements;
                        if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
                            processEndTag(value)
                        }
                        if (!l || (elementRule = r.getElementRule(value))) {
                            isValidElement = true;
                            if (l) {
                                validAttributesMap = elementRule.attributes;
                                validAttributePatterns = elementRule.attributePatterns
                            }
                            if ((attribsValue = matches[8])) {
                                k = attribsValue.indexOf('data-mce-type') !== -1;
                                if (k && removeInternalElements) {
                                    isValidElement = false
                                }
                                attrList = [];
                                attrList.map = {};
                                attribsValue.replace(attrRegExp, parseAttribute)
                            } else {
                                attrList = [];
                                attrList.map = {}
                            }
                            if (l && !k) {
                                m = elementRule.attributesRequired;
                                attributesDefault = elementRule.attributesDefault;
                                attributesForced = elementRule.attributesForced;
                                n = elementRule.removeEmptyAttrs;
                                if (n && !attrList.length) {
                                    isValidElement = false
                                }
                                if (attributesForced) {
                                    i = attributesForced.length;
                                    while (i--) {
                                        attr = attributesForced[i];
                                        name = attr.name;
                                        attrValue = attr.value;
                                        if (attrValue === '{$uid}') {
                                            attrValue = 'mce_' + idCount++
                                        }
                                        attrList.map[name] = attrValue;
                                        attrList.push({
                                            name: name,
                                            value: attrValue
                                        })
                                    }
                                }
                                if (attributesDefault) {
                                    i = attributesDefault.length;
                                    while (i--) {
                                        attr = attributesDefault[i];
                                        name = attr.name;
                                        if (!(name in attrList.map)) {
                                            attrValue = attr.value;
                                            if (attrValue === '{$uid}') {
                                                attrValue = 'mce_' + idCount++
                                            }
                                            attrList.map[name] = attrValue;
                                            attrList.push({
                                                name: name,
                                                value: attrValue
                                            })
                                        }
                                    }
                                }
                                if (m) {
                                    i = m.length;
                                    while (i--) {
                                        if (m[i] in attrList.map) {
                                            break
                                        }
                                    }
                                    if (i === -1) {
                                        isValidElement = false
                                    }
                                }
                                if ((attr = attrList.map['data-mce-bogus'])) {
                                    if (attr === 'all') {
                                        index = findEndTag(r, h, tokenRegExp.lastIndex);
                                        tokenRegExp.lastIndex = index;
                                        continue
                                    }
                                    isValidElement = false
                                }
                            }
                            if (isValidElement) {
                                j.start(value, attrList, isShortEnded)
                            }
                        } else {
                            isValidElement = false
                        }
                        if ((endRegExp = specialElements[value])) {
                            endRegExp.lastIndex = index = matches.index + matches[0].length;
                            if ((matches = endRegExp.exec(h))) {
                                if (isValidElement) {
                                    text = h.substr(index, matches.index - index)
                                }
                                index = matches.index + matches[0].length
                            } else {
                                text = h.substr(index);
                                index = h.length
                            }
                            if (isValidElement) {
                                if (text.length > 0) {
                                    j.text(text, true)
                                }
                                j.end(value)
                            }
                            tokenRegExp.lastIndex = index;
                            continue
                        }
                        if (!isShortEnded) {
                            if (!attribsValue || attribsValue.indexOf('/') != attribsValue.length - 1) {
                                stack.push({
                                    name: value,
                                    valid: isValidElement
                                })
                            } else if (isValidElement) {
                                j.end(value)
                            }
                        }
                    } else if ((value = matches[1])) {
                        if (value.charAt(0) === '>') {
                            value = ' ' + value
                        }
                        if (!q.allow_conditional_comments && value.substr(0, 3) === '[if') {
                            value = ' ' + value
                        }
                        j.comment(value)
                    } else if ((value = matches[2])) {
                        j.cdata(value)
                    } else if ((value = matches[3])) {
                        j.doctype(value)
                    } else if ((value = matches[4])) {
                        j.pi(value, matches[5])
                    }
                    index = matches.index + matches[0].length
                }
                if (index < h.length) {
                    j.text(o(h.substr(index)))
                }
                for (i = stack.length - 1; i >= 0; i--) {
                    value = stack[i];
                    if (value.valid) {
                        j.end(value.name)
                    }
                }
            }
        }
        SaxParser.findEndTag = findEndTag;
        return SaxParser
    });
    define("tinymce/html/DomParser", ["tinymce/html/Node", "tinymce/html/Schema", "tinymce/html/SaxParser", "tinymce/util/Tools"], function (p, q, r, s) {
        var t = s.makeMap,
            each = s.each,
            explode = s.explode,
            extend = s.extend;
        return function (m, n) {
            var o = this,
                nodeFilters = {},
                attributeFilters = [],
                matchedNodes = {},
                matchedAttributes = {};
            m = m || {};
            m.validate = "validate" in m ? m.validate : true;
            m.root_name = m.root_name || 'body';
            o.schema = n = n || new q();

            function fixInvalidChildren(a) {
                var b, node, parent, parents, newParent, currentNode, tempNode, childNode, i;
                var c, nonSplitableElements, textBlockElements, specialElements, sibling, nextNode;
                nonSplitableElements = t('tr,td,th,tbody,thead,tfoot,table');
                c = n.getNonEmptyElements();
                textBlockElements = n.getTextBlockElements();
                specialElements = n.getSpecialElements();
                for (b = 0; b < a.length; b++) {
                    node = a[b];
                    if (!node.parent || node.fixed) {
                        continue
                    }
                    if (textBlockElements[node.name] && node.parent.name == 'li') {
                        sibling = node.next;
                        while (sibling) {
                            if (textBlockElements[sibling.name]) {
                                sibling.name = 'li';
                                sibling.fixed = true;
                                node.parent.insert(sibling, node.parent)
                            } else {
                                break
                            }
                            sibling = sibling.next
                        }
                        node.unwrap(node);
                        continue
                    }
                    parents = [node];
                    for (parent = node.parent; parent && !n.isValidChild(parent.name, node.name) && !nonSplitableElements[parent.name]; parent = parent.parent) {
                        parents.push(parent)
                    }
                    if (parent && parents.length > 1) {
                        parents.reverse();
                        newParent = currentNode = o.filterNode(parents[0].clone());
                        for (i = 0; i < parents.length - 1; i++) {
                            if (n.isValidChild(currentNode.name, parents[i].name)) {
                                tempNode = o.filterNode(parents[i].clone());
                                currentNode.append(tempNode)
                            } else {
                                tempNode = currentNode
                            }
                            for (childNode = parents[i].firstChild; childNode && childNode != parents[i + 1];) {
                                nextNode = childNode.next;
                                tempNode.append(childNode);
                                childNode = nextNode
                            }
                            currentNode = tempNode
                        }
                        if (!newParent.isEmpty(c)) {
                            parent.insert(newParent, parents[0], true);
                            parent.insert(node, newParent)
                        } else {
                            parent.insert(node, parents[0], true)
                        }
                        parent = parents[0];
                        if (parent.isEmpty(c) || parent.firstChild === parent.lastChild && parent.firstChild.name === 'br') {
                            parent.empty().remove()
                        }
                    } else if (node.parent) {
                        if (node.name === 'li') {
                            sibling = node.prev;
                            if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
                                sibling.append(node);
                                continue
                            }
                            sibling = node.next;
                            if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
                                sibling.insert(node, sibling.firstChild, true);
                                continue
                            }
                            node.wrap(o.filterNode(new p('ul', 1)));
                            continue
                        }
                        if (n.isValidChild(node.parent.name, 'div') && n.isValidChild('div', node.name)) {
                            node.wrap(o.filterNode(new p('div', 1)))
                        } else {
                            if (specialElements[node.name]) {
                                node.empty().remove()
                            } else {
                                node.unwrap()
                            }
                        }
                    }
                }
            }
            o.filterNode = function (a) {
                var i, name, list;
                if (name in nodeFilters) {
                    list = matchedNodes[name];
                    if (list) {
                        list.push(a)
                    } else {
                        matchedNodes[name] = [a]
                    }
                }
                i = attributeFilters.length;
                while (i--) {
                    name = attributeFilters[i].name;
                    if (name in a.attributes.map) {
                        list = matchedAttributes[name];
                        if (list) {
                            list.push(a)
                        } else {
                            matchedAttributes[name] = [a]
                        }
                    }
                }
                return a
            };
            o.addNodeFilter = function (c, d) {
                each(explode(c), function (a) {
                    var b = nodeFilters[a];
                    if (!b) {
                        nodeFilters[a] = b = []
                    }
                    b.push(d)
                })
            };
            o.addAttributeFilter = function (b, c) {
                each(explode(b), function (a) {
                    var i;
                    for (i = 0; i < attributeFilters.length; i++) {
                        if (attributeFilters[i].name === a) {
                            attributeFilters[i].callbacks.push(c);
                            return
                        }
                    }
                    attributeFilters.push({
                        name: a,
                        callbacks: [c]
                    })
                })
            };
            o.parse = function (e, f) {
                var g, rootNode, node, nodes, i, l, fi, fl, list, name, validate;
                var h, startWhiteSpaceRegExp, invalidChildren = [],
                    isInWhiteSpacePreservedElement;
                var j, allWhiteSpaceRegExp, isAllWhiteSpaceRegExp, whiteSpaceElements;
                var k, nonEmptyElements, rootBlockName;
                f = f || {};
                matchedNodes = {};
                matchedAttributes = {};
                h = extend(t('script,style,head,html,body,title,meta,param'), n.getBlockElements());
                nonEmptyElements = n.getNonEmptyElements();
                k = n.children;
                validate = m.validate;
                rootBlockName = "forced_root_block" in f ? f.forced_root_block : m.forced_root_block;
                whiteSpaceElements = n.getWhiteSpaceElements();
                startWhiteSpaceRegExp = /^[ \t\r\n]+/;
                j = /[ \t\r\n]+$/;
                allWhiteSpaceRegExp = /[ \t\r\n]+/g;
                isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;

                function addRootBlocks() {
                    var b = rootNode.firstChild,
                        next, rootBlockNode;

                    function trim(a) {
                        if (a) {
                            b = a.firstChild;
                            if (b && b.type == 3) {
                                b.value = b.value.replace(startWhiteSpaceRegExp, '')
                            }
                            b = a.lastChild;
                            if (b && b.type == 3) {
                                b.value = b.value.replace(j, '')
                            }
                        }
                    }
                    if (!n.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
                        return
                    }
                    while (b) {
                        next = b.next;
                        if (b.type == 3 || (b.type == 1 && b.name !== 'p' && !h[b.name] && !b.attr('data-mce-type'))) {
                            if (!rootBlockNode) {
                                rootBlockNode = createNode(rootBlockName, 1);
                                rootBlockNode.attr(m.forced_root_block_attrs);
                                rootNode.insert(rootBlockNode, b);
                                rootBlockNode.append(b)
                            } else {
                                rootBlockNode.append(b)
                            }
                        } else {
                            trim(rootBlockNode);
                            rootBlockNode = null
                        }
                        b = next
                    }
                    trim(rootBlockNode)
                }
                function createNode(a, b) {
                    var c = new p(a, b),
                        list;
                    if (a in nodeFilters) {
                        list = matchedNodes[a];
                        if (list) {
                            list.push(c)
                        } else {
                            matchedNodes[a] = [c]
                        }
                    }
                    return c
                }
                function removeWhitespaceBefore(a) {
                    var b, textNodeNext, textVal, sibling, h = n.getBlockElements();
                    for (b = a.prev; b && b.type === 3;) {
                        textVal = b.value.replace(j, '');
                        if (textVal.length > 0) {
                            b.value = textVal;
                            return
                        }
                        textNodeNext = b.next;
                        if (textNodeNext) {
                            if (textNodeNext.type == 3 && textNodeNext.value.length) {
                                b = b.prev;
                                continue
                            }
                            if (!h[textNodeNext.name] && textNodeNext.name != 'script' && textNodeNext.name != 'style') {
                                b = b.prev;
                                continue
                            }
                        }
                        sibling = b.prev;
                        b.remove();
                        b = sibling
                    }
                }
                function cloneAndExcludeBlocks(a) {
                    var b, output = {};
                    for (b in a) {
                        if (b !== 'li' && b != 'p') {
                            output[b] = a[b]
                        }
                    }
                    return output
                }
                g = new r({
                    validate: validate,
                    allow_script_urls: m.allow_script_urls,
                    allow_conditional_comments: m.allow_conditional_comments,
                    self_closing_elements: cloneAndExcludeBlocks(n.getSelfClosingElements()),
                    cdata: function (a) {
                        node.append(createNode('#cdata', 4)).value = a
                    },
                    text: function (a, b) {
                        var c;
                        if (!isInWhiteSpacePreservedElement) {
                            a = a.replace(allWhiteSpaceRegExp, ' ');
                            if (node.lastChild && h[node.lastChild.name]) {
                                a = a.replace(startWhiteSpaceRegExp, '')
                            }
                        }
                        if (a.length !== 0) {
                            c = createNode('#text', 3);
                            c.raw = !!b;
                            node.append(c).value = a
                        }
                    },
                    comment: function (a) {
                        node.append(createNode('#comment', 8)).value = a
                    },
                    pi: function (a, b) {
                        node.append(createNode(a, 7)).value = b;
                        removeWhitespaceBefore(node)
                    },
                    doctype: function (a) {
                        var b;
                        b = node.append(createNode('#doctype', 10));
                        b.value = a;
                        removeWhitespaceBefore(node)
                    },
                    start: function (a, b, c) {
                        var d, attrFiltersLen, elementRule, attrName, parent;
                        elementRule = validate ? n.getElementRule(a) : {};
                        if (elementRule) {
                            d = createNode(elementRule.outputName || a, 1);
                            d.attributes = b;
                            d.shortEnded = c;
                            node.append(d);
                            parent = k[node.name];
                            if (parent && k[d.name] && !parent[d.name]) {
                                invalidChildren.push(d)
                            }
                            attrFiltersLen = attributeFilters.length;
                            while (attrFiltersLen--) {
                                attrName = attributeFilters[attrFiltersLen].name;
                                if (attrName in b.map) {
                                    list = matchedAttributes[attrName];
                                    if (list) {
                                        list.push(d)
                                    } else {
                                        matchedAttributes[attrName] = [d]
                                    }
                                }
                            }
                            if (h[a]) {
                                removeWhitespaceBefore(d)
                            }
                            if (!c) {
                                node = d
                            }
                            if (!isInWhiteSpacePreservedElement && whiteSpaceElements[a]) {
                                isInWhiteSpacePreservedElement = true
                            }
                        }
                    },
                    end: function (a) {
                        var b, elementRule, text, sibling, tempNode;
                        elementRule = validate ? n.getElementRule(a) : {};
                        if (elementRule) {
                            if (h[a]) {
                                if (!isInWhiteSpacePreservedElement) {
                                    b = node.firstChild;
                                    if (b && b.type === 3) {
                                        text = b.value.replace(startWhiteSpaceRegExp, '');
                                        if (text.length > 0) {
                                            b.value = text;
                                            b = b.next
                                        } else {
                                            sibling = b.next;
                                            b.remove();
                                            b = sibling;
                                            while (b && b.type === 3) {
                                                text = b.value;
                                                sibling = b.next;
                                                if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
                                                    b.remove();
                                                    b = sibling
                                                }
                                                b = sibling
                                            }
                                        }
                                    }
                                    b = node.lastChild;
                                    if (b && b.type === 3) {
                                        text = b.value.replace(j, '');
                                        if (text.length > 0) {
                                            b.value = text;
                                            b = b.prev
                                        } else {
                                            sibling = b.prev;
                                            b.remove();
                                            b = sibling;
                                            while (b && b.type === 3) {
                                                text = b.value;
                                                sibling = b.prev;
                                                if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
                                                    b.remove();
                                                    b = sibling
                                                }
                                                b = sibling
                                            }
                                        }
                                    }
                                }
                            }
                            if (isInWhiteSpacePreservedElement && whiteSpaceElements[a]) {
                                isInWhiteSpacePreservedElement = false
                            }
                            if (elementRule.removeEmpty || elementRule.paddEmpty) {
                                if (node.isEmpty(nonEmptyElements)) {
                                    if (elementRule.paddEmpty) {
                                        node.empty().append(new p('#text', '3')).value = '\u00a0';
                                    } else {
                                        if (!node.attributes.map.name && !node.attributes.map.id) {
                                            tempNode = node.parent;
                                            if (h[node.name]) {
                                                node.empty().remove()
                                            } else {
                                                node.unwrap()
                                            }
                                            node = tempNode;
                                            return
                                        }
                                    }
                                }
                            }
                            node = node.parent
                        }
                    }
                }, n);
                rootNode = node = new p(f.context || m.root_name, 11);
                g.parse(e);
                if (validate && invalidChildren.length) {
                    if (!f.context) {
                        fixInvalidChildren(invalidChildren)
                    } else {
                        f.invalid = true
                    }
                }
                if (rootBlockName && (rootNode.name == 'body' || f.isRootContent)) {
                    addRootBlocks()
                }
                if (!f.invalid) {
                    for (name in matchedNodes) {
                        list = nodeFilters[name];
                        nodes = matchedNodes[name];
                        fi = nodes.length;
                        while (fi--) {
                            if (!nodes[fi].parent) {
                                nodes.splice(fi, 1)
                            }
                        }
                        for (i = 0, l = list.length; i < l; i++) {
                            list[i](nodes, name, f)
                        }
                    }
                    for (i = 0, l = attributeFilters.length; i < l; i++) {
                        list = attributeFilters[i];
                        if (list.name in matchedAttributes) {
                            nodes = matchedAttributes[list.name];
                            fi = nodes.length;
                            while (fi--) {
                                if (!nodes[fi].parent) {
                                    nodes.splice(fi, 1)
                                }
                            }
                            for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
                                list.callbacks[fi](nodes, list.name, f)
                            }
                        }
                    }
                }
                return rootNode
            };
            if (m.remove_trailing_brs) {
                o.addNodeFilter('br', function (a) {
                    var i, l = a.length,
                        node, blockElements = extend({}, n.getBlockElements());
                    var b = n.getNonEmptyElements(),
                        parent, lastParent, prev, prevName;
                    var c, textNode;
                    blockElements.body = 1;
                    for (i = 0; i < l; i++) {
                        node = a[i];
                        parent = node.parent;
                        if (blockElements[node.parent.name] && node === parent.lastChild) {
                            prev = node.prev;
                            while (prev) {
                                prevName = prev.name;
                                if (prevName !== "span" || prev.attr('data-mce-type') !== 'bookmark') {
                                    if (prevName !== "br") {
                                        break
                                    }
                                    if (prevName === 'br') {
                                        node = null;
                                        break
                                    }
                                }
                                prev = prev.prev
                            }
                            if (node) {
                                node.remove();
                                if (parent.isEmpty(b)) {
                                    c = n.getElementRule(parent.name);
                                    if (c) {
                                        if (c.removeEmpty) {
                                            parent.remove()
                                        } else if (c.paddEmpty) {
                                            parent.empty().append(new p('#text', 3)).value = '\u00a0';
                                        }
                                    }
                                }
                            }
                        } else {
                            lastParent = node;
                            while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
                                lastParent = parent;
                                if (blockElements[parent.name]) {
                                    break
                                }
                                parent = parent.parent
                            }
                            if (lastParent === parent) {
                                textNode = new p('#text', 3);
                                textNode.value = '\u00a0';
                                node.replace(textNode)
                            }
                        }
                    }
                })
            }
            if (!m.allow_html_in_named_anchor) {
                o.addAttributeFilter('id,name', function (a) {
                    var i = a.length,
                        sibling, prevSibling, parent, node;
                    while (i--) {
                        node = a[i];
                        if (node.name === 'a' && node.firstChild && !node.attr('href')) {
                            parent = node.parent;
                            sibling = node.lastChild;
                            do {
                                prevSibling = sibling.prev;
                                parent.insert(sibling, node);
                                sibling = prevSibling
                            } while (sibling)
                        }
                    }
                })
            }
            if (m.validate && n.getValidClasses()) {
                o.addAttributeFilter('class', function (a) {
                    var i = a.length,
                        node, classList, ci, className, classValue;
                    var b = n.getValidClasses(),
                        validClassesMap, valid;
                    while (i--) {
                        node = a[i];
                        classList = node.attr('class').split(' ');
                        classValue = '';
                        for (ci = 0; ci < classList.length; ci++) {
                            className = classList[ci];
                            valid = false;
                            validClassesMap = b['*'];
                            if (validClassesMap && validClassesMap[className]) {
                                valid = true
                            }
                            validClassesMap = b[node.name];
                            if (!valid && validClassesMap && validClassesMap[className]) {
                                valid = true
                            }
                            if (valid) {
                                if (classValue) {
                                    classValue += ' '
                                }
                                classValue += className
                            }
                        }
                        if (!classValue.length) {
                            classValue = null
                        }
                        node.attr('class', classValue)
                    }
                })
            }
        }
    });
    define("tinymce/html/Writer", ["tinymce/html/Entities", "tinymce/util/Tools"], function (f, g) {
        var h = g.makeMap;
        return function (d) {
            var e = [],
                indent, indentBefore, indentAfter, encode, htmlOutput;
            d = d || {};
            indent = d.indent;
            indentBefore = h(d.indent_before || '');
            indentAfter = h(d.indent_after || '');
            encode = f.getEncodeFunc(d.entity_encoding || 'raw', d.entities);
            htmlOutput = d.element_format == "html";
            return {
                start: function (a, b, c) {
                    var i, l, attr, value;
                    if (indent && indentBefore[a] && e.length > 0) {
                        value = e[e.length - 1];
                        if (value.length > 0 && value !== '\n') {
                            e.push('\n')
                        }
                    }
                    e.push('<', a);
                    if (b) {
                        for (i = 0, l = b.length; i < l; i++) {
                            attr = b[i];
                            e.push(' ', attr.name, '="', encode(attr.value, true), '"')
                        }
                    }
                    if (!c || htmlOutput) {
                        e[e.length] = '>'
                    } else {
                        e[e.length] = ' />'
                    }
                    if (c && indent && indentAfter[a] && e.length > 0) {
                        value = e[e.length - 1];
                        if (value.length > 0 && value !== '\n') {
                            e.push('\n')
                        }
                    }
                },
                end: function (a) {
                    var b;
                    e.push('</', a, '>');
                    if (indent && indentAfter[a] && e.length > 0) {
                        b = e[e.length - 1];
                        if (b.length > 0 && b !== '\n') {
                            e.push('\n')
                        }
                    }
                },
                text: function (a, b) {
                    if (a.length > 0) {
                        e[e.length] = b ? a : encode(a)
                    }
                },
                cdata: function (a) {
                    e.push('<![CDATA[', a, ']]>')
                },
                comment: function (a) {
                    e.push('<!--', a, '-->')
                },
                pi: function (a, b) {
                    if (b) {
                        e.push('<?', a, ' ', encode(b), '?>')
                    } else {
                        e.push('<?', a, '?>')
                    }
                    if (indent) {
                        e.push('\n')
                    }
                },
                doctype: function (a) {
                    e.push('<!DOCTYPE', a, '>', indent ? '\n' : '')
                },
                reset: function () {
                    e.length = 0
                },
                getContent: function () {
                    return e.join('').replace(/\n$/, '')
                }
            }
        }
    });
    define("tinymce/html/Serializer", ["tinymce/html/Writer", "tinymce/html/Schema"], function (h, j) {
        return function (e, f) {
            var g = this,
                writer = new h(e);
            e = e || {};
            e.validate = "validate" in e ? e.validate : true;
            g.schema = f = f || new j();
            g.writer = writer;
            g.serialize = function (c) {
                var d, validate;
                validate = e.validate;
                d = {
                    3: function (a) {
                        writer.text(a.value, a.raw)
                    },
                    8: function (a) {
                        writer.comment(a.value)
                    },
                    7: function (a) {
                        writer.pi(a.name, a.value)
                    },
                    10: function (a) {
                        writer.doctype(a.value)
                    },
                    4: function (a) {
                        writer.cdata(a.value)
                    },
                    11: function (a) {
                        if ((a = a.firstChild)) {
                            do {
                                walk(a)
                            } while ((a = a.next))
                        }
                    }
                };
                writer.reset();

                function walk(a) {
                    var b = d[a.type],
                        name, isEmpty, attrs, attrName, attrValue, sortedAttrs, i, l, elementRule;
                    if (!b) {
                        name = a.name;
                        isEmpty = a.shortEnded;
                        attrs = a.attributes;
                        if (validate && attrs && attrs.length > 1) {
                            sortedAttrs = [];
                            sortedAttrs.map = {};
                            elementRule = f.getElementRule(a.name);
                            if (elementRule) {
                                for (i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
                                    attrName = elementRule.attributesOrder[i];
                                    if (attrName in attrs.map) {
                                        attrValue = attrs.map[attrName];
                                        sortedAttrs.map[attrName] = attrValue;
                                        sortedAttrs.push({
                                            name: attrName,
                                            value: attrValue
                                        })
                                    }
                                }
                                for (i = 0, l = attrs.length; i < l; i++) {
                                    attrName = attrs[i].name;
                                    if (!(attrName in sortedAttrs.map)) {
                                        attrValue = attrs.map[attrName];
                                        sortedAttrs.map[attrName] = attrValue;
                                        sortedAttrs.push({
                                            name: attrName,
                                            value: attrValue
                                        })
                                    }
                                }
                                attrs = sortedAttrs
                            }
                        }
                        writer.start(a.name, attrs, isEmpty);
                        if (!isEmpty) {
                            if ((a = a.firstChild)) {
                                do {
                                    walk(a)
                                } while ((a = a.next))
                            }
                            writer.end(name)
                        }
                    } else {
                        b(a)
                    }
                }
                if (c.type == 1 && !e.inner) {
                    walk(c)
                } else {
                    d[11](c)
                }
                return writer.getContent()
            }
        }
    });
    define("tinymce/dom/Serializer", ["tinymce/dom/DOMUtils", "tinymce/html/DomParser", "tinymce/html/SaxParser", "tinymce/html/Entities", "tinymce/html/Serializer", "tinymce/html/Node", "tinymce/html/Schema", "tinymce/Env", "tinymce/util/Tools", "tinymce/text/Zwsp"], function (h, j, k, l, m, n, o, p, q, r) {
        var s = q.each,
            trim = q.trim;
        var t = h.DOM,
            tempAttrs = ["data-mce-selected"];

        function trimTrailingBr(b) {
            var c, brNode2;

            function isBr(a) {
                return a && a.name === 'br'
            }
            c = b.lastChild;
            if (isBr(c)) {
                brNode2 = c.prev;
                if (isBr(brNode2)) {
                    c.remove();
                    brNode2.remove()
                }
            }
        }
        return function (e, f) {
            var g, schema, htmlParser;
            if (f) {
                g = f.dom;
                schema = f.schema
            }
            function trimHtml(a) {
                var b = new RegExp(['<span[^>]+data-mce-bogus[^>]+>[\u200B\uFEFF]+<\\/span>', '\\s?(' + tempAttrs.join('|') + ')="[^"]+"'].join('|'), 'gi');
                a = r.trim(a.replace(b, ''));
                return a
            }
            function getTrimmedContent() {
                var a = f.getBody().innerHTML;
                var b = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
                var c, index, matchLength, matches, shortEndedElements, schema = f.schema;
                a = trimHtml(a);
                shortEndedElements = schema.getShortEndedElements();
                while ((matches = b.exec(a))) {
                    index = b.lastIndex;
                    matchLength = matches[0].length;
                    if (shortEndedElements[matches[1]]) {
                        c = index
                    } else {
                        c = k.findEndTag(schema, a, index)
                    }
                    a = a.substring(0, index - matchLength) + a.substring(c);
                    b.lastIndex = index - matchLength
                }
                return trim(a)
            }
            function addTempAttr(c) {
                if (q.inArray(tempAttrs, c) === -1) {
                    htmlParser.addAttributeFilter(c, function (a, b) {
                        var i = a.length;
                        while (i--) {
                            a[i].attr(b, null)
                        }
                    });
                    tempAttrs.push(c)
                }
            }
            g = g || t;
            schema = schema || new o(e);
            e.entity_encoding = e.entity_encoding || 'named';
            e.remove_trailing_brs = "remove_trailing_brs" in e ? e.remove_trailing_brs : true;
            htmlParser = new j(e, schema);
            htmlParser.addAttributeFilter('data-mce-tabindex', function (a, b) {
                var i = a.length,
                    node;
                while (i--) {
                    node = a[i];
                    node.attr('tabindex', node.attributes.map['data-mce-tabindex']);
                    node.attr(b, null)
                }
            });
            htmlParser.addAttributeFilter('src,href,style', function (a, b) {
                var i = a.length,
                    node, value, internalName = 'data-mce-' + b;
                var c = e.url_converter,
                    urlConverterScope = e.url_converter_scope,
                    undef;
                while (i--) {
                    node = a[i];
                    value = node.attributes.map[internalName];
                    if (value !== undef) {
                        node.attr(b, value.length > 0 ? value : null);
                        node.attr(internalName, null)
                    } else {
                        value = node.attributes.map[b];
                        if (b === "style") {
                            value = g.serializeStyle(g.parseStyle(value), node.name)
                        } else if (c) {
                            value = c.call(urlConverterScope, value, b, node.name)
                        }
                        node.attr(b, value.length > 0 ? value : null)
                    }
                }
            });
            htmlParser.addAttributeFilter('class', function (a) {
                var i = a.length,
                    node, value;
                while (i--) {
                    node = a[i];
                    value = node.attr('class');
                    if (value) {
                        value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
                        node.attr('class', value.length > 0 ? value : null)
                    }
                }
            });
            htmlParser.addAttributeFilter('data-mce-type', function (a, b, c) {
                var i = a.length,
                    node;
                while (i--) {
                    node = a[i];
                    if (node.attributes.map['data-mce-type'] === 'bookmark' && !c.cleanup) {
                        node.remove()
                    }
                }
            });
            htmlParser.addNodeFilter('noscript', function (a) {
                var i = a.length,
                    node;
                while (i--) {
                    node = a[i].firstChild;
                    if (node) {
                        node.value = l.decode(node.value)
                    }
                }
            });
            htmlParser.addNodeFilter('script,style', function (b, c) {
                var i = b.length,
                    node, value, type;

                function trim(a) {
                    return a.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n').replace(/^[\r\n]*|[\r\n]*$/g, '').replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '').replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '')
                }
                while (i--) {
                    node = b[i];
                    value = node.firstChild ? node.firstChild.value : '';
                    if (c === "script") {
                        type = node.attr('type');
                        if (type) {
                            node.attr('type', type == 'mce-no/type' ? null : type.replace(/^mce\-/, ''))
                        }
                        if (value.length > 0) {
                            node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>'
                        }
                    } else {
                        if (value.length > 0) {
                            node.firstChild.value = '<!--\n' + trim(value) + '\n-->'
                        }
                    }
                }
            });
            htmlParser.addNodeFilter('#comment', function (a) {
                var i = a.length,
                    node;
                while (i--) {
                    node = a[i];
                    if (node.value.indexOf('[CDATA[') === 0) {
                        node.name = '#cdata';
                        node.type = 4;
                        node.value = node.value.replace(/^\[CDATA\[|\]\]$/g, '')
                    } else if (node.value.indexOf('mce:protected ') === 0) {
                        node.name = "#text";
                        node.type = 3;
                        node.raw = true;
                        node.value = unescape(node.value).substr(14)
                    }
                }
            });
            htmlParser.addNodeFilter('xml:namespace,input', function (a, b) {
                var i = a.length,
                    node;
                while (i--) {
                    node = a[i];
                    if (node.type === 7) {
                        node.remove()
                    } else if (node.type === 1) {
                        if (b === "input" && !("type" in node.attributes.map)) {
                            node.attr('type', 'text')
                        }
                    }
                }
            });
            if (e.fix_list_elements) {
                htmlParser.addNodeFilter('ul,ol', function (a) {
                    var i = a.length,
                        node, parentNode;
                    while (i--) {
                        node = a[i];
                        parentNode = node.parent;
                        if (parentNode.name === 'ul' || parentNode.name === 'ol') {
                            if (node.prev && node.prev.name === 'li') {
                                node.prev.append(node)
                            }
                        }
                    }
                })
            }
            htmlParser.addAttributeFilter('data-mce-src,data-mce-href,data-mce-style,' + 'data-mce-selected,data-mce-expando,' + 'data-mce-type,data-mce-resize', function (a, b) {
                var i = a.length;
                while (i--) {
                    a[i].attr(b, null)
                }
            });
            return {
                schema: schema,
                addNodeFilter: htmlParser.addNodeFilter,
                addAttributeFilter: htmlParser.addAttributeFilter,
                serialize: function (b, c) {
                    var d = this,
                        impl, doc, oldDoc, htmlSerializer, content, rootNode;
                    if (p.ie && g.select('script,style,select,map').length > 0) {
                        content = b.innerHTML;
                        b = b.cloneNode(false);
                        g.setHTML(b, content)
                    } else {
                        b = b.cloneNode(true)
                    }
                    impl = document.implementation;
                    if (impl.createHTMLDocument) {
                        doc = impl.createHTMLDocument("");
                        s(b.nodeName == 'BODY' ? b.childNodes : [b], function (a) {
                            doc.body.appendChild(doc.importNode(a, true))
                        });
                        if (b.nodeName != 'BODY') {
                            b = doc.body.firstChild
                        } else {
                            b = doc.body
                        }
                        oldDoc = g.doc;
                        g.doc = doc
                    }
                    c = c || {};
                    c.format = c.format || 'html';
                    if (c.selection) {
                        c.forced_root_block = ''
                    }
                    if (!c.no_events) {
                        c.node = b;
                        d.onPreProcess(c)
                    }
                    rootNode = htmlParser.parse(trim(c.getInner ? b.innerHTML : g.getOuterHTML(b)), c);
                    trimTrailingBr(rootNode);
                    htmlSerializer = new m(e, schema);
                    c.content = htmlSerializer.serialize(rootNode);
                    if (!c.cleanup) {
                        c.content = r.trim(c.content);
                        c.content = c.content.replace(/\uFEFF/g, '')
                    }
                    if (!c.no_events) {
                        d.onPostProcess(c)
                    }
                    if (oldDoc) {
                        g.doc = oldDoc
                    }
                    c.node = null;
                    return c.content
                },
                addRules: function (a) {
                    schema.addValidElements(a)
                },
                setRules: function (a) {
                    schema.setValidElements(a)
                },
                onPreProcess: function (a) {
                    if (f) {
                        f.fire('PreProcess', a)
                    }
                },
                onPostProcess: function (a) {
                    if (f) {
                        f.fire('PostProcess', a)
                    }
                },
                addTempAttr: addTempAttr,
                trimHtml: trimHtml,
                getTrimmedContent: getTrimmedContent
            }
        }
    });
    define("tinymce/dom/TridentSelection", [], function () {
        function Selection(e) {
            var f = this,
                dom = e.dom,
                FALSE = false;

            function getPosition(a, b) {
                var c, startIndex = 0,
                    endIndex, inside, children, child, offset, index, position = -1,
                    parent;
                c = a.duplicate();
                c.collapse(b);
                parent = c.parentElement();
                if (parent.ownerDocument !== e.dom.doc) {
                    return
                }
                while (parent.contentEditable === "false") {
                    parent = parent.parentNode
                }
                if (!parent.hasChildNodes()) {
                    return {
                        node: parent,
                        inside: 1
                    }
                }
                children = parent.children;
                endIndex = children.length - 1;
                while (startIndex <= endIndex) {
                    index = Math.floor((startIndex + endIndex) / 2);
                    child = children[index];
                    c.moveToElementText(child);
                    position = c.compareEndPoints(b ? 'StartToStart' : 'EndToEnd', a);
                    if (position > 0) {
                        endIndex = index - 1
                    } else if (position < 0) {
                        startIndex = index + 1
                    } else {
                        return {
                            node: child
                        }
                    }
                }
                if (position < 0) {
                    if (!child) {
                        c.moveToElementText(parent);
                        c.collapse(true);
                        child = parent;
                        inside = true
                    } else {
                        c.collapse(false)
                    }
                    offset = 0;
                    while (c.compareEndPoints(b ? 'StartToStart' : 'StartToEnd', a) !== 0) {
                        if (c.move('character', 1) === 0 || parent != c.parentElement()) {
                            break
                        }
                        offset++
                    }
                } else {
                    c.collapse(true);
                    offset = 0;
                    while (c.compareEndPoints(b ? 'StartToStart' : 'StartToEnd', a) !== 0) {
                        if (c.move('character', -1) === 0 || parent != c.parentElement()) {
                            break
                        }
                        offset++
                    }
                }
                return {
                    node: child,
                    position: position,
                    offset: offset,
                    inside: inside
                }
            }
            function getRange() {
                var c = e.getRng(),
                    domRange = dom.createRng(),
                    element, collapsed, tmpRange, element2, bookmark;
                element = c.item ? c.item(0) : c.parentElement();
                if (element.ownerDocument != dom.doc) {
                    return domRange
                }
                collapsed = e.isCollapsed();
                if (c.item) {
                    domRange.setStart(element.parentNode, dom.nodeIndex(element));
                    domRange.setEnd(domRange.startContainer, domRange.startOffset + 1);
                    return domRange
                }
                function findEndPoint(a) {
                    var b = getPosition(c, a),
                        container, offset, textNodeOffset = 0,
                        sibling, undef, nodeValue;
                    container = b.node;
                    offset = b.offset;
                    if (b.inside && !container.hasChildNodes()) {
                        domRange[a ? 'setStart' : 'setEnd'](container, 0);
                        return
                    }
                    if (offset === undef) {
                        domRange[a ? 'setStartBefore' : 'setEndAfter'](container);
                        return
                    }
                    if (b.position < 0) {
                        sibling = b.inside ? container.firstChild : container.nextSibling;
                        if (!sibling) {
                            domRange[a ? 'setStartAfter' : 'setEndAfter'](container);
                            return
                        }
                        if (!offset) {
                            if (sibling.nodeType == 3) {
                                domRange[a ? 'setStart' : 'setEnd'](sibling, 0)
                            } else {
                                domRange[a ? 'setStartBefore' : 'setEndBefore'](sibling)
                            }
                            return
                        }
                        while (sibling) {
                            if (sibling.nodeType == 3) {
                                nodeValue = sibling.nodeValue;
                                textNodeOffset += nodeValue.length;
                                if (textNodeOffset >= offset) {
                                    container = sibling;
                                    textNodeOffset -= offset;
                                    textNodeOffset = nodeValue.length - textNodeOffset;
                                    break
                                }
                            }
                            sibling = sibling.nextSibling
                        }
                    } else {
                        sibling = container.previousSibling;
                        if (!sibling) {
                            return domRange[a ? 'setStartBefore' : 'setEndBefore'](container)
                        }
                        if (!offset) {
                            if (container.nodeType == 3) {
                                domRange[a ? 'setStart' : 'setEnd'](sibling, container.nodeValue.length)
                            } else {
                                domRange[a ? 'setStartAfter' : 'setEndAfter'](sibling)
                            }
                            return
                        }
                        while (sibling) {
                            if (sibling.nodeType == 3) {
                                textNodeOffset += sibling.nodeValue.length;
                                if (textNodeOffset >= offset) {
                                    container = sibling;
                                    textNodeOffset -= offset;
                                    break
                                }
                            }
                            sibling = sibling.previousSibling
                        }
                    }
                    domRange[a ? 'setStart' : 'setEnd'](container, textNodeOffset)
                }
                try {
                    findEndPoint(true);
                    if (!collapsed) {
                        findEndPoint()
                    }
                } catch (ex) {
                    if (ex.number == -2147024809) {
                        bookmark = f.getBookmark(2);
                        tmpRange = c.duplicate();
                        tmpRange.collapse(true);
                        element = tmpRange.parentElement();
                        if (!collapsed) {
                            tmpRange = c.duplicate();
                            tmpRange.collapse(false);
                            element2 = tmpRange.parentElement();
                            element2.innerHTML = element2.innerHTML
                        }
                        element.innerHTML = element.innerHTML;
                        f.moveToBookmark(bookmark);
                        c = e.getRng();
                        findEndPoint(true);
                        if (!collapsed) {
                            findEndPoint()
                        }
                    } else {
                        throw ex
                    }
                }
                return domRange
            }
            this.getBookmark = function (c) {
                var d = e.getRng(),
                    bookmark = {};

                function getIndexes(a) {
                    var b, root, children, i, indexes = [];
                    b = a.parentNode;
                    root = dom.getRoot().parentNode;
                    while (b != root && b.nodeType !== 9) {
                        children = b.children;
                        i = children.length;
                        while (i--) {
                            if (a === children[i]) {
                                indexes.push(i);
                                break
                            }
                        }
                        a = b;
                        b = b.parentNode
                    }
                    return indexes
                }
                function getBookmarkEndPoint(a) {
                    var b;
                    b = getPosition(d, a);
                    if (b) {
                        return {
                            position: b.position,
                            offset: b.offset,
                            indexes: getIndexes(b.node),
                            inside: b.inside
                        }
                    }
                }
                if (c === 2) {
                    if (!d.item) {
                        bookmark.start = getBookmarkEndPoint(true);
                        if (!e.isCollapsed()) {
                            bookmark.end = getBookmarkEndPoint()
                        }
                    } else {
                        bookmark.start = {
                            ctrl: true,
                            indexes: getIndexes(d.item(0))
                        }
                    }
                }
                return bookmark
            };
            this.moveToBookmark = function (c) {
                var d, body = dom.doc.body;

                function resolveIndexes(a) {
                    var b, i, idx, children;
                    b = dom.getRoot();
                    for (i = a.length - 1; i >= 0; i--) {
                        children = b.children;
                        idx = a[i];
                        if (idx <= children.length - 1) {
                            b = children[idx]
                        }
                    }
                    return b
                }
                function setBookmarkEndPoint(a) {
                    var b = c[a ? 'start' : 'end'],
                        moveLeft, moveRng, undef, offset;
                    if (b) {
                        moveLeft = b.position > 0;
                        moveRng = body.createTextRange();
                        moveRng.moveToElementText(resolveIndexes(b.indexes));
                        offset = b.offset;
                        if (offset !== undef) {
                            moveRng.collapse(b.inside || moveLeft);
                            moveRng.moveStart('character', moveLeft ? -offset : offset)
                        } else {
                            moveRng.collapse(a)
                        }
                        d.setEndPoint(a ? 'StartToStart' : 'EndToStart', moveRng);
                        if (a) {
                            d.collapse(true)
                        }
                    }
                }
                if (c.start) {
                    if (c.start.ctrl) {
                        d = body.createControlRange();
                        d.addElement(resolveIndexes(c.start.indexes));
                        d.select()
                    } else {
                        d = body.createTextRange();
                        setBookmarkEndPoint(true);
                        setBookmarkEndPoint();
                        d.select()
                    }
                }
            };
            this.addRange = function (c) {
                var d, ctrlRng, startContainer, startOffset, endContainer, endOffset, sibling, doc = e.dom.doc,
                    body = doc.body,
                    nativeRng, ctrlElm;

                function setEndPoint(a) {
                    var b, offset, marker, tmpRng, nodes;
                    marker = dom.create('a');
                    b = a ? startContainer : endContainer;
                    offset = a ? startOffset : endOffset;
                    tmpRng = d.duplicate();
                    if (b == doc || b == doc.documentElement) {
                        b = body;
                        offset = 0
                    }
                    if (b.nodeType == 3) {
                        b.parentNode.insertBefore(marker, b);
                        tmpRng.moveToElementText(marker);
                        tmpRng.moveStart('character', offset);
                        dom.remove(marker);
                        d.setEndPoint(a ? 'StartToStart' : 'EndToEnd', tmpRng)
                    } else {
                        nodes = b.childNodes;
                        if (nodes.length) {
                            if (offset >= nodes.length) {
                                dom.insertAfter(marker, nodes[nodes.length - 1])
                            } else {
                                b.insertBefore(marker, nodes[offset])
                            }
                            tmpRng.moveToElementText(marker)
                        } else if (b.canHaveHTML) {
                            b.innerHTML = '<span>&#xFEFF;</span>';
                            marker = b.firstChild;
                            tmpRng.moveToElementText(marker);
                            tmpRng.collapse(FALSE)
                        }
                        d.setEndPoint(a ? 'StartToStart' : 'EndToEnd', tmpRng);
                        dom.remove(marker)
                    }
                }
                startContainer = c.startContainer;
                startOffset = c.startOffset;
                endContainer = c.endContainer;
                endOffset = c.endOffset;
                d = body.createTextRange();
                if (startContainer == endContainer && startContainer.nodeType == 1) {
                    if (startOffset == endOffset && !startContainer.hasChildNodes()) {
                        if (startContainer.canHaveHTML) {
                            sibling = startContainer.previousSibling;
                            if (sibling && !sibling.hasChildNodes() && dom.isBlock(sibling)) {
                                sibling.innerHTML = '&#xFEFF;'
                            } else {
                                sibling = null
                            }
                            startContainer.innerHTML = '<span>&#xFEFF;</span><span>&#xFEFF;</span>';
                            d.moveToElementText(startContainer.lastChild);
                            d.select();
                            dom.doc.selection.clear();
                            startContainer.innerHTML = '';
                            if (sibling) {
                                sibling.innerHTML = ''
                            }
                            return
                        }
                        startOffset = dom.nodeIndex(startContainer);
                        startContainer = startContainer.parentNode
                    }
                    if (startOffset == endOffset - 1) {
                        try {
                            ctrlElm = startContainer.childNodes[startOffset];
                            ctrlRng = body.createControlRange();
                            ctrlRng.addElement(ctrlElm);
                            ctrlRng.select();
                            nativeRng = e.getRng();
                            if (nativeRng.item && ctrlElm === nativeRng.item(0)) {
                                return
                            }
                        } catch (ex) { }
                    }
                }
                setEndPoint(true);
                setEndPoint();
                d.select()
            };
            this.getRangeAt = getRange
        }
        return Selection
    });
    define("tinymce/util/VK", ["tinymce/Env"], function (a) {
        return {
            BACKSPACE: 8,
            DELETE: 46,
            DOWN: 40,
            ENTER: 13,
            LEFT: 37,
            RIGHT: 39,
            SPACEBAR: 32,
            TAB: 9,
            UP: 38,
            modifierPressed: function (e) {
                return e.shiftKey || e.ctrlKey || e.altKey || this.metaKeyPressed(e)
            },
            metaKeyPressed: function (e) {
                return (a.mac ? e.metaKey : e.ctrlKey && !e.altKey)
            }
        }
    });
    define("tinymce/dom/ControlSelection", ["tinymce/util/VK", "tinymce/util/Tools", "tinymce/util/Delay", "tinymce/Env", "tinymce/dom/NodeType"], function (q, r, s, t, u) {
        var v = u.isContentEditableFalse;
        var w = u.isContentEditableTrue;

        function getContentEditableRoot(a, b) {
            while (b && b != a) {
                if (w(b) || v(b)) {
                    return b
                }
                b = b.parentNode
            }
            return null
        }
        return function (i, j) {
            var k = j.dom,
                each = r.each;
            var l, selectedElmGhost, resizeHelper, resizeHandles, selectedHandle, lastMouseDownEvent;
            var m, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
            var n, height, editableDoc = j.getDoc(),
                rootDocument = document,
                isIE = t.ie && t.ie < 11;
            var o = Math.abs,
                round = Math.round,
                rootElement = j.getBody(),
                startScrollWidth, startScrollHeight;
            resizeHandles = {
                nw: [0, 0, -1, -1],
                ne: [1, 0, 1, -1],
                se: [1, 1, 1, 1],
                sw: [0, 1, -1, 1]
            };
            var p = '.mce-content-body';
            j.contentStyles.push(p + ' div.mce-resizehandle {' + 'position: absolute;' + 'border: 1px solid black;' + 'box-sizing: box-sizing;' + 'background: #FFF;' + 'width: 7px;' + 'height: 7px;' + 'z-index: 10000' + '}' + p + ' .mce-resizehandle:hover {' + 'background: #000' + '}' + p + ' img[data-mce-selected],' + p + ' hr[data-mce-selected] {' + 'outline: 1px solid black;' + 'resize: none' + '}' + p + ' .mce-clonedresizable {' + 'position: absolute;' + (t.gecko ? '' : 'outline: 1px dashed black;') + 'opacity: .5;' + 'filter: alpha(opacity=50);' + 'z-index: 10000' + '}' + p + ' .mce-resize-helper {' + 'background: #555;' + 'background: rgba(0,0,0,0.75);' + 'border-radius: 3px;' + 'border: 1px;' + 'color: white;' + 'display: none;' + 'font-family: sans-serif;' + 'font-size: 12px;' + 'white-space: nowrap;' + 'line-height: 14px;' + 'margin: 5px 10px;' + 'padding: 5px;' + 'position: absolute;' + 'z-index: 10001' + '}');

            function isResizable(a) {
                var b = j.settings.object_resizing;
                if (b === false || t.iOS) {
                    return false
                }
                if (typeof b != 'string') {
                    b = 'table,img,div'
                }
                if (a.getAttribute('data-mce-resize') === 'false') {
                    return false
                }
                if (a == j.getBody()) {
                    return false
                }
                return j.dom.is(a, b)
            }
            function resizeGhostElement(e) {
                var a, deltaY, proportional;
                var b, resizeHelperY;
                a = e.screenX - m;
                deltaY = e.screenY - startY;
                n = a * selectedHandle[2] + startW;
                height = deltaY * selectedHandle[3] + startH;
                n = n < 5 ? 5 : n;
                height = height < 5 ? 5 : height;
                if (l.nodeName == "IMG" && j.settings.resize_img_proportional !== false) {
                    proportional = !q.modifierPressed(e)
                } else {
                    proportional = q.modifierPressed(e) || (l.nodeName == "IMG" && selectedHandle[2] * selectedHandle[3] !== 0)
                }
                if (proportional) {
                    if (o(a) > o(deltaY)) {
                        height = round(n * ratio);
                        n = round(height / ratio)
                    } else {
                        n = round(height / ratio);
                        height = round(n * ratio)
                    }
                }
                k.setStyles(selectedElmGhost, {
                    width: n,
                    height: height
                });
                b = selectedHandle.startPos.x + a;
                resizeHelperY = selectedHandle.startPos.y + deltaY;
                b = b > 0 ? b : 0;
                resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
                k.setStyles(resizeHelper, {
                    left: b,
                    top: resizeHelperY,
                    display: 'block'
                });
                resizeHelper.innerHTML = n + ' &times; ' + height;
                if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= n) {
                    k.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - n))
                }
                if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
                    k.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height))
                }
                a = rootElement.scrollWidth - startScrollWidth;
                deltaY = rootElement.scrollHeight - startScrollHeight;
                if (a + deltaY !== 0) {
                    k.setStyles(resizeHelper, {
                        left: b - a,
                        top: resizeHelperY - deltaY
                    })
                }
                if (!resizeStarted) {
                    j.fire('ObjectResizeStart', {
                        target: l,
                        width: startW,
                        height: startH
                    });
                    resizeStarted = true
                }
            }
            function endGhostResize() {
                resizeStarted = false;

                function setSizeProp(a, b) {
                    if (b) {
                        if (l.style[a] || !j.schema.isValid(l.nodeName.toLowerCase(), a)) {
                            k.setStyle(l, a, b)
                        } else {
                            k.setAttrib(l, a, b)
                        }
                    }
                }
                setSizeProp('width', n);
                setSizeProp('height', height);
                k.unbind(editableDoc, 'mousemove', resizeGhostElement);
                k.unbind(editableDoc, 'mouseup', endGhostResize);
                if (rootDocument != editableDoc) {
                    k.unbind(rootDocument, 'mousemove', resizeGhostElement);
                    k.unbind(rootDocument, 'mouseup', endGhostResize)
                }
                k.remove(selectedElmGhost);
                k.remove(resizeHelper);
                if (!isIE || l.nodeName == "TABLE") {
                    showResizeRect(l)
                }
                j.fire('ObjectResized', {
                    target: l,
                    width: n,
                    height: height
                });
                k.setAttrib(l, 'style', k.getAttrib(l, 'style'));
                j.nodeChanged()
            }
            function showResizeRect(d, f, g) {
                var h, targetWidth, targetHeight, e, rect;
                hideResizeRect();
                unbindResizeHandleEvents();
                h = k.getPos(d, rootElement);
                selectedElmX = h.x;
                selectedElmY = h.y;
                rect = d.getBoundingClientRect();
                targetWidth = rect.width || (rect.right - rect.left);
                targetHeight = rect.height || (rect.bottom - rect.top);
                if (l != d) {
                    detachResizeStartListener();
                    l = d;
                    n = height = 0
                }
                e = j.fire('ObjectSelected', {
                    target: d
                });
                if (isResizable(d) && !e.isDefaultPrevented()) {
                    each(resizeHandles, function (a, b) {
                        var c;

                        function startDrag(e) {
                            m = e.screenX;
                            startY = e.screenY;
                            startW = l.clientWidth;
                            startH = l.clientHeight;
                            ratio = startH / startW;
                            selectedHandle = a;
                            a.startPos = {
                                x: targetWidth * a[0] + selectedElmX,
                                y: targetHeight * a[1] + selectedElmY
                            };
                            startScrollWidth = rootElement.scrollWidth;
                            startScrollHeight = rootElement.scrollHeight;
                            selectedElmGhost = l.cloneNode(true);
                            k.addClass(selectedElmGhost, 'mce-clonedresizable');
                            k.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
                            selectedElmGhost.contentEditable = false;
                            selectedElmGhost.unSelectabe = true;
                            k.setStyles(selectedElmGhost, {
                                left: selectedElmX,
                                top: selectedElmY,
                                margin: 0
                            });
                            selectedElmGhost.removeAttribute('data-mce-selected');
                            rootElement.appendChild(selectedElmGhost);
                            k.bind(editableDoc, 'mousemove', resizeGhostElement);
                            k.bind(editableDoc, 'mouseup', endGhostResize);
                            if (rootDocument != editableDoc) {
                                k.bind(rootDocument, 'mousemove', resizeGhostElement);
                                k.bind(rootDocument, 'mouseup', endGhostResize)
                            }
                            resizeHelper = k.add(rootElement, 'div', {
                                'class': 'mce-resize-helper',
                                'data-mce-bogus': 'all'
                            }, startW + ' &times; ' + startH)
                        }
                        if (f) {
                            if (b == f) {
                                startDrag(g)
                            }
                            return
                        }
                        c = k.get('mceResizeHandle' + b);
                        if (c) {
                            k.remove(c)
                        }
                        c = k.add(rootElement, 'div', {
                            id: 'mceResizeHandle' + b,
                            'data-mce-bogus': 'all',
                            'class': 'mce-resizehandle',
                            unselectable: true,
                            style: 'cursor:' + b + '-resize; margin:0; padding:0'
                        });
                        if (t.ie) {
                            c.contentEditable = false
                        }
                        k.bind(c, 'mousedown', function (e) {
                            e.stopImmediatePropagation();
                            e.preventDefault();
                            startDrag(e)
                        });
                        a.elm = c;
                        k.setStyles(c, {
                            left: (targetWidth * a[0] + selectedElmX) - (c.offsetWidth / 2),
                            top: (targetHeight * a[1] + selectedElmY) - (c.offsetHeight / 2)
                        })
                    })
                } else {
                    hideResizeRect()
                }
                l.setAttribute('data-mce-selected', '1')
            }
            function hideResizeRect() {
                var a, handleElm;
                unbindResizeHandleEvents();
                if (l) {
                    l.removeAttribute('data-mce-selected')
                }
                for (a in resizeHandles) {
                    handleElm = k.get('mceResizeHandle' + a);
                    if (handleElm) {
                        k.unbind(handleElm);
                        k.remove(handleElm)
                    }
                }
            }
            function updateResizeRect(e) {
                var c, controlElm;

                function isChildOrEqual(a, b) {
                    if (a) {
                        do {
                            if (a === b) {
                                return true
                            }
                        } while ((a = a.parentNode))
                    }
                }
                if (resizeStarted || j.removed) {
                    return
                }
                each(k.select('img[data-mce-selected],hr[data-mce-selected]'), function (a) {
                    a.removeAttribute('data-mce-selected')
                });
                controlElm = e.type == 'mousedown' ? e.target : i.getNode();
                controlElm = k.$(controlElm).closest(isIE ? 'table' : 'table,img,hr')[0];
                if (isChildOrEqual(controlElm, rootElement)) {
                    disableGeckoResize();
                    c = i.getStart(true);
                    if (isChildOrEqual(c, controlElm) && isChildOrEqual(i.getEnd(true), controlElm)) {
                        if (!isIE || (controlElm != c && c.nodeName !== 'IMG')) {
                            showResizeRect(controlElm);
                            return
                        }
                    }
                }
                hideResizeRect()
            }
            function attachEvent(a, b, c) {
                if (a && a.attachEvent) {
                    a.attachEvent('on' + b, c)
                }
            }
            function detachEvent(a, b, c) {
                if (a && a.detachEvent) {
                    a.detachEvent('on' + b, c)
                }
            }
            function resizeNativeStart(e) {
                var a = e.srcElement,
                    pos, name, corner, cornerX, cornerY, relativeX, relativeY;
                pos = a.getBoundingClientRect();
                relativeX = lastMouseDownEvent.clientX - pos.left;
                relativeY = lastMouseDownEvent.clientY - pos.top;
                for (name in resizeHandles) {
                    corner = resizeHandles[name];
                    cornerX = a.offsetWidth * corner[0];
                    cornerY = a.offsetHeight * corner[1];
                    if (o(cornerX - relativeX) < 8 && o(cornerY - relativeY) < 8) {
                        selectedHandle = corner;
                        break
                    }
                }
                resizeStarted = true;
                j.fire('ObjectResizeStart', {
                    target: l,
                    width: l.clientWidth,
                    height: l.clientHeight
                });
                j.getDoc().selection.empty();
                showResizeRect(a, name, lastMouseDownEvent)
            }
            function preventDefault(e) {
                if (e.preventDefault) {
                    e.preventDefault()
                } else {
                    e.returnValue = false
                }
            }
            function isWithinContentEditableFalse(a) {
                return v(getContentEditableRoot(j.getBody(), a))
            }
            function nativeControlSelect(e) {
                var a = e.srcElement;
                if (isWithinContentEditableFalse(a)) {
                    preventDefault(e);
                    return
                }
                if (a != l) {
                    j.fire('ObjectSelected', {
                        target: a
                    });
                    detachResizeStartListener();
                    if (a.id.indexOf('mceResizeHandle') === 0) {
                        e.returnValue = false;
                        return
                    }
                    if (a.nodeName == 'IMG' || a.nodeName == 'TABLE') {
                        hideResizeRect();
                        l = a;
                        attachEvent(a, 'resizestart', resizeNativeStart)
                    }
                }
            }
            function detachResizeStartListener() {
                detachEvent(l, 'resizestart', resizeNativeStart)
            }
            function unbindResizeHandleEvents() {
                for (var a in resizeHandles) {
                    var b = resizeHandles[a];
                    if (b.elm) {
                        k.unbind(b.elm);
                        delete b.elm
                    }
                }
            }
            function disableGeckoResize() {
                try {
                    j.getDoc().execCommand('enableObjectResizing', false, false)
                } catch (ex) { }
            }
            function controlSelect(a) {
                var b;
                if (!isIE) {
                    return
                }
                b = editableDoc.body.createControlRange();
                try {
                    b.addElement(a);
                    b.select();
                    return true
                } catch (ex) { }
            }
            j.on('init', function () {
                if (isIE) {
                    j.on('ObjectResized', function (e) {
                        if (e.target.nodeName != 'TABLE') {
                            hideResizeRect();
                            controlSelect(e.target)
                        }
                    });
                    attachEvent(rootElement, 'controlselect', nativeControlSelect);
                    j.on('mousedown', function (e) {
                        lastMouseDownEvent = e
                    })
                } else {
                    disableGeckoResize();
                    if (t.ie >= 11) {
                        j.on('mousedown click', function (e) {
                            var a = e.target,
                                nodeName = a.nodeName;
                            if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(a)) {
                                j.selection.select(a, nodeName == 'TABLE');
                                if (e.type == 'mousedown') {
                                    j.nodeChanged()
                                }
                            }
                        });
                        j.dom.bind(rootElement, 'mscontrolselect', function (e) {
                            function delayedSelect(a) {
                                s.setEditorTimeout(j, function () {
                                    j.selection.select(a)
                                })
                            }
                            if (isWithinContentEditableFalse(e.target)) {
                                e.preventDefault();
                                delayedSelect(e.target);
                                return
                            }
                            if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
                                e.preventDefault();
                                if (e.target.tagName == 'IMG') {
                                    delayedSelect(e.target)
                                }
                            }
                        })
                    }
                }
                var b = s.throttle(function (e) {
                    if (!j.composing) {
                        updateResizeRect(e)
                    }
                });
                j.on('nodechange ResizeEditor ResizeWindow drop', b);
                j.on('keyup compositionend', function (e) {
                    if (l && l.nodeName == "TABLE") {
                        b(e)
                    }
                });
                j.on('hide blur', hideResizeRect)
            });
            j.on('remove', unbindResizeHandleEvents);

            function destroy() {
                l = selectedElmGhost = null;
                if (isIE) {
                    detachResizeStartListener();
                    detachEvent(rootElement, 'controlselect', nativeControlSelect)
                }
            }
            return {
                isResizable: isResizable,
                showResizeRect: showResizeRect,
                hideResizeRect: hideResizeRect,
                updateResizeRect: updateResizeRect,
                controlSelect: controlSelect,
                destroy: destroy
            }
        }
    });
    define("tinymce/util/Fun", [], function () {
        var d = [].slice;

        function constant(a) {
            return function () {
                return a
            }
        }
        function negate(a) {
            return function (x) {
                return !a(x)
            }
        }
        function compose(f, g) {
            return function (x) {
                return f(g(x))
            }
        }
        function or() {
            var a = d.call(arguments);
            return function (x) {
                for (var i = 0; i < a.length; i++) {
                    if (a[i](x)) {
                        return true
                    }
                }
                return false
            }
        }
        function and() {
            var a = d.call(arguments);
            return function (x) {
                for (var i = 0; i < a.length; i++) {
                    if (!a[i](x)) {
                        return false
                    }
                }
                return true
            }
        }
        function curry(b) {
            var c = d.call(arguments);
            if (c.length - 1 >= b.length) {
                return b.apply(this, c.slice(1))
            }
            return function () {
                var a = c.concat([].slice.call(arguments));
                return curry.apply(this, a)
            }
        }
        return {
            constant: constant,
            negate: negate,
            and: and,
            or: or,
            curry: curry,
            compose: compose
        }
    });
    define("tinymce/caret/CaretCandidate", ["tinymce/dom/NodeType", "tinymce/util/Arr", "tinymce/caret/CaretContainer"], function (d, e, f) {
        var g = d.isContentEditableTrue,
            isContentEditableFalse = d.isContentEditableFalse,
            isBr = d.isBr,
            isText = d.isText,
            isInvalidTextElement = d.matchNodeNames('script style textarea'),
            isAtomicInline = d.matchNodeNames('img input textarea hr iframe video audio object'),
            isTable = d.matchNodeNames('table'),
            isCaretContainer = f.isCaretContainer;

        function isCaretCandidate(a) {
            if (isCaretContainer(a)) {
                return false
            }
            if (isText(a)) {
                if (isInvalidTextElement(a.parentNode)) {
                    return false
                }
                return true
            }
            return isAtomicInline(a) || isBr(a) || isTable(a) || isContentEditableFalse(a)
        }
        function isInEditable(a, b) {
            for (a = a.parentNode; a && a != b; a = a.parentNode) {
                if (isContentEditableFalse(a)) {
                    return false
                }
                if (g(a)) {
                    return true
                }
            }
            return true
        }
        function isAtomicContentEditableFalse(c) {
            if (!isContentEditableFalse(c)) {
                return false
            }
            return e.reduce(c.getElementsByTagName('*'), function (a, b) {
                return a || g(b)
            }, false) !== true
        }
        function isAtomic(a) {
            return isAtomicInline(a) || isAtomicContentEditableFalse(a)
        }
        function isEditableCaretCandidate(a, b) {
            return isCaretCandidate(a) && isInEditable(a, b)
        }
        return {
            isCaretCandidate: isCaretCandidate,
            isInEditable: isInEditable,
            isAtomic: isAtomic,
            isEditableCaretCandidate: isEditableCaretCandidate
        }
    });
    define("tinymce/geom/ClientRect", [], function () {
        var d = Math.round;

        function clone(a) {
            if (!a) {
                return {
                    left: 0,
                    top: 0,
                    bottom: 0,
                    right: 0,
                    width: 0,
                    height: 0
                }
            }
            return {
                left: d(a.left),
                top: d(a.top),
                bottom: d(a.bottom),
                right: d(a.right),
                width: d(a.width),
                height: d(a.height)
            }
        }
        function collapse(a, b) {
            a = clone(a);
            if (b) {
                a.right = a.left
            } else {
                a.left = a.left + a.width;
                a.right = a.left
            }
            a.width = 0;
            return a
        }
        function isEqual(a, b) {
            return (a.left === b.left && a.top === b.top && a.bottom === b.bottom && a.right === b.right)
        }
        function isValidOverflow(a, b, c) {
            return a >= 0 && a <= Math.min(b.height, c.height) / 2
        }
        function isAbove(a, b) {
            if (a.bottom < b.top) {
                return true
            }
            if (a.top > b.bottom) {
                return false
            }
            return isValidOverflow(b.top - a.bottom, a, b)
        }
        function isBelow(a, b) {
            if (a.top > b.bottom) {
                return true
            }
            if (a.bottom < b.top) {
                return false
            }
            return isValidOverflow(b.bottom - a.top, a, b)
        }
        function isLeft(a, b) {
            return a.left < b.left
        }
        function isRight(a, b) {
            return a.right > b.right
        }
        function compare(a, b) {
            if (isAbove(a, b)) {
                return -1
            }
            if (isBelow(a, b)) {
                return 1
            }
            if (isLeft(a, b)) {
                return -1
            }
            if (isRight(a, b)) {
                return 1
            }
            return 0
        }
        function containsXY(a, b, c) {
            return (b >= a.left && b <= a.right && c >= a.top && c <= a.bottom)
        }
        return {
            clone: clone,
            collapse: collapse,
            isEqual: isEqual,
            isAbove: isAbove,
            isBelow: isBelow,
            isLeft: isLeft,
            isRight: isRight,
            compare: compare,
            containsXY: containsXY
        }
    });
    define("tinymce/text/ExtendingChar", [], function () {
        var b = new RegExp("[̀-ͯ҃-҇҈-҉֑-ֽֿׁ-ׂׄ-ׇׅؐ-ؚ" + "ً-ٰٟۖ-ۜ۟-ۤۧ-۪ۨ-ܑۭܰ-݊ަ-ް" + "߫-߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࣣ-ंऺ़" + "ु-ै्॑-ॗॢ-ॣঁ়াু-ৄ্ৗৢ-ৣ" + "ਁ-ਂ਼ੁ-ੂੇ-ੈੋ-੍ੑੰ-ੱੵઁ-ં઼" + "ુ-ૅે-ૈ્ૢ-ૣଁ଼ାିୁ-ୄ୍ୖୗ" + "ୢ-ୣஂாீ்ௗఀా-ీె-ైొ-్ౕ-ౖ" + "ౢ-ౣಁ಼ಿೂೆೌ-್ೕ-ೖೢ-ೣഁാു-ൄ" + "്ൗൢ-ൣ්ාි-ුූෟัิ-ฺ็-๎ັິ-ູ" + "ົ-ຼ່-ໍ༘-ཱ༹༙༵༷-ཾྀ-྄྆-྇ྍ-ྗ" + "ྙ-ྼ࿆ိ-ူဲ-့္-်ွ-ှၘ-ၙၞ-ၠၱ-ၴ" + "ႂႅ-ႆႍႝ፝-፟ᜒ-᜔ᜲ-᜴ᝒ-ᝓᝲ-ᝳ឴-឵" + "ិ-ួំ៉-៓៝᠋-᠍ᢩᤠ-ᤢᤧ-ᤨᤲ᤹-᤻ᨗ-ᨘ" + "ᨛᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼᪰-᪽᪾ᬀ-ᬃ᬴" + "ᬶ-ᬺᬼᭂ᭫-᭳ᮀ-ᮁᮢ-ᮥᮨ-ᮩ᮫-ᮭ᯦ᯨ-ᯩ" + "ᯭᯯ-ᯱᰬ-ᰳᰶ-᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸-᳹" + "᷀-᷵᷼-᷿‌-‍⃐-⃜⃝-⃠⃡⃢-⃤⃥-⃰⳯-⳱" + "⵿ⷠ-〪ⷿ-〭〮-゙〯-゚꙯꙰-꙲ꙴ-꙽ꚞ-ꚟ꛰-꛱" + "ꠂ꠆ꠋꠥ-ꠦ꣄꣠-꣱ꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼ" + "ꧥꨩ-ꨮꨱ-ꨲꨵ-ꨶꩃꩌꩼꪰꪲ-ꪴꪷ-ꪸꪾ-꪿꫁" + "ꫬ-ꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︯ﾞ-ﾟ]");

        function isExtendingChar(a) {
            return typeof a == "string" && a.charCodeAt(0) >= 768 && b.test(a)
        }
        return {
            isExtendingChar: isExtendingChar
        }
    });
    define("tinymce/caret/CaretPosition", ["tinymce/util/Fun", "tinymce/dom/NodeType", "tinymce/dom/DOMUtils", "tinymce/dom/RangeUtils", "tinymce/caret/CaretCandidate", "tinymce/geom/ClientRect", "tinymce/text/ExtendingChar"], function (f, g, h, i, j, k, l) {
        var m = g.isElement,
            isCaretCandidate = j.isCaretCandidate,
            isBlock = g.matchStyleValues('display', 'block table'),
            isFloated = g.matchStyleValues('float', 'left right'),
            isValidElementCaretCandidate = f.and(m, isCaretCandidate, f.negate(isFloated)),
            isNotPre = f.negate(g.matchStyleValues('white-space', 'pre pre-line pre-wrap')),
            isText = g.isText,
            isBr = g.isBr,
            nodeIndex = h.nodeIndex,
            resolveIndex = i.getNode;

        function createRange(a) {
            return "createRange" in a ? a.createRange() : h.DOM.createRng()
        }
        function isWhiteSpace(a) {
            return a && /[\r\n\t ]/.test(a)
        }
        function isHiddenWhiteSpaceRange(a) {
            var b = a.startContainer,
                offset = a.startOffset,
                text;
            if (isWhiteSpace(a.toString()) && isNotPre(b.parentNode)) {
                text = b.data;
                if (isWhiteSpace(text[offset - 1]) || isWhiteSpace(text[offset + 1])) {
                    return true
                }
            }
            return false
        }
        function getCaretPositionClientRects(d) {
            var e = [],
                beforeNode, node;

            function getBrClientRect(a) {
                var b = a.ownerDocument,
                    rng = createRange(b),
                    nbsp = b.createTextNode(' '),
                    parentNode = a.parentNode,
                    clientRect;
                parentNode.insertBefore(nbsp, a);
                rng.setStart(nbsp, 0);
                rng.setEnd(nbsp, 1);
                clientRect = k.clone(rng.getBoundingClientRect());
                parentNode.removeChild(nbsp);
                return clientRect
            }
            function getBoundingClientRect(a) {
                var b, e;
                e = a.getClientRects();
                if (e.length > 0) {
                    b = k.clone(e[0])
                } else {
                    b = k.clone(a.getBoundingClientRect())
                }
                if (isBr(a) && b.left === 0) {
                    return getBrClientRect(a)
                }
                return b
            }
            function collapseAndInflateWidth(a, b) {
                a = k.collapse(a, b);
                a.width = 1;
                a.right = a.left + 1;
                return a
            }
            function addUniqueAndValidRect(a) {
                if (a.height === 0) {
                    return
                }
                if (e.length > 0) {
                    if (k.isEqual(a, e[e.length - 1])) {
                        return
                    }
                }
                e.push(a)
            }
            function addCharacterOffset(a, b) {
                var c = createRange(a.ownerDocument);
                if (b < a.data.length) {
                    if (l.isExtendingChar(a.data[b])) {
                        return e
                    }
                    if (l.isExtendingChar(a.data[b - 1])) {
                        c.setStart(a, b);
                        c.setEnd(a, b + 1);
                        if (!isHiddenWhiteSpaceRange(c)) {
                            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(c), false));
                            return e
                        }
                    }
                }
                if (b > 0) {
                    c.setStart(a, b - 1);
                    c.setEnd(a, b);
                    if (!isHiddenWhiteSpaceRange(c)) {
                        addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(c), false))
                    }
                }
                if (b < a.data.length) {
                    c.setStart(a, b);
                    c.setEnd(a, b + 1);
                    if (!isHiddenWhiteSpaceRange(c)) {
                        addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(c), true))
                    }
                }
            }
            if (isText(d.container())) {
                addCharacterOffset(d.container(), d.offset());
                return e
            }
            if (m(d.container())) {
                if (d.isAtEnd()) {
                    node = resolveIndex(d.container(), d.offset());
                    if (isText(node)) {
                        addCharacterOffset(node, node.data.length)
                    }
                    if (isValidElementCaretCandidate(node) && !isBr(node)) {
                        addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false))
                    }
                } else {
                    node = resolveIndex(d.container(), d.offset());
                    if (isText(node)) {
                        addCharacterOffset(node, 0)
                    }
                    if (isValidElementCaretCandidate(node) && d.isAtEnd()) {
                        addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
                        return e
                    }
                    beforeNode = resolveIndex(d.container(), d.offset() - 1);
                    if (isValidElementCaretCandidate(beforeNode) && !isBr(beforeNode)) {
                        if (isBlock(beforeNode) || isBlock(node) || !isValidElementCaretCandidate(node)) {
                            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(beforeNode), false))
                        }
                    }
                    if (isValidElementCaretCandidate(node)) {
                        addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), true))
                    }
                }
            }
            return e
        }
        function CaretPosition(b, c, d) {
            function isAtStart() {
                if (isText(b)) {
                    return c === 0
                }
                return c === 0
            }
            function isAtEnd() {
                if (isText(b)) {
                    return c >= b.data.length
                }
                return c >= b.childNodes.length
            }
            function toRange() {
                var a;
                a = createRange(b.ownerDocument);
                a.setStart(b, c);
                a.setEnd(b, c);
                return a
            }
            function getClientRects() {
                if (!d) {
                    d = getCaretPositionClientRects(new CaretPosition(b, c))
                }
                return d
            }
            function isVisible() {
                return getClientRects().length > 0
            }
            function isEqual(a) {
                return a && b === a.container() && c === a.offset()
            }
            function getNode(a) {
                return resolveIndex(b, a ? c - 1 : c)
            }
            return {
                container: f.constant(b),
                offset: f.constant(c),
                toRange: toRange,
                getClientRects: getClientRects,
                isVisible: isVisible,
                isAtStart: isAtStart,
                isAtEnd: isAtEnd,
                isEqual: isEqual,
                getNode: getNode
            }
        }
        CaretPosition.fromRangeStart = function (a) {
            return new CaretPosition(a.startContainer, a.startOffset)
        };
        CaretPosition.fromRangeEnd = function (a) {
            return new CaretPosition(a.endContainer, a.endOffset)
        };
        CaretPosition.after = function (a) {
            return new CaretPosition(a.parentNode, nodeIndex(a) + 1)
        };
        CaretPosition.before = function (a) {
            return new CaretPosition(a.parentNode, nodeIndex(a))
        };
        return CaretPosition
    });
    define('tinymce/caret/CaretBookmark', ['tinymce/dom/NodeType', 'tinymce/dom/DOMUtils', 'tinymce/util/Fun', 'tinymce/util/Arr', 'tinymce/caret/CaretPosition'], function (g, h, j, k, l) {
        var m = g.isText,
            isBogus = g.isBogus,
            nodeIndex = h.nodeIndex;

        function normalizedParent(a) {
            var b = a.parentNode;
            if (isBogus(b)) {
                return normalizedParent(b)
            }
            return b
        }
        function getChildNodes(c) {
            if (!c) {
                return []
            }
            return k.reduce(c.childNodes, function (a, b) {
                if (isBogus(b) && b.nodeName != 'BR') {
                    a = a.concat(getChildNodes(b))
                } else {
                    a.push(b)
                }
                return a
            }, [])
        }
        function normalizedTextOffset(a, b) {
            while ((a = a.previousSibling)) {
                if (!m(a)) {
                    break
                }
                b += a.data.length
            }
            return b
        }
        function equal(b) {
            return function (a) {
                return b === a
            }
        }
        function normalizedNodeIndex(c) {
            var d, index, numTextFragments;
            d = getChildNodes(normalizedParent(c));
            index = k.findIndex(d, equal(c), c);
            d = d.slice(0, index + 1);
            numTextFragments = k.reduce(d, function (a, b, i) {
                if (m(b) && m(d[i - 1])) {
                    a++
                }
                return a
            }, 0);
            d = k.filter(d, g.matchNodeNames(c.nodeName));
            index = k.findIndex(d, equal(c), c);
            return index - numTextFragments
        }
        function createPathItem(a) {
            var b;
            if (m(a)) {
                b = 'text()'
            } else {
                b = a.nodeName.toLowerCase()
            }
            return b + '[' + normalizedNodeIndex(a) + ']'
        }
        function parentsUntil(a, b, c) {
            var d = [];
            for (b = b.parentNode; b != a; b = b.parentNode) {
                if (c && c(b)) {
                    break
                }
                d.push(b)
            }
            return d
        }
        function create(b, c) {
            var d, offset, path = [],
                outputOffset, childNodes, parents;
            d = c.container();
            offset = c.offset();
            if (m(d)) {
                outputOffset = normalizedTextOffset(d, offset)
            } else {
                childNodes = d.childNodes;
                if (offset >= childNodes.length) {
                    outputOffset = 'after';
                    offset = childNodes.length - 1
                } else {
                    outputOffset = 'before'
                }
                d = childNodes[offset]
            }
            path.push(createPathItem(d));
            parents = parentsUntil(b, d);
            parents = k.filter(parents, j.negate(g.isBogus));
            path = path.concat(k.map(parents, function (a) {
                return createPathItem(a)
            }));
            return path.reverse().join('/') + ',' + outputOffset
        }
        function resolvePathItem(c, d, e) {
            var f = getChildNodes(c);
            f = k.filter(f, function (a, b) {
                return !m(a) || !m(f[b - 1])
            });
            f = k.filter(f, g.matchNodeNames(d));
            return f[e]
        }
        function findTextPosition(a, b) {
            var c = a,
                targetOffset = 0,
                dataLen;
            while (m(c)) {
                dataLen = c.data.length;
                if (b >= targetOffset && b <= targetOffset + dataLen) {
                    a = c;
                    b = b - targetOffset;
                    break
                }
                if (!m(c.nextSibling)) {
                    a = c;
                    b = dataLen;
                    break
                }
                targetOffset += dataLen;
                c = c.nextSibling
            }
            if (b > a.data.length) {
                b = a.data.length
            }
            return new l(a, b)
        }
        function resolve(c, d) {
            var e, container, offset;
            if (!d) {
                return null
            }
            e = d.split(',');
            d = e[0].split('/');
            offset = e.length > 1 ? e[1] : 'before';
            container = k.reduce(d, function (a, b) {
                b = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(b);
                if (!b) {
                    return null
                }
                if (b[1] === 'text()') {
                    b[1] = '#text'
                }
                return resolvePathItem(a, b[1], parseInt(b[2], 10))
            }, c);
            if (!container) {
                return null
            }
            if (!m(container)) {
                if (offset === 'after') {
                    offset = nodeIndex(container) + 1
                } else {
                    offset = nodeIndex(container)
                }
                return new l(container.parentNode, offset)
            }
            return findTextPosition(container, parseInt(offset, 10))
        }
        return {
            create: create,
            resolve: resolve
        }
    });
    define("tinymce/dom/BookmarkManager", ["tinymce/Env", "tinymce/util/Tools", "tinymce/caret/CaretContainer", "tinymce/caret/CaretBookmark", "tinymce/caret/CaretPosition", "tinymce/dom/NodeType"], function (l, m, n, o, p, q) {
        var r = q.isContentEditableFalse;

        function BookmarkManager(j) {
            var k = j.dom;
            this.getBookmark = function (f, g) {
                var h, rng2, id, collapsed, name, element, chr = '&#xFEFF;',
                    styles;

                function findIndex(b, c) {
                    var d = 0;
                    m.each(k.select(b), function (a) {
                        if (a.getAttribute('data-mce-bogus') === 'all') {
                            return
                        }
                        if (a == c) {
                            return false
                        }
                        d++
                    });
                    return d
                }
                function normalizeTableCellSelection(c) {
                    function moveEndPoint(a) {
                        var b, offset, childNodes, prefix = a ? 'start' : 'end';
                        b = c[prefix + 'Container'];
                        offset = c[prefix + 'Offset'];
                        if (b.nodeType == 1 && b.nodeName == "TR") {
                            childNodes = b.childNodes;
                            b = childNodes[Math.min(a ? offset : offset - 1, childNodes.length - 1)];
                            if (b) {
                                offset = a ? 0 : b.childNodes.length;
                                c['set' + (a ? 'Start' : 'End')](b, offset)
                            }
                        }
                    }
                    moveEndPoint(true);
                    moveEndPoint();
                    return c
                }
                function getLocation(d) {
                    var e = k.getRoot(),
                        bookmark = {};

                    function getPoint(a, b) {
                        var c = a[b ? 'startContainer' : 'endContainer'],
                            offset = a[b ? 'startOffset' : 'endOffset'],
                            point = [],
                            node, childNodes, after = 0;
                        if (c.nodeType == 3) {
                            if (g) {
                                for (node = c.previousSibling; node && node.nodeType == 3; node = node.previousSibling) {
                                    offset += node.nodeValue.length
                                }
                            }
                            point.push(offset)
                        } else {
                            childNodes = c.childNodes;
                            if (offset >= childNodes.length && childNodes.length) {
                                after = 1;
                                offset = Math.max(0, childNodes.length - 1)
                            }
                            point.push(k.nodeIndex(childNodes[offset], g) + after)
                        }
                        for (; c && c != e; c = c.parentNode) {
                            point.push(k.nodeIndex(c, g))
                        }
                        return point
                    }
                    bookmark.start = getPoint(d, true);
                    if (!j.isCollapsed()) {
                        bookmark.end = getPoint(d)
                    }
                    return bookmark
                }
                function findAdjacentContentEditableFalseElm(c) {
                    function findSibling(a) {
                        var b;
                        if (n.isCaretContainer(a)) {
                            if (q.isText(a) && n.isCaretContainerBlock(a)) {
                                a = a.parentNode
                            }
                            b = a.previousSibling;
                            if (r(b)) {
                                return b
                            }
                            b = a.nextSibling;
                            if (r(b)) {
                                return b
                            }
                        }
                    }
                    return findSibling(c.startContainer) || findSibling(c.endContainer)
                }
                if (f == 2) {
                    element = j.getNode();
                    name = element ? element.nodeName : null;
                    h = j.getRng();
                    if (r(element) || name == 'IMG') {
                        return {
                            name: name,
                            index: findIndex(name, element)
                        }
                    }
                    if (j.tridentSel) {
                        return j.tridentSel.getBookmark(f)
                    }
                    element = findAdjacentContentEditableFalseElm(h);
                    if (element) {
                        name = element.tagName;
                        return {
                            name: name,
                            index: findIndex(name, element)
                        }
                    }
                    return getLocation(h)
                }
                if (f == 3) {
                    h = j.getRng();
                    return {
                        start: o.create(k.getRoot(), p.fromRangeStart(h)),
                        end: o.create(k.getRoot(), p.fromRangeEnd(h))
                    }
                }
                if (f) {
                    return {
                        rng: j.getRng()
                    }
                }
                h = j.getRng();
                id = k.uniqueId();
                collapsed = j.isCollapsed();
                styles = 'overflow:hidden;line-height:0';
                if (h.duplicate || h.item) {
                    if (!h.item) {
                        rng2 = h.duplicate();
                        try {
                            h.collapse();
                            h.pasteHTML('<span data-mce-type="bookmark" id="' + id + '_start" style="' + styles + '">' + chr + '</span>');
                            if (!collapsed) {
                                rng2.collapse(false);
                                h.moveToElementText(rng2.parentElement());
                                if (h.compareEndPoints('StartToEnd', rng2) === 0) {
                                    rng2.move('character', -1)
                                }
                                rng2.pasteHTML('<span data-mce-type="bookmark" id="' + id + '_end" style="' + styles + '">' + chr + '</span>')
                            }
                        } catch (ex) {
                            return null
                        }
                    } else {
                        element = h.item(0);
                        name = element.nodeName;
                        return {
                            name: name,
                            index: findIndex(name, element)
                        }
                    }
                } else {
                    element = j.getNode();
                    name = element.nodeName;
                    if (name == 'IMG') {
                        return {
                            name: name,
                            index: findIndex(name, element)
                        }
                    }
                    rng2 = normalizeTableCellSelection(h.cloneRange());
                    if (!collapsed) {
                        rng2.collapse(false);
                        rng2.insertNode(k.create('span', {
                            'data-mce-type': "bookmark",
                            id: id + '_end',
                            style: styles
                        }, chr))
                    }
                    h = normalizeTableCellSelection(h);
                    h.collapse(true);
                    h.insertNode(k.create('span', {
                        'data-mce-type': "bookmark",
                        id: id + '_start',
                        style: styles
                    }, chr))
                }
                j.moveToBookmark({
                    id: id,
                    keep: 1
                });
                return {
                    id: id
                }
            };
            this.moveToBookmark = function (d) {
                var e, root, startContainer, endContainer, startOffset, endOffset;

                function setEndPoint(a) {
                    var b = d[a ? 'start' : 'end'],
                        i, node, offset, children;
                    if (b) {
                        offset = b[0];
                        for (node = root, i = b.length - 1; i >= 1; i--) {
                            children = node.childNodes;
                            if (b[i] > children.length - 1) {
                                return
                            }
                            node = children[b[i]]
                        }
                        if (node.nodeType === 3) {
                            offset = Math.min(b[0], node.nodeValue.length)
                        }
                        if (node.nodeType === 1) {
                            offset = Math.min(b[0], node.childNodes.length)
                        }
                        if (a) {
                            e.setStart(node, offset)
                        } else {
                            e.setEnd(node, offset)
                        }
                    }
                    return true
                }
                function restoreEndPoint(b) {
                    var c = k.get(d.id + '_' + b),
                        node, idx, next, prev, keep = d.keep;
                    if (c) {
                        node = c.parentNode;
                        if (b == 'start') {
                            if (!keep) {
                                idx = k.nodeIndex(c)
                            } else {
                                node = c.firstChild;
                                idx = 1
                            }
                            startContainer = endContainer = node;
                            startOffset = endOffset = idx
                        } else {
                            if (!keep) {
                                idx = k.nodeIndex(c)
                            } else {
                                node = c.firstChild;
                                idx = 1
                            }
                            endContainer = node;
                            endOffset = idx
                        }
                        if (!keep) {
                            prev = c.previousSibling;
                            next = c.nextSibling;
                            m.each(m.grep(c.childNodes), function (a) {
                                if (a.nodeType == 3) {
                                    a.nodeValue = a.nodeValue.replace(/\uFEFF/g, '')
                                }
                            });
                            while ((c = k.get(d.id + '_' + b))) {
                                k.remove(c, 1)
                            }
                            if (prev && next && prev.nodeType == next.nodeType && prev.nodeType == 3 && !l.opera) {
                                idx = prev.nodeValue.length;
                                prev.appendData(next.nodeValue);
                                k.remove(next);
                                if (b == 'start') {
                                    startContainer = endContainer = prev;
                                    startOffset = endOffset = idx
                                } else {
                                    endContainer = prev;
                                    endOffset = idx
                                }
                            }
                        }
                    }
                }
                function addBogus(a) {
                    if (k.isBlock(a) && !a.innerHTML && !l.ie) {
                        a.innerHTML = '<br data-mce-bogus="1" />'
                    }
                    return a
                }
                function resolveCaretPositionBookmark() {
                    var a, pos;
                    a = k.createRng();
                    pos = o.resolve(k.getRoot(), d.start);
                    a.setStart(pos.container(), pos.offset());
                    pos = o.resolve(k.getRoot(), d.end);
                    a.setEnd(pos.container(), pos.offset());
                    return a
                }
                if (d) {
                    if (m.isArray(d.start)) {
                        e = k.createRng();
                        root = k.getRoot();
                        if (j.tridentSel) {
                            return j.tridentSel.moveToBookmark(d)
                        }
                        if (setEndPoint(true) && setEndPoint()) {
                            j.setRng(e)
                        }
                    } else if (typeof d.start == 'string') {
                        j.setRng(resolveCaretPositionBookmark(d))
                    } else if (d.id) {
                        restoreEndPoint('start');
                        restoreEndPoint('end');
                        if (startContainer) {
                            e = k.createRng();
                            e.setStart(addBogus(startContainer), startOffset);
                            e.setEnd(addBogus(endContainer), endOffset);
                            j.setRng(e)
                        }
                    } else if (d.name) {
                        j.select(k.select(d.name)[d.index])
                    } else if (d.rng) {
                        j.setRng(d.rng)
                    }
                }
            }
        }
        BookmarkManager.isBookmarkNode = function (a) {
            return a && a.tagName === 'SPAN' && a.getAttribute('data-mce-type') === 'bookmark'
        };
        return BookmarkManager
    });
    define("tinymce/dom/Selection", ["tinymce/dom/TreeWalker", "tinymce/dom/TridentSelection", "tinymce/dom/ControlSelection", "tinymce/dom/RangeUtils", "tinymce/dom/BookmarkManager", "tinymce/dom/NodeType", "tinymce/Env", "tinymce/util/Tools", "tinymce/caret/CaretPosition"], function (j, k, l, m, n, o, p, q, r) {
        var s = q.each,
            trim = q.trim;
        var t = p.ie;

        function Selection(a, b, c, d) {
            var e = this;
            e.dom = a;
            e.win = b;
            e.serializer = c;
            e.editor = d;
            e.bookmarkManager = new n(e);
            e.controlSelection = new l(e, d);
            if (!e.win.getSelection) {
                e.tridentSel = new k(e)
            }
        }
        Selection.prototype = {
            setCursorLocation: function (a, b) {
                var c = this,
                    rng = c.dom.createRng();
                if (!a) {
                    c._moveEndPoint(rng, c.editor.getBody(), true);
                    c.setRng(rng)
                } else {
                    rng.setStart(a, b);
                    rng.setEnd(a, b);
                    c.setRng(rng);
                    c.collapse(false)
                }
            },
            getContent: function (a) {
                var b = this,
                    rng = b.getRng(),
                    tmpElm = b.dom.create("body");
                var c = b.getSel(),
                    whiteSpaceBefore, whiteSpaceAfter, fragment;
                a = a || {};
                whiteSpaceBefore = whiteSpaceAfter = '';
                a.get = true;
                a.format = a.format || 'html';
                a.selection = true;
                b.editor.fire('BeforeGetContent', a);
                if (a.format == 'text') {
                    return b.isCollapsed() ? '' : (rng.text || (c.toString ? c.toString() : ''))
                }
                if (rng.cloneContents) {
                    fragment = rng.cloneContents();
                    if (fragment) {
                        tmpElm.appendChild(fragment)
                    }
                } else if (rng.item !== Y || rng.htmlText !== Y) {
                    tmpElm.innerHTML = '<br>' + (rng.item ? rng.item(0).outerHTML : rng.htmlText);
                    tmpElm.removeChild(tmpElm.firstChild)
                } else {
                    tmpElm.innerHTML = rng.toString()
                }
                if (/^\s/.test(tmpElm.innerHTML)) {
                    whiteSpaceBefore = ' '
                }
                if (/\s+$/.test(tmpElm.innerHTML)) {
                    whiteSpaceAfter = ' '
                }
                a.getInner = true;
                a.content = b.isCollapsed() ? '' : whiteSpaceBefore + b.serializer.serialize(tmpElm, a) + whiteSpaceAfter;
                b.editor.fire('GetContent', a);
                return a.content
            },
            setContent: function (a, b) {
                var c = this,
                    rng = c.getRng(),
                    caretNode, doc = c.win.document,
                    frag, temp;
                b = b || {
                    format: 'html'
                };
                b.set = true;
                b.selection = true;
                b.content = a;
                if (!b.no_events) {
                    c.editor.fire('BeforeSetContent', b)
                }
                a = b.content;
                if (rng.insertNode) {
                    a += '<span id="__caret">_</span>';
                    if (rng.startContainer == doc && rng.endContainer == doc) {
                        doc.body.innerHTML = a
                    } else {
                        rng.deleteContents();
                        if (doc.body.childNodes.length === 0) {
                            doc.body.innerHTML = a
                        } else {
                            if (rng.createContextualFragment) {
                                rng.insertNode(rng.createContextualFragment(a))
                            } else {
                                frag = doc.createDocumentFragment();
                                temp = doc.createElement('div');
                                frag.appendChild(temp);
                                temp.outerHTML = a;
                                rng.insertNode(frag)
                            }
                        }
                    }
                    caretNode = c.dom.get('__caret');
                    rng = doc.createRange();
                    rng.setStartBefore(caretNode);
                    rng.setEndBefore(caretNode);
                    c.setRng(rng);
                    c.dom.remove('__caret');
                    try {
                        c.setRng(rng)
                    } catch (ex) { }
                } else {
                    if (rng.item) {
                        doc.execCommand('Delete', false, null);
                        rng = c.getRng()
                    }
                    if (/^\s+/.test(a)) {
                        rng.pasteHTML('<span id="__mce_tmp">_</span>' + a);
                        c.dom.remove('__mce_tmp')
                    } else {
                        rng.pasteHTML(a)
                    }
                }
                if (!b.no_events) {
                    c.editor.fire('SetContent', b)
                }
            },
            getStart: function (a) {
                var b = this,
                    rng = b.getRng(),
                    startElement, parentElement, checkRng, node;
                if (rng.duplicate || rng.item) {
                    if (rng.item) {
                        return rng.item(0)
                    }
                    checkRng = rng.duplicate();
                    checkRng.collapse(1);
                    startElement = checkRng.parentElement();
                    if (startElement.ownerDocument !== b.dom.doc) {
                        startElement = b.dom.getRoot()
                    }
                    parentElement = node = rng.parentElement();
                    while ((node = node.parentNode)) {
                        if (node == startElement) {
                            startElement = parentElement;
                            break
                        }
                    }
                    return startElement
                }
                startElement = rng.startContainer;
                if (startElement.nodeType == 1 && startElement.hasChildNodes()) {
                    if (!a || !rng.collapsed) {
                        startElement = startElement.childNodes[Math.min(startElement.childNodes.length - 1, rng.startOffset)]
                    }
                }
                if (startElement && startElement.nodeType == 3) {
                    return startElement.parentNode
                }
                return startElement
            },
            getEnd: function (a) {
                var b = this,
                    rng = b.getRng(),
                    endElement, endOffset;
                if (rng.duplicate || rng.item) {
                    if (rng.item) {
                        return rng.item(0)
                    }
                    rng = rng.duplicate();
                    rng.collapse(0);
                    endElement = rng.parentElement();
                    if (endElement.ownerDocument !== b.dom.doc) {
                        endElement = b.dom.getRoot()
                    }
                    if (endElement && endElement.nodeName == 'BODY') {
                        return endElement.lastChild || endElement
                    }
                    return endElement
                }
                endElement = rng.endContainer;
                endOffset = rng.endOffset;
                if (endElement.nodeType == 1 && endElement.hasChildNodes()) {
                    if (!a || !rng.collapsed) {
                        endElement = endElement.childNodes[endOffset > 0 ? endOffset - 1 : endOffset]
                    }
                }
                if (endElement && endElement.nodeType == 3) {
                    return endElement.parentNode
                }
                return endElement
            },
            getBookmark: function (a, b) {
                return this.bookmarkManager.getBookmark(a, b)
            },
            moveToBookmark: function (a) {
                return this.bookmarkManager.moveToBookmark(a)
            },
            select: function (a, b) {
                var c = this,
                    dom = c.dom,
                    rng = dom.createRng(),
                    idx;
                c.lastFocusBookmark = null;
                if (a) {
                    if (!b && c.controlSelection.controlSelect(a)) {
                        return
                    }
                    idx = dom.nodeIndex(a);
                    rng.setStart(a.parentNode, idx);
                    rng.setEnd(a.parentNode, idx + 1);
                    if (b) {
                        c._moveEndPoint(rng, a, true);
                        c._moveEndPoint(rng, a)
                    }
                    c.setRng(rng)
                }
                return a
            },
            isCollapsed: function () {
                var a = this,
                    rng = a.getRng(),
                    sel = a.getSel();
                if (!rng || rng.item) {
                    return false
                }
                if (rng.compareEndPoints) {
                    return rng.compareEndPoints('StartToEnd', rng) === 0
                }
                return !sel || rng.collapsed
            },
            collapse: function (a) {
                var b = this,
                    rng = b.getRng(),
                    node;
                if (rng.item) {
                    node = rng.item(0);
                    rng = b.win.document.body.createTextRange();
                    rng.moveToElementText(node)
                }
                rng.collapse(!!a);
                b.setRng(rng)
            },
            getSel: function () {
                var a = this.win;
                return a.getSelection ? a.getSelection() : a.document.selection
            },
            getRng: function (d) {
                var e = this,
                    selection, rng, elm, doc, ieRng, evt;

                function tryCompareBoundaryPoints(a, b, c) {
                    try {
                        return b.compareBoundaryPoints(a, c)
                    } catch (ex) {
                        return -1
                    }
                }
                // Task 742585: System Error:JavaScript Error: Controls/Tinymce/tinymce.min.js (1) - Uncaught TypeError: Cannot read property 'createRange' of undefined
                if (!e.win || !e.win.document) {
                    return null
                }
                doc = e.win.document;
                if (!d && e.lastFocusBookmark) {
                    var f = e.lastFocusBookmark;
                    if (f.startContainer) {
                        rng = doc.createRange();
                        rng.setStart(f.startContainer, f.startOffset);
                        rng.setEnd(f.endContainer, f.endOffset)
                    } else {
                        rng = f
                    }
                    return rng
                }
                if (d && e.tridentSel) {
                    return e.tridentSel.getRangeAt(0)
                }
                try {
                    if ((selection = e.getSel())) {
                        if (selection.rangeCount > 0) {
                            rng = selection.getRangeAt(0)
                        } else {
                            rng = selection.createRange ? selection.createRange() : doc.createRange()
                        }
                    }
                } catch (ex) { }
                evt = e.editor.fire('GetSelectionRange', {
                    range: rng
                });
                if (evt.range !== rng) {
                    return evt.range
                }
                if (t && rng && rng.setStart && doc.selection) {
                    try {
                        ieRng = doc.selection.createRange()
                    } catch (ex) { }
                    if (ieRng && ieRng.item) {
                        elm = ieRng.item(0);
                        rng = doc.createRange();
                        rng.setStartBefore(elm);
                        rng.setEndAfter(elm)
                    }
                }
                if (!rng) {
                    rng = doc.createRange ? doc.createRange() : doc.body.createTextRange()
                }
                if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
                    elm = e.dom.getRoot();
                    rng.setStart(elm, 0);
                    rng.setEnd(elm, 0)
                }
                if (e.selectedRange && e.explicitRange) {
                    if (tryCompareBoundaryPoints(rng.START_TO_START, rng, e.selectedRange) === 0 && tryCompareBoundaryPoints(rng.END_TO_END, rng, e.selectedRange) === 0) {
                        rng = e.explicitRange
                    } else {
                        e.selectedRange = null;
                        e.explicitRange = null
                    }
                }
                return rng
            },
            setRng: function (a, b) {
                var c = this,
                    sel, node, evt;
                if (!a) {
                    return
                }
                if (a.select) {
                    c.explicitRange = null;
                    try {
                        a.select()
                    } catch (ex) { }
                    return
                }
                if (!c.tridentSel) {
                    sel = c.getSel();
                    evt = c.editor.fire('SetSelectionRange', {
                        range: a
                    });
                    a = evt.range;
                    if (sel) {
                        c.explicitRange = a;
                        try {
                            sel.removeAllRanges();
                            sel.addRange(a)
                        } catch (ex) { }
                        if (b === false && sel.extend) {
                            sel.collapse(a.endContainer, a.endOffset);
                            sel.extend(a.startContainer, a.startOffset)
                        }
                        c.selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null
                    }
                    if (!a.collapsed && a.startContainer == a.endContainer && sel.setBaseAndExtent && !p.ie) {
                        if (a.endOffset - a.startOffset < 2) {
                            if (a.startContainer.hasChildNodes()) {
                                node = a.startContainer.childNodes[a.startOffset];
                                if (node && node.tagName == 'IMG') {
                                    c.getSel().setBaseAndExtent(node, 0, node, 1)
                                }
                            }
                        }
                    }
                } else {
                    if (a.cloneRange) {
                        try {
                            c.tridentSel.addRange(a)
                        } catch (ex) { }
                    }
                }
            },
            setNode: function (a) {
                var b = this;
                b.setContent(b.dom.getOuterHTML(a));
                return a
            },
            getNode: function () {
                var d = this,
                    rng = d.getRng(),
                    elm;
                var e, endContainer, startOffset, endOffset, root = d.dom.getRoot();

                function skipEmptyTextNodes(a, b) {
                    var c = a;
                    while (a && a.nodeType === 3 && a.length === 0) {
                        a = b ? a.nextSibling : a.previousSibling
                    }
                    return a || c
                }
                if (!rng) {
                    return root
                }
                e = rng.startContainer;
                endContainer = rng.endContainer;
                startOffset = rng.startOffset;
                endOffset = rng.endOffset;
                if (rng.setStart) {
                    elm = rng.commonAncestorContainer;
                    if (!rng.collapsed) {
                        if (e == endContainer) {
                            if (endOffset - startOffset < 2) {
                                if (e.hasChildNodes()) {
                                    elm = e.childNodes[startOffset]
                                }
                            }
                        }
                        if (e.nodeType === 3 && endContainer.nodeType === 3) {
                            if (e.length === startOffset) {
                                e = skipEmptyTextNodes(e.nextSibling, true)
                            } else {
                                e = e.parentNode
                            }
                            if (endOffset === 0) {
                                endContainer = skipEmptyTextNodes(endContainer.previousSibling, false)
                            } else {
                                endContainer = endContainer.parentNode
                            }
                            if (e && e === endContainer) {
                                return e
                            }
                        }
                    }
                    if (elm && elm.nodeType == 3) {
                        return elm.parentNode
                    }
                    return elm
                }
                elm = rng.item ? rng.item(0) : rng.parentElement();
                if (elm.ownerDocument !== d.win.document) {
                    elm = root
                }
                return elm
            },
            getSelectedBlocks: function (a, b) {
                var c = this,
                    dom = c.dom,
                    node, root, selectedBlocks = [];
                root = dom.getRoot();
                a = dom.getParent(a || c.getStart(), dom.isBlock);
                b = dom.getParent(b || c.getEnd(), dom.isBlock);
                if (a && a != root) {
                    selectedBlocks.push(a)
                }
                if (a && b && a != b) {
                    node = a;
                    var d = new j(a, root);
                    while ((node = d.next()) && node != b) {
                        if (dom.isBlock(node)) {
                            selectedBlocks.push(node)
                        }
                    }
                }
                if (b && a != b && b != root) {
                    selectedBlocks.push(b)
                }
                return selectedBlocks
            },
            isForward: function () {
                var a = this.dom,
                    sel = this.getSel(),
                    anchorRange, focusRange;
                if (!sel || !sel.anchorNode || !sel.focusNode) {
                    return true
                }
                anchorRange = a.createRng();
                anchorRange.setStart(sel.anchorNode, sel.anchorOffset);
                anchorRange.collapse(true);
                focusRange = a.createRng();
                focusRange.setStart(sel.focusNode, sel.focusOffset);
                focusRange.collapse(true);
                return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0
            },
            normalize: function () {
                var a = this,
                    rng = a.getRng();
                if (p.range && new m(a.dom).normalize(rng)) {
                    a.setRng(rng, a.isForward())
                }
                return rng
            },
            selectorChanged: function (g, h) {
                var i = this,
                    currentSelectors;
                if (!i.selectorChangedData) {
                    i.selectorChangedData = {};
                    currentSelectors = {};
                    i.editor.on('NodeChange', function (e) {
                        var f = e.element,
                            dom = i.dom,
                            parents = dom.getParents(f, null, dom.getRoot()),
                            matchedSelectors = {};
                        s(i.selectorChangedData, function (c, d) {
                            s(parents, function (b) {
                                if (dom.is(b, d)) {
                                    if (!currentSelectors[d]) {
                                        s(c, function (a) {
                                            a(true, {
                                                node: b,
                                                selector: d,
                                                parents: parents
                                            })
                                        });
                                        currentSelectors[d] = c
                                    }
                                    matchedSelectors[d] = c;
                                    return false
                                }
                            })
                        });
                        s(currentSelectors, function (b, c) {
                            if (!matchedSelectors[c]) {
                                delete currentSelectors[c];
                                s(b, function (a) {
                                    a(false, {
                                        node: f,
                                        selector: c,
                                        parents: parents
                                    })
                                })
                            }
                        })
                    })
                }
                if (!i.selectorChangedData[g]) {
                    i.selectorChangedData[g] = []
                }
                i.selectorChangedData[g].push(h);
                return i
            },
            getScrollContainer: function () {
                var a, node = this.dom.getRoot();
                while (node && node.nodeName != 'BODY') {
                    if (node.scrollHeight > node.clientHeight) {
                        a = node;
                        break
                    }
                    node = node.parentNode
                }
                return a
            },
            scrollIntoView: function (c, d) {
                var y, viewPort, self = this,
                    dom = self.dom,
                    root = dom.getRoot(),
                    viewPortY, viewPortH, offsetY = 0;

                function getPos(a) {
                    var x = 0,
                        y = 0;
                    var b = a;
                    while (b && b.nodeType) {
                        x += b.offsetLeft || 0;
                        y += b.offsetTop || 0;
                        b = b.offsetParent
                    }
                    return {
                        x: x,
                        y: y
                    }
                }
                if (!o.isElement(c)) {
                    return
                }
                if (d === false) {
                    offsetY = c.offsetHeight
                }
                if (root.nodeName != 'BODY') {
                    var e = self.getScrollContainer();
                    if (e) {
                        y = getPos(c).y - getPos(e).y + offsetY;
                        viewPortH = e.clientHeight;
                        viewPortY = e.scrollTop;
                        if (y < viewPortY || y + 25 > viewPortY + viewPortH) {
                            e.scrollTop = y < viewPortY ? y : y - viewPortH + 25
                        }
                        return
                    }
                }
                viewPort = dom.getViewPort(self.editor.getWin());
                y = dom.getPos(c).y + offsetY;
                viewPortY = viewPort.y;
                viewPortH = viewPort.h;
                if (y < viewPort.y || y + 25 > viewPortY + viewPortH) {
                    self.editor.getWin().scrollTo(0, y < viewPortY ? y : y - viewPortH + 25)
                }
            },
            placeCaretAt: function (a, b) {
                this.setRng(m.getCaretRangeFromPoint(a, b, this.editor.getDoc()))
            },
            _moveEndPoint: function (a, b, c) {
                var d = b,
                    walker = new j(b, d);
                var e = this.dom.schema.getNonEmptyElements();
                do {
                    if (b.nodeType == 3 && trim(b.nodeValue).length !== 0) {
                        if (c) {
                            a.setStart(b, 0)
                        } else {
                            a.setEnd(b, b.nodeValue.length)
                        }
                        return
                    }
                    if (e[b.nodeName] && !/^(TD|TH)$/.test(b.nodeName)) {
                        if (c) {
                            a.setStartBefore(b)
                        } else {
                            if (b.nodeName == 'BR') {
                                a.setEndBefore(b)
                            } else {
                                a.setEndAfter(b)
                            }
                        }
                        return
                    }
                    if (p.ie && p.ie < 11 && this.dom.isBlock(b) && this.dom.isEmpty(b)) {
                        if (c) {
                            a.setStart(b, 0)
                        } else {
                            a.setEnd(b, 0)
                        }
                        return
                    }
                } while ((b = (c ? walker.next() : walker.prev())));
                if (d.nodeName == 'BODY') {
                    if (c) {
                        a.setStart(d, 0)
                    } else {
                        a.setEnd(d, d.childNodes.length)
                    }
                }
            },
            getBoundingClientRect: function () {
                var a = this.getRng();
                return a.collapsed ? r.fromRangeStart(a).getClientRects()[0] : a.getBoundingClientRect()
            },
            destroy: function () {
                this.win = null;
                this.controlSelection.destroy()
            }
        };
        return Selection
    });
    define("tinymce/dom/ElementUtils", ["tinymce/dom/BookmarkManager", "tinymce/util/Tools"], function (h, i) {
        var j = i.each;

        function ElementUtils(g) {
            this.compare = function (e, f) {
                if (e.nodeName != f.nodeName) {
                    return false
                }
                function getAttribs(c) {
                    var d = {};
                    j(g.getAttribs(c), function (a) {
                        var b = a.nodeName.toLowerCase();
                        if (b.indexOf('_') !== 0 && b !== 'style' && b.indexOf('data-') !== 0) {
                            d[b] = g.getAttrib(c, b)
                        }
                    });
                    return d
                }
                function compareObjects(a, b) {
                    var c, name;
                    for (name in a) {
                        if (a.hasOwnProperty(name)) {
                            c = b[name];
                            if (typeof c == "undefined") {
                                return false
                            }
                            if (a[name] != c) {
                                return false
                            }
                            delete b[name]
                        }
                    }
                    for (name in b) {
                        if (b.hasOwnProperty(name)) {
                            return false
                        }
                    }
                    return true
                }
                if (!compareObjects(getAttribs(e), getAttribs(f))) {
                    return false
                }
                if (!compareObjects(g.parseStyle(g.getAttrib(e, 'style')), g.parseStyle(g.getAttrib(f, 'style')))) {
                    return false
                }
                return !h.isBookmarkNode(e) && !h.isBookmarkNode(f)
            }
        }
        return ElementUtils
    });
    define("tinymce/fmt/Preview", ["tinymce/util/Tools"], function (g) {
        var h = g.each;

        function getCssText(c, d) {
            var e, previewElm, dom = c.dom;
            var f = '',
                parentFontSize, previewStyles;
            previewStyles = c.settings.preview_styles;
            if (previewStyles === false) {
                return ''
            }
            if (!previewStyles) {
                previewStyles = 'font-family font-size font-weight font-style text-decoration ' + 'text-transform color background-color border border-radius outline text-shadow'
            }
            function removeVars(a) {
                return a.replace(/%(\w+)/g, '')
            }
            if (typeof d == "string") {
                d = c.formatter.get(d);
                if (!d) {
                    return
                }
                d = d[0]
            }
            e = d.block || d.inline || 'span';
            previewElm = dom.create(e);
            h(d.styles, function (a, b) {
                a = removeVars(a);
                if (a) {
                    dom.setStyle(previewElm, b, a)
                }
            });
            h(d.attributes, function (a, b) {
                a = removeVars(a);
                if (a) {
                    dom.setAttrib(previewElm, b, a)
                }
            });
            h(d.classes, function (a) {
                a = removeVars(a);
                if (!dom.hasClass(previewElm, a)) {
                    dom.addClass(previewElm, a)
                }
            });
            c.fire('PreviewFormats');
            dom.setStyles(previewElm, {
                position: 'absolute',
                left: -0xFFFF
            });
            c.getBody().appendChild(previewElm);
            parentFontSize = dom.getStyle(c.getBody(), 'fontSize', true);
            parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
            h(previewStyles.split(' '), function (a) {
                var b = dom.getStyle(previewElm, a, true);
                if (a == 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(b)) {
                    b = dom.getStyle(c.getBody(), a, true);
                    if (dom.toHex(b).toLowerCase() == '#fff') {
                        return
                    }
                }
                if (a == 'color') {
                    if (dom.toHex(b).toLowerCase() == '#000') {
                        return
                    }
                }
                if (a == 'font-size') {
                    if (/em|%$/.test(b)) {
                        if (parentFontSize === 0) {
                            return
                        }
                        b = parseFloat(b, 10) / (/%$/.test(b) ? 100 : 1);
                        b = (b * parentFontSize) + 'px'
                    }
                }
                if (a == "border" && b) {
                    f += 'padding:0 2px;'
                }
                f += a + ':' + b + ';'
            });
            c.fire('AfterPreviewFormats');
            dom.remove(previewElm);
            return f
        }
        return {
            getCssText: getCssText
        }
    });
    define("tinymce/fmt/Hooks", ["tinymce/util/Arr", "tinymce/dom/NodeType", "tinymce/dom/DomQuery"], function (e, f, $) {
        var g = [],
            filter = e.filter,
            each = e.each;

        function addPostProcessHook(a, b) {
            var c = g[a];
            if (!c) {
                g[a] = c = []
            }
            g[a].push(b)
        }
        function postProcess(b, c) {
            each(g[b], function (a) {
                a(c)
            })
        }
        addPostProcessHook("pre", function (c) {
            var d = c.selection.getRng(),
                isPre, blocks;

            function hasPreSibling(a) {
                return isPre(a.previousSibling) && e.indexOf(blocks, a.previousSibling) != -1
            }
            function joinPre(a, b) {
                $(b).remove();
                $(a).append('<br><br>').append(b.childNodes)
            }
            isPre = f.matchNodeNames('pre');
            if (!d.collapsed) {
                blocks = c.selection.getSelectedBlocks();
                each(filter(filter(blocks, isPre), hasPreSibling), function (a) {
                    joinPre(a.previousSibling, a)
                })
            }
        });
        return {
            postProcess: postProcess
        }
    });
    define("tinymce/Formatter", ["tinymce/dom/TreeWalker", "tinymce/dom/RangeUtils", "tinymce/dom/BookmarkManager", "tinymce/dom/ElementUtils", "tinymce/util/Tools", "tinymce/fmt/Preview", "tinymce/fmt/Hooks"], function (s, t, u, v, w, z, A) {
        return function (p) {
            var q = {},
                dom = p.dom,
                selection = p.selection,
                rangeUtils = new t(dom),
                isValid = p.schema.isValidChild,
                isBlock = dom.isBlock,
                forcedRootBlock = p.settings.forced_root_block,
                nodeIndex = dom.nodeIndex,
                INVISIBLE_CHAR = '\uFEFF',
                MCE_ATTR_RE = /^(src|href|style)$/,
                FALSE = false,
                TRUE = true,
                formatChangeData, undef, getContentEditable = dom.getContentEditable,
                disableCaretContainer, markCaretContainersBogus, isBookmarkNode = u.isBookmarkNode;
            var r = w.each,
                grep = w.grep,
                walk = w.walk,
                extend = w.extend;

            function isTextBlock(a) {
                if (a.nodeType) {
                    a = a.nodeName
                }
                return !!p.schema.getTextBlockElements()[a.toLowerCase()]
            }
            function isTableCell(a) {
                return /^(TH|TD)$/.test(a.nodeName)
            }
            function isInlineBlock(a) {
                return a && /^(IMG)$/.test(a.nodeName)
            }
            function getParents(a, b) {
                return dom.getParents(a, b, dom.getRoot())
            }
            function isCaretNode(a) {
                return a.nodeType === 1 && a.id === '_mce_caret'
            }
            function defaultFormats() {
                register({
                    valigntop: [{
                        selector: 'td,th',
                        styles: {
                            'verticalAlign': 'top'
                        }
                    }],
                    valignmiddle: [{
                        selector: 'td,th',
                        styles: {
                            'verticalAlign': 'middle'
                        }
                    }],
                    valignbottom: [{
                        selector: 'td,th',
                        styles: {
                            'verticalAlign': 'bottom'
                        }
                    }],
                    alignleft: [{
                        selector: 'figure.image',
                        collapsed: false,
                        classes: 'align-left',
                        ceFalseOverride: true
                    }, {
                        selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
                        styles: {
                            textAlign: 'left'
                        },
                        inherit: false,
                        defaultBlock: 'div'
                    }, {
                        selector: 'img,table',
                        collapsed: false,
                        styles: {
                            'float': 'left'
                        }
                    }],
                    aligncenter: [{
                        selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
                        styles: {
                            textAlign: 'center'
                        },
                        inherit: false,
                        defaultBlock: 'div'
                    }, {
                        selector: 'figure.image',
                        collapsed: false,
                        classes: 'align-center',
                        ceFalseOverride: true
                    }, {
                        selector: 'img',
                        collapsed: false,
                        styles: {
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }
                    }, {
                        selector: 'table',
                        collapsed: false,
                        styles: {
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }
                    }],
                    alignright: [{
                        selector: 'figure.image',
                        collapsed: false,
                        classes: 'align-right',
                        ceFalseOverride: true
                    }, {
                        selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
                        styles: {
                            textAlign: 'right'
                        },
                        inherit: false,
                        defaultBlock: 'div'
                    }, {
                        selector: 'img,table',
                        collapsed: false,
                        styles: {
                            'float': 'right'
                        }
                    }],
                    alignjustify: [{
                        selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
                        styles: {
                            textAlign: 'justify'
                        },
                        inherit: false,
                        defaultBlock: 'div'
                    }],
                    bold: [{
                        inline: 'strong',
                        remove: 'all'
                    }, {
                        inline: 'span',
                        styles: {
                            fontWeight: 'bold'
                        }
                    }, {
                        inline: 'b',
                        remove: 'all'
                    }],
                    italic: [{
                        inline: 'em',
                        remove: 'all'
                    }, {
                        inline: 'span',
                        styles: {
                            fontStyle: 'italic'
                        }
                    }, {
                        inline: 'i',
                        remove: 'all'
                    }],
                    underline: [{
                        inline: 'span',
                        styles: {
                            textDecoration: 'underline'
                        },
                        exact: true
                    }, {
                        inline: 'u',
                        remove: 'all'
                    }],
                    strikethrough: [{
                        inline: 'span',
                        styles: {
                            textDecoration: 'line-through'
                        },
                        exact: true
                    }, {
                        inline: 'strike',
                        remove: 'all'
                    }],
                    forecolor: {
                        inline: 'span',
                        styles: {
                            color: '%value'
                        },
                        links: true,
                        remove_similar: true
                    },
                    hilitecolor: {
                        inline: 'span',
                        styles: {
                            backgroundColor: '%value'
                        },
                        links: true,
                        remove_similar: true
                    },
                    fontname: {
                        inline: 'span',
                        styles: {
                            fontFamily: '%value'
                        }
                    },
                    fontsize: {
                        inline: 'span',
                        styles: {
                            fontSize: '%value'
                        }
                    },
                    fontsize_class: {
                        inline: 'span',
                        attributes: {
                            'class': '%value'
                        }
                    },
                    blockquote: {
                        block: 'blockquote',
                        wrapper: 1,
                        remove: 'all'
                    },
                    subscript: {
                        inline: 'sub'
                    },
                    superscript: {
                        inline: 'sup'
                    },
                    code: {
                        inline: 'code'
                    },
                    link: {
                        inline: 'a',
                        selector: 'a',
                        remove: 'all',
                        split: true,
                        deep: true,
                        onmatch: function () {
                            return true
                        },
                        onformat: function (c, d, e) {
                            r(e, function (a, b) {
                                dom.setAttrib(c, b, a)
                            })
                        }
                    },
                    removeformat: [{
                        selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
                        remove: 'all',
                        split: true,
                        expand: false,
                        block_expand: true,
                        deep: true
                    }, {
                        selector: 'span',
                        attributes: ['style', 'class'],
                        remove: 'empty',
                        split: true,
                        expand: false,
                        deep: true
                    }, {
                        selector: '*',
                        attributes: ['style', 'class'],
                        split: false,
                        expand: false,
                        deep: true
                    }]
                });
                r('p h1 h2 h3 h4 h5 h6 div address pre div dt dd samp'.split(/\s/), function (a) {
                    register(a, {
                        block: a,
                        remove: 'all'
                    })
                });
                register(p.settings.formats)
            }
            function addKeyboardShortcuts() {
                p.addShortcut('meta+b', 'bold_desc', 'Bold');
                p.addShortcut('meta+i', 'italic_desc', 'Italic');
                p.addShortcut('meta+u', 'underline_desc', 'Underline');
                for (var i = 1; i <= 6; i++) {
                    p.addShortcut('access+' + i, '', ['FormatBlock', false, 'h' + i])
                }
                p.addShortcut('access+7', '', ['FormatBlock', false, 'p']);
                p.addShortcut('access+8', '', ['FormatBlock', false, 'div']);
                p.addShortcut('access+9', '', ['FormatBlock', false, 'address'])
            }
            function get(a) {
                return a ? q[a] : q
            }
            function register(c, d) {
                if (c) {
                    if (typeof c !== 'string') {
                        r(c, function (a, b) {
                            register(b, a)
                        })
                    } else {
                        d = d.length ? d : [d];
                        r(d, function (a) {
                            if (a.deep === undef) {
                                a.deep = !a.selector
                            }
                            if (a.split === undef) {
                                a.split = !a.selector || a.inline
                            }
                            if (a.remove === undef && a.selector && !a.inline) {
                                a.remove = 'none'
                            }
                            if (a.selector && a.inline) {
                                a.mixed = true;
                                a.block_expand = true
                            }
                            if (typeof a.classes === 'string') {
                                a.classes = a.classes.split(/\s+/)
                            }
                        });
                        q[c] = d
                    }
                }
            }
            function unregister(a) {
                if (a && q[a]) {
                    delete q[a]
                }
                return q
            }
            function matchesUnInheritedFormatSelector(a, b) {
                var c = get(b);
                if (c) {
                    for (var i = 0; i < c.length; i++) {
                        if (c[i].inherit === false && dom.is(a, c[i].selector)) {
                            return true
                        }
                    }
                }
                return false
            }
            function getTextDecoration(a) {
                var b;
                p.dom.getParent(a, function (n) {
                    b = p.dom.getStyle(n, 'text-decoration');
                    return b && b !== 'none'
                });
                return b
            }
            function processUnderlineAndColor(a) {
                var b;
                if (a.nodeType === 1 && a.parentNode && a.parentNode.nodeType === 1) {
                    b = getTextDecoration(a.parentNode);
                    if (p.dom.getStyle(a, 'color') && b) {
                        p.dom.setStyle(a, 'text-decoration', b)
                    } else if (p.dom.getStyle(a, 'text-decoration') === b) {
                        p.dom.setStyle(a, 'text-decoration', null)
                    }
                }
            }
            function apply(j, k, m) {
                var n = get(j),
                    format = n[0],
                    bookmark, rng, isCollapsed = !m && selection.isCollapsed();

                function setElementFormat(c, d) {
                    d = d || format;
                    if (c) {
                        if (d.onformat) {
                            d.onformat(c, d, k, m)
                        }
                        r(d.styles, function (a, b) {
                            dom.setStyle(c, b, replaceVars(a, k))
                        });
                        if (d.styles) {
                            var e = dom.getAttrib(c, 'style');
                            if (e) {
                                c.setAttribute('data-mce-style', e)
                            }
                        }
                        r(d.attributes, function (a, b) {
                            dom.setAttrib(c, b, replaceVars(a, k))
                        });
                        r(d.classes, function (a) {
                            a = replaceVars(a, k);
                            if (!dom.hasClass(c, a)) {
                                dom.addClass(c, a)
                            }
                        })
                    }
                }
                function adjustSelectionToVisibleSelection() {
                    function findSelectionEnd(a, b) {
                        var c = new s(b);
                        for (m = c.prev2(); m; m = c.prev2()) {
                            if (m.nodeType == 3 && m.data.length > 0) {
                                return m
                            }
                            if (m.childNodes.length > 1 || m == a || m.tagName == 'BR') {
                                return m
                            }
                        }
                    }
                    var d = p.selection.getRng();
                    var e = d.startContainer;
                    var f = d.endContainer;
                    if (e != f && d.endOffset === 0) {
                        var g = findSelectionEnd(e, f);
                        var h = g.nodeType == 3 ? g.data.length : g.childNodes.length;
                        d.setEnd(g, h)
                    }
                    return d
                }
                function applyRngStyle(f, g, h) {
                    var i = [],
                        wrapName, wrapElm, contentEditable = true;
                    wrapName = format.inline || format.block;
                    wrapElm = dom.create(wrapName);
                    setElementFormat(wrapElm);
                    rangeUtils.walk(f, function (d) {
                        var e;

                        function process(b) {
                            var c, parentName, found, hasContentEditableState, lastContentEditable;
                            lastContentEditable = contentEditable;
                            c = b.nodeName.toLowerCase();
                            parentName = b.parentNode.nodeName.toLowerCase();
                            if (b.nodeType === 1 && getContentEditable(b)) {
                                lastContentEditable = contentEditable;
                                contentEditable = getContentEditable(b) === "true";
                                hasContentEditableState = true
                            }
                            if (isEq(c, 'br')) {
                                e = 0;
                                if (format.block) {
                                    dom.remove(b)
                                }
                                return
                            }
                            if (format.wrapper && matchNode(b, j, k)) {
                                e = 0;
                                return
                            }
                            if (contentEditable && !hasContentEditableState && format.block && !format.wrapper && isTextBlock(c) && isValid(parentName, wrapName)) {
                                b = dom.rename(b, wrapName);
                                setElementFormat(b);
                                i.push(b);
                                e = 0;
                                return
                            }
                            if (format.selector) {
                                r(n, function (a) {
                                    if ('collapsed' in a && a.collapsed !== isCollapsed) {
                                        return
                                    }
                                    if (dom.is(b, a.selector) && !isCaretNode(b)) {
                                        setElementFormat(b, a);
                                        found = true;
                                        return false
                                    }
                                });
                                if (!format.inline || found) {
                                    e = 0;
                                    return
                                }
                            }
                            if (contentEditable && !hasContentEditableState && isValid(wrapName, c) && isValid(parentName, wrapName) && !(!h && b.nodeType === 3 && b.nodeValue.length === 1 && b.nodeValue.charCodeAt(0) === 65279) && !isCaretNode(b) && (!format.inline || !isBlock(b))) {
                                if (!e) {
                                    e = dom.clone(wrapElm, FALSE);
                                    b.parentNode.insertBefore(e, b);
                                    i.push(e)
                                }
                                e.appendChild(b)
                            } else {
                                e = 0;
                                r(grep(b.childNodes), process);
                                if (hasContentEditableState) {
                                    contentEditable = lastContentEditable
                                }
                                e = 0
                            }
                        }
                        r(d, process)
                    });
                    if (format.links === true) {
                        r(i, function (b) {
                            function process(a) {
                                if (a.nodeName === 'A') {
                                    setElementFormat(a, format)
                                }
                                r(grep(a.childNodes), process)
                            }
                            process(b)
                        })
                    }
                    r(i, function (d) {
                        var e;

                        function getChildCount(b) {
                            var c = 0;
                            r(b.childNodes, function (a) {
                                if (!isWhiteSpaceNode(a) && !isBookmarkNode(a)) {
                                    c++
                                }
                            });
                            return c
                        }
                        function mergeStyles(b) {
                            var c, clone;
                            r(b.childNodes, function (a) {
                                if (a.nodeType == 1 && !isBookmarkNode(a) && !isCaretNode(a)) {
                                    c = a;
                                    return FALSE
                                }
                            });
                            if (c && !isBookmarkNode(c) && matchName(c, format)) {
                                clone = dom.clone(c, FALSE);
                                setElementFormat(clone);
                                dom.replace(clone, b, TRUE);
                                dom.remove(c, 1)
                            }
                            return clone || b
                        }
                        e = getChildCount(d);
                        if ((i.length > 1 || !isBlock(d)) && e === 0) {
                            dom.remove(d, 1);
                            return
                        }
                        if (format.inline || format.wrapper) {
                            if (!format.exact && e === 1) {
                                d = mergeStyles(d)
                            }
                            r(n, function (b) {
                                r(dom.select(b.inline, d), function (a) {
                                    if (isBookmarkNode(a)) {
                                        return
                                    }
                                    removeFormat(b, k, a, b.exact ? a : null)
                                })
                            });
                            if (matchNode(d.parentNode, j, k)) {
                                dom.remove(d, 1);
                                d = 0;
                                return TRUE
                            }
                            if (format.merge_with_parents) {
                                dom.getParent(d.parentNode, function (a) {
                                    if (matchNode(a, j, k)) {
                                        dom.remove(d, 1);
                                        d = 0;
                                        return TRUE
                                    }
                                })
                            }
                            if (d && format.merge_siblings !== false) {
                                d = mergeSiblings(getNonWhiteSpaceSibling(d), d);
                                d = mergeSiblings(d, getNonWhiteSpaceSibling(d, TRUE))
                            }
                        }
                    })
                }
                if (getContentEditable(selection.getNode()) === "false") {
                    m = selection.getNode();
                    for (var i = 0, l = n.length; i < l; i++) {
                        if (n[i].ceFalseOverride && dom.is(m, n[i].selector)) {
                            setElementFormat(m, n[i]);
                            return
                        }
                    }
                    return
                }
                if (format) {
                    if (m) {
                        if (m.nodeType) {
                            rng = dom.createRng();
                            rng.setStartBefore(m);
                            rng.setEndAfter(m);
                            applyRngStyle(expandRng(rng, n), null, true)
                        } else {
                            applyRngStyle(m, null, true)
                        }
                    } else {
                        if (!isCollapsed || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
                            var o = p.selection.getNode();
                            if (!forcedRootBlock && n[0].defaultBlock && !dom.getParent(o, dom.isBlock)) {
                                apply(n[0].defaultBlock)
                            }
                            p.selection.setRng(adjustSelectionToVisibleSelection());
                            bookmark = selection.getBookmark();
                            applyRngStyle(expandRng(selection.getRng(TRUE), n), bookmark);
                            if (format.styles && (format.styles.color || format.styles.textDecoration)) {
                                walk(o, processUnderlineAndColor, 'childNodes');
                                processUnderlineAndColor(o)
                            }
                            selection.moveToBookmark(bookmark);
                            moveStart(selection.getRng(TRUE));
                            p.nodeChanged()
                        } else {
                            performCaretAction('apply', j, k)
                        }
                    }
                    A.postProcess(j, p)
                }
            }
            function remove(f, g, h, j) {
                var k = get(f),
                    format = k[0],
                    bookmark, rng, contentEditable = true;

                function process(a) {
                    var b, i, l, lastContentEditable, hasContentEditableState;
                    if (a.nodeType === 1 && getContentEditable(a)) {
                        lastContentEditable = contentEditable;
                        contentEditable = getContentEditable(a) === "true";
                        hasContentEditableState = true
                    }
                    b = grep(a.childNodes);
                    if (contentEditable && !hasContentEditableState) {
                        for (i = 0, l = k.length; i < l; i++) {
                            if (removeFormat(k[i], g, a, a)) {
                                break
                            }
                        }
                    }
                    if (format.deep) {
                        if (b.length) {
                            for (i = 0, l = b.length; i < l; i++) {
                                process(b[i])
                            }
                            if (hasContentEditableState) {
                                contentEditable = lastContentEditable
                            }
                        }
                    }
                }
                function findFormatRoot(c) {
                    var d;
                    r(getParents(c.parentNode).reverse(), function (a) {
                        var b;
                        if (!d && a.id != '_start' && a.id != '_end') {
                            b = matchNode(a, f, g, j);
                            if (b && b.split !== false) {
                                d = a
                            }
                        }
                    });
                    return d
                }
                function wrapAndSplit(a, b, c, d) {
                    var e, clone, lastClone, firstClone, i, formatRootParent;
                    if (a) {
                        formatRootParent = a.parentNode;
                        for (e = b.parentNode; e && e != formatRootParent; e = e.parentNode) {
                            clone = dom.clone(e, FALSE);
                            for (i = 0; i < k.length; i++) {
                                if (removeFormat(k[i], g, clone, clone)) {
                                    clone = 0;
                                    break
                                }
                            }
                            if (clone) {
                                if (lastClone) {
                                    clone.appendChild(lastClone)
                                }
                                if (!firstClone) {
                                    firstClone = clone
                                }
                                lastClone = clone
                            }
                        }
                        if (d && (!format.mixed || !isBlock(a))) {
                            b = dom.split(a, b)
                        }
                        if (lastClone) {
                            c.parentNode.insertBefore(lastClone, c);
                            firstClone.appendChild(c)
                        }
                    }
                    return b
                }
                function splitToFormatRoot(a) {
                    return wrapAndSplit(findFormatRoot(a), a, a, true)
                }
                function unwrap(a) {
                    var b = dom.get(a ? '_start' : '_end'),
                        out = b[a ? 'firstChild' : 'lastChild'];
                    if (isBookmarkNode(out)) {
                        out = out[a ? 'firstChild' : 'lastChild']
                    }
                    if (out.nodeType == 3 && out.data.length === 0) {
                        out = a ? b.previousSibling || b.nextSibling : b.nextSibling || b.previousSibling
                    }
                    dom.remove(b, true);
                    return out
                }
                function removeRngStyle(c) {
                    var d, endContainer;
                    var e = c.commonAncestorContainer;
                    c = expandRng(c, k, TRUE);
                    if (format.split) {
                        d = getContainer(c, TRUE);
                        endContainer = getContainer(c);
                        if (d != endContainer) {
                            if (/^(TR|TH|TD)$/.test(d.nodeName) && d.firstChild) {
                                if (d.nodeName == "TR") {
                                    d = d.firstChild.firstChild || d
                                } else {
                                    d = d.firstChild || d
                                }
                            }
                            if (e && /^T(HEAD|BODY|FOOT|R)$/.test(e.nodeName) && isTableCell(endContainer) && endContainer.firstChild) {
                                endContainer = endContainer.firstChild || endContainer
                            }
                            if (dom.isChildOf(d, endContainer) && !isBlock(endContainer) && !isTableCell(d) && !isTableCell(endContainer)) {
                                d = wrap(d, 'span', {
                                    id: '_start',
                                    'data-mce-type': 'bookmark'
                                });
                                splitToFormatRoot(d);
                                d = unwrap(TRUE);
                                return
                            }
                            d = wrap(d, 'span', {
                                id: '_start',
                                'data-mce-type': 'bookmark'
                            });
                            endContainer = wrap(endContainer, 'span', {
                                id: '_end',
                                'data-mce-type': 'bookmark'
                            });
                            splitToFormatRoot(d);
                            splitToFormatRoot(endContainer);
                            d = unwrap(TRUE);
                            endContainer = unwrap()
                        } else {
                            d = endContainer = splitToFormatRoot(d)
                        }
                        c.startContainer = d.parentNode ? d.parentNode : d;
                        c.startOffset = nodeIndex(d);
                        c.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
                        c.endOffset = nodeIndex(endContainer) + 1
                    }
                    rangeUtils.walk(c, function (b) {
                        r(b, function (a) {
                            process(a);
                            if (a.nodeType === 1 && p.dom.getStyle(a, 'text-decoration') === 'underline' && a.parentNode && getTextDecoration(a.parentNode) === 'underline') {
                                removeFormat({
                                    'deep': false,
                                    'exact': true,
                                    'inline': 'span',
                                    'styles': {
                                        'textDecoration': 'underline'
                                    }
                                }, null, a)
                            }
                        })
                    })
                }
                if (h) {
                    if (h.nodeType) {
                        rng = dom.createRng();
                        rng.setStartBefore(h);
                        rng.setEndAfter(h);
                        removeRngStyle(rng)
                    } else {
                        removeRngStyle(h)
                    }
                    return
                }
                if (getContentEditable(selection.getNode()) === "false") {
                    h = selection.getNode();
                    for (var i = 0, l = k.length; i < l; i++) {
                        if (k[i].ceFalseOverride) {
                            if (removeFormat(k[i], g, h, h)) {
                                break
                            }
                        }
                    }
                    return
                }
                if (!selection.isCollapsed() || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
                    bookmark = selection.getBookmark();
                    removeRngStyle(selection.getRng(TRUE));
                    selection.moveToBookmark(bookmark);
                    if (format.inline && match(f, g, selection.getStart())) {
                        moveStart(selection.getRng(true))
                    }
                    p.nodeChanged()
                } else {
                    performCaretAction('remove', f, g, j)
                }
            }
            function toggle(a, b, c) {
                var d = get(a);
                if (match(a, b, c) && (!('toggle' in d[0]) || d[0].toggle)) {
                    remove(a, b, c)
                } else {
                    apply(a, b, c)
                }
            }
            function matchNode(e, f, g, h) {
                var j = get(f),
                    format, i, classes;

                function matchItems(a, b, c) {
                    var d, value, items = b[c],
                        i;
                    if (b.onmatch) {
                        return b.onmatch(a, b, c)
                    }
                    if (items) {
                        if (items.length === undef) {
                            for (d in items) {
                                if (items.hasOwnProperty(d)) {
                                    if (c === 'attributes') {
                                        value = dom.getAttrib(a, d)
                                    } else {
                                        value = getStyle(a, d)
                                    }
                                    if (h && !value && !b.exact) {
                                        return
                                    }
                                    if ((!h || b.exact) && !isEq(value, normalizeStyleValue(replaceVars(items[d], g), d))) {
                                        return
                                    }
                                }
                            }
                        } else {
                            for (i = 0; i < items.length; i++) {
                                if (c === 'attributes' ? dom.getAttrib(a, items[i]) : getStyle(a, items[i])) {
                                    return b
                                }
                            }
                        }
                    }
                    return b
                }
                if (j && e) {
                    for (i = 0; i < j.length; i++) {
                        format = j[i];
                        if (matchName(e, format) && matchItems(e, format, 'attributes') && matchItems(e, format, 'styles')) {
                            if ((classes = format.classes)) {
                                for (i = 0; i < classes.length; i++) {
                                    if (!dom.hasClass(e, classes[i])) {
                                        return
                                    }
                                }
                            }
                            return format
                        }
                    }
                }
            }
            function match(d, e, f) {
                var g;

                function matchParents(b) {
                    var c = dom.getRoot();
                    if (b === c) {
                        return false
                    }
                    b = dom.getParent(b, function (a) {
                        if (matchesUnInheritedFormatSelector(a, d)) {
                            return true
                        }
                        return a.parentNode === c || !!matchNode(a, d, e, true)
                    });
                    return matchNode(b, d, e)
                }
                if (f) {
                    return matchParents(f)
                }
                f = selection.getNode();
                if (matchParents(f)) {
                    return TRUE
                }
                g = selection.getStart();
                if (g != f) {
                    if (matchParents(g)) {
                        return TRUE
                    }
                }
                return FALSE
            }
            function matchAll(b, c) {
                var d, matchedFormatNames = [],
                    checkedMap = {};
                d = selection.getStart();
                dom.getParent(d, function (a) {
                    var i, name;
                    for (i = 0; i < b.length; i++) {
                        name = b[i];
                        if (!checkedMap[name] && matchNode(a, name, c)) {
                            checkedMap[name] = true;
                            matchedFormatNames.push(name)
                        }
                    }
                }, dom.getRoot());
                return matchedFormatNames
            }
            function canApply(a) {
                var b = get(a),
                    startNode, parents, i, x, selector;
                if (b) {
                    startNode = selection.getStart();
                    parents = getParents(startNode);
                    for (x = b.length - 1; x >= 0; x--) {
                        selector = b[x].selector;
                        if (!selector || b[x].defaultBlock) {
                            return TRUE
                        }
                        for (i = parents.length - 1; i >= 0; i--) {
                            if (dom.is(parents[i], selector)) {
                                return TRUE
                            }
                        }
                    }
                }
                return FALSE
            }
            function formatChanged(g, h, i) {
                var j;
                if (!formatChangeData) {
                    formatChangeData = {};
                    j = {};
                    p.on('NodeChange', function (e) {
                        var f = getParents(e.element),
                            matchedFormats = {};
                        f = w.grep(f, function (a) {
                            return a.nodeType == 1 && !a.getAttribute('data-mce-bogus')
                        });
                        r(formatChangeData, function (c, d) {
                            r(f, function (b) {
                                if (matchNode(b, d, {}, c.similar)) {
                                    if (!j[d]) {
                                        r(c, function (a) {
                                            a(true, {
                                                node: b,
                                                format: d,
                                                parents: f
                                            })
                                        });
                                        j[d] = c
                                    }
                                    matchedFormats[d] = c;
                                    return false
                                }
                                if (matchesUnInheritedFormatSelector(b, d)) {
                                    return false
                                }
                            })
                        });
                        r(j, function (b, c) {
                            if (!matchedFormats[c]) {
                                delete j[c];
                                r(b, function (a) {
                                    a(false, {
                                        node: e.element,
                                        format: c,
                                        parents: f
                                    })
                                })
                            }
                        })
                    })
                }
                r(g.split(','), function (a) {
                    if (!formatChangeData[a]) {
                        formatChangeData[a] = [];
                        formatChangeData[a].similar = i
                    }
                    formatChangeData[a].push(h)
                });
                return this
            }
            function getCssText(a) {
                return z.getCssText(p, a)
            }
            extend(this, {
                get: get,
                register: register,
                unregister: unregister,
                apply: apply,
                remove: remove,
                toggle: toggle,
                match: match,
                matchAll: matchAll,
                matchNode: matchNode,
                canApply: canApply,
                formatChanged: formatChanged,
                getCssText: getCssText
            });
            defaultFormats();
            addKeyboardShortcuts();
            p.on('BeforeGetContent', function (e) {
                if (markCaretContainersBogus && e.format != 'raw') {
                    markCaretContainersBogus()
                }
            });
            p.on('mouseup keydown', function (e) {
                if (disableCaretContainer) {
                    disableCaretContainer(e)
                }
            });

            function matchName(a, b) {
                if (isEq(a, b.inline)) {
                    return TRUE
                }
                if (isEq(a, b.block)) {
                    return TRUE
                }
                if (b.selector) {
                    return a.nodeType == 1 && dom.is(a, b.selector)
                }
            }
            function isEq(a, b) {
                a = a || '';
                b = b || '';
                a = '' + (a.nodeName || a);
                b = '' + (b.nodeName || b);
                return a.toLowerCase() == b.toLowerCase()
            }
            function getStyle(a, b) {
                return normalizeStyleValue(dom.getStyle(a, b), b)
            }
            function normalizeStyleValue(a, b) {
                if (b == 'color' || b == 'backgroundColor') {
                    a = dom.toHex(a)
                }
                if (b == 'fontWeight' && a == 700) {
                    a = 'bold'
                }
                if (b == 'fontFamily') {
                    a = a.replace(/[\'\"]/g, '').replace(/,\s+/g, ',')
                }
                return '' + a
            }
            function replaceVars(c, d) {
                if (typeof c != "string") {
                    c = c(d)
                } else if (d) {
                    c = c.replace(/%(\w+)/g, function (a, b) {
                        return d[b] || a
                    })
                }
                return c
            }
            function isWhiteSpaceNode(a) {
                return a && a.nodeType === 3 && /^([\t \r\n]+|)$/.test(a.nodeValue)
            }
            function wrap(a, b, c) {
                var d = dom.create(b, c);
                a.parentNode.insertBefore(d, a);
                d.appendChild(a);
                return d
            }
            function expandRng(h, j, k) {
                var l, leaf, endPoint, startContainer = h.startContainer,
                    startOffset = h.startOffset,
                    endContainer = h.endContainer,
                    endOffset = h.endOffset;

                function findParentContainer(b) {
                    var c, parent, sibling, siblingName, root;
                    c = parent = b ? startContainer : endContainer;
                    siblingName = b ? 'previousSibling' : 'nextSibling';
                    root = dom.getRoot();

                    function isBogusBr(a) {
                        return a.nodeName == "BR" && a.getAttribute('data-mce-bogus') && !a.nextSibling
                    }
                    if (c.nodeType == 3 && !isWhiteSpaceNode(c)) {
                        if (b ? startOffset > 0 : endOffset < c.nodeValue.length) {
                            return c
                        }
                    }
                    while (true) {
                        if (!j[0].block_expand && isBlock(parent)) {
                            return parent
                        }
                        for (sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
                            if (!isBookmarkNode(sibling) && !isWhiteSpaceNode(sibling) && !isBogusBr(sibling)) {
                                return parent
                            }
                        }
                        if (parent == root || parent.parentNode == root) {
                            c = parent;
                            break
                        }
                        parent = parent.parentNode
                    }
                    return c
                }
                function findLeaf(a, b) {
                    if (b === undef) {
                        b = a.nodeType === 3 ? a.length : a.childNodes.length
                    }
                    while (a && a.hasChildNodes()) {
                        a = a.childNodes[b];
                        if (a) {
                            b = a.nodeType === 3 ? a.length : a.childNodes.length
                        }
                    }
                    return {
                        node: a,
                        offset: b
                    }
                }
                if (startContainer.nodeType == 1 && startContainer.hasChildNodes()) {
                    l = startContainer.childNodes.length - 1;
                    startContainer = startContainer.childNodes[startOffset > l ? l : startOffset];
                    if (startContainer.nodeType == 3) {
                        startOffset = 0
                    }
                }
                if (endContainer.nodeType == 1 && endContainer.hasChildNodes()) {
                    l = endContainer.childNodes.length - 1;
                    endContainer = endContainer.childNodes[endOffset > l ? l : endOffset - 1];
                    if (endContainer.nodeType == 3) {
                        endOffset = endContainer.nodeValue.length
                    }
                }
                function findParentContentEditable(a) {
                    var b = a;
                    while (b) {
                        if (b.nodeType === 1 && getContentEditable(b)) {
                            return getContentEditable(b) === "false" ? b : a
                        }
                        b = b.parentNode
                    }
                    return a
                }
                function findWordEndPoint(d, e, f) {
                    var g, node, pos, lastTextNode;

                    function findSpace(a, b) {
                        var c, pos2, str = a.nodeValue;
                        if (typeof b == "undefined") {
                            b = f ? str.length : 0
                        }
                        if (f) {
                            c = str.lastIndexOf(' ', b);
                            pos2 = str.lastIndexOf(' ', b);
                            c = c > pos2 ? c : pos2;
                            if (c !== -1 && !k) {
                                c++
                            }
                        } else {
                            c = str.indexOf(' ', b);
                            pos2 = str.indexOf(' ', b);
                            c = c !== -1 && (pos2 === -1 || c < pos2) ? c : pos2
                        }
                        return c
                    }
                    if (d.nodeType === 3) {
                        pos = findSpace(d, e);
                        if (pos !== -1) {
                            return {
                                container: d,
                                offset: pos
                            }
                        }
                        lastTextNode = d
                    }
                    g = new s(d, dom.getParent(d, isBlock) || p.getBody());
                    while ((node = g[f ? 'prev' : 'next']())) {
                        if (node.nodeType === 3) {
                            lastTextNode = node;
                            pos = findSpace(node);
                            if (pos !== -1) {
                                return {
                                    container: node,
                                    offset: pos
                                }
                            }
                        } else if (isBlock(node)) {
                            break
                        }
                    }
                    if (lastTextNode) {
                        if (f) {
                            e = 0
                        } else {
                            e = lastTextNode.length
                        }
                        return {
                            container: lastTextNode,
                            offset: e
                        }
                    }
                }
                function findSelectorEndPoint(a, b) {
                    var c, i, y, curFormat;
                    if (a.nodeType == 3 && a.nodeValue.length === 0 && a[b]) {
                        a = a[b]
                    }
                    c = getParents(a);
                    for (i = 0; i < c.length; i++) {
                        for (y = 0; y < j.length; y++) {
                            curFormat = j[y];
                            if ("collapsed" in curFormat && curFormat.collapsed !== h.collapsed) {
                                continue
                            }
                            if (dom.is(c[i], curFormat.selector)) {
                                return c[i]
                            }
                        }
                    }
                    return a
                }
                function findBlockEndPoint(b, c) {
                    var d, root = dom.getRoot();
                    if (!j[0].wrapper) {
                        d = dom.getParent(b, j[0].block, root)
                    }
                    if (!d) {
                        d = dom.getParent(b.nodeType == 3 ? b.parentNode : b, function (a) {
                            return a != root && isTextBlock(a)
                        })
                    }
                    if (d && j[0].wrapper) {
                        d = getParents(d, 'ul,ol').reverse()[0] || d
                    }
                    if (!d) {
                        d = b;
                        while (d[c] && !isBlock(d[c])) {
                            d = d[c];
                            if (isEq(d, 'br')) {
                                break
                            }
                        }
                    }
                    return d || b
                }
                startContainer = findParentContentEditable(startContainer);
                endContainer = findParentContentEditable(endContainer);
                if (isBookmarkNode(startContainer.parentNode) || isBookmarkNode(startContainer)) {
                    startContainer = isBookmarkNode(startContainer) ? startContainer : startContainer.parentNode;
                    startContainer = startContainer.nextSibling || startContainer;
                    if (startContainer.nodeType == 3) {
                        startOffset = 0
                    }
                }
                if (isBookmarkNode(endContainer.parentNode) || isBookmarkNode(endContainer)) {
                    endContainer = isBookmarkNode(endContainer) ? endContainer : endContainer.parentNode;
                    endContainer = endContainer.previousSibling || endContainer;
                    if (endContainer.nodeType == 3) {
                        endOffset = endContainer.length
                    }
                }
                if (j[0].inline) {
                    if (h.collapsed) {
                        endPoint = findWordEndPoint(startContainer, startOffset, true);
                        if (endPoint) {
                            startContainer = endPoint.container;
                            startOffset = endPoint.offset
                        }
                        endPoint = findWordEndPoint(endContainer, endOffset);
                        if (endPoint) {
                            endContainer = endPoint.container;
                            endOffset = endPoint.offset
                        }
                    }
                    leaf = findLeaf(endContainer, endOffset);
                    if (leaf.node) {
                        while (leaf.node && leaf.offset === 0 && leaf.node.previousSibling) {
                            leaf = findLeaf(leaf.node.previousSibling)
                        }
                        if (leaf.node && leaf.offset > 0 && leaf.node.nodeType === 3 && leaf.node.nodeValue.charAt(leaf.offset - 1) === ' ') {
                            if (leaf.offset > 1) {
                                endContainer = leaf.node;
                                endContainer.splitText(leaf.offset - 1)
                            }
                        }
                    }
                }
                if (j[0].inline || j[0].block_expand) {
                    if (!j[0].inline || (startContainer.nodeType != 3 || startOffset === 0)) {
                        startContainer = findParentContainer(true)
                    }
                    if (!j[0].inline || (endContainer.nodeType != 3 || endOffset === endContainer.nodeValue.length)) {
                        endContainer = findParentContainer()
                    }
                }
                if (j[0].selector && j[0].expand !== FALSE && !j[0].inline) {
                    startContainer = findSelectorEndPoint(startContainer, 'previousSibling');
                    endContainer = findSelectorEndPoint(endContainer, 'nextSibling')
                }
                if (j[0].block || j[0].selector) {
                    startContainer = findBlockEndPoint(startContainer, 'previousSibling');
                    endContainer = findBlockEndPoint(endContainer, 'nextSibling');
                    if (j[0].block) {
                        if (!isBlock(startContainer)) {
                            startContainer = findParentContainer(true)
                        }
                        if (!isBlock(endContainer)) {
                            endContainer = findParentContainer()
                        }
                    }
                }
                if (startContainer.nodeType == 1) {
                    startOffset = nodeIndex(startContainer);
                    startContainer = startContainer.parentNode
                }
                if (endContainer.nodeType == 1) {
                    endOffset = nodeIndex(endContainer) + 1;
                    endContainer = endContainer.parentNode
                }
                return {
                    startContainer: startContainer,
                    startOffset: startOffset,
                    endContainer: endContainer,
                    endOffset: endOffset
                }
            }
            function isColorFormatAndAnchor(a, b) {
                return b.links && a.tagName == 'A'
            }
            function removeFormat(e, f, g, h) {
                var i, attrs, stylesModified;
                if (!matchName(g, e) && !isColorFormatAndAnchor(g, e)) {
                    return FALSE
                }
                if (e.remove != 'all') {
                    r(e.styles, function (a, b) {
                        a = normalizeStyleValue(replaceVars(a, f), b);
                        if (typeof b === 'number') {
                            b = a;
                            h = 0
                        }
                        if (e.remove_similar || (!h || isEq(getStyle(h, b), a))) {
                            dom.setStyle(g, b, '')
                        }
                        stylesModified = 1
                    });
                    if (stylesModified && dom.getAttrib(g, 'style') === '') {
                        g.removeAttribute('style');
                        g.removeAttribute('data-mce-style')
                    }
                    r(e.attributes, function (b, c) {
                        var d;
                        b = replaceVars(b, f);
                        if (typeof c === 'number') {
                            c = b;
                            h = 0
                        }
                        if (!h || isEq(dom.getAttrib(h, c), b)) {
                            if (c == 'class') {
                                b = dom.getAttrib(g, c);
                                if (b) {
                                    d = '';
                                    r(b.split(/\s+/), function (a) {
                                        if (/mce\-\w+/.test(a)) {
                                            d += (d ? ' ' : '') + a
                                        }
                                    });
                                    if (d) {
                                        dom.setAttrib(g, c, d);
                                        return
                                    }
                                }
                            }
                            if (c == "class") {
                                g.removeAttribute('className')
                            }
                            if (MCE_ATTR_RE.test(c)) {
                                g.removeAttribute('data-mce-' + c)
                            }
                            g.removeAttribute(c)
                        }
                    });
                    r(e.classes, function (a) {
                        a = replaceVars(a, f);
                        if (!h || dom.hasClass(h, a)) {
                            dom.removeClass(g, a)
                        }
                    });
                    attrs = dom.getAttribs(g);
                    for (i = 0; i < attrs.length; i++) {
                        var j = attrs[i].nodeName;
                        if (j.indexOf('_') !== 0 && j.indexOf('data-') !== 0) {
                            return FALSE
                        }
                    }
                }
                if (e.remove != 'none') {
                    removeNode(g, e);
                    return TRUE
                }
            }
            function removeNode(d, e) {
                var f = d.parentNode,
                    rootBlockElm;

                function find(a, b, c) {
                    a = getNonWhiteSpaceSibling(a, b, c);
                    return !a || (a.nodeName == 'BR' || isBlock(a))
                }
                if (e.block) {
                    if (!forcedRootBlock) {
                        if (isBlock(d) && !isBlock(f)) {
                            if (!find(d, FALSE) && !find(d.firstChild, TRUE, 1)) {
                                d.insertBefore(dom.create('br'), d.firstChild)
                            }
                            if (!find(d, TRUE) && !find(d.lastChild, FALSE, 1)) {
                                d.appendChild(dom.create('br'))
                            }
                        }
                    } else {
                        if (f == dom.getRoot()) {
                            if (!e.list_block || !isEq(d, e.list_block)) {
                                r(grep(d.childNodes), function (a) {
                                    if (isValid(forcedRootBlock, a.nodeName.toLowerCase())) {
                                        if (!rootBlockElm) {
                                            rootBlockElm = wrap(a, forcedRootBlock);
                                            dom.setAttribs(rootBlockElm, p.settings.forced_root_block_attrs)
                                        } else {
                                            rootBlockElm.appendChild(a)
                                        }
                                    } else {
                                        rootBlockElm = 0
                                    }
                                })
                            }
                        }
                    }
                }
                if (e.selector && e.inline && !isEq(e.inline, d)) {
                    return
                }
                dom.remove(d, 1)
            }
            function getNonWhiteSpaceSibling(a, b, c) {
                if (a) {
                    b = b ? 'nextSibling' : 'previousSibling';
                    for (a = c ? a : a[b]; a; a = a[b]) {
                        if (a.nodeType == 1 || !isWhiteSpaceNode(a)) {
                            return a
                        }
                    }
                }
            }
            function mergeSiblings(c, d) {
                var e, tmpSibling, elementUtils = new v(dom);

                function findElementSibling(a, b) {
                    for (e = a; e; e = e[b]) {
                        if (e.nodeType == 3 && e.nodeValue.length !== 0) {
                            return a
                        }
                        if (e.nodeType == 1 && !isBookmarkNode(e)) {
                            return e
                        }
                    }
                    return a
                }
                if (c && d) {
                    c = findElementSibling(c, 'previousSibling');
                    d = findElementSibling(d, 'nextSibling');
                    if (elementUtils.compare(c, d)) {
                        for (e = c.nextSibling; e && e != d;) {
                            tmpSibling = e;
                            e = e.nextSibling;
                            c.appendChild(tmpSibling)
                        }
                        dom.remove(d);
                        r(grep(d.childNodes), function (a) {
                            c.appendChild(a)
                        });
                        return c
                    }
                }
                return d
            }
            function getContainer(a, b) {
                var c, offset, lastIdx;
                c = a[b ? 'startContainer' : 'endContainer'];
                offset = a[b ? 'startOffset' : 'endOffset'];
                if (c.nodeType == 1) {
                    lastIdx = c.childNodes.length - 1;
                    if (!b && offset) {
                        offset--
                    }
                    c = c.childNodes[offset > lastIdx ? lastIdx : offset]
                }
                if (c.nodeType === 3 && b && offset >= c.nodeValue.length) {
                    c = new s(c, p.getBody()).next() || c
                }
                if (c.nodeType === 3 && !b && offset === 0) {
                    c = new s(c, p.getBody()).prev() || c
                }
                return c
            }
            function performCaretAction(d, f, g, h) {
                var j = '_mce_caret',
                    debug = p.settings.caret_debug;

                function createCaretContainer(a) {
                    var b = dom.create('span', {
                        id: j,
                        'data-mce-bogus': true,
                        style: debug ? 'color:red' : ''
                    });
                    if (a) {
                        b.appendChild(p.getDoc().createTextNode(INVISIBLE_CHAR))
                    }
                    return b
                }
                function isCaretContainerEmpty(a, b) {
                    while (a) {
                        if ((a.nodeType === 3 && a.nodeValue !== INVISIBLE_CHAR) || a.childNodes.length > 1) {
                            return false
                        }
                        if (b && a.nodeType === 1) {
                            b.push(a)
                        }
                        a = a.firstChild
                    }
                    return true
                }
                function getParentCaretContainer(a) {
                    while (a) {
                        if (a.id === j) {
                            return a
                        }
                        a = a.parentNode
                    }
                }
                function findFirstTextNode(a) {
                    var b;
                    if (a) {
                        b = new s(a, a);
                        for (a = b.current(); a; a = b.next()) {
                            if (a.nodeType === 3) {
                                return a
                            }
                        }
                    }
                }
                function removeCaretContainer(a, b) {
                    var c, rng;
                    if (!a) {
                        a = getParentCaretContainer(selection.getStart());
                        if (!a) {
                            while ((a = dom.get(j))) {
                                removeCaretContainer(a, false)
                            }
                        }
                    } else {
                        rng = selection.getRng(true);
                        if (isCaretContainerEmpty(a)) {
                            if (b !== false) {
                                rng.setStartBefore(a);
                                rng.setEndBefore(a)
                            }
                            dom.remove(a)
                        } else {
                            c = findFirstTextNode(a);
                            if (c.nodeValue.charAt(0) === INVISIBLE_CHAR) {
                                c.deleteData(0, 1);
                                if (rng.startContainer == c && rng.startOffset > 0) {
                                    rng.setStart(c, rng.startOffset - 1)
                                }
                                if (rng.endContainer == c && rng.endOffset > 0) {
                                    rng.setEnd(c, rng.endOffset - 1)
                                }
                            }
                            dom.remove(a, 1)
                        }
                        selection.setRng(rng)
                    }
                }
                function applyCaretFormat() {
                    var a, caretContainer, textNode, offset, bookmark, container, text;
                    a = selection.getRng(true);
                    offset = a.startOffset;
                    container = a.startContainer;
                    text = container.nodeValue;
                    caretContainer = getParentCaretContainer(selection.getStart());
                    if (caretContainer) {
                        textNode = findFirstTextNode(caretContainer)
                    }
                    if (text && offset > 0 && offset < text.length && /\w/.test(text.charAt(offset)) && /\w/.test(text.charAt(offset - 1))) {
                        bookmark = selection.getBookmark();
                        a.collapse(true);
                        a = expandRng(a, get(f));
                        a = rangeUtils.split(a);
                        apply(f, g, a);
                        selection.moveToBookmark(bookmark)
                    } else {
                        if (!caretContainer || textNode.nodeValue !== INVISIBLE_CHAR) {
                            caretContainer = createCaretContainer(true);
                            textNode = caretContainer.firstChild;
                            a.insertNode(caretContainer);
                            offset = 1;
                            apply(f, g, caretContainer)
                        } else {
                            apply(f, g, caretContainer)
                        }
                        selection.setCursorLocation(textNode, offset)
                    }
                }
                function removeCaretFormat() {
                    var a = selection.getRng(true),
                        container, offset, bookmark, hasContentAfter, node, formatNode, parents = [],
                        i, caretContainer;
                    container = a.startContainer;
                    offset = a.startOffset;
                    node = container;
                    if (container.nodeType == 3) {
                        if (offset != container.nodeValue.length) {
                            hasContentAfter = true
                        }
                        node = node.parentNode
                    }
                    while (node) {
                        if (matchNode(node, f, g, h)) {
                            formatNode = node;
                            break
                        }
                        if (node.nextSibling) {
                            hasContentAfter = true
                        }
                        parents.push(node);
                        node = node.parentNode
                    }
                    if (!formatNode) {
                        return
                    }
                    if (hasContentAfter) {
                        bookmark = selection.getBookmark();
                        a.collapse(true);
                        a = expandRng(a, get(f), true);
                        a = rangeUtils.split(a);
                        remove(f, g, a);
                        selection.moveToBookmark(bookmark)
                    } else {
                        caretContainer = createCaretContainer();
                        node = caretContainer;
                        for (i = parents.length - 1; i >= 0; i--) {
                            node.appendChild(dom.clone(parents[i], false));
                            node = node.firstChild
                        }
                        node.appendChild(dom.doc.createTextNode(INVISIBLE_CHAR));
                        node = node.firstChild;
                        var b = dom.getParent(formatNode, isTextBlock);
                        if (b && dom.isEmpty(b)) {
                            formatNode.parentNode.replaceChild(caretContainer, formatNode)
                        } else {
                            dom.insertAfter(caretContainer, formatNode)
                        }
                        selection.setCursorLocation(node, 1);
                        if (dom.isEmpty(formatNode)) {
                            dom.remove(formatNode)
                        }
                    }
                }
                function unmarkBogusCaretParents() {
                    var b;
                    b = getParentCaretContainer(selection.getStart());
                    if (b && !dom.isEmpty(b)) {
                        walk(b, function (a) {
                            if (a.nodeType == 1 && a.id !== j && !dom.isEmpty(a)) {
                                dom.setAttrib(a, 'data-mce-bogus', null)
                            }
                        }, 'childNodes')
                    }
                }
                if (!p._hasCaretEvents) {
                    markCaretContainersBogus = function () {
                        var a = [],
                            i;
                        if (isCaretContainerEmpty(getParentCaretContainer(selection.getStart()), a)) {
                            i = a.length;
                            while (i--) {
                                dom.setAttrib(a[i], 'data-mce-bogus', '1')
                            }
                        }
                    };
                    disableCaretContainer = function (e) {
                        var a = e.keyCode;
                        removeCaretContainer();
                        if (a == 8 && selection.isCollapsed() && selection.getStart().innerHTML == INVISIBLE_CHAR) {
                            removeCaretContainer(getParentCaretContainer(selection.getStart()))
                        }
                        if (a == 37 || a == 39) {
                            removeCaretContainer(getParentCaretContainer(selection.getStart()))
                        }
                        unmarkBogusCaretParents()
                    };
                    p.on('SetContent', function (e) {
                        if (e.selection) {
                            unmarkBogusCaretParents()
                        }
                    });
                    p._hasCaretEvents = true
                }
                if (d == "apply") {
                    applyCaretFormat()
                } else {
                    removeCaretFormat()
                }
            }
            function moveStart(a) {
                var b = a.startContainer,
                    offset = a.startOffset,
                    isAtEndOfText, walker, node, nodes, tmpNode;
                if (a.startContainer == a.endContainer) {
                    if (isInlineBlock(a.startContainer.childNodes[a.startOffset])) {
                        return
                    }
                }
                if (b.nodeType == 3 && offset >= b.nodeValue.length) {
                    offset = nodeIndex(b);
                    b = b.parentNode;
                    isAtEndOfText = true
                }
                if (b.nodeType == 1) {
                    nodes = b.childNodes;
                    b = nodes[Math.min(offset, nodes.length - 1)];
                    walker = new s(b, dom.getParent(b, dom.isBlock));
                    if (offset > nodes.length - 1 || isAtEndOfText) {
                        walker.next()
                    }
                    for (node = walker.current(); node; node = walker.next()) {
                        if (node.nodeType == 3 && !isWhiteSpaceNode(node)) {
                            tmpNode = dom.create('a', {
                                'data-mce-bogus': 'all'
                            }, INVISIBLE_CHAR);
                            node.parentNode.insertBefore(tmpNode, node);
                            a.setStart(node, 0);
                            selection.setRng(a);
                            dom.remove(tmpNode);
                            return
                        }
                    }
                }
            }
        }
    });
    define("tinymce/UndoManager", ["tinymce/util/VK", "tinymce/Env"], function (g, h) {
        return function (d) {
            var f = this,
                index = 0,
                data = [],
                beforeBookmark, isFirstTypedCharacter, locks = 0;

            function getContent() {
                return d.serializer.getTrimmedContent()
            }
            function setDirty(a) {
                d.setDirty(a)
            }
            function addNonTypingUndoLevel(e) {
                f.typing = false;
                f.add({}, e)
            }
            d.on('init', function () {
                f.add()
            });
            d.on('BeforeExecCommand', function (e) {
                var a = e.command;
                if (a != 'Undo' && a != 'Redo' && a != 'mceRepaint') {
                    f.beforeChange()
                }
            });
            d.on('ExecCommand', function (e) {
                var a = e.command;
                if (a != 'Undo' && a != 'Redo' && a != 'mceRepaint') {
                    addNonTypingUndoLevel(e)
                }
            });
            d.on('ObjectResizeStart Cut', function () {
                f.beforeChange()
            });
            d.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
            d.on('DragEnd', addNonTypingUndoLevel);
            d.on('KeyUp', function (e) {
                var a = e.keyCode;
                if (e.isDefaultPrevented()) {
                    return
                }
                if ((a >= 33 && a <= 36) || (a >= 37 && a <= 40) || a == 45 || a == 13 || e.ctrlKey) {
                    addNonTypingUndoLevel();
                    d.nodeChanged()
                }
                if (a == 46 || a == 8 || (h.mac && (a == 91 || a == 93))) {
                    d.nodeChanged()
                }
                if (isFirstTypedCharacter && f.typing) {
                    if (!d.isDirty()) {
                        setDirty(data[0] && getContent() != data[0].content);
                        if (d.isDirty()) {
                            d.fire('change', {
                                level: data[0],
                                lastLevel: null
                            })
                        }
                    }
                    d.fire('TypingUndo');
                    isFirstTypedCharacter = false;
                    d.nodeChanged()
                }
            });
            d.on('KeyDown', function (e) {
                var a = e.keyCode;
                if (e.isDefaultPrevented()) {
                    return
                }
                if ((a >= 33 && a <= 36) || (a >= 37 && a <= 40) || a == 45) {
                    if (f.typing) {
                        addNonTypingUndoLevel(e)
                    }
                    return
                }
                var b = (e.ctrlKey && !e.altKey) || e.metaKey;
                if ((a < 16 || a > 20) && a != 224 && a != 91 && !f.typing && !b) {
                    f.beforeChange();
                    f.typing = true;
                    f.add({}, e);
                    isFirstTypedCharacter = true
                }
            });
            d.on('MouseDown', function (e) {
                if (f.typing) {
                    addNonTypingUndoLevel(e)
                }
            });
            d.addShortcut('meta+z', '', 'Undo');
            d.addShortcut('meta+y,meta+shift+z', '', 'Redo');
            d.on('AddUndo Undo Redo ClearUndos', function (e) {
                if (!e.isDefaultPrevented()) {
                    d.nodeChanged()
                }
            });
            f = {
                data: data,
                typing: false,
                beforeChange: function () {
                    if (!locks) {
                        beforeBookmark = d.selection.getBookmark(2, true)
                    }
                },
                add: function (a, b) {
                    var i, settings = d.settings,
                        lastLevel;
                    a = a || {};
                    a.content = getContent();
                    if (locks || d.removed) {
                        return null
                    }
                    lastLevel = data[index];
                    if (d.fire('BeforeAddUndo', {
                        level: a,
                        lastLevel: lastLevel,
                        originalEvent: b
                    }).isDefaultPrevented()) {
                        return null
                    }
                    if (lastLevel && lastLevel.content == a.content) {
                        return null
                    }
                    if (data[index]) {
                        data[index].beforeBookmark = beforeBookmark
                    }
                    if (settings.custom_undo_redo_levels) {
                        if (data.length > settings.custom_undo_redo_levels) {
                            for (i = 0; i < data.length - 1; i++) {
                                data[i] = data[i + 1]
                            }
                            data.length--;
                            index = data.length
                        }
                    }
                    a.bookmark = d.selection.getBookmark(2, true);
                    if (index < data.length - 1) {
                        data.length = index + 1
                    }
                    data.push(a);
                    index = data.length - 1;
                    var c = {
                        level: a,
                        lastLevel: lastLevel,
                        originalEvent: b
                    };
                    d.fire('AddUndo', c);
                    if (index > 0) {
                        setDirty(true);
                        d.fire('change', c)
                    }
                    return a
                },
                undo: function () {
                    var a;
                    if (f.typing) {
                        f.add();
                        f.typing = false
                    }
                    if (index > 0) {
                        a = data[--index];
                        d.setContent(a.content, {
                            format: 'raw'
                        });
                        d.selection.moveToBookmark(a.beforeBookmark);
                        setDirty(true);
                        d.fire('undo', {
                            level: a
                        })
                    }
                    return a
                },
                redo: function () {
                    var a;
                    if (index < data.length - 1) {
                        a = data[++index];
                        d.setContent(a.content, {
                            format: 'raw'
                        });
                        d.selection.moveToBookmark(a.bookmark);
                        setDirty(true);
                        d.fire('redo', {
                            level: a
                        })
                    }
                    return a
                },
                clear: function () {
                    data = [];
                    index = 0;
                    f.typing = false;
                    f.data = data;
                    d.fire('ClearUndos')
                },
                hasUndo: function () {
                    return index > 0 || (f.typing && data[0] && getContent() != data[0].content)
                },
                hasRedo: function () {
                    return index < data.length - 1 && !this.typing
                },
                transact: function (a) {
                    f.beforeChange();
                    try {
                        locks++;
                        a()
                    } finally {
                        locks--
                    }
                    return f.add()
                },
                extra: function (a, b) {
                    var c, bookmark;
                    if (f.transact(a)) {
                        bookmark = data[index].bookmark;
                        c = data[index - 1];
                        d.setContent(c.content, {
                            format: 'raw'
                        });
                        d.selection.moveToBookmark(c.beforeBookmark);
                        if (f.transact(b)) {
                            data[index - 1].beforeBookmark = bookmark
                        }
                    }
                }
            };
            return f
        }
    });
    define("tinymce/EnterKey", ["tinymce/dom/TreeWalker", "tinymce/dom/RangeUtils", "tinymce/Env"], function (k, l, m) {
        var n = m.ie && m.ie < 11;
        return function (g) {
            var h = g.dom,
                selection = g.selection,
                settings = g.settings;
            var j = g.undoManager,
                schema = g.schema,
                nonEmptyElementsMap = schema.getNonEmptyElements(),
                moveCaretBeforeOnEnterElementsMap = schema.getMoveCaretBeforeOnEnterElements();

            function handleEnterKey(e) {
                var f, tmpRng, editableRoot, container, offset, parentBlock, documentMode, shiftKey, newBlock, fragment, containerBlock, parentBlockName, containerBlockName, newBlockName, isAfterLastNodeInContainer;

                function canSplitBlock(a) {
                    return a && h.isBlock(a) && !/^(TD|TH|CAPTION|FORM)$/.test(a.nodeName) && !/^(fixed|absolute)/i.test(a.style.position) && h.getContentEditable(a) !== "true"
                }
                function isTableCell(a) {
                    return a && /^(TD|TH|CAPTION)$/.test(a.nodeName)
                }
                function renderBlockOnIE(a) {
                    var b;
                    if (h.isBlock(a)) {
                        b = selection.getRng();
                        a.appendChild(h.create('span', null, ' '));
                        selection.select(a);
                        a.lastChild.outerHTML = '';
                        selection.setRng(b)
                    }
                }
                function trimInlineElementsOnLeftSideOfBlock(a) {
                    var b = a,
                        firstChilds = [],
                        i;
                    if (!b) {
                        return
                    }
                    while ((b = b.firstChild)) {
                        if (h.isBlock(b)) {
                            return
                        }
                        if (b.nodeType == 1 && !nonEmptyElementsMap[b.nodeName.toLowerCase()]) {
                            firstChilds.push(b)
                        }
                    }
                    i = firstChilds.length;
                    while (i--) {
                        b = firstChilds[i];
                        if (!b.hasChildNodes() || (b.firstChild == b.lastChild && b.firstChild.nodeValue === '')) {
                            h.remove(b)
                        } else {
                            if (b.nodeName == "A" && (b.innerText || b.textContent) === ' ') {
                                h.remove(b)
                            }
                        }
                    }
                }
                function moveToCaretPosition(b) {
                    var c, node, f, lastNode = b,
                        tempElm;

                    function firstNonWhiteSpaceNodeSibling(a) {
                        while (a) {
                            if (a.nodeType == 1 || (a.nodeType == 3 && a.data && /[\r\n\s]/.test(a.data))) {
                                return a
                            }
                            a = a.nextSibling
                        }
                    }
                    if (!b) {
                        return
                    }
                    if (m.ie && m.ie < 9 && parentBlock && parentBlock.firstChild) {
                        if (parentBlock.firstChild == parentBlock.lastChild && parentBlock.firstChild.tagName == 'BR') {
                            h.remove(parentBlock.firstChild)
                        }
                    }
                    if (/^(LI|DT|DD)$/.test(b.nodeName)) {
                        var d = firstNonWhiteSpaceNodeSibling(b.firstChild);
                        if (d && /^(UL|OL|DL)$/.test(d.nodeName)) {
                            b.insertBefore(h.doc.createTextNode(' '), b.firstChild)
                        }
                    }
                    f = h.createRng();
                    if (!m.ie) {
                        b.normalize()
                    }
                    if (b.hasChildNodes()) {
                        c = new k(b, b);
                        while ((node = c.current())) {
                            if (node.nodeType == 3) {
                                f.setStart(node, 0);
                                f.setEnd(node, 0);
                                break
                            }
                            if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
                                f.setStartBefore(node);
                                f.setEndBefore(node);
                                break
                            }
                            lastNode = node;
                            node = c.next()
                        }
                        if (!node) {
                            f.setStart(lastNode, 0);
                            f.setEnd(lastNode, 0)
                        }
                    } else {
                        if (b.nodeName == 'BR') {
                            if (b.nextSibling && h.isBlock(b.nextSibling)) {
                                if (!documentMode || documentMode < 9) {
                                    tempElm = h.create('br');
                                    b.parentNode.insertBefore(tempElm, b)
                                }
                                f.setStartBefore(b);
                                f.setEndBefore(b)
                            } else {
                                f.setStartAfter(b);
                                f.setEndAfter(b)
                            }
                        } else {
                            f.setStart(b, 0);
                            f.setEnd(b, 0)
                        }
                    }
                    selection.setRng(f);
                    h.remove(tempElm);
                    selection.scrollIntoView(b)
                }
                function setForcedBlockAttrs(a) {
                    var b = settings.forced_root_block;
                    if (b && b.toLowerCase() === a.tagName.toLowerCase()) {
                        h.setAttribs(a, settings.forced_root_block_attrs)
                    }
                }
                function emptyBlock(a) {
                    a.innerHTML = !n ? '<br data-mce-bogus="1">' : ''
                }
                function createNewBlock(a) {
                    var b = container,
                        block, clonedNode, caretNode, textInlineElements = schema.getTextInlineElements();
                    if (a || parentBlockName == "TABLE") {
                        block = h.create(a || newBlockName);
                        setForcedBlockAttrs(block)
                    } else {
                        block = parentBlock.cloneNode(false)
                    }
                    caretNode = block;
                    if (settings.keep_styles !== false) {
                        do {
                            if (textInlineElements[b.nodeName]) {
                                if (b.id == '_mce_caret') {
                                    continue
                                }
                                clonedNode = b.cloneNode(false);
                                h.setAttrib(clonedNode, 'id', '');
                                if (block.hasChildNodes()) {
                                    clonedNode.appendChild(block.firstChild);
                                    block.appendChild(clonedNode)
                                } else {
                                    caretNode = clonedNode;
                                    block.appendChild(clonedNode)
                                }
                            }
                        } while ((b = b.parentNode) && b != editableRoot)
                    }
                    if (!n) {
                        caretNode.innerHTML = '<br data-mce-bogus="1">'
                    }
                    return block
                }
                function isCaretAtStartOrEndOfBlock(a) {
                    var b, node, name;
                    if (container.nodeType == 3 && (a ? offset > 0 : offset < container.nodeValue.length)) {
                        return false
                    }
                    if (container.parentNode == parentBlock && isAfterLastNodeInContainer && !a) {
                        return true
                    }
                    if (a && container.nodeType == 1 && container == parentBlock.firstChild) {
                        return true
                    }
                    if (container.nodeName === "TABLE" || (container.previousSibling && container.previousSibling.nodeName == "TABLE")) {
                        return (isAfterLastNodeInContainer && !a) || (!isAfterLastNodeInContainer && a)
                    }
                    b = new k(container, parentBlock);
                    if (container.nodeType == 3) {
                        if (a && offset === 0) {
                            b.prev()
                        } else if (!a && offset == container.nodeValue.length) {
                            b.next()
                        }
                    }
                    while ((node = b.current())) {
                        if (node.nodeType === 1) {
                            if (!node.getAttribute('data-mce-bogus')) {
                                name = node.nodeName.toLowerCase();
                                if (nonEmptyElementsMap[name] && name !== 'br') {
                                    return false
                                }
                            }
                        } else if (node.nodeType === 3 && !/^[ \t\r\n]*$/.test(node.nodeValue)) {
                            return false
                        }
                        if (a) {
                            b.prev()
                        } else {
                            b.next()
                        }
                    }
                    return true
                }
                function wrapSelfAndSiblingsInDefaultBlock(a, b) {
                    var c, parentBlock, startNode, node, next, rootBlockName, blockName = newBlockName || 'P';
                    parentBlock = h.getParent(a, h.isBlock);
                    if (!parentBlock || !canSplitBlock(parentBlock)) {
                        parentBlock = parentBlock || editableRoot;
                        if (parentBlock == g.getBody() || isTableCell(parentBlock)) {
                            rootBlockName = parentBlock.nodeName.toLowerCase()
                        } else {
                            rootBlockName = parentBlock.parentNode.nodeName.toLowerCase()
                        }
                        if (!parentBlock.hasChildNodes()) {
                            c = h.create(blockName);
                            setForcedBlockAttrs(c);
                            parentBlock.appendChild(c);
                            f.setStart(c, 0);
                            f.setEnd(c, 0);
                            return c
                        }
                        node = a;
                        while (node.parentNode != parentBlock) {
                            node = node.parentNode
                        }
                        while (node && !h.isBlock(node)) {
                            startNode = node;
                            node = node.previousSibling
                        }
                        if (startNode && schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
                            c = h.create(blockName);
                            setForcedBlockAttrs(c);
                            startNode.parentNode.insertBefore(c, startNode);
                            node = startNode;
                            while (node && !h.isBlock(node)) {
                                next = node.nextSibling;
                                c.appendChild(node);
                                node = next
                            }
                            f.setStart(a, b);
                            f.setEnd(a, b)
                        }
                    }
                    return a
                }
                function handleEmptyListItem() {
                    function isFirstOrLastLi(a) {
                        var b = containerBlock[a ? 'firstChild' : 'lastChild'];
                        while (b) {
                            if (b.nodeType == 1) {
                                break
                            }
                            b = b[a ? 'nextSibling' : 'previousSibling']
                        }
                        return b === parentBlock
                    }
                    function getContainerBlock() {
                        var a = containerBlock.parentNode;
                        if (/^(LI|DT|DD)$/.test(a.nodeName)) {
                            return a
                        }
                        return containerBlock
                    }
                    if (containerBlock == g.getBody()) {
                        return
                    }
                    var c = containerBlock.parentNode.nodeName;
                    if (/^(OL|UL|LI)$/.test(c)) {
                        newBlockName = 'LI'
                    }
                    newBlock = newBlockName ? createNewBlock(newBlockName) : h.create('BR');
                    if (isFirstOrLastLi(true) && isFirstOrLastLi()) {
                        if (c == 'LI') {
                            h.insertAfter(newBlock, getContainerBlock())
                        } else {
                            h.replace(newBlock, containerBlock)
                        }
                    } else if (isFirstOrLastLi(true)) {
                        if (c == 'LI') {
                            h.insertAfter(newBlock, getContainerBlock());
                            newBlock.appendChild(h.doc.createTextNode(' '));
                            newBlock.appendChild(containerBlock)
                        } else {
                            containerBlock.parentNode.insertBefore(newBlock, containerBlock)
                        }
                    } else if (isFirstOrLastLi()) {
                        h.insertAfter(newBlock, getContainerBlock());
                        renderBlockOnIE(newBlock)
                    } else {
                        containerBlock = getContainerBlock();
                        tmpRng = f.cloneRange();
                        tmpRng.setStartAfter(parentBlock);
                        tmpRng.setEndAfter(containerBlock);
                        fragment = tmpRng.extractContents();
                        if (newBlockName == 'LI' && fragment.firstChild.nodeName == 'LI') {
                            newBlock = fragment.firstChild;
                            h.insertAfter(fragment, containerBlock)
                        } else {
                            h.insertAfter(fragment, containerBlock);
                            h.insertAfter(newBlock, containerBlock)
                        }
                    }
                    h.remove(parentBlock);
                    moveToCaretPosition(newBlock);
                    j.add()
                }
                function insertBr() {
                    g.execCommand("InsertLineBreak", false, e)
                }
                function trimLeadingLineBreaks(a) {
                    do {
                        if (a.nodeType === 3) {
                            a.nodeValue = a.nodeValue.replace(/^[\r\n]+/, '')
                        }
                        a = a.firstChild
                    } while (a)
                }
                function getEditableRoot(a) {
                    var b = h.getRoot(),
                        parent, editableRoot;
                    parent = a;
                    while (parent !== b && h.getContentEditable(parent) !== "false") {
                        if (h.getContentEditable(parent) === "true") {
                            editableRoot = parent
                        }
                        parent = parent.parentNode
                    }
                    return parent !== b ? editableRoot : b
                }
                function addBrToBlockIfNeeded(a) {
                    var b;
                    if (!n) {
                        a.normalize();
                        b = a.lastChild;
                        if (!b || (/^(left|right)$/gi.test(h.getStyle(b, 'float', true)))) {
                            h.add(a, 'br')
                        }
                    }
                }
                function insertNewBlockAfter() {
                    if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName != 'HGROUP') {
                        newBlock = createNewBlock(newBlockName)
                    } else {
                        newBlock = createNewBlock()
                    }
                    if (settings.end_container_on_empty_block && canSplitBlock(containerBlock) && h.isEmpty(parentBlock)) {
                        newBlock = h.split(containerBlock, parentBlock)
                    } else {
                        h.insertAfter(newBlock, parentBlock)
                    }
                    moveToCaretPosition(newBlock)
                }
                f = selection.getRng(true);
                if (e.isDefaultPrevented()) {
                    return
                }
                if (!f.collapsed) {
                    g.execCommand('Delete');
                    return
                }
                new l(h).normalize(f);
                container = f.startContainer;
                offset = f.startOffset;
                newBlockName = (settings.force_p_newlines ? 'p' : '') || settings.forced_root_block;
                newBlockName = newBlockName ? newBlockName.toUpperCase() : '';
                documentMode = h.doc.documentMode;
                shiftKey = e.shiftKey;
                if (container.nodeType == 1 && container.hasChildNodes()) {
                    isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
                    container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
                    if (isAfterLastNodeInContainer && container.nodeType == 3) {
                        offset = container.nodeValue.length
                    } else {
                        offset = 0
                    }
                }
                editableRoot = getEditableRoot(container);
                if (!editableRoot) {
                    return
                }
                j.beforeChange();
                if (!h.isBlock(editableRoot) && editableRoot != h.getRoot()) {
                    if (!newBlockName || shiftKey) {
                        insertBr()
                    }
                    return
                }
                if ((newBlockName && !shiftKey) || (!newBlockName && shiftKey)) {
                    container = wrapSelfAndSiblingsInDefaultBlock(container, offset)
                }
                parentBlock = h.getParent(container, h.isBlock);
                containerBlock = parentBlock ? h.getParent(parentBlock.parentNode, h.isBlock) : null;
                parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : '';
                containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
                if (containerBlockName == 'LI' && !e.ctrlKey) {
                    parentBlock = containerBlock;
                    parentBlockName = containerBlockName
                }
                if (/^(LI|DT|DD)$/.test(parentBlockName)) {
                    if (!newBlockName && shiftKey) {
                        insertBr();
                        return
                    }
                    if (h.isEmpty(parentBlock)) {
                        handleEmptyListItem();
                        return
                    }
                }
                if (parentBlockName == 'PRE' && settings.br_in_pre !== false) {
                    if (!shiftKey) {
                        insertBr();
                        return
                    }
                } else {
                    if ((!newBlockName && !shiftKey && parentBlockName != 'LI') || (newBlockName && shiftKey)) {
                        insertBr();
                        return
                    }
                }
                if (newBlockName && parentBlock === g.getBody()) {
                    return
                }
                newBlockName = newBlockName || 'P';
                if (isCaretAtStartOrEndOfBlock()) {
                    insertNewBlockAfter()
                } else if (isCaretAtStartOrEndOfBlock(true)) {
                    newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
                    renderBlockOnIE(newBlock);
                    moveToCaretPosition(parentBlock)
                } else {
                    tmpRng = f.cloneRange();
                    tmpRng.setEndAfter(parentBlock);
                    fragment = tmpRng.extractContents();
                    trimLeadingLineBreaks(fragment);
                    newBlock = fragment.firstChild;
                    h.insertAfter(fragment, parentBlock);
                    trimInlineElementsOnLeftSideOfBlock(newBlock);
                    addBrToBlockIfNeeded(parentBlock);
                    if (h.isEmpty(parentBlock)) {
                        emptyBlock(parentBlock)
                    }
                    newBlock.normalize();
                    if (h.isEmpty(newBlock)) {
                        h.remove(newBlock);
                        insertNewBlockAfter()
                    } else {
                        moveToCaretPosition(newBlock)
                    }
                }
                h.setAttrib(newBlock, 'id', '');
                g.fire('NewBlock', {
                    newBlock: newBlock
                });
                j.add()
            }
            g.on('keydown', function (a) {
                if (a.keyCode == 13) {
                    if (handleEnterKey(a) !== false) {
                        a.preventDefault()
                    }
                }
            })
        }
    });
    define("tinymce/ForceBlocks", [], function () {
        return function (e) {
            var f = e.settings,
                dom = e.dom,
                selection = e.selection;
            var g = e.schema,
                blockElements = g.getBlockElements();

            function addRootBlocks() {
                var a = selection.getStart(),
                    rootNode = e.getBody(),
                    rng;
                var b, startOffset, endContainer, endOffset, rootBlockNode;
                var c, offset = -0xFFFFFF,
                    wrapped, restoreSelection;
                var d, rootNodeName, forcedRootBlock;
                forcedRootBlock = f.forced_root_block;
                if (!a || a.nodeType !== 1 || !forcedRootBlock) {
                    return
                }
                while (a && a != rootNode) {
                    if (blockElements[a.nodeName]) {
                        return
                    }
                    a = a.parentNode
                }
                rng = selection.getRng();
                if (rng.setStart) {
                    b = rng.startContainer;
                    startOffset = rng.startOffset;
                    endContainer = rng.endContainer;
                    endOffset = rng.endOffset;
                    try {
                        restoreSelection = e.getDoc().activeElement === rootNode
                    } catch (ex) { }
                } else {
                    if (rng.item) {
                        a = rng.item(0);
                        rng = e.getDoc().body.createTextRange();
                        rng.moveToElementText(a)
                    }
                    restoreSelection = rng.parentElement().ownerDocument === e.getDoc();
                    d = rng.duplicate();
                    d.collapse(true);
                    startOffset = d.move('character', offset) * -1;
                    if (!d.collapsed) {
                        d = rng.duplicate();
                        d.collapse(false);
                        endOffset = (d.move('character', offset) * -1) - startOffset
                    }
                }
                a = rootNode.firstChild;
                rootNodeName = rootNode.nodeName.toLowerCase();
                while (a) {
                    if (((a.nodeType === 3 || (a.nodeType == 1 && !blockElements[a.nodeName]))) && g.isValidChild(rootNodeName, forcedRootBlock.toLowerCase())) {
                        if (a.nodeType === 3 && a.nodeValue.length === 0) {
                            c = a;
                            a = a.nextSibling;
                            dom.remove(c);
                            continue
                        }
                        if (!rootBlockNode) {
                            rootBlockNode = dom.create(forcedRootBlock, e.settings.forced_root_block_attrs);
                            a.parentNode.insertBefore(rootBlockNode, a);
                            wrapped = true
                        }
                        c = a;
                        a = a.nextSibling;
                        rootBlockNode.appendChild(c)
                    } else {
                        rootBlockNode = null;
                        a = a.nextSibling
                    }
                }
                if (wrapped && restoreSelection) {
                    if (rng.setStart) {
                        rng.setStart(b, startOffset);
                        rng.setEnd(endContainer, endOffset);
                        selection.setRng(rng)
                    } else {
                        try {
                            rng = e.getDoc().body.createTextRange();
                            rng.moveToElementText(rootNode);
                            rng.collapse(true);
                            rng.moveStart('character', startOffset);
                            if (endOffset > 0) {
                                rng.moveEnd('character', endOffset)
                            }
                            rng.select()
                        } catch (ex) { }
                    }
                    e.nodeChanged()
                }
            }
            if (f.forced_root_block) {
                e.on('NodeChange', addRootBlocks)
            }
        }
    });
    define("tinymce/caret/CaretUtils", ["tinymce/util/Fun", "tinymce/dom/TreeWalker", "tinymce/dom/NodeType", "tinymce/caret/CaretPosition", "tinymce/caret/CaretContainer", "tinymce/caret/CaretCandidate"], function (g, h, i, j, k, l) {
        var m = i.isContentEditableTrue,
            isContentEditableFalse = i.isContentEditableFalse,
            isBlockLike = i.matchStyleValues('display', 'block table table-cell table-caption'),
            isCaretContainer = k.isCaretContainer,
            curry = g.curry,
            isElement = i.isElement,
            isCaretCandidate = l.isCaretCandidate;

        function isForwards(a) {
            return a > 0
        }
        function isBackwards(a) {
            return a < 0
        }
        function findNode(a, b, c, d, e) {
            var f = new h(a, d);
            if (isBackwards(b)) {
                if (isContentEditableFalse(a)) {
                    a = f.prev(true);
                    if (c(a)) {
                        return a
                    }
                }
                while ((a = f.prev(e))) {
                    if (c(a)) {
                        return a
                    }
                }
            }
            if (isForwards(b)) {
                if (isContentEditableFalse(a)) {
                    a = f.next(true);
                    if (c(a)) {
                        return a
                    }
                }
                while ((a = f.next(e))) {
                    if (c(a)) {
                        return a
                    }
                }
            }
            return null
        }
        function getEditingHost(a, b) {
            for (a = a.parentNode; a && a != b; a = a.parentNode) {
                if (m(a)) {
                    return a
                }
            }
            return b
        }
        function getParentBlock(a, b) {
            while (a && a != b) {
                if (isBlockLike(a)) {
                    return a
                }
                a = a.parentNode
            }
            return null
        }
        function isInSameBlock(a, b, c) {
            return getParentBlock(a.container(), c) == getParentBlock(b.container(), c)
        }
        function isInSameEditingHost(a, b, c) {
            return getEditingHost(a.container(), c) == getEditingHost(b.container(), c)
        }
        function getChildNodeAtRelativeOffset(a, b) {
            var c, offset;
            if (!b) {
                return null
            }
            c = b.container();
            offset = b.offset();
            if (!isElement(c)) {
                return null
            }
            return c.childNodes[offset + a]
        }
        function beforeAfter(a, b) {
            var c = b.ownerDocument.createRange();
            if (a) {
                c.setStartBefore(b);
                c.setEndBefore(b)
            } else {
                c.setStartAfter(b);
                c.setEndAfter(b)
            }
            return c
        }
        function isNodesInSameBlock(a, b, c) {
            return getParentBlock(b, a) == getParentBlock(c, a)
        }
        function lean(a, b, c) {
            var d, siblingName;
            if (a) {
                siblingName = 'previousSibling'
            } else {
                siblingName = 'nextSibling'
            }
            while (c && c != b) {
                d = c[siblingName];
                if (isCaretContainer(d)) {
                    d = d[siblingName]
                }
                if (isContentEditableFalse(d)) {
                    if (isNodesInSameBlock(b, d, c)) {
                        return d
                    }
                    break
                }
                if (isCaretCandidate(d)) {
                    break
                }
                c = c.parentNode
            }
            return null
        }
        var n = curry(beforeAfter, true);
        var o = curry(beforeAfter, false);

        function normalizeRange(a, b, c) {
            var d, container, offset, location;
            var e = curry(lean, true, b);
            var f = curry(lean, false, b);
            container = c.startContainer;
            offset = c.startOffset;
            if (k.isCaretContainerBlock(container)) {
                if (!isElement(container)) {
                    container = container.parentNode
                }
                location = container.getAttribute('data-mce-caret');
                if (location == 'before') {
                    d = container.nextSibling;
                    if (isContentEditableFalse(d)) {
                        return n(d)
                    }
                }
                if (location == 'after') {
                    d = container.previousSibling;
                    if (isContentEditableFalse(d)) {
                        return o(d)
                    }
                }
            }
            if (!c.collapsed) {
                return c
            }
            if (i.isText(container)) {
                if (isCaretContainer(container)) {
                    if (a === 1) {
                        d = f(container);
                        if (d) {
                            return n(d)
                        }
                        d = e(container);
                        if (d) {
                            return o(d)
                        }
                    }
                    if (a === -1) {
                        d = e(container);
                        if (d) {
                            return o(d)
                        }
                        d = f(container);
                        if (d) {
                            return n(d)
                        }
                    }
                    return c
                }
                if (k.endsWithCaretContainer(container) && offset >= container.data.length - 1) {
                    if (a === 1) {
                        d = f(container);
                        if (d) {
                            return n(d)
                        }
                    }
                    return c
                }
                if (k.startsWithCaretContainer(container) && offset <= 1) {
                    if (a === -1) {
                        d = e(container);
                        if (d) {
                            return o(d)
                        }
                    }
                    return c
                }
                if (offset === container.data.length) {
                    d = f(container);
                    if (d) {
                        return n(d)
                    }
                    return c
                }
                if (offset === 0) {
                    d = e(container);
                    if (d) {
                        return o(d)
                    }
                    return c
                }
            }
            return c
        }
        function isNextToContentEditableFalse(a, b) {
            return isContentEditableFalse(getChildNodeAtRelativeOffset(a, b))
        }
        return {
            isForwards: isForwards,
            isBackwards: isBackwards,
            findNode: findNode,
            getEditingHost: getEditingHost,
            getParentBlock: getParentBlock,
            isInSameBlock: isInSameBlock,
            isInSameEditingHost: isInSameEditingHost,
            isBeforeContentEditableFalse: curry(isNextToContentEditableFalse, 0),
            isAfterContentEditableFalse: curry(isNextToContentEditableFalse, -1),
            normalizeRange: normalizeRange
        }
    });
    define("tinymce/caret/CaretWalker", ["tinymce/dom/NodeType", "tinymce/caret/CaretCandidate", "tinymce/caret/CaretPosition", "tinymce/caret/CaretUtils", "tinymce/util/Arr", "tinymce/util/Fun"], function (e, f, g, h, i, j) {
        var k = e.isContentEditableFalse,
            isText = e.isText,
            isElement = e.isElement,
            isBr = e.isBr,
            isForwards = h.isForwards,
            isBackwards = h.isBackwards,
            isCaretCandidate = f.isCaretCandidate,
            isAtomic = f.isAtomic,
            isEditableCaretCandidate = f.isEditableCaretCandidate;

        function getParents(a, b) {
            var c = [];
            while (a && a != b) {
                c.push(a);
                a = a.parentNode
            }
            return c
        }
        function nodeAtIndex(a, b) {
            if (a.hasChildNodes() && b < a.childNodes.length) {
                return a.childNodes[b]
            }
            return null
        }
        function getCaretCandidatePosition(a, b) {
            if (isForwards(a)) {
                if (isCaretCandidate(b.previousSibling) && !isText(b.previousSibling)) {
                    return g.before(b)
                }
                if (isText(b)) {
                    return g(b, 0)
                }
            }
            if (isBackwards(a)) {
                if (isCaretCandidate(b.nextSibling) && !isText(b.nextSibling)) {
                    return g.after(b)
                }
                if (isText(b)) {
                    return g(b, b.data.length)
                }
            }
            if (isBackwards(a)) {
                if (isBr(b)) {
                    return g.before(b)
                }
                return g.after(b)
            }
            return g.before(b)
        }
        function isBrBeforeBlock(a, b) {
            var c;
            if (!e.isBr(a)) {
                return false
            }
            c = findCaretPosition(1, g.after(a), b);
            if (!c) {
                return false
            }
            return !h.isInSameBlock(g.before(a), g.before(c), b)
        }
        function findCaretPosition(a, b, c) {
            var d, offset, node, nextNode, innerNode, rootContentEditableFalseElm, caretPosition;
            if (!isElement(c) || !b) {
                return null
            }
            caretPosition = b;
            d = caretPosition.container();
            offset = caretPosition.offset();
            if (isText(d)) {
                if (isBackwards(a) && offset > 0) {
                    return g(d, --offset)
                }
                if (isForwards(a) && offset < d.length) {
                    return g(d, ++offset)
                }
                node = d
            } else {
                if (isBackwards(a) && offset > 0) {
                    nextNode = nodeAtIndex(d, offset - 1);
                    if (isCaretCandidate(nextNode)) {
                        if (!isAtomic(nextNode)) {
                            innerNode = h.findNode(nextNode, a, isEditableCaretCandidate, nextNode);
                            if (innerNode) {
                                if (isText(innerNode)) {
                                    return g(innerNode, innerNode.data.length)
                                }
                                return g.after(innerNode)
                            }
                        }
                        if (isText(nextNode)) {
                            return g(nextNode, nextNode.data.length)
                        }
                        return g.before(nextNode)
                    }
                }
                if (isForwards(a) && offset < d.childNodes.length) {
                    nextNode = nodeAtIndex(d, offset);
                    if (isCaretCandidate(nextNode)) {
                        if (isBrBeforeBlock(nextNode, c)) {
                            return findCaretPosition(a, g.after(nextNode), c)
                        }
                        if (!isAtomic(nextNode)) {
                            innerNode = h.findNode(nextNode, a, isEditableCaretCandidate, nextNode);
                            if (innerNode) {
                                if (isText(innerNode)) {
                                    return g(innerNode, 0)
                                }
                                return g.before(innerNode)
                            }
                        }
                        if (isText(nextNode)) {
                            return g(nextNode, 0)
                        }
                        return g.after(nextNode)
                    }
                }
                node = caretPosition.getNode()
            }
            if ((isForwards(a) && caretPosition.isAtEnd()) || (isBackwards(a) && caretPosition.isAtStart())) {
                node = h.findNode(node, a, j.constant(true), c, true);
                if (isEditableCaretCandidate(node)) {
                    return getCaretCandidatePosition(a, node)
                }
            }
            nextNode = h.findNode(node, a, isEditableCaretCandidate, c);
            rootContentEditableFalseElm = i.last(i.filter(getParents(d, c), k));
            if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
                if (isForwards(a)) {
                    caretPosition = g.after(rootContentEditableFalseElm)
                } else {
                    caretPosition = g.before(rootContentEditableFalseElm)
                }
                return caretPosition
            }
            if (nextNode) {
                return getCaretCandidatePosition(a, nextNode)
            }
            return null
        }
        return function (b) {
            return {
                next: function (a) {
                    return findCaretPosition(1, a, b)
                },
                prev: function (a) {
                    return findCaretPosition(-1, a, b)
                }
            }
        }
    });
    define("tinymce/InsertList", ["tinymce/util/Tools", "tinymce/caret/CaretWalker", "tinymce/caret/CaretPosition"], function (o, p, q) {
        var r = function (a) {
            var b = a.firstChild;
            var c = a.lastChild;
            if (b && b.name === 'meta') {
                b = b.next
            }
            if (c && c.attr('id') === 'mce_marker') {
                c = c.prev
            }
            if (!b || b !== c) {
                return false
            }
            return b.name === 'ul' || b.name === 'ol'
        };
        var s = function (a) {
            var b = a.firstChild;
            var c = a.lastChild;
            if (b && b.nodeName === 'META') {
                b.parentNode.removeChild(b)
            }
            if (c && c.id === 'mce_marker') {
                c.parentNode.removeChild(c)
            }
            return a
        };
        var t = function (a, b, c) {
            var d = b.serialize(c);
            var e = a.createFragment(d);
            return s(e)
        };
        var u = function (b) {
            return o.grep(b.childNodes, function (a) {
                return a.nodeName === 'LI'
            })
        };
        var v = function (a) {
            return !a.firstChild
        };
        var w = function (a) {
            return a.length > 0 && v(a[a.length - 1]) ? a.slice(0, -1) : a
        };
        var x = function (a, b) {
            var c = a.getParent(b, a.isBlock);
            return c && c.nodeName === 'LI' ? c : null
        };
        var y = function (a, b) {
            return !!x(a, b)
        };
        var z = function (a, b) {
            var c = b.cloneRange();
            var d = b.cloneRange();
            c.setStartBefore(a);
            d.setEndAfter(a);
            return [c.cloneContents(), d.cloneContents()]
        };
        var A = function (a, b) {
            var c = q.before(a);
            var d = new p(b);
            var e = d.next(c);
            return e ? e.toRange() : null
        };
        var B = function (a, b) {
            var c = q.after(a);
            var d = new p(b);
            var e = d.prev(c);
            return e ? e.toRange() : null
        };
        var C = function (b, c, d, e) {
            var f = z(b, e);
            var g = b.parentNode;
            g.insertBefore(f[0], b);
            o.each(c, function (a) {
                g.insertBefore(a, b)
            });
            g.insertBefore(f[1], b);
            g.removeChild(b);
            return B(c[c.length - 1], d)
        };
        var D = function (b, c, d) {
            var e = b.parentNode;
            o.each(c, function (a) {
                e.insertBefore(a, b)
            });
            return A(b, d)
        };
        var E = function (a, b, c, d) {
            d.insertAfter(b.reverse(), a);
            return B(b[0], c)
        };
        var F = function (e, f, g, h) {
            var i = t(f, e, h);
            var j = x(f, g.startContainer);
            var k = w(u(i.firstChild));
            var l = 1,
                END = 2;
            var m = f.getRoot();
            var n = function (a) {
                var b = q.fromRangeStart(g);
                var c = new p(f.getRoot());
                var d = a === l ? c.prev(b) : c.next(b);
                return d ? x(f, d.getNode()) !== j : true
            };
            if (n(l)) {
                return D(j, k, m)
            } else if (n(END)) {
                return E(j, k, m, f)
            }
            return C(j, k, m, g)
        };
        return {
            isListFragment: r,
            insertAtCaret: F,
            isParentBlockLi: y,
            trimListItems: w,
            listItems: u
        }
    });
    define("tinymce/InsertContent", ["tinymce/Env", "tinymce/util/Tools", "tinymce/html/Serializer", "tinymce/caret/CaretWalker", "tinymce/caret/CaretPosition", "tinymce/dom/ElementUtils", "tinymce/dom/NodeType", "tinymce/InsertList"], function (p, q, r, s, t, u, v, w) {
        var x = v.matchNodeNames('td th');
        var y = function (f, g, h) {
            var i, serializer, parentNode, rootNode, fragment, args;
            var j, rng, node, node2, bookmarkHtml, merge;
            var k = f.schema.getTextInlineElements();
            var l = f.selection,
                dom = f.dom;

            function trimOrPaddLeftRight(b) {
                var c, container, offset;
                c = l.getRng(true);
                container = c.startContainer;
                offset = c.startOffset;

                function hasSiblingText(a) {
                    return container[a] && container[a].nodeType == 3
                }
                if (container.nodeType == 3) {
                    if (offset > 0) {
                        b = b.replace(/^&nbsp;/, ' ')
                    } else if (!hasSiblingText('previousSibling')) {
                        b = b.replace(/^ /, '&nbsp;')
                    }
                    if (offset < container.length) {
                        b = b.replace(/&nbsp;(<br>|)$/, ' ')
                    } else if (!hasSiblingText('nextSibling')) {
                        b = b.replace(/(&nbsp;| )(<br>|)$/, '&nbsp;')
                    }
                }
                return b
            }
            function trimNbspAfterDeleteAndPaddValue() {
                var a, container, offset;
                a = l.getRng(true);
                container = a.startContainer;
                offset = a.startOffset;
                if (container.nodeType == 3 && a.collapsed) {
                    if (container.data[offset] === ' ') {
                        container.deleteData(offset, 1);
                        if (!/[ | ]$/.test(g)) {
                            g += ' '
                        }
                    } else if (container.data[offset - 1] === ' ') {
                        container.deleteData(offset - 1, 1);
                        if (!/[ | ]$/.test(g)) {
                            g = ' ' + g
                        }
                    }
                }
            }
            function reduceInlineTextElements() {
                if (merge) {
                    var c = f.getBody(),
                        elementUtils = new u(dom);
                    q.each(dom.select('*[data-mce-fragment]'), function (a) {
                        for (var b = a.parentNode; b && b != c; b = b.parentNode) {
                            if (k[a.nodeName.toLowerCase()] && elementUtils.compare(b, a)) {
                                dom.remove(a, true)
                            }
                        }
                    })
                }
            }
            function markFragmentElements(a) {
                var b = a;
                while ((b = b.walk())) {
                    if (b.type === 1) {
                        b.attr('data-mce-fragment', '1')
                    }
                }
            }
            function umarkFragmentElements(b) {
                q.each(b.getElementsByTagName('*'), function (a) {
                    a.removeAttribute('data-mce-fragment')
                })
            }
            function isPartOfFragment(a) {
                return !!a.getAttribute('data-mce-fragment')
            }
            function canHaveChildren(a) {
                return a && !f.schema.getShortEndedElements()[a.nodeName]
            }
            function moveSelectionToMarker(d) {
                var e, parentBlock, nextRng;

                function getContentEditableFalseParent(a) {
                    var b = f.getBody();
                    for (; a && a !== b; a = a.parentNode) {
                        if (f.dom.getContentEditable(a) === 'false') {
                            return a
                        }
                    }
                    return null
                }
                if (!d) {
                    return
                }
                l.scrollIntoView(d);
                e = getContentEditableFalseParent(d);
                if (e) {
                    dom.remove(d);
                    l.select(e);
                    return
                }
                rng = dom.createRng();
                node = d.previousSibling;
                if (node && node.nodeType == 3) {
                    rng.setStart(node, node.nodeValue.length);
                    if (!p.ie) {
                        node2 = d.nextSibling;
                        if (node2 && node2.nodeType == 3) {
                            node.appendData(node2.data);
                            node2.parentNode.removeChild(node2)
                        }
                    }
                } else {
                    rng.setStartBefore(d);
                    rng.setEndBefore(d)
                }
                function findNextCaretRng(a) {
                    var b = t.fromRangeStart(a);
                    var c = new s(f.getBody());
                    b = c.next(b);
                    if (b) {
                        return b.toRange()
                    }
                }
                parentBlock = dom.getParent(d, dom.isBlock);
                dom.remove(d);
                if (parentBlock && dom.isEmpty(parentBlock)) {
                    f.$(parentBlock).empty();
                    rng.setStart(parentBlock, 0);
                    rng.setEnd(parentBlock, 0);
                    if (!x(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
                        rng = nextRng;
                        dom.remove(parentBlock)
                    } else {
                        dom.add(parentBlock, dom.create('br', {
                            'data-mce-bogus': '1'
                        }))
                    }
                }
                l.setRng(rng)
            }
            if (/^ | $/.test(g)) {
                g = trimOrPaddLeftRight(g)
            }
            i = f.parser;
            merge = h.merge;
            serializer = new r({
                validate: f.settings.validate
            }, f.schema);
            bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;&#x200B;</span>';
            args = {
                content: g,
                format: 'html',
                selection: true
            };
            f.fire('BeforeSetContent', args);
            g = args.content;
            if (g.indexOf('{$caret}') == -1) {
                g += '{$caret}'
            }
            g = g.replace(/\{\$caret\}/, bookmarkHtml);
            rng = l.getRng();
            var m = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
            var n = f.getBody();
            if (m === n && l.isCollapsed()) {
                if (dom.isBlock(n.firstChild) && canHaveChildren(n.firstChild) && dom.isEmpty(n.firstChild)) {
                    rng = dom.createRng();
                    rng.setStart(n.firstChild, 0);
                    rng.setEnd(n.firstChild, 0);
                    l.setRng(rng)
                }
            }
            if (!l.isCollapsed()) {
                f.selection.setRng(f.selection.getRng());
                f.getDoc().execCommand('Delete', false, null);
                trimNbspAfterDeleteAndPaddValue()
            }
            parentNode = l.getNode();
            var o = {
                context: parentNode.nodeName.toLowerCase(),
                data: h.data
            };
            fragment = i.parse(g, o);
            if (h.paste === true && w.isListFragment(fragment) && w.isParentBlockLi(dom, parentNode)) {
                rng = w.insertAtCaret(serializer, dom, f.selection.getRng(true), fragment);
                f.selection.setRng(rng);
                f.fire('SetContent', args);
                return
            }
            markFragmentElements(fragment);
            node = fragment.lastChild;
            if (node.attr('id') == 'mce_marker') {
                j = node;
                for (node = node.prev; node; node = node.walk(true)) {
                    if (node.type == 3 || !dom.isBlock(node.name)) {
                        if (f.schema.isValidChild(node.parent.name, 'span')) {
                            node.parent.insert(j, node, node.name === 'br')
                        }
                        break
                    }
                }
            }
            f._selectionOverrides.showBlockCaretContainer(parentNode);
            if (!o.invalid) {
                g = serializer.serialize(fragment);
                node = parentNode.firstChild;
                node2 = parentNode.lastChild;
                if (!node || (node === node2 && node.nodeName === 'BR')) {
                    dom.setHTML(parentNode, g)
                } else {
                    l.setContent(g)
                }
            } else {
                l.setContent(bookmarkHtml);
                parentNode = l.getNode();
                rootNode = f.getBody();
                if (parentNode.nodeType == 9) {
                    parentNode = node = rootNode
                } else {
                    node = parentNode
                }
                while (node !== rootNode) {
                    parentNode = node;
                    node = node.parentNode
                }
                g = parentNode == rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
                g = serializer.serialize(i.parse(g.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function () {
                    return serializer.serialize(fragment)
                })));
                if (parentNode == rootNode) {
                    dom.setHTML(rootNode, g)
                } else {
                    dom.setOuterHTML(parentNode, g)
                }
            }
            reduceInlineTextElements();
            moveSelectionToMarker(dom.get('mce_marker'));
            umarkFragmentElements(f.getBody());
            f.fire('SetContent', args);
            f.addVisual()
        };
        var z = function (a) {
            var b;
            if (typeof a !== 'string') {
                b = q.extend({
                    paste: a.paste,
                    data: {
                        paste: a.paste
                    }
                }, a);
                return {
                    content: a.content,
                    details: b
                }
            }
            return {
                content: a,
                details: {}
            }
        };
        var A = function (a, b) {
            var c = z(b);
            y(a, c.content, c.details)
        };
        return {
            insertAtCaret: A
        }
    });
    define("tinymce/EditorCommands", ["tinymce/Env", "tinymce/util/Tools", "tinymce/dom/RangeUtils", "tinymce/dom/TreeWalker", "tinymce/InsertContent"], function (t, u, v, w, x) {
        var y = u.each,
            extend = u.extend;
        var z = u.map,
            inArray = u.inArray,
            explode = u.explode;
        var A = t.ie && t.ie < 11;
        var B = true,
            FALSE = false;
        return function (r) {
            var s, selection, formatter, commands = {
                state: {},
                exec: {},
                value: {}
            },
                settings = r.settings,
                bookmark;
            r.on('PreInit', function () {
                s = r.dom;
                selection = r.selection;
                settings = r.settings;
                formatter = r.formatter
            });

            function execCommand(a, b, c, d) {
                var e, customCommand, state = 0;
                if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(a) && (!d || !d.skip_focus)) {
                    r.focus()
                }
                d = r.fire('BeforeExecCommand', {
                    command: a,
                    ui: b,
                    value: c
                });
                if (d.isDefaultPrevented()) {
                    return false
                }
                customCommand = a.toLowerCase();
                if ((e = commands.exec[customCommand])) {
                    e(customCommand, b, c);
                    r.fire('ExecCommand', {
                        command: a,
                        ui: b,
                        value: c
                    });
                    return true
                }
                y(r.plugins, function (p) {
                    if (p.execCommand && p.execCommand(a, b, c)) {
                        r.fire('ExecCommand', {
                            command: a,
                            ui: b,
                            value: c
                        });
                        state = true;
                        return false
                    }
                });
                if (state) {
                    return state
                }
                if (r.theme && r.theme.execCommand && r.theme.execCommand(a, b, c)) {
                    r.fire('ExecCommand', {
                        command: a,
                        ui: b,
                        value: c
                    });
                    return true
                }
                try {
                    state = r.getDoc().execCommand(a, b, c)
                } catch (ex) { }
                if (state) {
                    r.fire('ExecCommand', {
                        command: a,
                        ui: b,
                        value: c
                    });
                    return true
                }
                return false
            }
            function queryCommandState(a) {
                var b;
                if (r.quirks.isHidden()) {
                    return
                }
                a = a.toLowerCase();
                if ((b = commands.state[a])) {
                    return b(a)
                }
                try {
                    return r.getDoc().queryCommandState(a)
                } catch (ex) { }
                return false
            }
            function queryCommandValue(a) {
                var b;
                if (r.quirks.isHidden()) {
                    return
                }
                a = a.toLowerCase();
                if ((b = commands.value[a])) {
                    return b(a)
                }
                try {
                    return r.getDoc().queryCommandValue(a)
                } catch (ex) { }
            }
            function addCommands(d, e) {
                e = e || 'exec';
                y(d, function (b, c) {
                    y(c.toLowerCase().split(','), function (a) {
                        commands[e][a] = b
                    })
                })
            }
            function addCommand(e, f, g) {
                e = e.toLowerCase();
                commands.exec[e] = function (a, b, c, d) {
                    return f.call(g || r, b, c, d)
                }
            }
            function queryCommandSupported(a) {
                a = a.toLowerCase();
                if (commands.exec[a]) {
                    return true
                }
                try {
                    return r.getDoc().queryCommandSupported(a)
                } catch (ex) { }
                return false
            }
            function addQueryStateHandler(a, b, c) {
                a = a.toLowerCase();
                commands.state[a] = function () {
                    return b.call(c || r)
                }
            }
            function addQueryValueHandler(a, b, c) {
                a = a.toLowerCase();
                commands.value[a] = function () {
                    return b.call(c || r)
                }
            }
            function hasCustomCommand(a) {
                a = a.toLowerCase();
                return !!commands.exec[a]
            }
            extend(this, {
                execCommand: execCommand,
                queryCommandState: queryCommandState,
                queryCommandValue: queryCommandValue,
                queryCommandSupported: queryCommandSupported,
                addCommands: addCommands,
                addCommand: addCommand,
                addQueryStateHandler: addQueryStateHandler,
                addQueryValueHandler: addQueryValueHandler,
                hasCustomCommand: hasCustomCommand
            });

            function execNativeCommand(a, b, c) {
                if (b === Y) {
                    b = FALSE
                }
                if (c === Y) {
                    c = null
                }
                return r.getDoc().execCommand(a, b, c)
            }
            function isFormatMatch(a) {
                return formatter.match(a)
            }
            function toggleFormat(a, b) {
                formatter.toggle(a, b ? {
                    value: b
                } : Y);
                r.nodeChanged()
            }
            function storeSelection(a) {
                bookmark = selection.getBookmark(a)
            }
            function restoreSelection() {
                selection.moveToBookmark(bookmark)
            }
            addCommands({
                'mceResetDesignMode,mceBeginUndoLevel': function () { },
                'mceEndUndoLevel,mceAddUndoLevel': function () {
                    r.undoManager.add()
                },
                'Cut,Copy,Paste': function (a) {
                    var b = r.getDoc(),
                        failed;
                    try {
                        execNativeCommand(a)
                    } catch (ex) {
                        failed = B
                    }
                    if (a === 'paste' && !b.queryCommandEnabled(a)) {
                        failed = true
                    }
                    if (failed || !b.queryCommandSupported(a)) {
                        var c = r.translate("Your browser doesn't support direct access to the clipboard. " + "Please use the Ctrl+X/C/V keyboard shortcuts instead.");
                        if (t.mac) {
                            c = c.replace(/Ctrl\+/g, '⌘+')
                        }
                        r.notificationManager.open({
                            text: c,
                            type: 'error'
                        })
                    }
                },
                unlink: function () {
                    if (selection.isCollapsed()) {
                        var a = selection.getNode();
                        if (a.tagName == 'A') {
                            r.dom.remove(a, true)
                        }
                        return
                    }
                    formatter.remove("link")
                },
                'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function (b) {
                    var c = b.substring(7);
                    if (c == 'full') {
                        c = 'justify'
                    }
                    y('left,center,right,justify'.split(','), function (a) {
                        if (c != a) {
                            formatter.remove('align' + a)
                        }
                    });
                    if (c != 'none') {
                        toggleFormat('align' + c)
                    }
                },
                'InsertUnorderedList,InsertOrderedList': function (a) {
                    var b, listParent;
                    execNativeCommand(a);
                    b = s.getParent(selection.getNode(), 'ol,ul');
                    if (b) {
                        listParent = b.parentNode;
                        if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
                            storeSelection();
                            s.split(listParent, b);
                            restoreSelection()
                        }
                    }
                },
                'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (a) {
                    toggleFormat(a)
                },
                'ForeColor,HiliteColor,FontName': function (a, b, c) {
                    toggleFormat(a, c)
                },
                FontSize: function (a, b, c) {
                    var d, fontSizes;
                    if (c >= 1 && c <= 7) {
                        fontSizes = explode(settings.font_size_style_values);
                        d = explode(settings.font_size_classes);
                        if (d) {
                            c = d[c - 1] || c
                        } else {
                            c = fontSizes[c - 1] || c
                        }
                    }
                    toggleFormat(a, c)
                },
                RemoveFormat: function (a) {
                    formatter.remove(a)
                },
                mceBlockQuote: function () {
                    toggleFormat('blockquote')
                },
                FormatBlock: function (a, b, c) {
                    return toggleFormat(c || 'p')
                },
                mceCleanup: function () {
                    var a = selection.getBookmark();
                    r.setContent(r.getContent({
                        cleanup: B
                    }), {
                            cleanup: B
                        });
                    selection.moveToBookmark(a)
                },
                mceRemoveNode: function (a, b, c) {
                    var d = c || selection.getNode();
                    if (d != r.getBody()) {
                        storeSelection();
                        r.dom.remove(d, B);
                        restoreSelection()
                    }
                },
                mceSelectNodeDepth: function (b, c, d) {
                    var e = 0;
                    s.getParent(selection.getNode(), function (a) {
                        if (a.nodeType == 1 && e++ == d) {
                            selection.select(a);
                            return FALSE
                        }
                    }, r.getBody())
                },
                mceSelectNode: function (a, b, c) {
                    selection.select(c)
                },
                mceInsertContent: function (a, b, c) {
                    x.insertAtCaret(r, c)
                },
                mceInsertRawHTML: function (a, b, c) {
                    selection.setContent('tiny_mce_marker');
                    r.setContent(r.getContent().replace(/tiny_mce_marker/g, function () {
                        return c
                    }))
                },
                mceToggleFormat: function (a, b, c) {
                    toggleFormat(c)
                },
                mceSetContent: function (a, b, c) {
                    r.setContent(c)
                },
                'Indent,Outdent': function (c) {
                    var d, indentUnit, value;
                    d = settings.indentation;
                    indentUnit = /[a-z%]+$/i.exec(d);
                    d = parseInt(d, 10);
                    if (!queryCommandState('InsertUnorderedList') && !queryCommandState('InsertOrderedList')) {
                        if (!settings.forced_root_block && !s.getParent(selection.getNode(), s.isBlock)) {
                            formatter.apply('div')
                        }
                        y(selection.getSelectedBlocks(), function (a) {
                            if (s.getContentEditable(a) === "false") {
                                return
                            }
                            if (a.nodeName != "LI") {
                                var b = r.getParam('indent_use_margin', false) ? 'margin' : 'padding';
                                b += s.getStyle(a, 'direction', true) == 'rtl' ? 'Right' : 'Left';
                                if (c == 'outdent') {
                                    value = Math.max(0, parseInt(a.style[b] || 0, 10) - d);
                                    s.setStyle(a, b, value ? value + indentUnit : '')
                                } else {
                                    value = (parseInt(a.style[b] || 0, 10) + d) + indentUnit;
                                    s.setStyle(a, b, value)
                                }
                            }
                        })
                    } else {
                        execNativeCommand(c)
                    }
                },
                mceRepaint: function () { },
                InsertHorizontalRule: function () {
                    r.execCommand('mceInsertContent', false, '<hr />')
                },
                mceToggleVisualAid: function () {
                    r.hasVisual = !r.hasVisual;
                    r.addVisual()
                },
                mceReplaceContent: function (a, b, c) {
                    r.execCommand('mceInsertContent', false, c.replace(/\{\$selection\}/g, selection.getContent({
                        format: 'text'
                    })))
                },
                mceInsertLink: function (a, b, c) {
                    var d;
                    if (typeof c == 'string') {
                        c = {
                            href: c
                        }
                    }
                    d = s.getParent(selection.getNode(), 'a');
                    c.href = c.href.replace(' ', '%20');
                    if (!d || !c.href) {
                        formatter.remove('link')
                    }
                    if (c.href) {
                        formatter.apply('link', c, d)
                    }
                },
                selectAll: function () {
                    var a = s.getRoot(),
                        rng;
                    if (selection.getRng().setStart) {
                        rng = s.createRng();
                        rng.setStart(a, 0);
                        rng.setEnd(a, a.childNodes.length);
                        selection.setRng(rng)
                    } else {
                        rng = selection.getRng();
                        if (!rng.item) {
                            rng.moveToElementText(a);
                            rng.select()
                        }
                    }
                },
                "delete": function () {
                    execNativeCommand("Delete");
                    var a = r.getBody();
                    if (s.isEmpty(a)) {
                        r.setContent('');
                        if (a.firstChild && s.isBlock(a.firstChild)) {
                            r.selection.setCursorLocation(a.firstChild, 0)
                        } else {
                            r.selection.setCursorLocation(a, 0)
                        }
                    }
                },
                mceNewDocument: function () {
                    r.setContent('')
                },
                InsertLineBreak: function (c, d, e) {
                    var f = e;
                    var g, extraBr, marker;
                    var h = selection.getRng(true);
                    new v(s).normalize(h);
                    var i = h.startOffset;
                    var j = h.startContainer;
                    if (j.nodeType == 1 && j.hasChildNodes()) {
                        var k = i > j.childNodes.length - 1;
                        j = j.childNodes[Math.min(i, j.childNodes.length - 1)] || j;
                        if (k && j.nodeType == 3) {
                            i = j.nodeValue.length
                        } else {
                            i = 0
                        }
                    }
                    var l = s.getParent(j, s.isBlock);
                    var m = l ? l.nodeName.toUpperCase() : '';
                    var n = l ? s.getParent(l.parentNode, s.isBlock) : null;
                    var o = n ? n.nodeName.toUpperCase() : '';
                    var p = f && f.ctrlKey;
                    if (o == 'LI' && !p) {
                        l = n;
                        m = o
                    }
                    function hasRightSideContent() {
                        var a = new w(j, l),
                            node;
                        var b = r.schema.getNonEmptyElements();
                        while ((node = a.next())) {
                            if (b[node.nodeName.toLowerCase()] || node.length > 0) {
                                return true
                            }
                        }
                    }
                    if (j && j.nodeType == 3 && i >= j.nodeValue.length) {
                        if (!A && !hasRightSideContent()) {
                            g = s.create('br');
                            h.insertNode(g);
                            h.setStartAfter(g);
                            h.setEndAfter(g);
                            extraBr = true
                        }
                    }
                    g = s.create('br');
                    h.insertNode(g);
                    var q = s.doc.documentMode;
                    if (A && m == 'PRE' && (!q || q < 8)) {
                        g.parentNode.insertBefore(s.doc.createTextNode('\r'), g)
                    }
                    marker = s.create('span', {}, '&nbsp;');
                    g.parentNode.insertBefore(marker, g);
                    selection.scrollIntoView(marker);
                    s.remove(marker);
                    if (!extraBr) {
                        h.setStartAfter(g);
                        h.setEndAfter(g)
                    } else {
                        h.setStartBefore(g);
                        h.setEndBefore(g)
                    }
                    selection.setRng(h);
                    r.undoManager.add();
                    return B
                }
            });
            addCommands({
                'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull': function (b) {
                    var c = 'align' + b.substring(7);
                    var d = selection.isCollapsed() ? [s.getParent(selection.getNode(), s.isBlock)] : selection.getSelectedBlocks();
                    var e = z(d, function (a) {
                        return !!formatter.matchNode(a, c)
                    });
                    return inArray(e, B) !== -1
                },
                'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (a) {
                    return isFormatMatch(a)
                },
                mceBlockQuote: function () {
                    return isFormatMatch('blockquote')
                },
                Outdent: function () {
                    var a;
                    if (settings.inline_styles) {
                        if ((a = s.getParent(selection.getStart(), s.isBlock)) && parseInt(a.style.paddingLeft, 10) > 0) {
                            return B
                        }
                        if ((a = s.getParent(selection.getEnd(), s.isBlock)) && parseInt(a.style.paddingLeft, 10) > 0) {
                            return B
                        }
                    }
                    return (queryCommandState('InsertUnorderedList') || queryCommandState('InsertOrderedList') || (!settings.inline_styles && !!s.getParent(selection.getNode(), 'BLOCKQUOTE')))
                },
                'InsertUnorderedList,InsertOrderedList': function (a) {
                    var b = s.getParent(selection.getNode(), 'ul,ol');
                    return b && (a === 'insertunorderedlist' && b.tagName === 'UL' || a === 'insertorderedlist' && b.tagName === 'OL')
                }
            }, 'state');
            addCommands({
                'FontSize,FontName': function (a) {
                    var b = 0,
                        parent;
                    if ((parent = s.getParent(selection.getNode(), 'span'))) {
                        if (a == 'fontsize') {
                            b = parent.style.fontSize
                        } else {
                            b = parent.style.fontFamily.replace(/, /g, ',').replace(/[\'\"]/g, '').toLowerCase()
                        }
                    }
                    return b
                }
            }, 'value');
            addCommands({
                Undo: function () {
                    r.undoManager.undo()
                },
                Redo: function () {
                    r.undoManager.redo()
                }
            })
        }
    });
    define("tinymce/util/URI", ["tinymce/util/Tools"], function (f) {
        var g = f.each,
            trim = f.trim;
        var h = "source protocol authority userInfo user password host port relative path directory file query anchor".split(' ');
        var j = {
            'ftp': 21,
            'http': 80,
            'https': 443,
            'mailto': 25
        };

        function URI(b, c) {
            var d = this,
                baseUri, base_url;
            b = trim(b);
            c = d.settings = c || {};
            baseUri = c.base_uri;
            if (/^([\w\-]+):([^\/]{2})/i.test(b) || /^\s*#/.test(b)) {
                d.source = b;
                return
            }
            var e = b.indexOf('//') === 0;
            if (b.indexOf('/') === 0 && !e) {
                b = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + b
            }
            if (!/^[\w\-]*:?\/\//.test(b)) {
                base_url = c.base_uri ? c.base_uri.path : new URI(location.href).directory;
                if (c.base_uri.protocol === "") {
                    b = '//mce_host' + d.toAbsPath(base_url, b)
                } else {
                    b = /([^#?]*)([#?]?.*)/.exec(b);
                    b = ((baseUri && baseUri.protocol) || 'http') + '://mce_host' + d.toAbsPath(base_url, b[1]) + b[2]
                }
            }
            b = b.replace(/@@/g, '(mce_at)');
            b = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(b);
            g(h, function (v, i) {
                var a = b[i];
                if (a) {
                    a = a.replace(/\(mce_at\)/g, '@@')
                }
                d[v] = a
            });
            if (baseUri) {
                if (!d.protocol) {
                    d.protocol = baseUri.protocol
                }
                if (!d.userInfo) {
                    d.userInfo = baseUri.userInfo
                }
                if (!d.port && d.host === 'mce_host') {
                    d.port = baseUri.port
                }
                if (!d.host || d.host === 'mce_host') {
                    d.host = baseUri.host
                }
                d.source = ''
            }
            if (e) {
                d.protocol = ''
            }
        }
        URI.prototype = {
            setPath: function (a) {
                var b = this;
                a = /^(.*?)\/?(\w+)?$/.exec(a);
                b.path = a[0];
                b.directory = a[1];
                b.file = a[2];
                b.source = '';
                b.getURI()
            },
            toRelative: function (a) {
                var b = this,
                    output;
                if (a === "./") {
                    return a
                }
                a = new URI(a, {
                    base_uri: b
                });
                if ((a.host != 'mce_host' && b.host != a.host && a.host) || b.port != a.port || (b.protocol != a.protocol && a.protocol !== "")) {
                    return a.getURI()
                }
                var c = b.getURI(),
                    uu = a.getURI();
                if (c == uu || (c.charAt(c.length - 1) == "/" && c.substr(0, c.length - 1) == uu)) {
                    return c
                }
                output = b.toRelPath(b.path, a.path);
                if (a.query) {
                    output += '?' + a.query
                }
                if (a.anchor) {
                    output += '#' + a.anchor
                }
                return output
            },
            toAbsolute: function (a, b) {
                a = new URI(a, {
                    base_uri: this
                });
                return a.getURI(b && this.isSameOrigin(a))
            },
            isSameOrigin: function (a) {
                if (this.host == a.host && this.protocol == a.protocol) {
                    if (this.port == a.port) {
                        return true
                    }
                    var b = j[this.protocol];
                    if (b && ((this.port || b) == (a.port || b))) {
                        return true
                    }
                }
                return false
            },
            toRelPath: function (a, b) {
                var c, breakPoint = 0,
                    out = '',
                    i, l;
                a = a.substring(0, a.lastIndexOf('/'));
                a = a.split('/');
                c = b.split('/');
                if (a.length >= c.length) {
                    for (i = 0, l = a.length; i < l; i++) {
                        if (i >= c.length || a[i] != c[i]) {
                            breakPoint = i + 1;
                            break
                        }
                    }
                }
                if (a.length < c.length) {
                    for (i = 0, l = c.length; i < l; i++) {
                        if (i >= a.length || a[i] != c[i]) {
                            breakPoint = i + 1;
                            break
                        }
                    }
                }
                if (breakPoint === 1) {
                    return b
                }
                for (i = 0, l = a.length - (breakPoint - 1); i < l; i++) {
                    out += "../"
                }
                for (i = breakPoint - 1, l = c.length; i < l; i++) {
                    if (i != breakPoint - 1) {
                        out += "/" + c[i]
                    } else {
                        out += c[i]
                    }
                }
                return out
            },
            toAbsPath: function (a, b) {
                var i, nb = 0,
                    o = [],
                    tr, outPath;
                tr = /\/$/.test(b) ? '/' : '';
                a = a.split('/');
                b = b.split('/');
                g(a, function (k) {
                    if (k) {
                        o.push(k)
                    }
                });
                a = o;
                for (i = b.length - 1, o = []; i >= 0; i--) {
                    if (b[i].length === 0 || b[i] === ".") {
                        continue
                    }
                    if (b[i] === '..') {
                        nb++;
                        continue
                    }
                    if (nb > 0) {
                        nb--;
                        continue
                    }
                    o.push(b[i])
                }
                i = a.length - nb;
                if (i <= 0) {
                    outPath = o.reverse().join('/')
                } else {
                    outPath = a.slice(0, i).join('/') + '/' + o.reverse().join('/')
                }
                if (outPath.indexOf('/') !== 0) {
                    outPath = '/' + outPath
                }
                if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
                    outPath += tr
                }
                return outPath
            },
            getURI: function (a) {
                var s, self = this;
                if (!self.source || a) {
                    s = '';
                    if (!a) {
                        if (self.protocol) {
                            s += self.protocol + '://'
                        } else {
                            s += '//'
                        }
                        if (self.userInfo) {
                            s += self.userInfo + '@'
                        }
                        if (self.host) {
                            s += self.host
                        }
                        if (self.port) {
                            s += ':' + self.port
                        }
                    }
                    if (self.path) {
                        s += self.path
                    }
                    if (self.query) {
                        s += '?' + self.query
                    }
                    if (self.anchor) {
                        s += '#' + self.anchor
                    }
                    self.source = s
                }
                return self.source
            }
        };
        URI.parseDataUri = function (a) {
            var b, matches;
            a = decodeURIComponent(a).split(',');
            matches = /data:([^;]+)/.exec(a[0]);
            if (matches) {
                b = matches[1]
            }
            return {
                type: b,
                data: a[1]
            }
        };
        URI.getDocumentBaseUrl = function (a) {
            var b;
            if (a.protocol.indexOf('http') !== 0 && a.protocol !== 'file:') {
                b = a.href
            } else {
                b = a.protocol + '//' + a.host + a.pathname
            }
            if (/^[^:]+:\/\/\/?[^\/]+\//.test(b)) {
                b = b.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
                if (!/[\/\\]$/.test(b)) {
                    b += '/'
                }
            }
            return b
        };
        return URI
    });
    define("tinymce/util/Class", ["tinymce/util/Tools"], function (g) {
        var h = g.each,
            extend = g.extend;
        var j, initializing;

        function Class() { }
        Class.extend = j = function (e) {
            var f = this,
                _super = f.prototype,
                prototype, name, member;

            function Class() {
                var i, mixins, mixin, f = this;
                if (!initializing) {
                    if (f.init) {
                        f.init.apply(f, arguments)
                    }
                    mixins = f.Mixins;
                    if (mixins) {
                        i = mixins.length;
                        while (i--) {
                            mixin = mixins[i];
                            if (mixin.init) {
                                mixin.init.apply(f, arguments)
                            }
                        }
                    }
                }
            }
            function dummy() {
                return this
            }
            function createMethod(b, c) {
                return function () {
                    var a = this,
                        tmp = a._super,
                        ret;
                    a._super = _super[b];
                    ret = c.apply(a, arguments);
                    a._super = tmp;
                    return ret
                }
            }
            initializing = true;
            prototype = new f();
            initializing = false;
            if (e.Mixins) {
                h(e.Mixins, function (a) {
                    for (var b in a) {
                        if (b !== "init") {
                            e[b] = a[b]
                        }
                    }
                });
                if (_super.Mixins) {
                    e.Mixins = _super.Mixins.concat(e.Mixins)
                }
            }
            if (e.Methods) {
                h(e.Methods.split(','), function (a) {
                    e[a] = dummy
                })
            }
            if (e.Properties) {
                h(e.Properties.split(','), function (c) {
                    var d = '_' + c;
                    e[c] = function (a) {
                        var b = this,
                            undef;
                        if (a !== undef) {
                            b[d] = a;
                            return b
                        }
                        return b[d]
                    }
                })
            }
            if (e.Statics) {
                h(e.Statics, function (a, b) {
                    Class[b] = a
                })
            }
            if (e.Defaults && _super.Defaults) {
                e.Defaults = extend({}, _super.Defaults, e.Defaults)
            }
            for (name in e) {
                member = e[name];
                if (typeof member == "function" && _super[name]) {
                    prototype[name] = createMethod(name, member)
                } else {
                    prototype[name] = member
                }
            }
            Class.prototype = prototype;
            Class.constructor = Class;
            Class.extend = j;
            return Class
        };
        return Class
    });
    define("tinymce/util/EventDispatcher", ["tinymce/util/Tools"], function (h) {
        var j = h.makeMap("focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange " + "mouseout mouseenter mouseleave wheel keydown keypress keyup input contextmenu dragstart dragend dragover " + "draggesture dragdrop drop drag submit " + "compositionstart compositionend compositionupdate touchstart touchmove touchend", ' ');

        function Dispatcher(f) {
            var g = this,
                scope, bindings = {},
                toggleEvent;

            function returnFalse() {
                return false
            }
            function returnTrue() {
                return true
            }
            f = f || {};
            scope = f.scope || g;
            toggleEvent = f.toggleEvent || returnFalse;

            function fire(a, b) {
                var c, i, l, callback;
                a = a.toLowerCase();
                b = b || {};
                b.type = a;
                if (!b.target) {
                    b.target = scope
                }
                if (!b.preventDefault) {
                    b.preventDefault = function () {
                        b.isDefaultPrevented = returnTrue
                    };
                    b.stopPropagation = function () {
                        b.isPropagationStopped = returnTrue
                    };
                    b.stopImmediatePropagation = function () {
                        b.isImmediatePropagationStopped = returnTrue
                    };
                    b.isDefaultPrevented = returnFalse;
                    b.isPropagationStopped = returnFalse;
                    b.isImmediatePropagationStopped = returnFalse
                }
                if (f.beforeFire) {
                    f.beforeFire(b)
                }
                c = bindings[a];
                if (c) {
                    for (i = 0, l = c.length; i < l; i++) {
                        callback = c[i];
                        if (callback.once) {
                            off(a, callback.func)
                        }
                        if (b.isImmediatePropagationStopped()) {
                            b.stopPropagation();
                            return b
                        }
                        if (callback.func.call(scope, b) === false) {
                            b.preventDefault();
                            return b
                        }
                    }
                }
                return b
            }
            function on(a, b, c, d) {
                var e, names, i;
                if (b === false) {
                    b = returnFalse
                }
                if (b) {
                    b = {
                        func: b
                    };
                    if (d) {
                        h.extend(b, d)
                    }
                    names = a.toLowerCase().split(' ');
                    i = names.length;
                    while (i--) {
                        a = names[i];
                        e = bindings[a];
                        if (!e) {
                            e = bindings[a] = [];
                            toggleEvent(a, true)
                        }
                        if (c) {
                            e.unshift(b)
                        } else {
                            e.push(b)
                        }
                    }
                }
                return g
            }
            function off(a, b) {
                var i, handlers, bindingName, names, hi;
                if (a) {
                    names = a.toLowerCase().split(' ');
                    i = names.length;
                    while (i--) {
                        a = names[i];
                        handlers = bindings[a];
                        if (!a) {
                            for (bindingName in bindings) {
                                toggleEvent(bindingName, false);
                                delete bindings[bindingName]
                            }
                            return g
                        }
                        if (handlers) {
                            if (!b) {
                                handlers.length = 0
                            } else {
                                hi = handlers.length;
                                while (hi--) {
                                    if (handlers[hi].func === b) {
                                        handlers = handlers.slice(0, hi).concat(handlers.slice(hi + 1));
                                        bindings[a] = handlers
                                    }
                                }
                            }
                            if (!handlers.length) {
                                toggleEvent(a, false);
                                delete bindings[a]
                            }
                        }
                    }
                } else {
                    for (a in bindings) {
                        toggleEvent(a, false)
                    }
                    bindings = {}
                }
                return g
            }
            function once(a, b, c) {
                return on(a, b, c, {
                    once: true
                })
            }
            function has(a) {
                a = a.toLowerCase();
                return !(!bindings[a] || bindings[a].length === 0)
            }
            g.fire = fire;
            g.on = on;
            g.off = off;
            g.once = once;
            g.has = has
        }
        Dispatcher.isNative = function (a) {
            return !!j[a.toLowerCase()]
        };
        return Dispatcher
    });
    define("tinymce/data/Binding", [], function () {
        function Binding(a) {
            this.create = a.create
        }
        Binding.create = function (d, f) {
            return new Binding({
                create: function (a, b) {
                    var c;

                    function fromSelfToOther(e) {
                        a.set(b, e.value)
                    }
                    function fromOtherToSelf(e) {
                        d.set(f, e.value)
                    }
                    a.on('change:' + b, fromOtherToSelf);
                    d.on('change:' + f, fromSelfToOther);
                    c = a._bindings;
                    if (!c) {
                        c = a._bindings = [];
                        a.on('destroy', function () {
                            var i = c.length;
                            while (i--) {
                                c[i]()
                            }
                        })
                    }
                    c.push(function () {
                        d.off('change:' + f, fromSelfToOther)
                    });
                    return d.get(f)
                }
            })
        };
        return Binding
    });
    define("tinymce/util/Observable", ["tinymce/util/EventDispatcher"], function (f) {
        function getEventDispatcher(c) {
            if (!c._eventDispatcher) {
                c._eventDispatcher = new f({
                    scope: c,
                    toggleEvent: function (a, b) {
                        if (f.isNative(a) && c.toggleNativeEvent) {
                            c.toggleNativeEvent(a, b)
                        }
                    }
                })
            }
            return c._eventDispatcher
        }
        return {
            fire: function (a, b, c) {
                var d = this;
                if (d.removed && a !== "remove") {
                    return b
                }
                b = getEventDispatcher(d).fire(a, b, c);
                if (c !== false && d.parent) {
                    var e = d.parent();
                    while (e && !b.isPropagationStopped()) {
                        e.fire(a, b, false);
                        e = e.parent()
                    }
                }
                return b
            },
            on: function (a, b, c) {
                return getEventDispatcher(this).on(a, b, c)
            },
            off: function (a, b) {
                return getEventDispatcher(this).off(a, b)
            },
            once: function (a, b) {
                return getEventDispatcher(this).once(a, b)
            },
            hasEventListeners: function (a) {
                return getEventDispatcher(this).has(a)
            }
        }
    });
    define("tinymce/data/ObservableObject", ["tinymce/data/Binding", "tinymce/util/Observable", "tinymce/util/Class", "tinymce/util/Tools"], function (d, e, f, g) {
        function isNode(a) {
            return a.nodeType > 0
        }
        function isEqual(a, b) {
            var k, checked;
            if (a === b) {
                return true
            }
            if (a === null || b === null) {
                return a === b
            }
            if (typeof a !== "object" || typeof b !== "object") {
                return a === b
            }
            if (g.isArray(b)) {
                if (a.length !== b.length) {
                    return false
                }
                k = a.length;
                while (k--) {
                    if (!isEqual(a[k], b[k])) {
                        return false
                    }
                }
            }
            if (isNode(a) || isNode(b)) {
                return a === b
            }
            checked = {};
            for (k in b) {
                if (!isEqual(a[k], b[k])) {
                    return false
                }
                checked[k] = true
            }
            for (k in a) {
                if (!checked[k] && !isEqual(a[k], b[k])) {
                    return false
                }
            }
            return true
        }
        return f.extend({
            Mixins: [e],
            init: function (a) {
                var b, value;
                a = a || {};
                for (b in a) {
                    value = a[b];
                    if (value instanceof d) {
                        a[b] = value.create(this, b)
                    }
                }
                this.data = a
            },
            set: function (a, b) {
                var c, args, oldValue = this.data[a];
                if (b instanceof d) {
                    b = b.create(this, a)
                }
                if (typeof a === "object") {
                    for (c in a) {
                        this.set(c, a[c])
                    }
                    return this
                }
                if (!isEqual(oldValue, b)) {
                    this.data[a] = b;
                    args = {
                        target: this,
                        name: a,
                        value: b,
                        oldValue: oldValue
                    };
                    this.fire('change:' + a, args);
                    this.fire('change', args)
                }
                return this
            },
            get: function (a) {
                return this.data[a]
            },
            has: function (a) {
                return a in this.data
            },
            bind: function (a) {
                return d.create(this, a)
            },
            destroy: function () {
                this.fire('destroy')
            }
        })
    });
    define("tinymce/ui/Selector", ["tinymce/util/Class"], function (h) {
        "use strict";

        function unique(a) {
            var b = [],
                i = a.length,
                item;
            while (i--) {
                item = a[i];
                if (!item.__checked) {
                    b.push(item);
                    item.__checked = 1
                }
            }
            i = b.length;
            while (i--) {
                delete b[i].__checked
            }
            return b
        }
        var j = /^([\w\\*]+)?(?:#([\w\-\\]+))?(?:\.([\w\\\.]+))?(?:\[\@?([\w\\]+)([\^\$\*!~]?=)([\w\\]+)\])?(?:\:(.+))?/i;
        var k = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
            whiteSpace = /^\s*|\s*$/g,
            Collection;
        var m = h.extend({
            init: function (f) {
                var g = this.match;

                function compileNameFilter(b) {
                    if (b) {
                        b = b.toLowerCase();
                        return function (a) {
                            return b === '*' || a.type === b
                        }
                    }
                }
                function compileIdFilter(b) {
                    if (b) {
                        return function (a) {
                            return a._name === b
                        }
                    }
                }
                function compileClassesFilter(b) {
                    if (b) {
                        b = b.split('.');
                        return function (a) {
                            var i = b.length;
                            while (i--) {
                                if (!a.classes.contains(b[i])) {
                                    return false
                                }
                            }
                            return true
                        }
                    }
                }
                function compileAttrFilter(c, d, e) {
                    if (c) {
                        return function (a) {
                            var b = a[c] ? a[c]() : '';
                            return !d ? !!e : d === "=" ? b === e : d === "*=" ? b.indexOf(e) >= 0 : d === "~=" ? (" " + b + " ").indexOf(" " + e + " ") >= 0 : d === "!=" ? b != e : d === "^=" ? b.indexOf(e) === 0 : d === "$=" ? b.substr(b.length - e.length) === e : false
                        }
                    }
                }
                function compilePsuedoFilter(d) {
                    var e;
                    if (d) {
                        d = /(?:not\((.+)\))|(.+)/i.exec(d);
                        if (!d[1]) {
                            d = d[2];
                            return function (a, b, c) {
                                return d === 'first' ? b === 0 : d === 'last' ? b === c - 1 : d === 'even' ? b % 2 === 0 : d === 'odd' ? b % 2 === 1 : a[d] ? a[d]() : false
                            }
                        }
                        e = parseChunks(d[1], []);
                        return function (a) {
                            return !g(a, e)
                        }
                    }
                }
                function compile(b, c, d) {
                    var e;

                    function add(a) {
                        if (a) {
                            c.push(a)
                        }
                    }
                    e = j.exec(b.replace(whiteSpace, ''));
                    add(compileNameFilter(e[1]));
                    add(compileIdFilter(e[2]));
                    add(compileClassesFilter(e[3]));
                    add(compileAttrFilter(e[4], e[5], e[6]));
                    add(compilePsuedoFilter(e[7]));
                    c.pseudo = !!e[7];
                    c.direct = d;
                    return c
                }
                function parseChunks(a, b) {
                    var c = [],
                        extra, matches, i;
                    do {
                        k.exec("");
                        matches = k.exec(a);
                        if (matches) {
                            a = matches[3];
                            c.push(matches[1]);
                            if (matches[2]) {
                                extra = matches[3];
                                break
                            }
                        }
                    } while (matches);
                    if (extra) {
                        parseChunks(extra, b)
                    }
                    a = [];
                    for (i = 0; i < c.length; i++) {
                        if (c[i] != '>') {
                            a.push(compile(c[i], [], c[i - 1] === '>'))
                        }
                    }
                    b.push(a);
                    return b
                }
                this._selectors = parseChunks(f, [])
            },
            match: function (a, b) {
                var i, l, si, sl, selector, fi, fl, filters, index, length, siblings, count, item;
                b = b || this._selectors;
                for (i = 0, l = b.length; i < l; i++) {
                    selector = b[i];
                    sl = selector.length;
                    item = a;
                    count = 0;
                    for (si = sl - 1; si >= 0; si--) {
                        filters = selector[si];
                        while (item) {
                            if (filters.pseudo) {
                                siblings = item.parent().items();
                                index = length = siblings.length;
                                while (index--) {
                                    if (siblings[index] === item) {
                                        break
                                    }
                                }
                            }
                            for (fi = 0, fl = filters.length; fi < fl; fi++) {
                                if (!filters[fi](item, index, length)) {
                                    fi = fl + 1;
                                    break
                                }
                            }
                            if (fi === fl) {
                                count++;
                                break
                            } else {
                                if (si === sl - 1) {
                                    break
                                }
                            }
                            item = item.parent()
                        }
                    }
                    if (count === sl) {
                        return true
                    }
                }
                return false
            },
            find: function (d) {
                var e = [],
                    i, l, selectors = this._selectors;

                function collect(a, b, c) {
                    var i, l, fi, fl, item, filters = b[c];
                    for (i = 0, l = a.length; i < l; i++) {
                        item = a[i];
                        for (fi = 0, fl = filters.length; fi < fl; fi++) {
                            if (!filters[fi](item, i, l)) {
                                fi = fl + 1;
                                break
                            }
                        }
                        if (fi === fl) {
                            if (c == b.length - 1) {
                                e.push(item)
                            } else {
                                if (item.items) {
                                    collect(item.items(), b, c + 1)
                                }
                            }
                        } else if (filters.direct) {
                            return
                        }
                        if (item.items) {
                            collect(item.items(), b, c)
                        }
                    }
                }
                if (d.items) {
                    for (i = 0, l = selectors.length; i < l; i++) {
                        collect(d.items(), selectors[i], 0)
                    }
                    if (l > 1) {
                        e = unique(e)
                    }
                }
                if (!Collection) {
                    Collection = m.Collection
                }
                return new Collection(e)
            }
        });
        return m
    });
    define("tinymce/ui/Collection", ["tinymce/util/Tools", "tinymce/ui/Selector", "tinymce/util/Class"], function (e, f, g) {
        "use strict";
        var h, proto, push = Array.prototype.push,
            slice = Array.prototype.slice;
        proto = {
            length: 0,
            init: function (a) {
                if (a) {
                    this.add(a)
                }
            },
            add: function (a) {
                var b = this;
                if (!e.isArray(a)) {
                    if (a instanceof h) {
                        b.add(a.toArray())
                    } else {
                        push.call(b, a)
                    }
                } else {
                    push.apply(b, a)
                }
                return b
            },
            set: function (a) {
                var b = this,
                    len = b.length,
                    i;
                b.length = 0;
                b.add(a);
                for (i = b.length; i < len; i++) {
                    delete b[i]
                }
                return b
            },
            filter: function (b) {
                var c = this,
                    i, l, matches = [],
                    item, match;
                if (typeof b === "string") {
                    b = new f(b);
                    match = function (a) {
                        return b.match(a)
                    }
                } else {
                    match = b
                }
                for (i = 0, l = c.length; i < l; i++) {
                    item = c[i];
                    if (match(item)) {
                        matches.push(item)
                    }
                }
                return new h(matches)
            },
            slice: function () {
                return new h(slice.apply(this, arguments))
            },
            eq: function (a) {
                return a === -1 ? this.slice(a) : this.slice(a, +a + 1)
            },
            each: function (a) {
                e.each(this, a);
                return this
            },
            toArray: function () {
                return e.toArray(this)
            },
            indexOf: function (a) {
                var b = this,
                    i = b.length;
                while (i--) {
                    if (b[i] === a) {
                        break
                    }
                }
                return i
            },
            reverse: function () {
                return new h(e.toArray(this).reverse())
            },
            hasClass: function (a) {
                return this[0] ? this[0].classes.contains(a) : false
            },
            prop: function (b, c) {
                var d = this,
                    undef, item;
                if (c !== undef) {
                    d.each(function (a) {
                        if (a[b]) {
                            a[b](c)
                        }
                    });
                    return d
                }
                item = d[0];
                if (item && item[b]) {
                    return item[b]()
                }
            },
            exec: function (b) {
                var c = this,
                    args = e.toArray(arguments).slice(1);
                c.each(function (a) {
                    if (a[b]) {
                        a[b].apply(a, args)
                    }
                });
                return c
            },
            remove: function () {
                var i = this.length;
                while (i--) {
                    this[i].remove()
                }
                return this
            },
            addClass: function (b) {
                return this.each(function (a) {
                    a.classes.add(b)
                })
            },
            removeClass: function (b) {
                return this.each(function (a) {
                    a.classes.remove(b)
                })
            }
        };
        e.each('fire on off show hide append prepend before after reflow'.split(' '), function (c) {
            proto[c] = function () {
                var b = e.toArray(arguments);
                this.each(function (a) {
                    if (c in a) {
                        a[c].apply(a, b)
                    }
                });
                return this
            }
        });
        e.each('text name disabled active selected checked visible parent value data'.split(' '), function (b) {
            proto[b] = function (a) {
                return this.prop(b, a)
            }
        });
        h = g.extend(proto);
        f.Collection = h;
        return h
    });
    define("tinymce/ui/DomUtils", ["tinymce/Env", "tinymce/util/Tools", "tinymce/dom/DOMUtils"], function (f, g, h) {
        "use strict";
        var i = 0;
        var j = {
            id: function () {
                return 'mceu_' + (i++)
            },
            create: function (b, c, d) {
                var e = document.createElement(b);
                h.DOM.setAttribs(e, c);
                if (typeof d === 'string') {
                    e.innerHTML = d
                } else {
                    g.each(d, function (a) {
                        if (a.nodeType) {
                            e.appendChild(a)
                        }
                    })
                }
                return e
            },
            createFragment: function (a) {
                return h.DOM.createFragment(a)
            },
            getWindowSize: function () {
                return h.DOM.getViewPort()
            },
            getSize: function (a) {
                var b, height;
                if (a.getBoundingClientRect) {
                    var c = a.getBoundingClientRect();
                    b = Math.max(c.width || (c.right - c.left), a.offsetWidth);
                    height = Math.max(c.height || (c.bottom - c.bottom), a.offsetHeight)
                } else {
                    b = a.offsetWidth;
                    height = a.offsetHeight
                }
                return {
                    width: b,
                    height: height
                }
            },
            getPos: function (a, b) {
                return h.DOM.getPos(a, b || j.getContainer())
            },
            getContainer: function () {
                return f.container ? f.container : document.body
            },
            getViewPort: function (a) {
                return h.DOM.getViewPort(a)
            },
            get: function (a) {
                return document.getElementById(a)
            },
            addClass: function (a, b) {
                return h.DOM.addClass(a, b)
            },
            removeClass: function (a, b) {
                return h.DOM.removeClass(a, b)
            },
            hasClass: function (a, b) {
                return h.DOM.hasClass(a, b)
            },
            toggleClass: function (a, b, c) {
                return h.DOM.toggleClass(a, b, c)
            },
            css: function (a, b, c) {
                return h.DOM.setStyle(a, b, c)
            },
            getRuntimeStyle: function (a, b) {
                return h.DOM.getStyle(a, b, true)
            },
            on: function (a, b, c, d) {
                return h.DOM.bind(a, b, c, d)
            },
            off: function (a, b, c) {
                return h.DOM.unbind(a, b, c)
            },
            fire: function (a, b, c) {
                return h.DOM.fire(a, b, c)
            },
            innerHtml: function (a, b) {
                h.DOM.setHTML(a, b)
            }
        };
        return j
    });
    define("tinymce/ui/BoxUtils", [], function () {
        "use strict";
        return {
            parseBox: function (a) {
                var b, radix = 10;
                if (!a) {
                    return
                }
                if (typeof a === "number") {
                    a = a || 0;
                    return {
                        top: a,
                        left: a,
                        bottom: a,
                        right: a
                    }
                }
                a = a.split(' ');
                b = a.length;
                if (b === 1) {
                    a[1] = a[2] = a[3] = a[0]
                } else if (b === 2) {
                    a[2] = a[0];
                    a[3] = a[1]
                } else if (b === 3) {
                    a[3] = a[1]
                }
                return {
                    top: parseInt(a[0], radix) || 0,
                    right: parseInt(a[1], radix) || 0,
                    bottom: parseInt(a[2], radix) || 0,
                    left: parseInt(a[3], radix) || 0
                }
            },
            measureBox: function (d, e) {
                function getStyle(b) {
                    var c = document.defaultView;
                    if (c) {
                        b = b.replace(/[A-Z]/g, function (a) {
                            return '-' + a
                        });
                        return c.getComputedStyle(d, null).getPropertyValue(b)
                    }
                    return d.currentStyle[b]
                }
                function getSide(a) {
                    var b = parseFloat(getStyle(a), 10);
                    return isNaN(b) ? 0 : b
                }
                return {
                    top: getSide(e + "TopWidth"),
                    right: getSide(e + "RightWidth"),
                    bottom: getSide(e + "BottomWidth"),
                    left: getSide(e + "LeftWidth")
                }
            }
        }
    });
    define("tinymce/ui/ClassList", ["tinymce/util/Tools"], function (d) {
        "use strict";

        function noop() { }
        function ClassList(a) {
            this.cls = [];
            this.cls._map = {};
            this.onchange = a || noop;
            this.prefix = ''
        }
        d.extend(ClassList.prototype, {
            add: function (a) {
                if (a && !this.contains(a)) {
                    this.cls._map[a] = true;
                    this.cls.push(a);
                    this._change()
                }
                return this
            },
            remove: function (a) {
                if (this.contains(a)) {
                    for (var i = 0; i < this.cls.length; i++) {
                        if (this.cls[i] === a) {
                            break
                        }
                    }
                    this.cls.splice(i, 1);
                    delete this.cls._map[a];
                    this._change()
                }
                return this
            },
            toggle: function (a, b) {
                var c = this.contains(a);
                if (c !== b) {
                    if (c) {
                        this.remove(a)
                    } else {
                        this.add(a)
                    }
                    this._change()
                }
                return this
            },
            contains: function (a) {
                return !!this.cls._map[a]
            },
            _change: function () {
                delete this.clsValue;
                this.onchange.call(this)
            }
        });
        ClassList.prototype.toString = function () {
            var a;
            if (this.clsValue) {
                return this.clsValue
            }
            a = '';
            for (var i = 0; i < this.cls.length; i++) {
                if (i > 0) {
                    a += ' '
                }
                a += this.prefix + this.cls[i]
            }
            return a
        };
        return ClassList
    });
    define("tinymce/ui/ReflowQueue", ["tinymce/util/Delay"], function (d) {
        var e = {},
            animationFrameRequested;
        return {
            add: function (b) {
                var c = b.parent();
                if (c) {
                    if (!c._layout || c._layout.isNative()) {
                        return
                    }
                    if (!e[c._id]) {
                        e[c._id] = c
                    }
                    if (!animationFrameRequested) {
                        animationFrameRequested = true;
                        d.requestAnimationFrame(function () {
                            var a, b;
                            animationFrameRequested = false;
                            for (a in e) {
                                b = e[a];
                                if (b.state.get('rendered')) {
                                    b.reflow()
                                }
                            }
                            e = {}
                        }, document.body)
                    }
                }
            },
            remove: function (a) {
                if (e[a._id]) {
                    delete e[a._id]
                }
            }
        }
    });
    define("tinymce/ui/Control", ["tinymce/util/Class", "tinymce/util/Tools", "tinymce/util/EventDispatcher", "tinymce/data/ObservableObject", "tinymce/ui/Collection", "tinymce/ui/DomUtils", "tinymce/dom/DomQuery", "tinymce/ui/BoxUtils", "tinymce/ui/ClassList", "tinymce/ui/ReflowQueue"], function (j, k, m, n, o, p, $, q, r, s) {
        "use strict";
        var t = "onmousewheel" in document;
        var u = false;
        var v = "mce-";
        var w, idCounter = 0;
        var z = {
            Statics: {
                classPrefix: v
            },
            isRtl: function () {
                return w.rtl
            },
            classPrefix: v,
            init: function (b) {
                var c = this,
                    classes, defaultClasses;

                function applyClasses(a) {
                    var i;
                    a = a.split(' ');
                    for (i = 0; i < a.length; i++) {
                        c.classes.add(a[i])
                    }
                }
                c.settings = b = k.extend({}, c.Defaults, b);
                c._id = b.id || ('mceu_' + (idCounter++));
                c._aria = {
                    role: b.role
                };
                c._elmCache = {};
                c.$ = $;
                c.state = new n({
                    visible: true,
                    active: false,
                    disabled: false,
                    value: ''
                });
                c.data = new n(b.data);
                c.classes = new r(function () {
                    if (c.state.get('rendered')) {
                        c.getEl().className = this.toString()
                    }
                });
                c.classes.prefix = c.classPrefix;
                classes = b.classes;
                if (classes) {
                    if (c.Defaults) {
                        defaultClasses = c.Defaults.classes;
                        if (defaultClasses && classes != defaultClasses) {
                            applyClasses(defaultClasses)
                        }
                    }
                    applyClasses(classes)
                }
                k.each('title text name visible disabled active value'.split(' '), function (a) {
                    if (a in b) {
                        c[a](b[a])
                    }
                });
                c.on('click', function () {
                    if (c.disabled()) {
                        return false
                    }
                });
                c.settings = b;
                c.borderBox = q.parseBox(b.border);
                c.paddingBox = q.parseBox(b.padding);
                c.marginBox = q.parseBox(b.margin);
                if (b.hidden) {
                    c.hide()
                }
            },
            Properties: 'parent,name',
            getContainerElm: function () {
                return p.getContainer()
            },
            getParentCtrl: function (a) {
                var b, lookup = this.getRoot().controlIdLookup;
                while (a && lookup) {
                    b = lookup[a.id];
                    if (b) {
                        break
                    }
                    a = a.parentNode
                }
                return b
            },
            initLayoutRect: function () {
                var a = this,
                    settings = a.settings,
                    borderBox, layoutRect;
                var b = a.getEl(),
                    width, height, minWidth, minHeight, autoResize;
                var c, startMinHeight, initialSize;
                borderBox = a.borderBox = a.borderBox || q.measureBox(b, 'border');
                a.paddingBox = a.paddingBox || q.measureBox(b, 'padding');
                a.marginBox = a.marginBox || q.measureBox(b, 'margin');
                initialSize = p.getSize(b);
                c = settings.minWidth;
                startMinHeight = settings.minHeight;
                minWidth = c || initialSize.width;
                minHeight = startMinHeight || initialSize.height;
                width = settings.width;
                height = settings.height;
                autoResize = settings.autoResize;
                autoResize = typeof autoResize != "undefined" ? autoResize : !width && !height;
                width = width || minWidth;
                height = height || minHeight;
                var d = borderBox.left + borderBox.right;
                var e = borderBox.top + borderBox.bottom;
                var f = settings.maxWidth || 0xFFFF;
                var g = settings.maxHeight || 0xFFFF;
                a._layoutRect = layoutRect = {
                    x: settings.x || 0,
                    y: settings.y || 0,
                    w: width,
                    h: height,
                    deltaW: d,
                    deltaH: e,
                    contentW: width - d,
                    contentH: height - e,
                    innerW: width - d,
                    innerH: height - e,
                    startMinWidth: c || 0,
                    startMinHeight: startMinHeight || 0,
                    minW: Math.min(minWidth, f),
                    minH: Math.min(minHeight, g),
                    maxW: f,
                    maxH: g,
                    autoResize: autoResize,
                    scrollW: 0
                };
                a._lastLayoutRect = {};
                return layoutRect
            },
            layoutRect: function (a) {
                var b = this,
                    curRect = b._layoutRect,
                    lastLayoutRect, size, deltaWidth, deltaHeight, undef, repaintControls;
                if (!curRect) {
                    curRect = b.initLayoutRect()
                }
                if (a) {
                    deltaWidth = curRect.deltaW;
                    deltaHeight = curRect.deltaH;
                    if (a.x !== undef) {
                        curRect.x = a.x
                    }
                    if (a.y !== undef) {
                        curRect.y = a.y
                    }
                    if (a.minW !== undef) {
                        curRect.minW = a.minW
                    }
                    if (a.minH !== undef) {
                        curRect.minH = a.minH
                    }
                    size = a.w;
                    if (size !== undef) {
                        size = size < curRect.minW ? curRect.minW : size;
                        size = size > curRect.maxW ? curRect.maxW : size;
                        curRect.w = size;
                        curRect.innerW = size - deltaWidth
                    }
                    size = a.h;
                    if (size !== undef) {
                        size = size < curRect.minH ? curRect.minH : size;
                        size = size > curRect.maxH ? curRect.maxH : size;
                        curRect.h = size;
                        curRect.innerH = size - deltaHeight
                    }
                    size = a.innerW;
                    if (size !== undef) {
                        size = size < curRect.minW - deltaWidth ? curRect.minW - deltaWidth : size;
                        size = size > curRect.maxW - deltaWidth ? curRect.maxW - deltaWidth : size;
                        curRect.innerW = size;
                        curRect.w = size + deltaWidth
                    }
                    size = a.innerH;
                    if (size !== undef) {
                        size = size < curRect.minH - deltaHeight ? curRect.minH - deltaHeight : size;
                        size = size > curRect.maxH - deltaHeight ? curRect.maxH - deltaHeight : size;
                        curRect.innerH = size;
                        curRect.h = size + deltaHeight
                    }
                    if (a.contentW !== undef) {
                        curRect.contentW = a.contentW
                    }
                    if (a.contentH !== undef) {
                        curRect.contentH = a.contentH
                    }
                    lastLayoutRect = b._lastLayoutRect;
                    if (lastLayoutRect.x !== curRect.x || lastLayoutRect.y !== curRect.y || lastLayoutRect.w !== curRect.w || lastLayoutRect.h !== curRect.h) {
                        repaintControls = w.repaintControls;
                        if (repaintControls) {
                            if (repaintControls.map && !repaintControls.map[b._id]) {
                                repaintControls.push(b);
                                repaintControls.map[b._id] = true
                            }
                        }
                        lastLayoutRect.x = curRect.x;
                        lastLayoutRect.y = curRect.y;
                        lastLayoutRect.w = curRect.w;
                        lastLayoutRect.h = curRect.h
                    }
                    return b
                }
                return curRect
            },
            repaint: function () {
                var b = this,
                    style, bodyStyle, bodyElm, rect, borderBox;
                var c, borderH, lastRepaintRect, round, value;
                round = !document.createRange ? Math.round : function (a) {
                    return a
                };
                style = b.getEl().style;
                rect = b._layoutRect;
                lastRepaintRect = b._lastRepaintRect || {};
                borderBox = b.borderBox;
                c = borderBox.left + borderBox.right;
                borderH = borderBox.top + borderBox.bottom;
                if (rect.x !== lastRepaintRect.x) {
                    style.left = round(rect.x) + 'px';
                    lastRepaintRect.x = rect.x
                }
                if (rect.y !== lastRepaintRect.y) {
                    style.top = round(rect.y) + 'px';
                    lastRepaintRect.y = rect.y
                }
                if (rect.w !== lastRepaintRect.w) {
                    value = round(rect.w - c);
                    style.width = (value >= 0 ? value : 0) + 'px';
                    lastRepaintRect.w = rect.w
                }
                if (rect.h !== lastRepaintRect.h) {
                    value = round(rect.h - borderH);
                    style.height = (value >= 0 ? value : 0) + 'px';
                    lastRepaintRect.h = rect.h
                }
                if (b._hasBody && rect.innerW !== lastRepaintRect.innerW) {
                    value = round(rect.innerW);
                    bodyElm = b.getEl('body');
                    if (bodyElm) {
                        bodyStyle = bodyElm.style;
                        bodyStyle.width = (value >= 0 ? value : 0) + 'px'
                    }
                    lastRepaintRect.innerW = rect.innerW
                }
                if (b._hasBody && rect.innerH !== lastRepaintRect.innerH) {
                    value = round(rect.innerH);
                    bodyElm = bodyElm || b.getEl('body');
                    if (bodyElm) {
                        bodyStyle = bodyStyle || bodyElm.style;
                        bodyStyle.height = (value >= 0 ? value : 0) + 'px'
                    }
                    lastRepaintRect.innerH = rect.innerH
                }
                b._lastRepaintRect = lastRepaintRect;
                b.fire('repaint', {}, false)
            },
            updateLayoutRect: function () {
                var a = this;
                a.parent()._lastRect = null;
                p.css(a.getEl(), {
                    width: '',
                    height: ''
                });
                a._layoutRect = a._lastRepaintRect = a._lastLayoutRect = null;
                a.initLayoutRect()
            },
            on: function (f, g) {
                var h = this;

                function resolveCallbackName(c) {
                    var d, scope;
                    if (typeof c != 'string') {
                        return c
                    }
                    return function (e) {
                        if (!d) {
                            h.parentsAndSelf().each(function (a) {
                                var b = a.settings.callbacks;
                                if (b && (d = b[c])) {
                                    scope = a;
                                    return false
                                }
                            })
                        }
                        if (!d) {
                            e.action = c;
                            this.fire('execute', e);
                            return
                        }
                        return d.call(scope, e)
                    }
                }
                getEventDispatcher(h).on(f, resolveCallbackName(g));
                return h
            },
            off: function (a, b) {
                getEventDispatcher(this).off(a, b);
                return this
            },
            fire: function (a, b, c) {
                var d = this;
                b = b || {};
                if (!b.control) {
                    b.control = d
                }
                b = getEventDispatcher(d).fire(a, b);
                if (c !== false && d.parent) {
                    var e = d.parent();
                    while (e && !b.isPropagationStopped()) {
                        e.fire(a, b, false);
                        e = e.parent()
                    }
                }
                return b
            },
            hasEventListeners: function (a) {
                return getEventDispatcher(this).has(a)
            },
            parents: function (a) {
                var b = this,
                    ctrl, parents = new o();
                for (ctrl = b.parent(); ctrl; ctrl = ctrl.parent()) {
                    parents.add(ctrl)
                }
                if (a) {
                    parents = parents.filter(a)
                }
                return parents
            },
            parentsAndSelf: function (a) {
                return new o(this).add(this.parents(a))
            },
            next: function () {
                var a = this.parent().items();
                return a[a.indexOf(this) + 1]
            },
            prev: function () {
                var a = this.parent().items();
                return a[a.indexOf(this) - 1]
            },
            innerHtml: function (a) {
                this.$el.html(a);
                return this
            },
            getEl: function (a) {
                var b = a ? this._id + '-' + a : this._id;
                if (!this._elmCache[b]) {
                    this._elmCache[b] = $('#' + b)[0]
                }
                return this._elmCache[b]
            },
            show: function () {
                return this.visible(true)
            },
            hide: function () {
                return this.visible(false)
            },
            focus: function () {
                try {
                    this.getEl().focus()
                } catch (ex) { }
                return this
            },
            blur: function () {
                this.getEl().blur();
                return this
            },
            aria: function (a, b) {
                var c = this,
                    elm = c.getEl(c.ariaTarget);
                if (typeof b === "undefined") {
                    return c._aria[a]
                }
                c._aria[a] = b;
                if (c.state.get('rendered')) {
                    elm.setAttribute(a == 'role' ? a : 'aria-' + a, b)
                }
                return c
            },
            encode: function (b, c) {
                if (c !== false) {
                    b = this.translate(b)
                }
                return (b || '').replace(/[&<>"]/g, function (a) {
                    return '&#' + a.charCodeAt(0) + ';'
                })
            },
            translate: function (a) {
                return w.translate ? w.translate(a) : a
            },
            before: function (a) {
                var b = this,
                    parent = b.parent();
                if (parent) {
                    parent.insert(a, parent.items().indexOf(b), true)
                }
                return b
            },
            after: function (a) {
                var b = this,
                    parent = b.parent();
                if (parent) {
                    parent.insert(a, parent.items().indexOf(b))
                }
                return b
            },
            remove: function () {
                var b = this,
                    elm = b.getEl(),
                    parent = b.parent(),
                    newItems, i;
                if (b.items) {
                    var c = b.items().toArray();
                    i = c.length;
                    while (i--) {
                        c[i].remove()
                    }
                }
                if (parent && parent.items) {
                    newItems = [];
                    parent.items().each(function (a) {
                        if (a !== b) {
                            newItems.push(a)
                        }
                    });
                    parent.items().set(newItems);
                    parent._lastRect = null
                }
                if (b._eventsRoot && b._eventsRoot == b) {
                    $(elm).off()
                }
                var d = b.getRoot().controlIdLookup;
                if (d) {
                    delete d[b._id]
                }
                if (elm && elm.parentNode) {
                    elm.parentNode.removeChild(elm)
                }
                b.state.set('rendered', false);
                b.state.destroy();
                b.fire('remove');
                return b
            },
            renderBefore: function (a) {
                $(a).before(this.renderHtml());
                this.postRender();
                return this
            },
            renderTo: function (a) {
                $(a || this.getContainerElm()).append(this.renderHtml());
                this.postRender();
                return this
            },
            preRender: function () { },
            render: function () { },
            renderHtml: function () {
                return '<div id="' + this._id + '" class="' + this.classes + '"></div>'
            },
            postRender: function () {
                var b = this,
                    settings = b.settings,
                    elm, box, parent, name, parentEventsRoot;
                b.$el = $(b.getEl());
                b.state.set('rendered', true);
                for (name in settings) {
                    if (name.indexOf("on") === 0) {
                        b.on(name.substr(2), settings[name])
                    }
                }
                if (b._eventsRoot) {
                    for (parent = b.parent(); !parentEventsRoot && parent; parent = parent.parent()) {
                        parentEventsRoot = parent._eventsRoot
                    }
                    if (parentEventsRoot) {
                        for (name in parentEventsRoot._nativeEvents) {
                            b._nativeEvents[name] = true
                        }
                    }
                }
                bindPendingEvents(b);
                if (settings.style) {
                    elm = b.getEl();
                    if (elm) {
                        elm.setAttribute('style', settings.style);
                        elm.style.cssText = settings.style
                    }
                }
                if (b.settings.border) {
                    box = b.borderBox;
                    b.$el.css({
                        'border-top-width': box.top,
                        'border-right-width': box.right,
                        'border-bottom-width': box.bottom,
                        'border-left-width': box.left
                    })
                }
                var c = b.getRoot();
                if (!c.controlIdLookup) {
                    c.controlIdLookup = {}
                }
                c.controlIdLookup[b._id] = b;
                for (var d in b._aria) {
                    b.aria(d, b._aria[d])
                }
                if (b.state.get('visible') === false) {
                    b.getEl().style.display = 'none'
                }
                b.bindStates();
                b.state.on('change:visible', function (e) {
                    var a = e.value,
                        parentCtrl;
                    if (b.state.get('rendered')) {
                        b.getEl().style.display = a === false ? 'none' : '';
                        b.getEl().getBoundingClientRect()
                    }
                    parentCtrl = b.parent();
                    if (parentCtrl) {
                        parentCtrl._lastRect = null
                    }
                    b.fire(a ? 'show' : 'hide');
                    s.add(b)
                });
                b.fire('postrender', {}, false)
            },
            bindStates: function () { },
            scrollIntoView: function (c) {
                function getOffset(a, b) {
                    var x, y, parent = a;
                    x = y = 0;
                    while (parent && parent != b && parent.nodeType) {
                        x += parent.offsetLeft || 0;
                        y += parent.offsetTop || 0;
                        parent = parent.offsetParent
                    }
                    return {
                        x: x,
                        y: y
                    }
                }
                var d = this.getEl(),
                    parentElm = d.parentNode;
                var x, y, width, height, parentWidth, parentHeight;
                var e = getOffset(d, parentElm);
                x = e.x;
                y = e.y;
                width = d.offsetWidth;
                height = d.offsetHeight;
                parentWidth = parentElm.clientWidth;
                parentHeight = parentElm.clientHeight;
                if (c == "end") {
                    x -= parentWidth - width;
                    y -= parentHeight - height
                } else if (c == "center") {
                    x -= (parentWidth / 2) - (width / 2);
                    y -= (parentHeight / 2) - (height / 2)
                }
                parentElm.scrollLeft = x;
                parentElm.scrollTop = y;
                return this
            },
            getRoot: function () {
                var a = this,
                    rootControl, parents = [];
                while (a) {
                    if (a.rootControl) {
                        rootControl = a.rootControl;
                        break
                    }
                    parents.push(a);
                    rootControl = a;
                    a = a.parent()
                }
                if (!rootControl) {
                    rootControl = this
                }
                var i = parents.length;
                while (i--) {
                    parents[i].rootControl = rootControl
                }
                return rootControl
            },
            reflow: function () {
                s.remove(this);
                var a = this.parent();
                if (a._layout && !a._layout.isNative()) {
                    a.reflow()
                }
                return this
            }
        };
        k.each('text title visible disabled active value'.split(' '), function (b) {
            z[b] = function (a) {
                if (arguments.length === 0) {
                    return this.state.get(b)
                }
                if (typeof a != "undefined") {
                    this.state.set(b, a)
                }
                return this
            }
        });
        w = j.extend(z);

        function getEventDispatcher(c) {
            if (!c._eventDispatcher) {
                c._eventDispatcher = new m({
                    scope: c,
                    toggleEvent: function (a, b) {
                        if (b && m.isNative(a)) {
                            if (!c._nativeEvents) {
                                c._nativeEvents = {}
                            }
                            c._nativeEvents[a] = true;
                            if (c.state.get('rendered')) {
                                bindPendingEvents(c)
                            }
                        }
                    }
                })
            }
            return c._eventDispatcher
        }
        function bindPendingEvents(c) {
            var i, l, parents, eventRootCtrl, nativeEvents, name;

            function delegate(e) {
                var a = c.getParentCtrl(e.target);
                if (a) {
                    a.fire(e.type, e)
                }
            }
            function mouseLeaveHandler() {
                var b = eventRootCtrl._lastHoverCtrl;
                if (b) {
                    b.fire("mouseleave", {
                        target: b.getEl()
                    });
                    b.parents().each(function (a) {
                        a.fire("mouseleave", {
                            target: a.getEl()
                        })
                    });
                    eventRootCtrl._lastHoverCtrl = null
                }
            }
            function mouseEnterHandler(e) {
                var a = c.getParentCtrl(e.target),
                    lastCtrl = eventRootCtrl._lastHoverCtrl,
                    idx = 0,
                    i, parents, lastParents;
                if (a !== lastCtrl) {
                    eventRootCtrl._lastHoverCtrl = a;
                    parents = a.parents().toArray().reverse();
                    parents.push(a);
                    if (lastCtrl) {
                        lastParents = lastCtrl.parents().toArray().reverse();
                        lastParents.push(lastCtrl);
                        for (idx = 0; idx < lastParents.length; idx++) {
                            if (parents[idx] !== lastParents[idx]) {
                                break
                            }
                        }
                        for (i = lastParents.length - 1; i >= idx; i--) {
                            lastCtrl = lastParents[i];
                            lastCtrl.fire("mouseleave", {
                                target: lastCtrl.getEl()
                            })
                        }
                    }
                    for (i = idx; i < parents.length; i++) {
                        a = parents[i];
                        a.fire("mouseenter", {
                            target: a.getEl()
                        })
                    }
                }
            }
            function fixWheelEvent(e) {
                e.preventDefault();
                if (e.type == "mousewheel") {
                    e.deltaY = -1 / 40 * e.wheelDelta;
                    if (e.wheelDeltaX) {
                        e.deltaX = -1 / 40 * e.wheelDeltaX
                    }
                } else {
                    e.deltaX = 0;
                    e.deltaY = e.detail
                }
                e = c.fire("wheel", e)
            }
            nativeEvents = c._nativeEvents;
            if (nativeEvents) {
                parents = c.parents().toArray();
                parents.unshift(c);
                for (i = 0, l = parents.length; !eventRootCtrl && i < l; i++) {
                    eventRootCtrl = parents[i]._eventsRoot
                }
                if (!eventRootCtrl) {
                    eventRootCtrl = parents[parents.length - 1] || c
                }
                c._eventsRoot = eventRootCtrl;
                for (l = i, i = 0; i < l; i++) {
                    parents[i]._eventsRoot = eventRootCtrl
                }
                var d = eventRootCtrl._delegates;
                if (!d) {
                    d = eventRootCtrl._delegates = {}
                }
                for (name in nativeEvents) {
                    if (!nativeEvents) {
                        return false
                    }
                    if (name === "wheel" && !u) {
                        if (t) {
                            $(c.getEl()).on("mousewheel", fixWheelEvent)
                        } else {
                            $(c.getEl()).on("DOMMouseScroll", fixWheelEvent)
                        }
                        continue
                    }
                    if (name === "mouseenter" || name === "mouseleave") {
                        if (!eventRootCtrl._hasMouseEnter) {
                            $(eventRootCtrl.getEl()).on("mouseleave", mouseLeaveHandler).on("mouseover", mouseEnterHandler);
                            eventRootCtrl._hasMouseEnter = 1
                        }
                    } else if (!d[name]) {
                        $(eventRootCtrl.getEl()).on(name, delegate);
                        d[name] = true
                    }
                    nativeEvents[name] = false
                }
            }
        }
        return w
    });
    define("tinymce/ui/Factory", [], function () {
        "use strict";
        var d = {},
            namespaceInit;
        return {
            add: function (a, b) {
                d[a.toLowerCase()] = b
            },
            has: function (a) {
                return !!d[a.toLowerCase()]
            },
            create: function (a, b) {
                var c, name, namespace;
                if (!namespaceInit) {
                    namespace = tinymce.ui;
                    for (name in namespace) {
                        d[name.toLowerCase()] = namespace[name]
                    }
                    namespaceInit = true
                }
                if (typeof a == 'string') {
                    b = b || {};
                    b.type = a
                } else {
                    b = a;
                    a = b.type
                }
                a = a.toLowerCase();
                c = d[a];
                if (!c) {
                    throw new Error("Could not find control by type: " + a)
                }
                c = new c(b);
                c.type = a;
                return c
            }
        }
    });
    define("tinymce/ui/KeyboardNavigation", [], function () {
        "use strict";
        return function (d) {
            var f = d.root,
                focusedElement, focusedControl;

            function isElement(a) {
                return a && a.nodeType === 1
            }
            try {
                focusedElement = document.activeElement
            } catch (ex) {
                focusedElement = document.body
            }
            focusedControl = f.getParentCtrl(focusedElement);

            function getRole(a) {
                a = a || focusedElement;
                if (isElement(a)) {
                    return a.getAttribute('role')
                }
                return null
            }
            function getParentRole(a) {
                var b, parent = a || focusedElement;
                while ((parent = parent.parentNode)) {
                    if ((b = getRole(parent))) {
                        return b
                    }
                }
            }
            function getAriaProp(a) {
                var b = focusedElement;
                if (isElement(b)) {
                    return b.getAttribute('aria-' + a)
                }
            }
            function isTextInputElement(a) {
                var b = a.tagName.toUpperCase();
                return b == "INPUT" || b == "TEXTAREA" || b == "SELECT"
            }
            function canFocus(a) {
                if (isTextInputElement(a) && !a.hidden) {
                    return true
                }
                if (/^(button|menuitem|checkbox|tab|menuitemcheckbox|option|gridcell|slider)$/.test(getRole(a))) {
                    return true
                }
                return false
            }
            function getFocusElements(b) {
                var c = [];

                function collect(a) {
                    if (a.nodeType != 1 || a.style.display == 'none') {
                        return
                    }
                    if (canFocus(a)) {
                        c.push(a)
                    }
                    for (var i = 0; i < a.childNodes.length; i++) {
                        collect(a.childNodes[i])
                    }
                }
                collect(b || f.getEl());
                return c
            }
            function getNavigationRoot(a) {
                var b, controls;
                a = a || focusedControl;
                controls = a.parents().toArray();
                controls.unshift(a);
                for (var i = 0; i < controls.length; i++) {
                    b = controls[i];
                    if (b.settings.ariaRoot) {
                        break
                    }
                }
                return b
            }
            function focusFirst(a) {
                var b = getNavigationRoot(a);
                var c = getFocusElements(b.getEl());
                if (b.settings.ariaRemember && "lastAriaIndex" in b) {
                    moveFocusToIndex(b.lastAriaIndex, c)
                } else {
                    moveFocusToIndex(0, c)
                }
            }
            function moveFocusToIndex(a, b) {
                if (a < 0) {
                    a = b.length - 1
                } else if (a >= b.length) {
                    a = 0
                }
                if (b[a]) {
                    b[a].focus()
                }
                return a
            }
            function moveFocus(a, b) {
                var c = -1,
                    navigationRoot = getNavigationRoot();
                b = b || getFocusElements(navigationRoot.getEl());
                for (var i = 0; i < b.length; i++) {
                    if (b[i] === focusedElement) {
                        c = i
                    }
                }
                c += a;
                navigationRoot.lastAriaIndex = moveFocusToIndex(c, b)
            }
            function left() {
                var a = getParentRole();
                if (a == "tablist") {
                    moveFocus(-1, getFocusElements(focusedElement.parentNode))
                } else if (focusedControl.parent().submenu) {
                    cancel()
                } else {
                    moveFocus(-1)
                }
            }
            function right() {
                var a = getRole(),
                    parentRole = getParentRole();
                if (parentRole == "tablist") {
                    moveFocus(1, getFocusElements(focusedElement.parentNode))
                } else if (a == "menuitem" && parentRole == "menu" && getAriaProp('haspopup')) {
                    enter()
                } else {
                    moveFocus(1)
                }
            }
            function up() {
                moveFocus(-1)
            }
            function down() {
                var a = getRole(),
                    parentRole = getParentRole();
                if (a == "menuitem" && parentRole == "menubar") {
                    enter()
                } else if (a == "button" && getAriaProp('haspopup')) {
                    enter({
                        key: 'down'
                    })
                } else {
                    moveFocus(1)
                }
            }
            function tab(e) {
                var a = getParentRole();
                if (a == "tablist") {
                    var b = getFocusElements(focusedControl.getEl('body'))[0];
                    if (b) {
                        b.focus()
                    }
                } else {
                    moveFocus(e.shiftKey ? -1 : 1)
                }
            }
            function cancel() {
                focusedControl.fire('cancel')
            }
            function enter(a) {
                a = a || {};
                focusedControl.fire('click', {
                    target: focusedElement,
                    aria: a
                })
            }
            f.on('keydown', function (e) {
                function handleNonTabOrEscEvent(e, a) {
                    if (isTextInputElement(focusedElement)) {
                        return
                    }
                    if (getRole(focusedElement) === 'slider') {
                        return
                    }
                    if (a(e) !== false) {
                        e.preventDefault()
                    }
                }
                if (e.isDefaultPrevented()) {
                    return
                }
                switch (e.keyCode) {
                    case 37:
                        handleNonTabOrEscEvent(e, left);
                        break;
                    case 39:
                        handleNonTabOrEscEvent(e, right);
                        break;
                    case 38:
                        handleNonTabOrEscEvent(e, up);
                        break;
                    case 40:
                        handleNonTabOrEscEvent(e, down);
                        break;
                    case 27:
                        cancel();
                        break;
                    case 14:
                    case 13:
                    case 32:
                        handleNonTabOrEscEvent(e, enter);
                        break;
                    case 9:
                        if (tab(e) !== false) {
                            e.preventDefault()
                        }
                        break
                }
            });
            f.on('focusin', function (e) {
                focusedElement = e.target;
                focusedControl = e.control
            });
            return {
                focusFirst: focusFirst
            }
        }
    });
    define("tinymce/ui/Container", ["tinymce/ui/Control", "tinymce/ui/Collection", "tinymce/ui/Selector", "tinymce/ui/Factory", "tinymce/ui/KeyboardNavigation", "tinymce/util/Tools", "tinymce/dom/DomQuery", "tinymce/ui/ClassList", "tinymce/ui/ReflowQueue"], function (e, f, g, h, j, k, $, l, m) {
        "use strict";
        var n = {};
        return e.extend({
            init: function (a) {
                var b = this;
                b._super(a);
                a = b.settings;
                if (a.fixed) {
                    b.state.set('fixed', true)
                }
                b._items = new f();
                if (b.isRtl()) {
                    b.classes.add('rtl')
                }
                b.bodyClasses = new l(function () {
                    if (b.state.get('rendered')) {
                        b.getEl('body').className = this.toString()
                    }
                });
                b.bodyClasses.prefix = b.classPrefix;
                b.classes.add('container');
                b.bodyClasses.add('container-body');
                if (a.containerCls) {
                    b.classes.add(a.containerCls)
                }
                b._layout = h.create((a.layout || '') + 'layout');
                if (b.settings.items) {
                    b.add(b.settings.items)
                } else {
                    b.add(b.render())
                }
                b._hasBody = true
            },
            items: function () {
                return this._items
            },
            find: function (a) {
                a = n[a] = n[a] || new g(a);
                return a.find(this)
            },
            add: function (a) {
                var b = this;
                b.items().add(b.create(a)).parent(b);
                return b
            },
            focus: function (b) {
                var c = this,
                    focusCtrl, keyboardNav, items;
                if (b) {
                    keyboardNav = c.keyboardNav || c.parents().eq(-1)[0].keyboardNav;
                    if (keyboardNav) {
                        keyboardNav.focusFirst(c);
                        return
                    }
                }
                items = c.find('*');
                if (c.statusbar) {
                    items.add(c.statusbar.items())
                }
                items.each(function (a) {
                    if (a.settings.autofocus) {
                        focusCtrl = null;
                        return false
                    }
                    if (a.canFocus) {
                        focusCtrl = focusCtrl || a
                    }
                });
                if (focusCtrl) {
                    focusCtrl.focus()
                }
                return c
            },
            replace: function (a, b) {
                var c, items = this.items(),
                    i = items.length;
                while (i--) {
                    if (items[i] === a) {
                        items[i] = b;
                        break
                    }
                }
                if (i >= 0) {
                    c = b.getEl();
                    if (c) {
                        c.parentNode.removeChild(c)
                    }
                    c = a.getEl();
                    if (c) {
                        c.parentNode.removeChild(c)
                    }
                }
                b.parent(this)
            },
            create: function (b) {
                var c = this,
                    settings, ctrlItems = [];
                if (!k.isArray(b)) {
                    b = [b]
                }
                k.each(b, function (a) {
                    if (a) {
                        if (!(a instanceof e)) {
                            if (typeof a == "string") {
                                a = {
                                    type: a
                                }
                            }
                            settings = k.extend({}, c.settings.defaults, a);
                            a.type = settings.type = settings.type || a.type || c.settings.defaultType || (settings.defaults ? settings.defaults.type : null);
                            a = h.create(settings)
                        }
                        ctrlItems.push(a)
                    }
                });
                return ctrlItems
            },
            renderNew: function () {
                var d = this;
                d.items().each(function (a, b) {
                    var c;
                    a.parent(d);
                    if (!a.state.get('rendered')) {
                        c = d.getEl('body');
                        if (c.hasChildNodes() && b <= c.childNodes.length - 1) {
                            $(c.childNodes[b]).before(a.renderHtml())
                        } else {
                            $(c).append(a.renderHtml())
                        }
                        a.postRender();
                        m.add(a)
                    }
                });
                d._layout.applyClasses(d.items().filter(':visible'));
                d._lastRect = null;
                return d
            },
            append: function (a) {
                return this.add(a).renderNew()
            },
            prepend: function (a) {
                var b = this;
                b.items().set(b.create(a).concat(b.items().toArray()));
                return b.renderNew()
            },
            insert: function (a, b, c) {
                var d = this,
                    curItems, beforeItems, afterItems;
                a = d.create(a);
                curItems = d.items();
                if (!c && b < curItems.length - 1) {
                    b += 1
                }
                if (b >= 0 && b < curItems.length) {
                    beforeItems = curItems.slice(0, b).toArray();
                    afterItems = curItems.slice(b).toArray();
                    curItems.set(beforeItems.concat(a, afterItems))
                }
                return d.renderNew()
            },
            fromJSON: function (a) {
                var b = this;
                for (var c in a) {
                    b.find('#' + c).value(a[c])
                }
                return b
            },
            toJSON: function () {
                var c = this,
                    data = {};
                c.find('*').each(function (a) {
                    var b = a.name(),
                        value = a.value();
                    if (b && typeof value != "undefined") {
                        data[b] = value
                    }
                });
                return data
            },
            renderHtml: function () {
                var a = this,
                    layout = a._layout,
                    role = this.settings.role;
                a.preRender();
                layout.preRender(a);
                return ('<div id="' + a._id + '" class="' + a.classes + '"' + (role ? ' role="' + this.settings.role + '"' : '') + '>' + '<div id="' + a._id + '-body" class="' + a.bodyClasses + '">' + (a.settings.html || '') + layout.renderHtml(a) + '</div>' + '</div>')
            },
            postRender: function () {
                var a = this,
                    box;
                a.items().exec('postRender');
                a._super();
                a._layout.postRender(a);
                a.state.set('rendered', true);
                if (a.settings.style) {
                    a.$el.css(a.settings.style)
                }
                if (a.settings.border) {
                    box = a.borderBox;
                    a.$el.css({
                        'border-top-width': box.top,
                        'border-right-width': box.right,
                        'border-bottom-width': box.bottom,
                        'border-left-width': box.left
                    })
                }
                if (!a.parent()) {
                    a.keyboardNav = new j({
                        root: a
                    })
                }
                return a
            },
            initLayoutRect: function () {
                var a = this,
                    layoutRect = a._super();
                a._layout.recalc(a);
                return layoutRect
            },
            recalc: function () {
                var a = this,
                    rect = a._layoutRect,
                    lastRect = a._lastRect;
                if (!lastRect || lastRect.w != rect.w || lastRect.h != rect.h) {
                    a._layout.recalc(a);
                    rect = a.layoutRect();
                    a._lastRect = {
                        x: rect.x,
                        y: rect.y,
                        w: rect.w,
                        h: rect.h
                    };
                    return true
                }
            },
            reflow: function () {
                var i;
                m.remove(this);
                if (this.visible()) {
                    e.repaintControls = [];
                    e.repaintControls.map = {};
                    this.recalc();
                    i = e.repaintControls.length;
                    while (i--) {
                        e.repaintControls[i].repaint()
                    }
                    if (this.settings.layout !== "flow" && this.settings.layout !== "stack") {
                        this.repaint()
                    }
                    e.repaintControls = []
                }
                return this
            }
        })
    });
    define("tinymce/ui/DragHelper", ["tinymce/dom/DomQuery"], function ($) {
        "use strict";

        function getDocumentSize(a) {
            var b, body, scrollWidth, clientWidth;
            var c, scrollHeight, clientHeight, offsetHeight, max = Math.max;
            b = a.documentElement;
            body = a.body;
            scrollWidth = max(b.scrollWidth, body.scrollWidth);
            clientWidth = max(b.clientWidth, body.clientWidth);
            c = max(b.offsetWidth, body.offsetWidth);
            scrollHeight = max(b.scrollHeight, body.scrollHeight);
            clientHeight = max(b.clientHeight, body.clientHeight);
            offsetHeight = max(b.offsetHeight, body.offsetHeight);
            return {
                width: scrollWidth < c ? clientWidth : scrollWidth,
                height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
            }
        }
        function updateWithTouchData(e) {
            var a, i;
            if (e.changedTouches) {
                a = "screenX screenY pageX pageY clientX clientY".split(' ');
                for (i = 0; i < a.length; i++) {
                    e[a[i]] = e.changedTouches[0][a[i]]
                }
            }
        }
        return function (b, c) {
            var d, doc = c.document || document,
                downButton, start, stop, drag, startX, startY;
            c = c || {};

            function getHandleElm() {
                return doc.getElementById(c.handle || b)
            }
            start = function (e) {
                var a = getDocumentSize(doc),
                    handleElm, cursor;
                updateWithTouchData(e);
                e.preventDefault();
                downButton = e.button;
                handleElm = getHandleElm();
                startX = e.screenX;
                startY = e.screenY;
                if (window.getComputedStyle) {
                    cursor = window.getComputedStyle(handleElm, null).getPropertyValue("cursor")
                } else {
                    cursor = handleElm.runtimeStyle.cursor
                }
                d = $('<div>').css({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: a.width,
                    height: a.height,
                    zIndex: 0x7FFFFFFF,
                    opacity: 0.0001,
                    cursor: cursor
                }).appendTo(doc.body);
                $(doc).on('mousemove touchmove', drag).on('mouseup touchend', stop);
                c.start(e)
            };
            drag = function (e) {
                updateWithTouchData(e);
                if (e.button !== downButton) {
                    return stop(e)
                }
                e.deltaX = e.screenX - startX;
                e.deltaY = e.screenY - startY;
                e.preventDefault();
                c.drag(e)
            };
            stop = function (e) {
                updateWithTouchData(e);
                $(doc).off('mousemove touchmove', drag).off('mouseup touchend', stop);
                d.remove();
                if (c.stop) {
                    c.stop(e)
                }
            };
            this.destroy = function () {
                $(getHandleElm()).off()
            };
            $(getHandleElm()).on('mousedown touchstart', start)
        }
    });
    define("tinymce/ui/Scrollable", ["tinymce/dom/DomQuery", "tinymce/ui/DragHelper"], function ($, l) {
        "use strict";
        return {
            init: function () {
                var a = this;
                a.on('repaint', a.renderScroll)
            },
            renderScroll: function () {
                var k = this,
                    margin = 2;

                function repaintScroll() {
                    var j, hasScrollV, bodyElm;

                    function repaintAxis(a, b, c, d, e, f) {
                        var g, scrollBarElm, scrollThumbElm;
                        var h, scrollSize, ratio, rect;
                        var i, sizeNameLower;
                        scrollBarElm = k.getEl('scroll' + a);
                        if (scrollBarElm) {
                            i = b.toLowerCase();
                            sizeNameLower = c.toLowerCase();
                            $(k.getEl('absend')).css(i, k.layoutRect()[d] - 1);
                            if (!e) {
                                $(scrollBarElm).css('display', 'none');
                                return
                            }
                            $(scrollBarElm).css('display', 'block');
                            g = k.getEl('body');
                            scrollThumbElm = k.getEl('scroll' + a + "t");
                            h = g["client" + c] - (margin * 2);
                            h -= j && hasScrollV ? scrollBarElm["client" + f] : 0;
                            scrollSize = g["scroll" + c];
                            ratio = h / scrollSize;
                            rect = {};
                            rect[i] = g["offset" + b] + margin;
                            rect[sizeNameLower] = h;
                            $(scrollBarElm).css(rect);
                            rect = {};
                            rect[i] = g["scroll" + b] * ratio;
                            rect[sizeNameLower] = h * ratio;
                            $(scrollThumbElm).css(rect)
                        }
                    }
                    bodyElm = k.getEl('body');
                    j = bodyElm.scrollWidth > bodyElm.clientWidth;
                    hasScrollV = bodyElm.scrollHeight > bodyElm.clientHeight;
                    repaintAxis("h", "Left", "Width", "contentW", j, "Height");
                    repaintAxis("v", "Top", "Height", "contentH", hasScrollV, "Width")
                }
                function addScroll() {
                    function addScrollAxis(b, c, d, f, g) {
                        var h, axisId = k._id + '-scroll' + b,
                            prefix = k.classPrefix;
                        $(k.getEl()).append('<div id="' + axisId + '" class="' + prefix + 'scrollbar ' + prefix + 'scrollbar-' + b + '">' + '<div id="' + axisId + 't" class="' + prefix + 'scrollbar-thumb"></div>' + '</div>');
                        k.draghelper = new l(axisId + 't', {
                            start: function () {
                                h = k.getEl('body')["scroll" + c];
                                $('#' + axisId).addClass(prefix + 'active')
                            },
                            drag: function (e) {
                                var a, hasScrollH, hasScrollV, containerSize, layoutRect = k.layoutRect();
                                hasScrollH = layoutRect.contentW > layoutRect.innerW;
                                hasScrollV = layoutRect.contentH > layoutRect.innerH;
                                containerSize = k.getEl('body')["client" + d] - (margin * 2);
                                containerSize -= hasScrollH && hasScrollV ? k.getEl('scroll' + b)["client" + g] : 0;
                                a = containerSize / k.getEl('body')["scroll" + d];
                                k.getEl('body')["scroll" + c] = h + (e["delta" + f] / a)
                            },
                            stop: function () {
                                $('#' + axisId).removeClass(prefix + 'active')
                            }
                        })
                    }
                    k.classes.add('scroll');
                    addScrollAxis("v", "Top", "Height", "Y", "Width");
                    addScrollAxis("h", "Left", "Width", "X", "Height")
                }
                if (k.settings.autoScroll) {
                    if (!k._hasScroll) {
                        k._hasScroll = true;
                        addScroll();
                        k.on('wheel', function (e) {
                            var a = k.getEl('body');
                            a.scrollLeft += (e.deltaX || 0) * 10;
                            a.scrollTop += e.deltaY * 10;
                            repaintScroll()
                        });
                        $(k.getEl('body')).on("scroll", repaintScroll)
                    }
                    repaintScroll()
                }
            }
        }
    });
    define("tinymce/ui/Panel", ["tinymce/ui/Container", "tinymce/ui/Scrollable"], function (b, c) {
        "use strict";
        return b.extend({
            Defaults: {
                layout: 'fit',
                containerCls: 'panel'
            },
            Mixins: [c],
            renderHtml: function () {
                var a = this,
                    layout = a._layout,
                    innerHtml = a.settings.html;
                a.preRender();
                layout.preRender(a);
                if (typeof innerHtml == "undefined") {
                    innerHtml = ('<div id="' + a._id + '-body" class="' + a.bodyClasses + '">' + layout.renderHtml(a) + '</div>')
                } else {
                    if (typeof innerHtml == 'function') {
                        innerHtml = innerHtml.call(a)
                    }
                    a._hasBody = false
                }
                return ('<div id="' + a._id + '" class="' + a.classes + '" hidefocus="1" tabindex="-1" role="group">' + (a._preBodyHtml || '') + innerHtml + '</div>')
            }
        })
    });
    define("tinymce/ui/Movable", ["tinymce/ui/DomUtils"], function (g) {
        "use strict";

        function calculateRelativePosition(a, b, c) {
            var d, pos, x, y, selfW, selfH, targetW, targetH, viewport, size;
            viewport = g.getViewPort();
            pos = g.getPos(b);
            x = pos.x;
            y = pos.y;
            if (a.state.get('fixed') && g.getRuntimeStyle(document.body, 'position') == 'static') {
                x -= viewport.x;
                y -= viewport.y
            }
            d = a.getEl();
            size = g.getSize(d);
            selfW = size.width;
            selfH = size.height;
            size = g.getSize(b);
            targetW = size.width;
            targetH = size.height;
            c = (c || '').split('');
            if (c[0] === 'b') {
                y += targetH
            }
            if (c[1] === 'r') {
                x += targetW
            }
            if (c[0] === 'c') {
                y += Math.round(targetH / 2)
            }
            if (c[1] === 'c') {
                x += Math.round(targetW / 2)
            }
            if (c[3] === 'b') {
                y -= selfH
            }
            if (c[4] === 'r') {
                x -= selfW
            }
            if (c[3] === 'c') {
                y -= Math.round(selfH / 2)
            }
            if (c[4] === 'c') {
                x -= Math.round(selfW / 2)
            }
            return {
                x: x,
                y: y,
                w: selfW,
                h: selfH
            }
        }
        return {
            testMoveRel: function (a, b) {
                var c = g.getViewPort();
                for (var i = 0; i < b.length; i++) {
                    var d = calculateRelativePosition(this, a, b[i]);
                    if (this.state.get('fixed')) {
                        if (d.x > 0 && d.x + d.w < c.w && d.y > 0 && d.y + d.h < c.h) {
                            return b[i]
                        }
                    } else {
                        if (d.x > c.x && d.x + d.w < c.w + c.x && d.y > c.y && d.y + d.h < c.h + c.y) {
                            return b[i]
                        }
                    }
                }
                return b[0]
            },
            moveRel: function (a, b) {
                if (typeof b != 'string') {
                    b = this.testMoveRel(a, b)
                }
                var c = calculateRelativePosition(this, a, b);
                return this.moveTo(c.x, c.y)
            },
            moveBy: function (a, b) {
                var c = this,
                    rect = c.layoutRect();
                c.moveTo(rect.x + a, rect.y + b);
                return c
            },
            moveTo: function (x, y) {
                var d = this;

                function constrain(a, b, c) {
                    if (a < 0) {
                        return 0
                    }
                    if (a + c > b) {
                        a = b - c;
                        return a < 0 ? 0 : a
                    }
                    return a
                }
                if (d.settings.constrainToViewport) {
                    var e = g.getViewPort(window);
                    var f = d.layoutRect();
                    x = constrain(x, e.w + e.x, f.w);
                    y = constrain(y, e.h + e.y, f.h)
                }
                if (d.state.get('rendered')) {
                    d.layoutRect({
                        x: x,
                        y: y
                    }).repaint()
                } else {
                    d.settings.x = x;
                    d.settings.y = y
                }
                d.fire('move', {
                    x: x,
                    y: y
                });
                return d
            }
        }
    });
    define("tinymce/ui/Resizable", ["tinymce/ui/DomUtils"], function (d) {
        "use strict";
        return {
            resizeToContent: function () {
                this._layoutRect.autoResize = true;
                this._lastRect = null;
                this.reflow()
            },
            resizeTo: function (w, h) {
                if (w <= 1 || h <= 1) {
                    var a = d.getWindowSize();
                    w = w <= 1 ? w * a.w : w;
                    h = h <= 1 ? h * a.h : h
                }
                this._layoutRect.autoResize = false;
                return this.layoutRect({
                    minW: w,
                    minH: h,
                    w: w,
                    h: h
                }).reflow()
            },
            resizeBy: function (a, b) {
                var c = this,
                    rect = c.layoutRect();
                return c.resizeTo(rect.w + a, rect.h + b)
            }
        }
    });
    define("tinymce/ui/FloatPanel", ["tinymce/ui/Panel", "tinymce/ui/Movable", "tinymce/ui/Resizable", "tinymce/ui/DomUtils", "tinymce/dom/DomQuery", "tinymce/util/Delay"], function (f, g, h, j, $, k) {
        "use strict";
        var l, documentScrollHandler, windowResizeHandler, visiblePanels = [];
        var m = [],
            hasModal;

        function isChildOf(a, b) {
            while (a) {
                if (a == b) {
                    return true
                }
                a = a.parent()
            }
        }
        function skipOrHidePanels(e) {
            var i = visiblePanels.length;
            while (i--) {
                var a = visiblePanels[i],
                    clickCtrl = a.getParentCtrl(e.target);
                if (a.settings.autohide) {
                    if (clickCtrl) {
                        if (isChildOf(clickCtrl, a) || a.parent() === clickCtrl) {
                            continue
                        }
                    }
                    e = a.fire('autohide', {
                        target: e.target
                    });
                    if (!e.isDefaultPrevented()) {
                        a.hide()
                    }
                }
            }
        }
        function bindDocumentClickHandler() {
            if (!l) {
                l = function (e) {
                    if (e.button == 2) {
                        return
                    }
                    skipOrHidePanels(e)
                };
                $(document).on('click touchstart', l)
            }
        }
        function bindDocumentScrollHandler() {
            if (!documentScrollHandler) {
                documentScrollHandler = function () {
                    var i;
                    i = visiblePanels.length;
                    while (i--) {
                        repositionPanel(visiblePanels[i])
                    }
                };
                $(window).on('scroll', documentScrollHandler)
            }
        }
        function bindWindowResizeHandler() {
            if (!windowResizeHandler) {
                var a = document.documentElement,
                    clientWidth = a.clientWidth,
                    clientHeight = a.clientHeight;
                windowResizeHandler = function () {
                    if (!document.all || clientWidth != a.clientWidth || clientHeight != a.clientHeight) {
                        clientWidth = a.clientWidth;
                        clientHeight = a.clientHeight;
                        n.hideAll()
                    }
                };
                $(window).on('resize', windowResizeHandler)
            }
        }
        function repositionPanel(d) {
            var e = j.getViewPort().y;

            function toggleFixedChildPanels(a, b) {
                var c;
                for (var i = 0; i < visiblePanels.length; i++) {
                    if (visiblePanels[i] != d) {
                        c = visiblePanels[i].parent();
                        while (c && (c = c.parent())) {
                            if (c == d) {
                                visiblePanels[i].fixed(a).moveBy(0, b).repaint()
                            }
                        }
                    }
                }
            }
            if (d.settings.autofix) {
                if (!d.state.get('fixed')) {
                    d._autoFixY = d.layoutRect().y;
                    if (d._autoFixY < e) {
                        d.fixed(true).layoutRect({
                            y: 0
                        }).repaint();
                        toggleFixedChildPanels(true, e - d._autoFixY)
                    }
                } else {
                    if (d._autoFixY > e) {
                        d.fixed(false).layoutRect({
                            y: d._autoFixY
                        }).repaint();
                        toggleFixedChildPanels(false, d._autoFixY - e)
                    }
                }
            }
        }
        function addRemove(a, b) {
            var i, zIndex = n.zIndex || 0xFFFF,
                topModal;
            if (a) {
                m.push(b)
            } else {
                i = m.length;
                while (i--) {
                    if (m[i] === b) {
                        m.splice(i, 1)
                    }
                }
            }
            if (m.length) {
                for (i = 0; i < m.length; i++) {
                    if (m[i].modal) {
                        zIndex++;
                        topModal = m[i]
                    }
                    m[i].getEl().style.zIndex = zIndex;
                    m[i].zIndex = zIndex;
                    zIndex++
                }
            }
            var c = $('#' + b.classPrefix + 'modal-block', b.getContainerElm())[0];
            if (topModal) {
                $(c).css('z-index', topModal.zIndex - 1)
            } else if (c) {
                c.parentNode.removeChild(c);
                hasModal = false
            }
            n.currentZIndex = zIndex
        }
        var n = f.extend({
            Mixins: [g, h],
            init: function (b) {
                var c = this;
                c._super(b);
                c._eventsRoot = c;
                c.classes.add('floatpanel');
                if (b.autohide) {
                    bindDocumentClickHandler();
                    bindWindowResizeHandler();
                    visiblePanels.push(c)
                }
                if (b.autofix) {
                    bindDocumentScrollHandler();
                    c.on('move', function () {
                        repositionPanel(this)
                    })
                }
                c.on('postrender show', function (e) {
                    if (e.control == c) {
                        var a, prefix = c.classPrefix;
                        if (c.modal && !hasModal) {
                            a = $('#' + prefix + 'modal-block', c.getContainerElm());
                            if (!a[0]) {
                                a = $('<div id="' + prefix + 'modal-block" class="' + prefix + 'reset ' + prefix + 'fade"></div>').appendTo(c.getContainerElm())
                            }
                            k.setTimeout(function () {
                                a.addClass(prefix + 'in');
                                $(c.getEl()).addClass(prefix + 'in')
                            });
                            hasModal = true
                        }
                        addRemove(true, c)
                    }
                });
                c.on('show', function () {
                    c.parents().each(function (a) {
                        if (a.state.get('fixed')) {
                            c.fixed(true);
                            return false
                        }
                    })
                });
                if (b.popover) {
                    c._preBodyHtml = '<div class="' + c.classPrefix + 'arrow"></div>';
                    c.classes.add('popover').add('bottom').add(c.isRtl() ? 'end' : 'start')
                }
                c.aria('label', b.ariaLabel);
                c.aria('labelledby', c._id);
                c.aria('describedby', c.describedBy || c._id + '-none')
            },
            fixed: function (a) {
                var b = this;
                if (b.state.get('fixed') != a) {
                    if (b.state.get('rendered')) {
                        var c = j.getViewPort();
                        if (a) {
                            b.layoutRect().y -= c.y
                        } else {
                            b.layoutRect().y += c.y
                        }
                    }
                    b.classes.toggle('fixed', a);
                    b.state.set('fixed', a)
                }
                return b
            },
            show: function () {
                var a = this,
                    i, state = a._super();
                i = visiblePanels.length;
                while (i--) {
                    if (visiblePanels[i] === a) {
                        break
                    }
                }
                if (i === -1) {
                    visiblePanels.push(a)
                }
                return state
            },
            hide: function () {
                removeVisiblePanel(this);
                addRemove(false, this);
                return this._super()
            },
            hideAll: function () {
                n.hideAll()
            },
            close: function () {
                var a = this;
                if (!a.fire('close').isDefaultPrevented()) {
                    a.remove();
                    addRemove(false, a)
                }
                return a
            },
            remove: function () {
                removeVisiblePanel(this);
                this._super()
            },
            postRender: function () {
                var a = this;
                if (a.settings.bodyRole) {
                    this.getEl('body').setAttribute('role', a.settings.bodyRole)
                }
                return a._super()
            }
        });
        n.hideAll = function () {
            var i = visiblePanels.length;
            while (i--) {
                var a = visiblePanels[i];
                if (a && a.settings.autohide) {
                    a.hide();
                    visiblePanels.splice(i, 1)
                }
            }
        };

        function removeVisiblePanel(a) {
            var i;
            i = visiblePanels.length;
            while (i--) {
                if (visiblePanels[i] === a) {
                    visiblePanels.splice(i, 1)
                }
            }
            i = m.length;
            while (i--) {
                if (m[i] === a) {
                    m.splice(i, 1)
                }
            }
        }
        return n
    });
    define("tinymce/ui/Window", ["tinymce/ui/FloatPanel", "tinymce/ui/Panel", "tinymce/ui/DomUtils", "tinymce/dom/DomQuery", "tinymce/ui/DragHelper", "tinymce/ui/BoxUtils", "tinymce/Env", "tinymce/util/Delay"], function (g, j, k, $, l, m, n, o) {
        "use strict";
        var p = [],
            oldMetaValue = '';

        function toggleFullScreenState(a) {
            var b = 'width=device-width,initial-scale=1.0,user-scalable=0,minimum-scale=1.0,maximum-scale=1.0',
                viewport = $("meta[name=viewport]")[0],
                contentValue;
            if (n.overrideViewPort === false) {
                return
            }
            if (!viewport) {
                viewport = document.createElement('meta');
                viewport.setAttribute('name', 'viewport');
                document.getElementsByTagName('head')[0].appendChild(viewport)
            }
            contentValue = viewport.getAttribute('content');
            if (contentValue && typeof oldMetaValue != 'undefined') {
                oldMetaValue = contentValue
            }
            viewport.setAttribute('content', a ? b : oldMetaValue)
        }
        function toggleBodyFullScreenClasses(a) {
            for (var i = 0; i < p.length; i++) {
                if (p[i]._fullscreen) {
                    return
                }
            }
            $([document.documentElement, document.body]).removeClass(a + 'fullscreen')
        }
        function handleWindowResize() {
            if (!n.desktop) {
                var a = {
                    w: window.innerWidth,
                    h: window.innerHeight
                };
                o.setInterval(function () {
                    var w = window.innerWidth,
                        h = window.innerHeight;
                    if (a.w != w || a.h != h) {
                        a = {
                            w: w,
                            h: h
                        };
                        $(window).trigger('resize')
                    }
                }, 100)
            }
            function reposition() {
                var i, rect = k.getWindowSize(),
                    layoutRect;
                for (i = 0; i < p.length; i++) {
                    layoutRect = p[i].layoutRect();
                    p[i].moveTo(p[i].settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2), p[i].settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2))
                }
            }
            $(window).on('resize', reposition)
        }
        var q = g.extend({
            modal: true,
            Defaults: {
                border: 1,
                layout: 'flex',
                containerCls: 'panel',
                role: 'dialog',
                callbacks: {
                    submit: function () {
                        this.fire('submit', {
                            data: this.toJSON()
                        })
                    },
                    close: function () {
                        this.close()
                    }
                }
            },
            init: function (b) {
                var c = this;
                c._super(b);
                if (c.isRtl()) {
                    c.classes.add('rtl')
                }
                c.classes.add('window');
                c.bodyClasses.add('window-body');
                c.state.set('fixed', true);
                if (b.buttons) {
                    c.statusbar = new j({
                        layout: 'flex',
                        border: '1 0 0 0',
                        spacing: 3,
                        padding: 10,
                        align: 'center',
                        pack: c.isRtl() ? 'start' : 'end',
                        defaults: {
                            type: 'button'
                        },
                        items: b.buttons
                    });
                    c.statusbar.classes.add('foot');
                    c.statusbar.parent(c)
                }
                c.on('click', function (e) {
                    var a = c.classPrefix + 'close';
                    if (k.hasClass(e.target, a) || k.hasClass(e.target.parentNode, a)) {
                        c.close()
                    }
                });
                c.on('cancel', function () {
                    c.close()
                });
                c.aria('describedby', c.describedBy || c._id + '-none');
                c.aria('label', b.title);
                c._fullscreen = false
            },
            recalc: function () {
                var a = this,
                    statusbar = a.statusbar,
                    layoutRect, width, x, needsRecalc;
                if (a._fullscreen) {
                    a.layoutRect(k.getWindowSize());
                    a.layoutRect().contentH = a.layoutRect().innerH
                }
                a._super();
                layoutRect = a.layoutRect();
                if (a.settings.title && !a._fullscreen) {
                    width = layoutRect.headerW;
                    if (width > layoutRect.w) {
                        x = layoutRect.x - Math.max(0, width / 2);
                        a.layoutRect({
                            w: width,
                            x: x
                        });
                        needsRecalc = true
                    }
                }
                if (statusbar) {
                    statusbar.layoutRect({
                        w: a.layoutRect().innerW
                    }).recalc();
                    width = statusbar.layoutRect().minW + layoutRect.deltaW;
                    if (width > layoutRect.w) {
                        x = layoutRect.x - Math.max(0, width - layoutRect.w);
                        a.layoutRect({
                            w: width,
                            x: x
                        });
                        needsRecalc = true
                    }
                }
                if (needsRecalc) {
                    a.recalc()
                }
            },
            initLayoutRect: function () {
                var a = this,
                    layoutRect = a._super(),
                    deltaH = 0,
                    headEl;
                if (a.settings.title && !a._fullscreen) {
                    headEl = a.getEl('head');
                    var b = k.getSize(headEl);
                    layoutRect.headerW = b.width;
                    layoutRect.headerH = b.height;
                    deltaH += layoutRect.headerH
                }
                if (a.statusbar) {
                    deltaH += a.statusbar.layoutRect().h
                }
                layoutRect.deltaH += deltaH;
                layoutRect.minH += deltaH;
                layoutRect.h += deltaH;
                var c = k.getWindowSize();
                layoutRect.x = a.settings.x || Math.max(0, c.w / 2 - layoutRect.w / 2);
                layoutRect.y = a.settings.y || Math.max(0, c.h / 2 - layoutRect.h / 2);
                return layoutRect
            },
            renderHtml: function () {
                var a = this,
                    layout = a._layout,
                    id = a._id,
                    prefix = a.classPrefix;
                var b = a.settings,
                    headerHtml = '',
                    footerHtml = '',
                    html = b.html;
                a.preRender();
                layout.preRender(a);
                if (b.title) {
                    headerHtml = ('<div id="' + id + '-head" class="' + prefix + 'window-head">' + '<div id="' + id + '-title" class="' + prefix + 'title">' + a.encode(b.title) + '</div>' + '<div id="' + id + '-dragh" class="' + prefix + 'dragh"></div>' + '<button type="button" class="' + prefix + 'close" aria-hidden="true">' + '<i class="mce-ico mce-i-remove"></i>' + '</button>' + '</div>')
                }
                if (b.url) {
                    html = '<iframe src="' + b.url + '" tabindex="-1"></iframe>'
                }
                if (typeof html == "undefined") {
                    html = layout.renderHtml(a)
                }
                if (a.statusbar) {
                    footerHtml = a.statusbar.renderHtml()
                }
                return ('<div id="' + id + '" class="' + a.classes + '" hidefocus="1">' + '<div class="' + a.classPrefix + 'reset" role="application">' + headerHtml + '<div id="' + id + '-body" class="' + a.bodyClasses + '">' + html + '</div>' + footerHtml + '</div>' + '</div>')
            },
            fullscreen: function (d) {
                var e = this,
                    documentElement = document.documentElement,
                    slowRendering, prefix = e.classPrefix,
                    layoutRect;
                if (d != e._fullscreen) {
                    $(window).on('resize', function () {
                        var b;
                        if (e._fullscreen) {
                            if (!slowRendering) {
                                b = new Date().getTime();
                                var c = k.getWindowSize();
                                e.moveTo(0, 0).resizeTo(c.w, c.h);
                                if ((new Date().getTime()) - b > 50) {
                                    slowRendering = true
                                }
                            } else {
                                if (!e._timer) {
                                    e._timer = o.setTimeout(function () {
                                        var a = k.getWindowSize();
                                        e.moveTo(0, 0).resizeTo(a.w, a.h);
                                        e._timer = 0
                                    }, 50)
                                }
                            }
                        }
                    });
                    layoutRect = e.layoutRect();
                    e._fullscreen = d;
                    if (!d) {
                        e.borderBox = m.parseBox(e.settings.border);
                        e.getEl('head').style.display = '';
                        layoutRect.deltaH += layoutRect.headerH;
                        $([documentElement, document.body]).removeClass(prefix + 'fullscreen');
                        e.classes.remove('fullscreen');
                        e.moveTo(e._initial.x, e._initial.y).resizeTo(e._initial.w, e._initial.h)
                    } else {
                        e._initial = {
                            x: layoutRect.x,
                            y: layoutRect.y,
                            w: layoutRect.w,
                            h: layoutRect.h
                        };
                        e.borderBox = m.parseBox('0');
                        e.getEl('head').style.display = 'none';
                        layoutRect.deltaH -= layoutRect.headerH + 2;
                        $([documentElement, document.body]).addClass(prefix + 'fullscreen');
                        e.classes.add('fullscreen');
                        var f = k.getWindowSize();
                        e.moveTo(0, 0).resizeTo(f.w, f.h)
                    }
                }
                return e.reflow()
            },
            postRender: function () {
                var a = this,
                    startPos;
                setTimeout(function () {
                    a.classes.add('in');
                    a.fire('open')
                }, 0);
                a._super();
                if (a.statusbar) {
                    a.statusbar.postRender()
                }
                a.focus();
                this.dragHelper = new l(a._id + '-dragh', {
                    start: function () {
                        startPos = {
                            x: a.layoutRect().x,
                            y: a.layoutRect().y
                        }
                    },
                    drag: function (e) {
                        a.moveTo(startPos.x + e.deltaX, startPos.y + e.deltaY)
                    }
                });
                a.on('submit', function (e) {
                    if (!e.isDefaultPrevented()) {
                        a.close()
                    }
                });
                p.push(a);
                toggleFullScreenState(true)
            },
            submit: function () {
                return this.fire('submit', {
                    data: this.toJSON()
                })
            },
            remove: function () {
                var a = this,
                    i;
                a.dragHelper.destroy();
                a._super();
                if (a.statusbar) {
                    this.statusbar.remove()
                }
                i = p.length;
                while (i--) {
                    if (p[i] === a) {
                        p.splice(i, 1)
                    }
                }
                toggleFullScreenState(p.length > 0);
                toggleBodyFullScreenClasses(a.classPrefix)
            },
            getContentWindow: function () {
                var a = this.getEl().getElementsByTagName('iframe')[0];
                return a ? a.contentWindow : null
            }
        });
        handleWindowResize();
        return q
    });
    define("tinymce/ui/MessageBox", ["tinymce/ui/Window"], function (g) {
        "use strict";
        var h = g.extend({
            init: function (a) {
                a = {
                    border: 1,
                    padding: 20,
                    layout: 'flex',
                    pack: "center",
                    align: "center",
                    containerCls: 'panel',
                    autoScroll: true,
                    buttons: {
                        type: "button",
                        text: "Ok",
                        action: "ok"
                    },
                    items: {
                        type: "label",
                        multiline: true,
                        maxWidth: 500,
                        maxHeight: 200
                    }
                };
                this._super(a)
            },
            Statics: {
                OK: 1,
                OK_CANCEL: 2,
                YES_NO: 3,
                YES_NO_CANCEL: 4,
                msgBox: function (d) {
                    var f, callback = d.callback ||
                        function () { };

                    function createButton(a, b, c) {
                        return {
                            type: "button",
                            text: a,
                            subtype: c ? 'primary' : '',
                            onClick: function (e) {
                                e.control.parents()[1].close();
                                callback(b)
                            }
                        }
                    }
                    switch (d.buttons) {
                        case h.OK_CANCEL:
                            f = [createButton('Ok', true, true), createButton('Cancel', false)];
                            break;
                        case h.YES_NO:
                        case h.YES_NO_CANCEL:
                            f = [createButton('Yes', 1, true), createButton('No', 0)];
                            if (d.buttons == h.YES_NO_CANCEL) {
                                f.push(createButton('Cancel', -1))
                            }
                            break;
                        default:
                            f = [createButton('Ok', true, true)];
                            break
                    }
                    return new g({
                        padding: 20,
                        x: d.x,
                        y: d.y,
                        minWidth: 300,
                        minHeight: 100,
                        layout: "flex",
                        pack: "center",
                        align: "center",
                        buttons: f,
                        title: d.title,
                        role: 'alertdialog',
                        items: {
                            type: "label",
                            multiline: true,
                            maxWidth: 500,
                            maxHeight: 200,
                            text: d.text
                        },
                        onPostRender: function () {
                            this.aria('describedby', this.items()[0]._id)
                        },
                        onClose: d.onClose,
                        onCancel: function () {
                            callback(false)
                        }
                    }).renderTo(document.body).reflow()
                },
                alert: function (a, b) {
                    if (typeof a == "string") {
                        a = {
                            text: a
                        }
                    }
                    a.callback = b;
                    return h.msgBox(a)
                },
                confirm: function (a, b) {
                    if (typeof a == "string") {
                        a = {
                            text: a
                        }
                    }
                    a.callback = b;
                    a.buttons = h.OK_CANCEL;
                    return h.msgBox(a)
                }
            }
        });
        return h
    });
    define("tinymce/WindowManager", ["tinymce/ui/Window", "tinymce/ui/MessageBox"], function (h, j) {
        return function (f) {
            var g = this,
                windows = [];

            function getTopMostWindow() {
                if (windows.length) {
                    return windows[windows.length - 1]
                }
            }
            function fireOpenEvent(a) {
                f.fire('OpenWindow', {
                    win: a
                })
            }
            function fireCloseEvent(a) {
                f.fire('CloseWindow', {
                    win: a
                })
            }
            g.windows = windows;
            f.on('remove', function () {
                var i = windows.length;
                while (i--) {
                    windows[i].close()
                }
            });
            g.open = function (c, d) {
                var e;
                f.editorManager.setActive(f);
                c.title = c.title || ' ';
                c.url = c.url || c.file;
                if (c.url) {
                    c.width = parseInt(c.width || 320, 10);
                    c.height = parseInt(c.height || 240, 10)
                }
                if (c.body) {
                    c.items = {
                        defaults: c.defaults,
                        type: c.bodyType || 'form',
                        items: c.body,
                        data: c.data,
                        callbacks: c.commands
                    }
                }
                if (!c.url && !c.buttons) {
                    c.buttons = [{
                        text: 'Cancel',
                        onclick: function () {
                            e.close()
                        }
                    }, {
                        text: 'Ok',
                        subtype: 'primary',
                        onclick: function () {
                            e.find('form')[0].submit()
                        }
                    }]
                }
                e = new h(c);
                windows.push(e);
                e.on('close', function () {
                    var i = windows.length;
                    while (i--) {
                        if (windows[i] === e) {
                            windows.splice(i, 1)
                        }
                    }
                    if (!windows.length) {
                        f.focus()
                    }
                    fireCloseEvent(e)
                });
                if (c.data) {
                    e.on('postRender', function () {
                        this.find('*').each(function (a) {
                            var b = a.name();
                            if (b in c.data) {
                                a.value(c.data[b])
                            }
                        })
                    })
                }
                e.features = c || {};
                e.params = d || {};
                if (windows.length === 1) {
                    f.nodeChanged()
                }
                e = e.renderTo().reflow();
                fireOpenEvent(e);
                return e
            };
            g.alert = function (a, b, c) {
                var d;
                d = j.alert(a, function () {
                    if (b) {
                        b.call(c || this)
                    } else {
                        f.focus()
                    }
                });
                d.on('close', function () {
                    fireCloseEvent(d)
                });
                fireOpenEvent(d)
            };
            g.confirm = function (b, c, d) {
                var e;
                e = j.confirm(b, function (a) {
                    c.call(d || this, a)
                });
                e.on('close', function () {
                    fireCloseEvent(e)
                });
                fireOpenEvent(e)
            };
            g.close = function () {
                if (getTopMostWindow()) {
                    getTopMostWindow().close()
                }
            };
            g.getParams = function () {
                return getTopMostWindow() ? getTopMostWindow().params : null
            };
            g.setParams = function (a) {
                if (getTopMostWindow()) {
                    getTopMostWindow().params = a
                }
            };
            g.getWindows = function () {
                return windows
            }
        }
    });
    define("tinymce/ui/Tooltip", ["tinymce/ui/Control", "tinymce/ui/Movable"], function (b, c) {
        return b.extend({
            Mixins: [c],
            Defaults: {
                classes: 'widget tooltip tooltip-n'
            },
            renderHtml: function () {
                var a = this,
                    prefix = a.classPrefix;
                return ('<div id="' + a._id + '" class="' + a.classes + '" role="presentation">' + '<div class="' + prefix + 'tooltip-arrow"></div>' + '<div class="' + prefix + 'tooltip-inner">' + a.encode(a.state.get('text')) + '</div>' + '</div>')
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:text', function (e) {
                    a.getEl().lastChild.innerHTML = a.encode(e.value)
                });
                return a._super()
            },
            repaint: function () {
                var a = this,
                    style, rect;
                style = a.getEl().style;
                rect = a._layoutRect;
                style.left = rect.x + 'px';
                style.top = rect.y + 'px';
                style.zIndex = 0xFFFF + 0xFFFF
            }
        })
    });
    define("tinymce/ui/Widget", ["tinymce/ui/Control", "tinymce/ui/Tooltip"], function (f, g) {
        "use strict";
        var h;
        var i = f.extend({
            init: function (c) {
                var d = this;
                d._super(c);
                c = d.settings;
                d.canFocus = true;
                if (c.tooltip && i.tooltips !== false) {
                    d.on('mouseenter', function (e) {
                        var a = d.tooltip().moveTo(-0xFFFF);
                        if (e.control == d) {
                            var b = a.text(c.tooltip).show().testMoveRel(d.getEl(), ['bc-tc', 'bc-tl', 'bc-tr']);
                            a.classes.toggle('tooltip-n', b == 'bc-tc');
                            a.classes.toggle('tooltip-nw', b == 'bc-tl');
                            a.classes.toggle('tooltip-ne', b == 'bc-tr');
                            a.moveRel(d.getEl(), b)
                        } else {
                            a.hide()
                        }
                    });
                    d.on('mouseleave mousedown click', function () {
                        d.tooltip().hide()
                    })
                }
                d.aria('label', c.ariaLabel || c.tooltip)
            },
            tooltip: function () {
                if (!h) {
                    h = new g({
                        type: 'tooltip'
                    });
                    h.renderTo()
                }
                return h
            },
            postRender: function () {
                var a = this,
                    settings = a.settings;
                a._super();
                if (!a.parent() && (settings.width || settings.height)) {
                    a.initLayoutRect();
                    a.repaint()
                }
                if (settings.autofocus) {
                    a.focus()
                }
            },
            bindStates: function () {
                var b = this;

                function disable(a) {
                    b.aria('disabled', a);
                    b.classes.toggle('disabled', a)
                }
                function active(a) {
                    b.aria('pressed', a);
                    b.classes.toggle('active', a)
                }
                b.state.on('change:disabled', function (e) {
                    disable(e.value)
                });
                b.state.on('change:active', function (e) {
                    active(e.value)
                });
                if (b.state.get('disabled')) {
                    disable(true)
                }
                if (b.state.get('active')) {
                    active(true)
                }
                return b._super()
            },
            remove: function () {
                this._super();
                if (h) {
                    h.remove();
                    h = null
                }
            }
        });
        return i
    });
    define("tinymce/ui/Progress", ["tinymce/ui/Widget"], function (d) {
        "use strict";
        return d.extend({
            Defaults: {
                value: 0
            },
            init: function (b) {
                var c = this;
                c._super(b);
                c.classes.add('progress');
                if (!c.settings.filter) {
                    c.settings.filter = function (a) {
                        return Math.round(a)
                    }
                }
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    prefix = this.classPrefix;
                return ('<div id="' + id + '" class="' + a.classes + '">' + '<div class="' + prefix + 'bar-container">' + '<div class="' + prefix + 'bar"></div>' + '</div>' + '<div class="' + prefix + 'text">0%</div>' + '</div>')
            },
            postRender: function () {
                var a = this;
                a._super();
                a.value(a.settings.value);
                return a
            },
            bindStates: function () {
                var b = this;

                function setValue(a) {
                    a = b.settings.filter(a);
                    b.getEl().lastChild.innerHTML = a + '%';
                    b.getEl().firstChild.firstChild.style.width = a + '%'
                }
                b.state.on('change:value', function (e) {
                    setValue(e.value)
                });
                setValue(b.state.get('value'));
                return b._super()
            }
        })
    });
    define("tinymce/ui/Notification", ["tinymce/ui/Control", "tinymce/ui/Movable", "tinymce/ui/Progress", "tinymce/util/Delay"], function (c, d, f, g) {
        return c.extend({
            Mixins: [d],
            Defaults: {
                classes: 'widget notification'
            },
            init: function (a) {
                var b = this;
                b._super(a);
                if (a.text) {
                    b.text(a.text)
                }
                if (a.icon) {
                    b.icon = a.icon
                }
                if (a.color) {
                    b.color = a.color
                }
                if (a.type) {
                    b.classes.add('notification-' + a.type)
                }
                if (a.timeout && (a.timeout < 0 || a.timeout > 0) && !a.closeButton) {
                    b.closeButton = false
                } else {
                    b.classes.add('has-close');
                    b.closeButton = true
                }
                if (a.progressBar) {
                    b.progressBar = new f()
                }
                b.on('click', function (e) {
                    if (e.target.className.indexOf(b.classPrefix + 'close') != -1) {
                        b.close()
                    }
                })
            },
            renderHtml: function () {
                var a = this,
                    prefix = a.classPrefix,
                    icon = '',
                    closeButton = '',
                    progressBar = '',
                    notificationStyle = '';
                if (a.icon) {
                    icon = '<i class="' + sele.icon + '""></i>'
                }
                if (a.color) {
                    notificationStyle = ' style="background-color: ' + a.color + '"'
                }
                if (a.closeButton) {
                    closeButton = '<button type="button" class="' + prefix + 'close" aria-hidden="true">×</button>'
                }
                if (a.progressBar) {
                    progressBar = a.progressBar.renderHtml()
                }
                return ('<div id="' + a._id + '" class="' + a.classes + '"' + notificationStyle + ' role="presentation">' + icon + '<div class="' + prefix + 'notification-inner">' + a.state.get('text') + '</div>' + progressBar + closeButton + '</div>')
            },
            postRender: function () {
                var a = this;
                g.setTimeout(function () {
                    a.$el.addClass(a.classPrefix + 'in')
                });
                return a._super()
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:text', function (e) {
                    a.getEl().childNodes[1].innerHTML = e.value
                });
                if (a.progressBar) {
                    a.progressBar.bindStates()
                }
                return a._super()
            },
            close: function () {
                var a = this;
                if (!a.fire('close').isDefaultPrevented()) {
                    a.remove()
                }
                return a
            },
            repaint: function () {
                var a = this,
                    style, rect;
                style = a.getEl().style;
                rect = a._layoutRect;
                style.left = rect.x + 'px';
                style.top = rect.y + 'px';
                style.zIndex = 0xFFFF + 0xFFFF
            }
        })
    });
    define("tinymce/NotificationManager", ["tinymce/ui/Notification", "tinymce/util/Delay"], function (e, f) {
        return function (c) {
            var d = this,
                notifications = [];

            function getLastNotification() {
                if (notifications.length) {
                    return notifications[notifications.length - 1]
                }
            }
            d.notifications = notifications;

            function resizeWindowEvent() {
                f.requestAnimationFrame(function () {
                    prePositionNotifications();
                    positionNotifications()
                })
            }
            function prePositionNotifications() {
                for (var i = 0; i < notifications.length; i++) {
                    notifications[i].moveTo(0, 0)
                }
            }
            function positionNotifications() {
                if (notifications.length > 0) {
                    var a = notifications.slice(0, 1)[0];
                    var b = c.inline ? c.getElement() : c.getContentAreaContainer();
                    a.moveRel(b, 'tc-tc');
                    if (notifications.length > 1) {
                        for (var i = 1; i < notifications.length; i++) {
                            notifications[i].moveRel(notifications[i - 1].getEl(), 'bc-tc')
                        }
                    }
                }
            }
            c.on('remove', function () {
                var i = notifications.length;
                while (i--) {
                    notifications[i].close()
                }
            });
            c.on('ResizeEditor', positionNotifications);
            c.on('ResizeWindow', resizeWindowEvent);
            d.open = function (a) {
                var b;
                c.editorManager.setActive(c);
                b = new e(a);
                notifications.push(b);
                if (a.timeout > 0) {
                    b.timer = setTimeout(function () {
                        b.close()
                    }, a.timeout)
                }
                b.on('close', function () {
                    var i = notifications.length;
                    if (b.timer) {
                        c.getWin().clearTimeout(b.timer)
                    }
                    while (i--) {
                        if (notifications[i] === b) {
                            notifications.splice(i, 1)
                        }
                    }
                    positionNotifications()
                });
                b.renderTo();
                positionNotifications();
                return b
            };
            d.close = function () {
                if (getLastNotification()) {
                    getLastNotification().close()
                }
            };
            d.getNotifications = function () {
                return notifications
            };
            c.on('SkinLoaded', function () {
                var a = c.settings.service_message;
                if (a) {
                    c.notificationManager.open({
                        text: a,
                        type: 'warning',
                        timeout: 0,
                        icon: ''
                    })
                }
            })
        }
    });
    define("tinymce/dom/NodePath", ["tinymce/dom/DOMUtils"], function (e) {
        function create(a, b, c) {
            var d = [];
            for (; b && b != a; b = b.parentNode) {
                d.push(e.nodeIndex(b, c))
            }
            return d
        }
        function resolve(a, b) {
            var i, node, children;
            for (node = a, i = b.length - 1; i >= 0; i--) {
                children = node.childNodes;
                if (b[i] > children.length - 1) {
                    return null
                }
                node = children[b[i]]
            }
            return node
        }
        return {
            create: create,
            resolve: resolve
        }
    });
    define("tinymce/util/Quirks", ["tinymce/util/VK", "tinymce/dom/RangeUtils", "tinymce/dom/TreeWalker", "tinymce/dom/NodePath", "tinymce/html/Node", "tinymce/html/Entities", "tinymce/Env", "tinymce/util/Tools", "tinymce/util/Delay", "tinymce/caret/CaretContainer", "tinymce/caret/CaretPosition", "tinymce/caret/CaretWalker"], function (q, r, s, t, u, v, w, z, A, B, C, D) {
        return function (k) {
            var l = z.each,
                $ = k.$;
            var m = q.BACKSPACE,
                DELETE = q.DELETE,
                dom = k.dom,
                selection = k.selection,
                settings = k.settings,
                parser = k.parser,
                serializer = k.serializer;
            var n = w.gecko,
                isIE = w.ie,
                isWebKit = w.webkit;
            var o = 'data:text/mce-internal,';
            var p = isIE ? 'Text' : 'URL';

            function setEditorCommandState(a, b) {
                try {
                    k.getDoc().execCommand(a, false, b)
                } catch (ex) { }
            }
            function getDocumentMode() {
                var a = k.getDoc().documentMode;
                return a ? a : 6
            }
            function isDefaultPrevented(e) {
                return e.isDefaultPrevented()
            }
            function setMceInternalContent(e) {
                var a, internalContent;
                if (e.dataTransfer) {
                    if (k.selection.isCollapsed() && e.target.tagName == 'IMG') {
                        selection.select(e.target)
                    }
                    a = k.selection.getContent();
                    if (a.length > 0) {
                        internalContent = o + escape(k.id) + ',' + escape(a);
                        e.dataTransfer.setData(p, internalContent)
                    }
                }
            }
            function getMceInternalContent(e) {
                var a;
                if (e.dataTransfer) {
                    a = e.dataTransfer.getData(p);
                    if (a && a.indexOf(o) >= 0) {
                        a = a.substr(o.length).split(',');
                        return {
                            id: unescape(a[0]),
                            html: unescape(a[1])
                        }
                    }
                }
                return null
            }
            function insertClipboardContents(a) {
                if (k.queryCommandSupported('mceInsertClipboardContent')) {
                    k.execCommand('mceInsertClipboardContent', false, {
                        content: a
                    })
                } else {
                    k.execCommand('mceInsertContent', false, a)
                }
            }
            function cleanupStylesWhenDeleting() {
                var h = k.getDoc(),
                    dom = k.dom,
                    selection = k.selection;
                var i = window.MutationObserver,
                    olderWebKit, dragStartRng;
                if (!i) {
                    olderWebKit = true;
                    i = function () {
                        var b = [],
                            target;

                        function nodeInsert(e) {
                            var a = e.relatedNode || e.target;
                            b.push({
                                target: a,
                                addedNodes: [a]
                            })
                        }
                        function attrModified(e) {
                            var a = e.relatedNode || e.target;
                            b.push({
                                target: a,
                                attributeName: e.attrName
                            })
                        }
                        this.observe = function (a) {
                            target = a;
                            target.addEventListener('DOMSubtreeModified', nodeInsert, false);
                            target.addEventListener('DOMNodeInsertedIntoDocument', nodeInsert, false);
                            target.addEventListener('DOMNodeInserted', nodeInsert, false);
                            target.addEventListener('DOMAttrModified', attrModified, false)
                        };
                        this.disconnect = function () {
                            target.removeEventListener('DOMSubtreeModified', nodeInsert, false);
                            target.removeEventListener('DOMNodeInsertedIntoDocument', nodeInsert, false);
                            target.removeEventListener('DOMNodeInserted', nodeInsert, false);
                            target.removeEventListener('DOMAttrModified', attrModified, false)
                        };
                        this.takeRecords = function () {
                            return b
                        }
                    }
                }
                function isTrailingBr(a) {
                    var b = dom.schema.getBlockElements(),
                        rootNode = k.getBody();
                    if (a.nodeName != 'BR') {
                        return false
                    }
                    for (; a != rootNode && !b[a.nodeName]; a = a.parentNode) {
                        if (a.nextSibling) {
                            return false
                        }
                    }
                    return true
                }
                function isSiblingsIgnoreWhiteSpace(a, b) {
                    var c;
                    for (c = a.nextSibling; c && c != b; c = c.nextSibling) {
                        if (c.nodeType == 3 && $.trim(c.data).length === 0) {
                            continue
                        }
                        if (c !== b) {
                            return false
                        }
                    }
                    return c === b
                }
                function findCaretNode(a, b, c) {
                    var d, current, nonEmptyElements;
                    nonEmptyElements = dom.schema.getNonEmptyElements();
                    d = new s(c || a, a);
                    while ((current = d[b ? 'next' : 'prev']())) {
                        if (nonEmptyElements[current.nodeName] && !isTrailingBr(current)) {
                            return current
                        }
                        if (current.nodeType == 3 && current.data.length > 0) {
                            return current
                        }
                    }
                }
                function deleteRangeBetweenTextBlocks(a) {
                    var b, endBlock, caretNodeBefore, caretNodeAfter, textBlockElements;
                    if (a.collapsed) {
                        return
                    }
                    b = dom.getParent(r.getNode(a.startContainer, a.startOffset), dom.isBlock);
                    endBlock = dom.getParent(r.getNode(a.endContainer, a.endOffset), dom.isBlock);
                    textBlockElements = k.schema.getTextBlockElements();
                    if (b == endBlock) {
                        return
                    }
                    if (!textBlockElements[b.nodeName] || !textBlockElements[endBlock.nodeName]) {
                        return
                    }
                    if (dom.getContentEditable(b) === "false" || dom.getContentEditable(endBlock) === "false") {
                        return
                    }
                    a.deleteContents();
                    caretNodeBefore = findCaretNode(b, false);
                    caretNodeAfter = findCaretNode(endBlock, true);
                    if (!dom.isEmpty(endBlock)) {
                        $(b).append(endBlock.childNodes)
                    }
                    $(endBlock).remove();
                    if (caretNodeBefore) {
                        if (caretNodeBefore.nodeType == 1) {
                            if (caretNodeBefore.nodeName == "BR") {
                                a.setStartBefore(caretNodeBefore);
                                a.setEndBefore(caretNodeBefore)
                            } else {
                                a.setStartAfter(caretNodeBefore);
                                a.setEndAfter(caretNodeBefore)
                            }
                        } else {
                            a.setStart(caretNodeBefore, caretNodeBefore.data.length);
                            a.setEnd(caretNodeBefore, caretNodeBefore.data.length)
                        }
                    } else if (caretNodeAfter) {
                        if (caretNodeAfter.nodeType == 1) {
                            a.setStartBefore(caretNodeAfter);
                            a.setEndBefore(caretNodeAfter)
                        } else {
                            a.setStart(caretNodeAfter, 0);
                            a.setEnd(caretNodeAfter, 0)
                        }
                    }
                    selection.setRng(a);
                    return true
                }
                function expandBetweenBlocks(a, b) {
                    var c, targetCaretNode, textBlock, targetTextBlock, container, offset;
                    if (!a.collapsed) {
                        return a
                    }
                    container = a.startContainer;
                    offset = a.startOffset;
                    if (container.nodeType == 3) {
                        if (b) {
                            if (offset < container.data.length) {
                                return a
                            }
                        } else {
                            if (offset > 0) {
                                return a
                            }
                        }
                    }
                    c = r.getNode(a.startContainer, a.startOffset);
                    textBlock = dom.getParent(c, dom.isBlock);
                    targetCaretNode = findCaretNode(k.getBody(), b, c);
                    targetTextBlock = dom.getParent(targetCaretNode, dom.isBlock);
                    if (!c || !targetCaretNode) {
                        return a
                    }
                    if (targetTextBlock && textBlock != targetTextBlock) {
                        if (!b) {
                            if (!isSiblingsIgnoreWhiteSpace(targetTextBlock, textBlock)) {
                                return a
                            }
                            if (targetCaretNode.nodeType == 1) {
                                if (targetCaretNode.nodeName == "BR") {
                                    a.setStartBefore(targetCaretNode)
                                } else {
                                    a.setStartAfter(targetCaretNode)
                                }
                            } else {
                                a.setStart(targetCaretNode, targetCaretNode.data.length)
                            }
                            if (c.nodeType == 1) {
                                a.setEnd(c, 0)
                            } else {
                                a.setEndBefore(c)
                            }
                        } else {
                            if (!isSiblingsIgnoreWhiteSpace(textBlock, targetTextBlock)) {
                                return a
                            }
                            if (c.nodeType == 1) {
                                if (c.nodeName == "BR") {
                                    a.setStartBefore(c)
                                } else {
                                    a.setStartAfter(c)
                                }
                            } else {
                                a.setStart(c, c.data.length)
                            }
                            if (targetCaretNode.nodeType == 1) {
                                a.setEnd(targetCaretNode, 0)
                            } else {
                                a.setEndBefore(targetCaretNode)
                            }
                        }
                    }
                    return a
                }
                function handleTextBlockMergeDelete(a) {
                    var b = selection.getRng();
                    b = expandBetweenBlocks(b, a);
                    if (deleteRangeBetweenTextBlocks(b)) {
                        return true
                    }
                }
                function handleLastBlockCharacterDelete(e, f) {
                    var g, blockElm, newBlockElm, clonedBlockElm, sibling, container, offset, br, currentFormatNodes;

                    function cloneTextBlockWithFormats(c, d) {
                        currentFormatNodes = $(d).parents().filter(function (a, b) {
                            return !!k.schema.getTextInlineElements()[b.nodeName]
                        });
                        newBlockElm = c.cloneNode(false);
                        currentFormatNodes = z.map(currentFormatNodes, function (a) {
                            a = a.cloneNode(false);
                            if (newBlockElm.hasChildNodes()) {
                                a.appendChild(newBlockElm.firstChild);
                                newBlockElm.appendChild(a)
                            } else {
                                newBlockElm.appendChild(a)
                            }
                            newBlockElm.appendChild(a);
                            return a
                        });
                        if (currentFormatNodes.length) {
                            br = dom.create('br');
                            currentFormatNodes[0].appendChild(br);
                            dom.replace(newBlockElm, c);
                            f.setStartBefore(br);
                            f.setEndBefore(br);
                            k.selection.setRng(f);
                            return br
                        }
                        return null
                    }
                    function isTextBlock(a) {
                        return a && k.schema.getTextBlockElements()[a.tagName]
                    }
                    if (!f.collapsed) {
                        return
                    }
                    container = f.startContainer;
                    offset = f.startOffset;
                    blockElm = dom.getParent(container, dom.isBlock);
                    if (!isTextBlock(blockElm)) {
                        return
                    }
                    if (container.nodeType == 1) {
                        container = container.childNodes[offset];
                        if (container && container.tagName != 'BR') {
                            return
                        }
                        if (e) {
                            sibling = blockElm.nextSibling
                        } else {
                            sibling = blockElm.previousSibling
                        }
                        if (dom.isEmpty(blockElm) && isTextBlock(sibling) && dom.isEmpty(sibling)) {
                            if (cloneTextBlockWithFormats(blockElm, container)) {
                                dom.remove(sibling);
                                return true
                            }
                        }
                    } else if (container.nodeType == 3) {
                        g = t.create(blockElm, container);
                        clonedBlockElm = blockElm.cloneNode(true);
                        container = t.resolve(clonedBlockElm, g);
                        if (e) {
                            if (offset >= container.data.length) {
                                return
                            }
                            container.deleteData(offset, 1)
                        } else {
                            if (offset <= 0) {
                                return
                            }
                            container.deleteData(offset - 1, 1)
                        }
                        if (dom.isEmpty(clonedBlockElm)) {
                            return cloneTextBlockWithFormats(blockElm, container)
                        }
                    }
                }
                function customDelete(e) {
                    var f, rng, caretElement;
                    if (handleTextBlockMergeDelete(e)) {
                        return
                    }
                    z.each(k.getBody().getElementsByTagName('*'), function (a) {
                        if (a.tagName == 'SPAN') {
                            a.setAttribute('mce-data-marked', 1)
                        }
                        if (!a.hasAttribute('data-mce-style') && a.hasAttribute('style')) {
                            k.dom.setAttrib(a, 'style', k.dom.getAttrib(a, 'style'))
                        }
                    });
                    f = new i(function () { });
                    f.observe(k.getDoc(), {
                        childList: true,
                        attributes: true,
                        subtree: true,
                        attributeFilter: ['style']
                    });
                    k.getDoc().execCommand(e ? 'ForwardDelete' : 'Delete', false, null);
                    rng = k.selection.getRng();
                    caretElement = rng.startContainer.parentNode;
                    z.each(f.takeRecords(), function (c) {
                        if (!dom.isChildOf(c.target, k.getBody())) {
                            return
                        }
                        if (c.attributeName == "style") {
                            var d = c.target.getAttribute('data-mce-style');
                            if (d) {
                                c.target.setAttribute("style", d)
                            } else {
                                c.target.removeAttribute("style")
                            }
                        }
                        z.each(c.addedNodes, function (a) {
                            if (a.nodeName == "SPAN" && !a.getAttribute('mce-data-marked')) {
                                var b, container;
                                if (a == caretElement) {
                                    b = rng.startOffset;
                                    container = a.firstChild
                                }
                                dom.remove(a, true);
                                if (container) {
                                    rng.setStart(container, b);
                                    rng.setEnd(container, b);
                                    k.selection.setRng(rng)
                                }
                            }
                        })
                    });
                    f.disconnect();
                    z.each(k.dom.select('span[mce-data-marked]'), function (a) {
                        a.removeAttribute('mce-data-marked')
                    })
                }
                k.on('keydown', function (e) {
                    var a = e.keyCode == DELETE,
                        isMetaOrCtrl = e.ctrlKey || e.metaKey;
                    if (!isDefaultPrevented(e) && (a || e.keyCode == m)) {
                        var b = k.selection.getRng(),
                            container = b.startContainer,
                            offset = b.startOffset;
                        if (a && e.shiftKey) {
                            return
                        }
                        if (handleLastBlockCharacterDelete(a, b)) {
                            e.preventDefault();
                            return
                        }
                        if (!isMetaOrCtrl && b.collapsed && container.nodeType == 3) {
                            if (a ? offset < container.data.length : offset > 0) {
                                return
                            }
                        }
                        e.preventDefault();
                        if (isMetaOrCtrl) {
                            k.selection.getSel().modify("extend", a ? "forward" : "backward", e.metaKey ? "lineboundary" : "word")
                        }
                        customDelete(a)
                    }
                });
                k.on('keypress', function (e) {
                    if (!isDefaultPrevented(e) && !selection.isCollapsed() && e.charCode > 31 && !q.metaKeyPressed(e)) {
                        var c, currentFormatNodes, fragmentNode, blockParent, caretNode, charText;
                        c = k.selection.getRng();
                        charText = String.fromCharCode(e.charCode);
                        e.preventDefault();
                        currentFormatNodes = $(c.startContainer).parents().filter(function (a, b) {
                            return !!k.schema.getTextInlineElements()[b.nodeName]
                        });
                        customDelete(true);
                        currentFormatNodes = currentFormatNodes.filter(function (a, b) {
                            return !$.contains(k.getBody(), b)
                        });
                        if (currentFormatNodes.length) {
                            fragmentNode = dom.createFragment();
                            currentFormatNodes.each(function (a, b) {
                                b = b.cloneNode(false);
                                if (fragmentNode.hasChildNodes()) {
                                    b.appendChild(fragmentNode.firstChild);
                                    fragmentNode.appendChild(b)
                                } else {
                                    caretNode = b;
                                    fragmentNode.appendChild(b)
                                }
                                fragmentNode.appendChild(b)
                            });
                            caretNode.appendChild(k.getDoc().createTextNode(charText));
                            blockParent = dom.getParent(c.startContainer, dom.isBlock);
                            if (dom.isEmpty(blockParent)) {
                                $(blockParent).empty().append(fragmentNode)
                            } else {
                                c.insertNode(fragmentNode)
                            }
                            c.setStart(caretNode.firstChild, 1);
                            c.setEnd(caretNode.firstChild, 1);
                            k.selection.setRng(c)
                        } else {
                            k.selection.setContent(charText)
                        }
                    }
                });
                k.addCommand('Delete', function () {
                    customDelete()
                });
                k.addCommand('ForwardDelete', function () {
                    customDelete(true)
                });
                if (olderWebKit) {
                    return
                }
                k.on('dragstart', function (e) {
                    dragStartRng = selection.getRng();
                    setMceInternalContent(e)
                });
                k.on('drop', function (e) {
                    if (!isDefaultPrevented(e)) {
                        var b = getMceInternalContent(e);
                        if (b) {
                            e.preventDefault();
                            A.setEditorTimeout(k, function () {
                                var a = r.getCaretRangeFromPoint(e.x, e.y, h);
                                if (dragStartRng) {
                                    selection.setRng(dragStartRng);
                                    dragStartRng = null
                                }
                                customDelete();
                                selection.setRng(a);
                                insertClipboardContents(b.html)
                            })
                        }
                    }
                });
                k.on('cut', function (e) {
                    if (!isDefaultPrevented(e) && e.clipboardData && !k.selection.isCollapsed()) {
                        e.preventDefault();
                        e.clipboardData.clearData();
                        e.clipboardData.setData('text/html', k.selection.getContent());
                        e.clipboardData.setData('text/plain', k.selection.getContent({
                            format: 'text'
                        }));
                        A.setEditorTimeout(k, function () {
                            customDelete(true)
                        })
                    }
                })
            }
            function emptyEditorWhenDeleting() {
                function serializeRng(a) {
                    var b = dom.create("body");
                    var c = a.cloneContents();
                    b.appendChild(c);
                    return selection.serializer.serialize(b, {
                        format: 'html'
                    })
                }
                function allContentsSelected(a) {
                    if (!a.setStart) {
                        if (a.item) {
                            return false
                        }
                        var b = a.duplicate();
                        b.moveToElementText(k.getBody());
                        return r.compareRanges(a, b)
                    }
                    var c = serializeRng(a);
                    var d = dom.createRng();
                    d.selectNode(k.getBody());
                    var e = serializeRng(d);
                    return c === e
                }
                k.on('keydown', function (e) {
                    var a = e.keyCode,
                        isCollapsed, body;
                    if (!isDefaultPrevented(e) && (a == DELETE || a == m)) {
                        isCollapsed = k.selection.isCollapsed();
                        body = k.getBody();
                        if (isCollapsed && !dom.isEmpty(body)) {
                            return
                        }
                        if (!isCollapsed && !allContentsSelected(k.selection.getRng())) {
                            return
                        }
                        e.preventDefault();
                        k.setContent('');
                        if (body.firstChild && dom.isBlock(body.firstChild)) {
                            k.selection.setCursorLocation(body.firstChild, 0)
                        } else {
                            k.selection.setCursorLocation(body, 0)
                        }
                        k.nodeChanged()
                    }
                })
            }
            function selectAll() {
                k.shortcuts.add('meta+a', null, 'SelectAll')
            }
            function inputMethodFocus() {
                if (!k.settings.content_editable) {
                    dom.bind(k.getDoc(), 'mousedown mouseup', function (e) {
                        var a;
                        if (e.target == k.getDoc().documentElement) {
                            a = selection.getRng();
                            k.getBody().focus();
                            if (e.type == 'mousedown') {
                                if (B.isCaretContainer(a.startContainer)) {
                                    return
                                }
                                selection.placeCaretAt(e.clientX, e.clientY)
                            } else {
                                selection.setRng(a)
                            }
                        }
                    })
                }
            }
            function removeHrOnBackspace() {
                k.on('keydown', function (e) {
                    if (!isDefaultPrevented(e) && e.keyCode === m) {
                        if (!k.getBody().getElementsByTagName('hr').length) {
                            return
                        }
                        if (selection.isCollapsed() && selection.getRng(true).startOffset === 0) {
                            var a = selection.getNode();
                            var b = a.previousSibling;
                            if (a.nodeName == 'HR') {
                                dom.remove(a);
                                e.preventDefault();
                                return
                            }
                            if (b && b.nodeName && b.nodeName.toLowerCase() === "hr") {
                                dom.remove(b);
                                e.preventDefault()
                            }
                        }
                    }
                })
            }
            function focusBody() {
                if (!window.Range.prototype.getClientRects) {
                    k.on('mousedown', function (e) {
                        if (!isDefaultPrevented(e) && e.target.nodeName === "HTML") {
                            var a = k.getBody();
                            a.blur();
                            A.setEditorTimeout(k, function () {
                                a.focus()
                            })
                        }
                    })
                }
            }
            function selectControlElements() {
                k.on('click', function (e) {
                    var a = e.target;
                    if (/^(IMG|HR)$/.test(a.nodeName) && dom.getContentEditableParent(a) !== "false") {
                        e.preventDefault();
                        try {
                            selection.getSel().setBaseAndExtent(a, 0, a, 1);
                        } catch (e) {
                            selection.getSel().setBaseAndExtent(a, 0, a, 0);
                        }

                        k.nodeChanged()
                    }
                    if (a.nodeName == 'A' && dom.hasClass(a, 'mce-item-anchor')) {
                        e.preventDefault();
                        selection.select(a)
                    }
                })
            }
            function removeStylesWhenDeletingAcrossBlockElements() {
                function getAttributeApplyFunction() {
                    var c = dom.getAttribs(selection.getStart().cloneNode(false));
                    return function () {
                        var b = selection.getStart();
                        if (b !== k.getBody()) {
                            dom.setAttrib(b, "style", null);
                            l(c, function (a) {
                                b.setAttributeNode(a.cloneNode(true))
                            })
                        }
                    }
                }
                function isSelectionAcrossElements() {
                    return !selection.isCollapsed() && dom.getParent(selection.getStart(), dom.isBlock) != dom.getParent(selection.getEnd(), dom.isBlock)
                }
                k.on('keypress', function (e) {
                    var a;
                    if (!isDefaultPrevented(e) && (e.keyCode == 8 || e.keyCode == 46) && isSelectionAcrossElements()) {
                        a = getAttributeApplyFunction();
                        k.getDoc().execCommand('delete', false, null);
                        a();
                        e.preventDefault();
                        return false
                    }
                });
                dom.bind(k.getDoc(), 'cut', function (e) {
                    var a;
                    if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
                        a = getAttributeApplyFunction();
                        A.setEditorTimeout(k, function () {
                            a()
                        })
                    }
                })
            }
            function ensureBodyHasRoleApplication() {
                document.body.setAttribute("role", "application")
            }
            function disableBackspaceIntoATable() {
                k.on('keydown', function (e) {
                    if (!isDefaultPrevented(e) && e.keyCode === m) {
                        if (selection.isCollapsed() && selection.getRng(true).startOffset === 0) {
                            var a = selection.getNode().previousSibling;
                            if (a && a.nodeName && a.nodeName.toLowerCase() === "table") {
                                e.preventDefault();
                                return false
                            }
                        }
                    }
                })
            }
            function addNewLinesBeforeBrInPre() {
                if (getDocumentMode() > 7) {
                    return
                }
                setEditorCommandState('RespectVisibilityInDesign', true);
                k.contentStyles.push('.mceHideBrInPre pre br {display: none}');
                dom.addClass(k.getBody(), 'mceHideBrInPre');
                parser.addNodeFilter('pre', function (a) {
                    var i = a.length,
                        brNodes, j, brElm, sibling;
                    while (i--) {
                        brNodes = a[i].getAll('br');
                        j = brNodes.length;
                        while (j--) {
                            brElm = brNodes[j];
                            sibling = brElm.prev;
                            if (sibling && sibling.type === 3 && sibling.value.charAt(sibling.value - 1) != '\n') {
                                sibling.value += '\n'
                            } else {
                                brElm.parent.insert(new u('#text', 3), brElm, true).value = '\n'
                            }
                        }
                    }
                });
                serializer.addNodeFilter('pre', function (a) {
                    var i = a.length,
                        brNodes, j, brElm, sibling;
                    while (i--) {
                        brNodes = a[i].getAll('br');
                        j = brNodes.length;
                        while (j--) {
                            brElm = brNodes[j];
                            sibling = brElm.prev;
                            if (sibling && sibling.type == 3) {
                                sibling.value = sibling.value.replace(/\r?\n$/, '')
                            }
                        }
                    }
                })
            }
            function removePreSerializedStylesWhenSelectingControls() {
                dom.bind(k.getBody(), 'mouseup', function () {
                    var a, node = selection.getNode();
                    if (node.nodeName == 'IMG') {
                        if ((a = dom.getStyle(node, 'width'))) {
                            dom.setAttrib(node, 'width', a.replace(/[^0-9%]+/g, ''));
                            dom.setStyle(node, 'width', '')
                        }
                        if ((a = dom.getStyle(node, 'height'))) {
                            dom.setAttrib(node, 'height', a.replace(/[^0-9%]+/g, ''));
                            dom.setStyle(node, 'height', '')
                        }
                    }
                })
            }
            function removeBlockQuoteOnBackSpace() {
                k.on('keydown', function (e) {
                    var a, container, offset, root, parent;
                    if (isDefaultPrevented(e) || e.keyCode != q.BACKSPACE) {
                        return
                    }
                    a = selection.getRng();
                    container = a.startContainer;
                    offset = a.startOffset;
                    root = dom.getRoot();
                    parent = container;
                    if (!a.collapsed || offset !== 0) {
                        return
                    }
                    while (parent && parent.parentNode && parent.parentNode.firstChild == parent && parent.parentNode != root) {
                        parent = parent.parentNode
                    }
                    if (parent.tagName === 'BLOCKQUOTE') {
                        k.formatter.toggle('blockquote', null, parent);
                        a = dom.createRng();
                        a.setStart(container, 0);
                        a.setEnd(container, 0);
                        selection.setRng(a)
                    }
                })
            }
            function setGeckoEditingOptions() {
                function setOpts() {
                    refreshContentEditable();
                    setEditorCommandState("StyleWithCSS", false);
                    setEditorCommandState("enableInlineTableEditing", false);
                    if (!settings.object_resizing) {
                        setEditorCommandState("enableObjectResizing", false)
                    }
                }
                if (!settings.readonly) {
                    k.on('BeforeExecCommand MouseDown', setOpts)
                }
            }
            function addBrAfterLastLinks() {
                function fixLinks() {
                    l(dom.select('a'), function (a) {
                        var b = a.parentNode,
                            root = dom.getRoot();
                        if (b.lastChild === a) {
                            while (b && !dom.isBlock(b)) {
                                if (b.parentNode.lastChild !== b || b === root) {
                                    return
                                }
                                b = b.parentNode
                            }
                            dom.add(b, 'br', {
                                'data-mce-bogus': 1
                            })
                        }
                    })
                }
                k.on('SetContent ExecCommand', function (e) {
                    if (e.type == "setcontent" || e.command === 'mceInsertLink') {
                        fixLinks()
                    }
                })
            }
            function setDefaultBlockType() {
                if (settings.forced_root_block) {
                    k.on('init', function () {
                        setEditorCommandState('DefaultParagraphSeparator', settings.forced_root_block)
                    })
                }
            }
            function deleteControlItemOnBackSpace() {
                k.on('keydown', function (e) {
                    var a;
                    if (!isDefaultPrevented(e) && e.keyCode == m) {
                        a = k.getDoc().selection.createRange();
                        if (a && a.item) {
                            e.preventDefault();
                            k.undoManager.beforeChange();
                            dom.remove(a.item(0));
                            k.undoManager.add()
                        }
                    }
                })
            }
            function renderEmptyBlocksFix() {
                var b;
                if (getDocumentMode() >= 10) {
                    b = '';
                    l('p div h1 h2 h3 h4 h5 h6'.split(' '), function (a, i) {
                        b += (i > 0 ? ',' : '') + a + ':empty'
                    });
                    k.contentStyles.push(b + '{padding-right: 1px !important}')
                }
            }
            function keepNoScriptContents() {
                if (getDocumentMode() < 9) {
                    parser.addNodeFilter('noscript', function (a) {
                        var i = a.length,
                            node, textNode;
                        while (i--) {
                            node = a[i];
                            textNode = node.firstChild;
                            if (textNode) {
                                node.attr('data-mce-innertext', textNode.value)
                            }
                        }
                    });
                    serializer.addNodeFilter('noscript', function (a) {
                        var i = a.length,
                            node, textNode, value;
                        while (i--) {
                            node = a[i];
                            textNode = a[i].firstChild;
                            if (textNode) {
                                textNode.value = v.decode(textNode.value)
                            } else {
                                value = node.attributes.map['data-mce-innertext'];
                                if (value) {
                                    node.attr('data-mce-innertext', null);
                                    textNode = new u('#text', 3);
                                    textNode.value = value;
                                    textNode.raw = true;
                                    node.append(textNode)
                                }
                            }
                        }
                    })
                }
            }
            function fixCaretSelectionOfDocumentElementOnIe() {
                var b = dom.doc,
                    body = b.body,
                    started, startRng, htmlElm;

                function rngFromPoint(x, y) {
                    var a = body.createTextRange();
                    try {
                        a.moveToPoint(x, y)
                    } catch (ex) {
                        a = null
                    }
                    return a
                }
                function selectionChange(e) {
                    var a;
                    if (e.button) {
                        a = rngFromPoint(e.x, e.y);
                        if (a) {
                            if (a.compareEndPoints('StartToStart', startRng) > 0) {
                                a.setEndPoint('StartToStart', startRng)
                            } else {
                                a.setEndPoint('EndToEnd', startRng)
                            }
                            a.select()
                        }
                    } else {
                        endSelection()
                    }
                }
                function endSelection() {
                    var a = b.selection.createRange();
                    if (startRng && !a.item && a.compareEndPoints('StartToEnd', a) === 0) {
                        startRng.select()
                    }
                    dom.unbind(b, 'mouseup', endSelection);
                    dom.unbind(b, 'mousemove', selectionChange);
                    startRng = started = 0
                }
                b.documentElement.unselectable = true;
                dom.bind(b, 'mousedown contextmenu', function (e) {
                    if (e.target.nodeName === 'HTML') {
                        if (started) {
                            endSelection()
                        }
                        htmlElm = b.documentElement;
                        if (htmlElm.scrollHeight > htmlElm.clientHeight) {
                            return
                        }
                        started = 1;
                        startRng = rngFromPoint(e.x, e.y);
                        if (startRng) {
                            dom.bind(b, 'mouseup', endSelection);
                            dom.bind(b, 'mousemove', selectionChange);
                            dom.getRoot().focus();
                            startRng.select()
                        }
                    }
                })
            }
            function normalizeSelection() {
                k.on('keyup focusin mouseup', function (e) {
                    if (e.keyCode != 65 || !q.metaKeyPressed(e)) {
                        selection.normalize()
                    }
                }, true)
            }
            function showBrokenImageIcon() {
                k.contentStyles.push('img:-moz-broken {' + '-moz-force-broken-image-icon:1;' + 'min-width:24px;' + 'min-height:24px' + '}')
            }
            function restoreFocusOnKeyDown() {
                if (!k.inline) {
                    k.on('keydown', function () {
                        if (document.activeElement == document.body) {
                            k.getWin().focus()
                        }
                    })
                }
            }
            function bodyHeight() {
                if (!k.inline) {
                    k.contentStyles.push('body {min-height: 150px}');
                    k.on('click', function (e) {
                        var a;
                        if (e.target.nodeName == 'HTML') {
                            if (w.ie > 11) {
                                k.getBody().focus();
                                return
                            }
                            a = k.selection.getRng();
                            k.getBody().focus();
                            k.selection.setRng(a);
                            k.selection.normalize();
                            k.nodeChanged()
                        }
                    })
                }
            }
            function blockCmdArrowNavigation() {
                if (w.mac) {
                    k.on('keydown', function (e) {
                        if (q.metaKeyPressed(e) && !e.shiftKey && (e.keyCode == 37 || e.keyCode == 39)) {
                            e.preventDefault();
                            k.selection.getSel().modify('move', e.keyCode == 37 ? 'backward' : 'forward', 'lineboundary')
                        }
                    })
                }
            }
            function disableAutoUrlDetect() {
                setEditorCommandState("AutoUrlDetect", false)
            }
            function tapLinksAndImages() {
                k.on('click', function (e) {
                    var a = e.target;
                    do {
                        if (a.tagName === 'A') {
                            e.preventDefault();
                            return
                        }
                    } while ((a = a.parentNode))
                });
                k.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}')
            }
            function blockFormSubmitInsideEditor() {
                k.on('init', function () {
                    k.dom.bind(k.getBody(), 'submit', function (e) {
                        e.preventDefault()
                    })
                })
            }
            function removeAppleInterchangeBrs() {
                parser.addNodeFilter('br', function (a) {
                    var i = a.length;
                    while (i--) {
                        if (a[i].attr('class') == 'Apple-interchange-newline') {
                            a[i].remove()
                        }
                    }
                })
            }
            function ieInternalDragAndDrop() {
                k.on('dragstart', function (e) {
                    setMceInternalContent(e)
                });
                k.on('drop', function (e) {
                    if (!isDefaultPrevented(e)) {
                        var a = getMceInternalContent(e);
                        if (a && a.id != k.id) {
                            e.preventDefault();
                            var b = r.getCaretRangeFromPoint(e.x, e.y, k.getDoc());
                            selection.setRng(b);
                            insertClipboardContents(a.html)
                        }
                    }
                })
            }
            function refreshContentEditable() {
                var a, parent;
                if (isHidden()) {
                    a = k.getBody();
                    parent = a.parentNode;
                    parent.removeChild(a);
                    parent.appendChild(a);
                    a.focus()
                }
            }
            function isHidden() {
                var a;
                if (!n) {
                    return 0
                }
                a = k.selection.getSel();
                return (!a || !a.rangeCount || a.rangeCount === 0)
            }
            function emptyEditorOnDeleteEverything() {
                function isEverythingSelected(a) {
                    var b = new D(a.getBody());
                    var c = a.selection.getRng();
                    var d = C.fromRangeStart(c);
                    var e = C.fromRangeEnd(c);
                    return !a.selection.isCollapsed() && !b.prev(d) && !b.next(e)
                }
                k.on('keypress', function (e) {
                    if (!isDefaultPrevented(e) && !selection.isCollapsed() && e.charCode > 31 && !q.metaKeyPressed(e)) {
                        if (isEverythingSelected(k)) {
                            e.preventDefault();
                            k.setContent(String.fromCharCode(e.charCode));
                            k.selection.select(k.getBody(), true);
                            k.selection.collapse(false);
                            k.nodeChanged()
                        }
                    }
                });
                k.on('keydown', function (e) {
                    var a = e.keyCode;
                    if (!isDefaultPrevented(e) && (a == DELETE || a == m)) {
                        if (isEverythingSelected(k)) {
                            e.preventDefault();
                            k.setContent('');
                            k.nodeChanged()
                        }
                    }
                })
            }
            removeBlockQuoteOnBackSpace();
            emptyEditorWhenDeleting();
            if (!w.windowsPhone) {
                normalizeSelection()
            }
            if (isWebKit) {
                emptyEditorOnDeleteEverything();
                cleanupStylesWhenDeleting();
                inputMethodFocus();
                selectControlElements();
                setDefaultBlockType();
                blockFormSubmitInsideEditor();
                disableBackspaceIntoATable();
                removeAppleInterchangeBrs();
                if (w.iOS) {
                    restoreFocusOnKeyDown();
                    bodyHeight();
                    tapLinksAndImages()
                } else {
                    selectAll()
                }
            }
            if (isIE && w.ie < 11) {
                removeHrOnBackspace();
                ensureBodyHasRoleApplication();
                addNewLinesBeforeBrInPre();
                removePreSerializedStylesWhenSelectingControls();
                deleteControlItemOnBackSpace();
                renderEmptyBlocksFix();
                keepNoScriptContents();
                fixCaretSelectionOfDocumentElementOnIe()
            }
            if (w.ie >= 11) {
                bodyHeight();
                disableBackspaceIntoATable()
            }
            if (w.ie) {
                selectAll();
                disableAutoUrlDetect();
                ieInternalDragAndDrop()
            }
            if (n) {
                emptyEditorOnDeleteEverything();
                removeHrOnBackspace();
                focusBody();
                removeStylesWhenDeletingAcrossBlockElements();
                setGeckoEditingOptions();
                addBrAfterLastLinks();
                showBrokenImageIcon();
                blockCmdArrowNavigation();
                disableBackspaceIntoATable()
            }
            return {
                refreshContentEditable: refreshContentEditable,
                isHidden: isHidden
            }
        }
    });
    define("tinymce/EditorObservable", ["tinymce/util/Observable", "tinymce/dom/DOMUtils", "tinymce/util/Tools"], function (g, h, j) {
        var k = h.DOM,
            customEventRootDelegates;

        function getEventTarget(a, b) {
            if (b == 'selectionchange') {
                return a.getDoc()
            }
            if (!a.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(b)) {
                return a.getDoc().documentElement
            }
            if (a.settings.event_root) {
                if (!a.eventRoot) {
                    a.eventRoot = k.select(a.settings.event_root)[0]
                }
                return a.eventRoot
            }
            return a.getBody()
        }
        function bindEventDelegate(c, d) {
            var f = getEventTarget(c, d),
                delegate;

            function isListening(a) {
                return !a.hidden && !a.readonly
            }
            if (!c.delegates) {
                c.delegates = {}
            }
            if (c.delegates[d]) {
                return
            }
            if (c.settings.event_root) {
                if (!customEventRootDelegates) {
                    customEventRootDelegates = {};
                    c.editorManager.on('removeEditor', function () {
                        var a;
                        if (!c.editorManager.activeEditor) {
                            if (customEventRootDelegates) {
                                for (a in customEventRootDelegates) {
                                    c.dom.unbind(getEventTarget(c, a))
                                }
                                customEventRootDelegates = null
                            }
                        }
                    })
                }
                if (customEventRootDelegates[d]) {
                    return
                }
                delegate = function (e) {
                    var a = e.target,
                        editors = c.editorManager.editors,
                        i = editors.length;
                    while (i--) {
                        var b = editors[i].getBody();
                        if (b === a || k.isChildOf(a, b)) {
                            if (isListening(editors[i])) {
                                editors[i].fire(d, e)
                            }
                        }
                    }
                };
                customEventRootDelegates[d] = delegate;
                k.bind(f, d, delegate)
            } else {
                delegate = function (e) {
                    if (isListening(c)) {
                        c.fire(d, e)
                    }
                };
                k.bind(f, d, delegate);
                c.delegates[d] = delegate
            }
        }
        var l = {
            bindPendingEventDelegates: function () {
                var b = this;
                j.each(b._pendingNativeEvents, function (a) {
                    bindEventDelegate(b, a)
                })
            },
            toggleNativeEvent: function (a, b) {
                var c = this;
                if (a == "focus" || a == "blur") {
                    return
                }
                if (b) {
                    if (c.initialized) {
                        bindEventDelegate(c, a)
                    } else {
                        if (!c._pendingNativeEvents) {
                            c._pendingNativeEvents = [a]
                        } else {
                            c._pendingNativeEvents.push(a)
                        }
                    }
                } else if (c.initialized) {
                    c.dom.unbind(getEventTarget(c, a), a, c.delegates[a]);
                    delete c.delegates[a]
                }
            },
            unbindAllNativeEvents: function () {
                var a = this,
                    name;
                if (a.delegates) {
                    for (name in a.delegates) {
                        a.dom.unbind(getEventTarget(a, name), name, a.delegates[name])
                    }
                    delete a.delegates
                }
                if (!a.inline) {
                    a.getBody().onload = null;
                    a.dom.unbind(a.getWin());
                    a.dom.unbind(a.getDoc())
                }
                a.dom.unbind(a.getBody());
                a.dom.unbind(a.getContainer())
            }
        };
        l = j.extend({}, g, l);
        return l
    });
    define("tinymce/Mode", [], function () {
        function setEditorCommandState(a, b, c) {
            try {
                a.getDoc().execCommand(b, false, c)
            } catch (ex) { }
        }
        function clickBlocker(a) {
            var b, handler;
            b = a.getBody();
            handler = function (e) {
                if (a.dom.getParents(e.target, 'a').length > 0) {
                    e.preventDefault()
                }
            };
            a.dom.bind(b, 'click', handler);
            return {
                unbind: function () {
                    a.dom.unbind(b, 'click', handler)
                }
            }
        }
        function toggleReadOnly(a, b) {
            if (a._clickBlocker) {
                a._clickBlocker.unbind();
                a._clickBlocker = null
            }
            if (b) {
                a._clickBlocker = clickBlocker(a);
                a.selection.controlSelection.hideResizeRect();
                a.readonly = true;
                a.getBody().contentEditable = false
            } else {
                a.readonly = false;
                a.getBody().contentEditable = true;
                setEditorCommandState(a, "StyleWithCSS", false);
                setEditorCommandState(a, "enableInlineTableEditing", false);
                setEditorCommandState(a, "enableObjectResizing", false);
                a.focus();
                a.nodeChanged()
            }
        }
        function setMode(a, b) {
            var c = a.readonly ? 'readonly' : 'design';
            if (b == c) {
                return
            }
            if (a.initialized) {
                toggleReadOnly(a, b == 'readonly')
            } else {
                a.on('init', function () {
                    toggleReadOnly(a, b == 'readonly')
                })
            }
            a.fire('SwitchMode', {
                mode: b
            })
        }
        return {
            setMode: setMode
        }
    });
    define("tinymce/Shortcuts", ["tinymce/util/Tools", "tinymce/Env"], function (j, k) {
        var l = j.each,
            explode = j.explode;
        var m = {
            "f9": 120,
            "f10": 121,
            "f11": 122
        };
        var n = j.makeMap('alt,ctrl,shift,meta,access');
        return function (h) {
            var i = this,
                shortcuts = {},
                pendingPatterns = [];

            function parseShortcut(b) {
                var c, key, shortcut = {};
                l(explode(b, '+'), function (a) {
                    if (a in n) {
                        shortcut[a] = true
                    } else {
                        if (/^[0-9]{2,}$/.test(a)) {
                            shortcut.keyCode = parseInt(a, 10)
                        } else {
                            shortcut.charCode = a.charCodeAt(0);
                            shortcut.keyCode = m[a] || a.toUpperCase().charCodeAt(0)
                        }
                    }
                });
                c = [shortcut.keyCode];
                for (key in n) {
                    if (shortcut[key]) {
                        c.push(key)
                    } else {
                        shortcut[key] = false
                    }
                }
                shortcut.id = c.join(',');
                if (shortcut.access) {
                    shortcut.alt = true;
                    if (k.mac) {
                        shortcut.ctrl = true
                    } else {
                        shortcut.shift = true
                    }
                }
                if (shortcut.meta) {
                    if (k.mac) {
                        shortcut.meta = true
                    } else {
                        shortcut.ctrl = true;
                        shortcut.meta = false
                    }
                }
                return shortcut
            }
            function createShortcut(a, b, c, d) {
                var e;
                e = j.map(explode(a, '>'), parseShortcut);
                e[e.length - 1] = j.extend(e[e.length - 1], {
                    func: c,
                    scope: d || h
                });
                return j.extend(e[0], {
                    desc: h.translate(b),
                    subpatterns: e.slice(1)
                })
            }
            function hasModifier(e) {
                return e.altKey || e.ctrlKey || e.metaKey
            }
            function isFunctionKey(e) {
                return e.keyCode >= 112 && e.keyCode <= 123
            }
            function matchShortcut(e, a) {
                if (!a) {
                    return false
                }
                if (a.ctrl != e.ctrlKey || a.meta != e.metaKey) {
                    return false
                }
                if (a.alt != e.altKey || a.shift != e.shiftKey) {
                    return false
                }
                if (e.keyCode == a.keyCode || (e.charCode && e.charCode == a.charCode)) {
                    e.preventDefault();
                    return true
                }
                return false
            }
            function executeShortcutAction(a) {
                return a.func ? a.func.call(a.scope) : null
            }
            h.on('keyup keypress keydown', function (e) {
                if ((hasModifier(e) || isFunctionKey(e)) && !e.isDefaultPrevented()) {
                    l(shortcuts, function (a) {
                        if (matchShortcut(e, a)) {
                            pendingPatterns = a.subpatterns.slice(0);
                            if (e.type == "keydown") {
                                executeShortcutAction(a)
                            }
                            return true
                        }
                    });
                    if (matchShortcut(e, pendingPatterns[0])) {
                        if (pendingPatterns.length === 1) {
                            if (e.type == "keydown") {
                                executeShortcutAction(pendingPatterns[0])
                            }
                        }
                        pendingPatterns.shift()
                    }
                }
            });
            i.add = function (c, d, e, f) {
                var g;
                g = e;
                if (typeof e === 'string') {
                    e = function () {
                        h.execCommand(g, false, null)
                    }
                } else if (j.isArray(g)) {
                    e = function () {
                        h.execCommand(g[0], g[1], g[2])
                    }
                }
                l(explode(j.trim(c.toLowerCase())), function (a) {
                    var b = createShortcut(a, d, e, f);
                    shortcuts[b.id] = b
                });
                return true
            };
            i.remove = function (a) {
                var b = createShortcut(a);
                if (shortcuts[b.id]) {
                    delete shortcuts[b.id];
                    return true
                }
                return false
            }
        }
    });
    define("tinymce/file/Uploader", ["tinymce/util/Promise", "tinymce/util/Tools", "tinymce/util/Fun"], function (n, o, p) {
        return function (k, l) {
            var m = {};

            function fileName(a) {
                var b, extensions;
                extensions = {
                    'image/jpeg': 'jpg',
                    'image/jpg': 'jpg',
                    'image/gif': 'gif',
                    'image/png': 'png'
                };
                b = extensions[a.blob().type.toLowerCase()] || 'dat';
                return a.id() + '.' + b
            }
            function pathJoin(a, b) {
                if (a) {
                    return a.replace(/\/$/, '') + '/' + b.replace(/^\//, '')
                }
                return b
            }
            function blobInfoToData(a) {
                return {
                    id: a.id,
                    blob: a.blob,
                    base64: a.base64,
                    filename: p.constant(fileName(a))
                }
            }
            function defaultHandler(b, c, d, f) {
                var g, formData;
                g = new XMLHttpRequest();
                g.open('POST', l.url);
                g.withCredentials = l.credentials;
                g.upload.onprogress = function (e) {
                    f(e.loaded / e.total * 100)
                };
                g.onerror = function () {
                    d("Image upload failed due to a XHR Transport error. Code: " + g.status)
                };
                g.onload = function () {
                    var a;
                    if (g.status != 200) {
                        d("HTTP Error: " + g.status);
                        return
                    }
                    a = JSON.parse(g.responseText);
                    if (!a || typeof a.location != "string") {
                        d("Invalid JSON: " + g.responseText);
                        return
                    }
                    c(pathJoin(l.basePath, a.location))
                };
                formData = new FormData();
                formData.append('file', b.blob(), fileName(b));
                g.send(formData)
            }
            function noUpload() {
                return new n(function (a) {
                    a([])
                })
            }
            function handlerSuccess(a, b) {
                return {
                    url: b,
                    blobInfo: a,
                    status: true
                }
            }
            function handlerFailure(a, b) {
                return {
                    url: '',
                    blobInfo: a,
                    status: false,
                    error: b
                }
            }
            function resolvePending(b, c) {
                o.each(m[b], function (a) {
                    a(c)
                });
                delete m[b]
            }
            function uploadBlobInfo(h, i, j) {
                k.markPending(h.blobUri());
                return new n(function (b) {
                    var c, progress;
                    var d = function () { };
                    try {
                        var e = function () {
                            if (c) {
                                c.close();
                                progress = d
                            }
                        };
                        var f = function (a) {
                            e();
                            k.markUploaded(h.blobUri(), a);
                            resolvePending(h.blobUri(), handlerSuccess(h, a));
                            b(handlerSuccess(h, a))
                        };
                        var g = function () {
                            e();
                            k.removeFailed(h.blobUri());
                            resolvePending(h.blobUri(), handlerFailure(h, g));
                            b(handlerFailure(h, g))
                        };
                        progress = function (a) {
                            if (a < 0 || a > 100) {
                                return
                            }
                            if (!c) {
                                c = j()
                            }
                            c.progressBar.value(a)
                        };
                        i(blobInfoToData(h), f, g, progress)
                    } catch (ex) {
                        b(handlerFailure(h, ex.message))
                    }
                })
            }
            function isDefaultHandler(a) {
                return a === defaultHandler
            }
            function pendingUploadBlobInfo(b) {
                var c = b.blobUri();
                return new n(function (a) {
                    m[c] = m[c] || [];
                    m[c].push(a)
                })
            }
            function uploadBlobs(b, c) {
                b = o.grep(b, function (a) {
                    return !k.isUploaded(a.blobUri())
                });
                return n.all(o.map(b, function (a) {
                    return k.isPending(a.blobUri()) ? pendingUploadBlobInfo(a) : uploadBlobInfo(a, l.handler, c)
                }))
            }
            function upload(a, b) {
                return (!l.url && isDefaultHandler(l.handler)) ? noUpload() : uploadBlobs(a, b)
            }
            l = o.extend({
                credentials: false,
                handler: defaultHandler
            }, l);
            return {
                upload: upload
            }
        }
    });
    define("tinymce/file/Conversions", ["tinymce/util/Promise"], function (d) {
        function blobUriToBlob(c) {
            return new d(function (a) {
                var b = new XMLHttpRequest();
                b.open('GET', c, true);
                b.responseType = 'blob';
                b.onload = function () {
                    if (this.status == 200) {
                        a(this.response)
                    }
                };
                b.send()
            })
        }
        function parseDataUri(a) {
            var b, matches;
            a = decodeURIComponent(a).split(',');
            matches = /data:([^;]+)/.exec(a[0]);
            if (matches) {
                b = matches[1]
            }
            return {
                type: b,
                data: a[1]
            }
        }
        function dataUriToBlob(c) {
            return new d(function (a) {
                var b, arr, i;
                c = parseDataUri(c);
                try {
                    b = atob(c.data)
                } catch (e) {
                    a(new Blob([]));
                    return
                }
                arr = new Uint8Array(b.length);
                for (i = 0; i < arr.length; i++) {
                    arr[i] = b.charCodeAt(i)
                }
                a(new Blob([arr], {
                    type: c.type
                }))
            })
        }
        function uriToBlob(a) {
            if (a.indexOf('blob:') === 0) {
                return blobUriToBlob(a)
            }
            if (a.indexOf('data:') === 0) {
                return dataUriToBlob(a)
            }
            return null
        }
        function blobToDataUri(c) {
            return new d(function (a) {
                var b = new FileReader();
                b.onloadend = function () {
                    a(b.result)
                };
                b.readAsDataURL(c)
            })
        }
        return {
            uriToBlob: uriToBlob,
            blobToDataUri: blobToDataUri,
            parseDataUri: parseDataUri
        }
    });
    define("tinymce/file/ImageScanner", ["tinymce/util/Promise", "tinymce/util/Arr", "tinymce/util/Fun", "tinymce/file/Conversions", "tinymce/Env"], function (l, m, n, o, p) {
        var q = 0;
        return function (i, j) {
            var k = {};

            function findAll(f, g) {
                var h, promises;

                function imageToBlobInfo(c, d) {
                    var e, blobInfo;
                    if (c.src.indexOf('blob:') === 0) {
                        blobInfo = j.getByUri(c.src);
                        if (blobInfo) {
                            d({
                                image: c,
                                blobInfo: blobInfo
                            })
                        }
                        return
                    }
                    e = o.parseDataUri(c.src).data;
                    blobInfo = j.findFirst(function (a) {
                        return a.base64() === e
                    });
                    if (blobInfo) {
                        d({
                            image: c,
                            blobInfo: blobInfo
                        })
                    } else {
                        o.uriToBlob(c.src).then(function (a) {
                            var b = 'blobid' + (q++),
                                blobInfo = j.create(b, a, e);
                            j.add(blobInfo);
                            d({
                                image: c,
                                blobInfo: blobInfo
                            })
                        })
                    }
                }
                if (!g) {
                    g = n.constant(true)
                }
                h = m.filter(f.getElementsByTagName('img'), function (a) {
                    var b = a.src;
                    if (!p.fileApi) {
                        return false
                    }
                    if (a.hasAttribute('data-mce-bogus')) {
                        return false
                    }
                    if (a.hasAttribute('data-mce-placeholder')) {
                        return false
                    }
                    if (!b || b == p.transparentSrc) {
                        return false
                    }
                    if (b.indexOf('blob:') === 0) {
                        return !i.isUploaded(b)
                    }
                    if (b.indexOf('data:') === 0) {
                        return g(a)
                    }
                    return false
                });
                promises = m.map(h, function (c) {
                    var d;
                    if (k[c.src]) {
                        return new l(function (b) {
                            k[c.src].then(function (a) {
                                b({
                                    image: c,
                                    blobInfo: a.blobInfo
                                })
                            })
                        })
                    }
                    d = new l(function (a) {
                        imageToBlobInfo(c, a)
                    }).then(function (a) {
                        delete k[a.image.src];
                        return a
                    })['catch'](function (a) {
                        delete k[c.src];
                        return a
                    });
                    k[c.src] = d;
                    return d
                });
                return l.all(promises)
            }
            return {
                findAll: findAll
            }
        }
    });
    define("tinymce/file/BlobCache", ["tinymce/util/Arr", "tinymce/util/Fun"], function (e, f) {
        return function () {
            var d = [],
                constant = f.constant;

            function create(a, b, c) {
                return {
                    id: constant(a),
                    blob: constant(b),
                    base64: constant(c),
                    blobUri: constant(URL.createObjectURL(b))
                }
            }
            function add(a) {
                if (!get(a.id())) {
                    d.push(a)
                }
            }
            function get(b) {
                return findFirst(function (a) {
                    return a.id() === b
                })
            }
            function findFirst(a) {
                return e.filter(d, a)[0]
            }
            function getByUri(b) {
                return findFirst(function (a) {
                    return a.blobUri() == b
                })
            }
            function removeByUri(b) {
                d = e.filter(d, function (a) {
                    if (a.blobUri() === b) {
                        URL.revokeObjectURL(a.blobUri());
                        return false
                    }
                    return true
                })
            }
            function destroy() {
                e.each(d, function (a) {
                    URL.revokeObjectURL(a.blobUri())
                });
                d = []
            }
            return {
                create: create,
                add: add,
                get: get,
                getByUri: getByUri,
                findFirst: findFirst,
                removeByUri: removeByUri,
                destroy: destroy
            }
        }
    });
    define("tinymce/file/UploadStatus", [], function () {
        return function () {
            var c = 1,
                UPLOADED = 2;
            var d = {};

            function createStatus(a, b) {
                return {
                    status: a,
                    resultUri: b
                }
            }
            function hasBlobUri(a) {
                return a in d
            }
            function getResultUri(a) {
                var b = d[a];
                return b ? b.resultUri : null
            }
            function isPending(a) {
                return hasBlobUri(a) ? d[a].status === c : false
            }
            function isUploaded(a) {
                return hasBlobUri(a) ? d[a].status === UPLOADED : false
            }
            function markPending(a) {
                d[a] = createStatus(c, null)
            }
            function markUploaded(a, b) {
                d[a] = createStatus(UPLOADED, b)
            }
            function removeFailed(a) {
                delete d[a]
            }
            function destroy() {
                d = {}
            }
            return {
                hasBlobUri: hasBlobUri,
                getResultUri: getResultUri,
                isPending: isPending,
                isUploaded: isUploaded,
                markPending: markPending,
                markUploaded: markUploaded,
                removeFailed: removeFailed,
                destroy: destroy
            }
        }
    });
    define("tinymce/EditorUpload", ["tinymce/util/Arr", "tinymce/file/Uploader", "tinymce/file/ImageScanner", "tinymce/file/BlobCache", "tinymce/file/UploadStatus"], function (k, l, m, n, o) {
        return function (h) {
            var i = new n(),
                uploader, imageScanner, settings = h.settings;
            var j = new o();

            function aliveGuard(b) {
                return function (a) {
                    if (h.selection) {
                        return b(a)
                    }
                    return []
                }
            }
            function replaceString(a, b, c) {
                var d = 0;
                do {
                    d = a.indexOf(b, d);
                    if (d !== -1) {
                        a = a.substring(0, d) + c + a.substr(d + b.length);
                        d += c.length - b.length + 1
                    }
                } while (d !== -1);
                return a
            }
            function replaceImageUrl(a, b, c) {
                a = replaceString(a, 'src="' + b + '"', 'src="' + c + '"');
                a = replaceString(a, 'data-mce-src="' + b + '"', 'data-mce-src="' + c + '"');
                return a
            }
            function replaceUrlInUndoStack(b, c) {
                k.each(h.undoManager.data, function (a) {
                    a.content = replaceImageUrl(a.content, b, c)
                })
            }
            function openNotification() {
                return h.notificationManager.open({
                    text: h.translate('Image uploading...'),
                    type: 'info',
                    timeout: -1,
                    progressBar: true
                })
            }
            function replaceImageUri(a, b) {
                i.removeByUri(a.src);
                replaceUrlInUndoStack(a.src, b);
                h.$(a).attr({
                    src: b,
                    'data-mce-src': h.convertURL(b, 'src')
                })
            }
            function uploadImages(g) {
                if (!uploader) {
                    uploader = new l(j, {
                        url: settings.images_upload_url,
                        basePath: settings.images_upload_base_path,
                        credentials: settings.images_upload_credentials,
                        handler: settings.images_upload_handler
                    })
                }
                return scanForImages().then(aliveGuard(function (e) {
                    var f;
                    f = k.map(e, function (a) {
                        return a.blobInfo
                    });
                    return uploader.upload(f, openNotification).then(aliveGuard(function (d) {
                        d = k.map(d, function (a, b) {
                            var c = e[b].image;
                            if (a.status && h.settings.images_replace_blob_uris !== false) {
                                replaceImageUri(c, a.url)
                            }
                            return {
                                element: c,
                                status: a.status
                            }
                        });
                        if (g) {
                            g(d)
                        }
                        return d
                    }))
                }))
            }
            function uploadImagesAuto(a) {
                if (settings.automatic_uploads !== false) {
                    return uploadImages(a)
                }
            }
            function isValidDataUriImage(a) {
                return settings.images_dataimg_filter ? settings.images_dataimg_filter(a) : true
            }
            function scanForImages() {
                if (!imageScanner) {
                    imageScanner = new m(j, i)
                }
                return imageScanner.findAll(h.getBody(), isValidDataUriImage).then(aliveGuard(function (b) {
                    k.each(b, function (a) {
                        replaceUrlInUndoStack(a.image.src, a.blobInfo.blobUri());
                        a.image.src = a.blobInfo.blobUri();
                        a.image.removeAttribute('data-mce-src')
                    });
                    return b
                }))
            }
            function destroy() {
                i.destroy();
                j.destroy();
                imageScanner = uploader = null
            }
            function replaceBlobUris(g) {
                return g.replace(/src="(blob:[^"]+)"/g, function (c, d) {
                    var e = j.getResultUri(d);
                    if (e) {
                        return 'src="' + e + '"'
                    }
                    var f = i.getByUri(d);
                    if (!f) {
                        f = k.reduce(h.editorManager.editors, function (a, b) {
                            return a || b.editorUpload.blobCache.getByUri(d)
                        }, null)
                    }
                    if (f) {
                        return 'src="data:' + f.blob().type + ';base64,' + f.base64() + '"'
                    }
                    return c
                })
            }
            h.on('setContent', function () {
                if (h.settings.automatic_uploads !== false) {
                    uploadImagesAuto()
                } else {
                    scanForImages()
                }
            });
            h.on('RawSaveContent', function (e) {
                e.content = replaceBlobUris(e.content)
            });
            h.on('getContent', function (e) {
                if (e.source_view || e.format == 'raw') {
                    return
                }
                e.content = replaceBlobUris(e.content)
            });
            h.on('PostRender', function () {
                h.parser.addNodeFilter('img', function (d) {
                    k.each(d, function (a) {
                        var b = a.attr('src');
                        if (i.getByUri(b)) {
                            return
                        }
                        var c = j.getResultUri(b);
                        if (c) {
                            a.attr('src', c)
                        }
                    })
                })
            });
            return {
                blobCache: i,
                uploadImages: uploadImages,
                uploadImagesAuto: uploadImagesAuto,
                scanForImages: scanForImages,
                destroy: destroy
            }
        }
    });
    define("tinymce/caret/FakeCaret", ["tinymce/caret/CaretContainer", "tinymce/caret/CaretPosition", "tinymce/dom/NodeType", "tinymce/dom/RangeUtils", "tinymce/dom/DomQuery", "tinymce/geom/ClientRect", "tinymce/util/Delay"], function (g, h, j, k, $, l, m) {
        var n = j.isContentEditableFalse;
        return function (d, e) {
            var f, $lastVisualCaret, caretContainerNode;

            function getAbsoluteClientRect(a, b) {
                var c = l.collapse(a.getBoundingClientRect(), b),
                    docElm, scrollX, scrollY, margin, rootRect;
                if (d.tagName == 'BODY') {
                    docElm = d.ownerDocument.documentElement;
                    scrollX = d.scrollLeft || docElm.scrollLeft;
                    scrollY = d.scrollTop || docElm.scrollTop
                } else {
                    rootRect = d.getBoundingClientRect();
                    scrollX = d.scrollLeft - rootRect.left;
                    scrollY = d.scrollTop - rootRect.top
                }
                c.left += scrollX;
                c.right += scrollX;
                c.top += scrollY;
                c.bottom += scrollY;
                c.width = 1;
                margin = a.offsetWidth - a.clientWidth;
                if (margin > 0) {
                    if (b) {
                        margin *= -1
                    }
                    c.left += margin;
                    c.right += margin
                }
                return c
            }
            function trimInlineCaretContainers() {
                var a, node, sibling, i, data;
                a = $('*[contentEditable=false]', d);
                for (i = 0; i < a.length; i++) {
                    node = a[i];
                    sibling = node.previousSibling;
                    if (g.endsWithCaretContainer(sibling)) {
                        data = sibling.data;
                        if (data.length == 1) {
                            sibling.parentNode.removeChild(sibling)
                        } else {
                            sibling.deleteData(data.length - 1, 1)
                        }
                    }
                    sibling = node.nextSibling;
                    if (g.startsWithCaretContainer(sibling)) {
                        data = sibling.data;
                        if (data.length == 1) {
                            sibling.parentNode.removeChild(sibling)
                        } else {
                            sibling.deleteData(0, 1)
                        }
                    }
                }
                return null
            }
            function show(a, b) {
                var c, rng, container;
                hide();
                if (e(b)) {
                    caretContainerNode = g.insertBlock('p', b, a);
                    c = getAbsoluteClientRect(b, a);
                    $(caretContainerNode).css('top', c.top);
                    $lastVisualCaret = $('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(c).appendTo(d);
                    if (a) {
                        $lastVisualCaret.addClass('mce-visual-caret-before')
                    }
                    startBlink();
                    rng = b.ownerDocument.createRange();
                    container = caretContainerNode.firstChild;
                    rng.setStart(container, 0);
                    rng.setEnd(container, 1)
                } else {
                    caretContainerNode = g.insertInline(b, a);
                    rng = b.ownerDocument.createRange();
                    if (n(caretContainerNode.nextSibling)) {
                        rng.setStart(caretContainerNode, 0);
                        rng.setEnd(caretContainerNode, 0)
                    } else {
                        rng.setStart(caretContainerNode, 1);
                        rng.setEnd(caretContainerNode, 1)
                    }
                    return rng
                }
                return rng
            }
            function hide() {
                trimInlineCaretContainers();
                if (caretContainerNode) {
                    g.remove(caretContainerNode);
                    caretContainerNode = null
                }
                if ($lastVisualCaret) {
                    $lastVisualCaret.remove();
                    $lastVisualCaret = null
                }
                clearInterval(f)
            }
            function startBlink() {
                f = m.setInterval(function () {
                    $('div.mce-visual-caret', d).toggleClass('mce-visual-caret-hidden')
                }, 500)
            }
            function destroy() {
                m.clearInterval(f)
            }
            function getCss() {
                return ('.mce-visual-caret {' + 'position: absolute;' + 'background-color: black;' + 'background-color: currentcolor;' + '}' + '.mce-visual-caret-hidden {' + 'display: none;' + '}' + '*[data-mce-caret] {' + 'position: absolute;' + 'left: -1000px;' + 'right: auto;' + 'top: 0;' + 'margin: 0;' + 'padding: 0;' + '}')
            }
            return {
                show: show,
                hide: hide,
                getCss: getCss,
                destroy: destroy
            }
        }
    });
    define("tinymce/dom/Dimensions", ["tinymce/util/Arr", "tinymce/dom/NodeType", "tinymce/geom/ClientRect"], function (e, f, g) {
        function getClientRects(c) {
            function toArrayWithNode(b) {
                return e.map(b, function (a) {
                    a = g.clone(a);
                    a.node = c;
                    return a
                })
            }
            if (e.isArray(c)) {
                return e.reduce(c, function (a, b) {
                    return a.concat(getClientRects(b))
                }, [])
            }
            if (f.isElement(c)) {
                return toArrayWithNode(c.getClientRects())
            }
            if (f.isText(c)) {
                var d = c.ownerDocument.createRange();
                d.setStart(c, 0);
                d.setEnd(c, c.data.length);
                return toArrayWithNode(d.getClientRects())
            }
        }
        return {
            getClientRects: getClientRects
        }
    });
    define("tinymce/caret/LineWalker", ["tinymce/util/Fun", "tinymce/util/Arr", "tinymce/dom/Dimensions", "tinymce/caret/CaretCandidate", "tinymce/caret/CaretUtils", "tinymce/caret/CaretWalker", "tinymce/caret/CaretPosition", "tinymce/geom/ClientRect"], function (j, k, l, m, n, o, p, q) {
        var r = j.curry;

        function findUntil(a, b, c, d) {
            while ((d = n.findNode(d, a, m.isEditableCaretCandidate, b))) {
                if (c(d)) {
                    return
                }
            }
        }
        function walkUntil(b, c, d, e, f, g) {
            var h = 0,
                node, result = [],
                targetClientRect;

            function add(a) {
                var i, clientRect, clientRects;
                clientRects = l.getClientRects(a);
                if (b == -1) {
                    clientRects = clientRects.reverse()
                }
                for (i = 0; i < clientRects.length; i++) {
                    clientRect = clientRects[i];
                    if (d(clientRect, targetClientRect)) {
                        continue
                    }
                    if (result.length > 0 && c(clientRect, k.last(result))) {
                        h++
                    }
                    clientRect.line = h;
                    if (f(clientRect)) {
                        return true
                    }
                    result.push(clientRect)
                }
            }
            targetClientRect = k.last(g.getClientRects());
            if (!targetClientRect) {
                return result
            }
            node = g.getNode();
            add(node);
            findUntil(b, e, add, node);
            return result
        }
        function aboveLineNumber(a, b) {
            return b.line > a
        }
        function isLine(a, b) {
            return b.line === a
        }
        var s = r(walkUntil, -1, q.isAbove, q.isBelow);
        var t = r(walkUntil, 1, q.isBelow, q.isAbove);

        function positionsUntil(b, c, d, e) {
            var f = new o(c),
                walkFn, isBelowFn, isAboveFn, caretPosition, result = [],
                line = 0,
                clientRect, targetClientRect;

            function getClientRect(a) {
                if (b == 1) {
                    return k.last(a.getClientRects())
                }
                return k.last(a.getClientRects())
            }
            if (b == 1) {
                walkFn = f.next;
                isBelowFn = q.isBelow;
                isAboveFn = q.isAbove;
                caretPosition = p.after(e)
            } else {
                walkFn = f.prev;
                isBelowFn = q.isAbove;
                isAboveFn = q.isBelow;
                caretPosition = p.before(e)
            }
            targetClientRect = getClientRect(caretPosition);
            do {
                if (!caretPosition.isVisible()) {
                    continue
                }
                clientRect = getClientRect(caretPosition);
                if (isAboveFn(clientRect, targetClientRect)) {
                    continue
                }
                if (result.length > 0 && isBelowFn(clientRect, k.last(result))) {
                    line++
                }
                clientRect = q.clone(clientRect);
                clientRect.position = caretPosition;
                clientRect.line = line;
                if (d(clientRect)) {
                    return result
                }
                result.push(clientRect)
            } while ((caretPosition = walkFn(caretPosition)));
            return result
        }
        return {
            upUntil: s,
            downUntil: t,
            positionsUntil: positionsUntil,
            isAboveLine: r(aboveLineNumber),
            isLine: r(isLine)
        }
    });
    define("tinymce/caret/LineUtils", ["tinymce/util/Fun", "tinymce/util/Arr", "tinymce/dom/NodeType", "tinymce/dom/Dimensions", "tinymce/geom/ClientRect", "tinymce/caret/CaretUtils", "tinymce/caret/CaretCandidate"], function (h, i, j, k, l, m, n) {
        var o = j.isContentEditableFalse,
            findNode = m.findNode,
            curry = h.curry;

        function distanceToRectLeft(a, b) {
            return Math.abs(a.left - b)
        }
        function distanceToRectRight(a, b) {
            return Math.abs(a.right - b)
        }
        function findClosestClientRect(d, e) {
            function isInside(a, b) {
                return a >= b.left && a <= b.right
            }
            return i.reduce(d, function (a, b) {
                var c, newDistance;
                c = Math.min(distanceToRectLeft(a, e), distanceToRectRight(a, e));
                newDistance = Math.min(distanceToRectLeft(b, e), distanceToRectRight(b, e));
                if (isInside(e, b)) {
                    return b
                }
                if (isInside(e, a)) {
                    return a
                }
                if (newDistance == c && o(b.node)) {
                    return b
                }
                if (newDistance < c) {
                    return b
                }
                return a
            })
        }
        function walkUntil(a, b, c, d) {
            while ((d = findNode(d, a, n.isEditableCaretCandidate, b))) {
                if (c(d)) {
                    return
                }
            }
        }
        function findLineNodeRects(e, f) {
            var g = [];

            function collect(b, c) {
                var d;
                d = i.filter(k.getClientRects(c), function (a) {
                    return !b(a, f)
                });
                g = g.concat(d);
                return d.length === 0
            }
            g.push(f);
            walkUntil(-1, e, curry(collect, l.isAbove), f.node);
            walkUntil(1, e, curry(collect, l.isBelow), f.node);
            return g
        }
        function getContentEditableFalseChildren(a) {
            return i.filter(i.toArray(a.getElementsByTagName('*')), o)
        }
        function caretInfo(a, b) {
            return {
                node: a.node,
                before: distanceToRectLeft(a, b) < distanceToRectRight(a, b)
            }
        }
        function closestCaret(b, c, d) {
            var e, closestNodeRect;
            e = k.getClientRects(getContentEditableFalseChildren(b));
            e = i.filter(e, function (a) {
                return d >= a.top && d <= a.bottom
            });
            closestNodeRect = findClosestClientRect(e, c);
            if (closestNodeRect) {
                closestNodeRect = findClosestClientRect(findLineNodeRects(b, closestNodeRect), c);
                if (closestNodeRect && o(closestNodeRect.node)) {
                    return caretInfo(closestNodeRect, c)
                }
            }
            return null
        }
        return {
            findClosestClientRect: findClosestClientRect,
            findLineNodeRects: findLineNodeRects,
            closestCaret: closestCaret
        }
    });
    define("tinymce/dom/MousePosition", [], function () {
        var e = function (a) {
            var b, docElem, win, clientRect;
            clientRect = a.getBoundingClientRect();
            b = a.ownerDocument;
            docElem = b.documentElement;
            win = b.defaultView;
            return {
                top: clientRect.top + win.pageYOffset - docElem.clientTop,
                left: clientRect.left + win.pageXOffset - docElem.clientLeft
            }
        };
        var f = function (a) {
            return a.inline ? e(a.getBody()) : {
                left: 0,
                top: 0
            }
        };
        var g = function (a) {
            var b = a.getBody();
            return a.inline ? {
                left: b.scrollLeft,
                top: b.scrollTop
            } : {
                    left: 0,
                    top: 0
                }
        };
        var h = function (a) {
            var b = a.getBody(),
                docElm = a.getDoc().documentElement;
            var c = {
                left: b.scrollLeft,
                top: b.scrollTop
            };
            var d = {
                left: b.scrollLeft || docElm.scrollLeft,
                top: b.scrollTop || docElm.scrollTop
            };
            return a.inline ? c : d
        };
        var i = function (a, b) {
            if (b.target.ownerDocument !== a.getDoc()) {
                var c = e(a.getContentAreaContainer());
                var d = h(a);
                return {
                    left: b.pageX - c.left + d.left,
                    top: b.pageY - c.top + d.top
                }
            }
            return {
                left: b.pageX,
                top: b.pageY
            }
        };
        var j = function (a, b, c) {
            return {
                pageX: (c.left - a.left) + b.left,
                pageY: (c.top - a.top) + b.top
            }
        };
        var k = function (a, b) {
            return j(f(a), g(a), i(a, b))
        };
        return {
            calc: k
        }
    });
    define("tinymce/DragDropOverrides", ["tinymce/dom/NodeType", "tinymce/util/Arr", "tinymce/util/Fun", "tinymce/util/Delay", "tinymce/dom/DOMUtils", "tinymce/dom/MousePosition"], function (h, i, j, k, l, m) {
        var n = h.isContentEditableFalse,
            isContentEditableTrue = h.isContentEditableTrue;
        var o = function (a) {
            return n(a)
        };
        var p = function (a, b, c) {
            if (b === c || a.dom.isChildOf(b, c)) {
                return false
            }
            if (n(b)) {
                return false
            }
            return true
        };
        var q = function (a) {
            var b = a.cloneNode(true);
            b.removeAttribute('data-mce-selected');
            return b
        };
        var r = function (a, b, c, d) {
            var e = b.cloneNode(true);
            a.dom.setStyles(e, {
                width: c,
                height: d
            });
            a.dom.setAttrib(e, 'data-mce-selected', null);
            var f = a.dom.create('div', {
                'class': 'mce-drag-container',
                'data-mce-bogus': 'all',
                unselectable: 'on',
                contenteditable: 'false'
            });
            a.dom.setStyles(f, {
                position: 'absolute',
                opacity: 0.5,
                overflow: 'hidden',
                border: 0,
                padding: 0,
                margin: 0,
                width: c,
                height: d
            });
            a.dom.setStyles(e, {
                margin: 0,
                boxSizing: 'border-box'
            });
            f.appendChild(e);
            return f
        };
        var s = function (a, b) {
            if (a.parentNode !== b) {
                b.appendChild(a)
            }
        };
        var t = function (a, b, c, d, e, f) {
            var g = 0,
                overflowY = 0;
            a.style.left = b.pageX + 'px';
            a.style.top = b.pageY + 'px';
            if (b.pageX + c > e) {
                g = (b.pageX + c) - e
            }
            if (b.pageY + d > f) {
                overflowY = (b.pageY + d) - f
            }
            a.style.width = (c - g) + 'px';
            a.style.height = (d - overflowY) + 'px'
        };
        var u = function (a) {
            if (a && a.parentNode) {
                a.parentNode.removeChild(a)
            }
        };
        var v = function (e) {
            return e.button === 0
        };
        var w = function (a) {
            return a.element
        };
        var x = function (a, b) {
            return {
                pageX: b.pageX - a.relX,
                pageY: b.pageY + 5
            }
        };
        var y = function (f, g) {
            return function (e) {
                if (v(e)) {
                    var a = i.find(g.dom.getParents(e.target), j.or(n, isContentEditableTrue));
                    if (o(a)) {
                        var b = g.dom.getPos(a);
                        var c = g.getBody();
                        var d = g.getDoc().documentElement;
                        f.element = a;
                        f.screenX = e.screenX;
                        f.screenY = e.screenY;
                        f.maxX = (g.inline ? c.scrollWidth : d.offsetWidth) - 2;
                        f.maxY = (g.inline ? c.scrollHeight : d.offsetHeight) - 2;
                        f.relX = e.pageX - b.x;
                        f.relY = e.pageY - b.y;
                        f.width = a.offsetWidth;
                        f.height = a.offsetHeight;
                        f.ghost = r(g, a, f.width, f.height)
                    }
                }
            }
        };
        var z = function (d, f) {
            var g = k.throttle(function (a, b) {
                f._selectionOverrides.hideFakeCaret();
                f.selection.placeCaretAt(a, b)
            }, 0);
            return function (e) {
                var a = Math.max(Math.abs(e.screenX - d.screenX), Math.abs(e.screenY - d.screenY));
                if (w(d) && !d.dragging && a > 10) {
                    var b = f.fire('dragstart', {
                        target: d.element
                    });
                    if (b.isDefaultPrevented()) {
                        return
                    }
                    d.dragging = true;
                    f.focus()
                }
                if (d.dragging) {
                    var c = x(d, m.calc(f, e));
                    s(d.ghost, f.getBody());
                    t(d.ghost, c, d.width, d.height, d.maxX, d.maxY);
                    g(e.clientX, e.clientY)
                }
            }
        };
        var A = function (c, d) {
            return function (e) {
                if (c.dragging) {
                    if (p(d, d.selection.getNode(), c.element)) {
                        var a = q(c.element);
                        var b = d.fire('drop', {
                            targetClone: a,
                            clientX: e.clientX,
                            clientY: e.clientY
                        });
                        if (!b.isDefaultPrevented()) {
                            a = b.targetClone;
                            d.undoManager.transact(function () {
                                u(c.element);
                                d.insertContent(d.dom.getOuterHTML(a));
                                d._selectionOverrides.hideFakeCaret()
                            })
                        }
                    }
                }
                C(c)
            }
        };
        var B = function (a, b) {
            return function () {
                C(a);
                if (a.dragging) {
                    b.fire('dragend')
                }
            }
        };
        var C = function (a) {
            a.dragging = false;
            a.element = null;
            u(a.ghost)
        };
        var D = function (a) {
            var b = {},
                pageDom, dragStartHandler, dragHandler, dropHandler, dragEndHandler, rootDocument;
            pageDom = l.DOM;
            rootDocument = document;
            dragStartHandler = y(b, a);
            dragHandler = z(b, a);
            dropHandler = A(b, a);
            dragEndHandler = B(b, a);
            a.on('mousedown', dragStartHandler);
            a.on('mousemove', dragHandler);
            a.on('mouseup', dropHandler);
            pageDom.bind(rootDocument, 'mousemove', dragHandler);
            pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
            a.on('remove', function () {
                pageDom.unbind(rootDocument, 'mousemove', dragHandler);
                pageDom.unbind(rootDocument, 'mouseup', dragEndHandler)
            })
        };
        var E = function (b) {
            b.on('drop', function (e) {
                var a = typeof e.clientX !== 'undefined' ? b.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
                if (n(a) || n(b.dom.getContentEditableParent(a))) {
                    e.preventDefault()
                }
            })
        };
        var F = function (a) {
            D(a);
            E(a)
        };
        return {
            init: F
        }
    });
    define("tinymce/SelectionOverrides", ["tinymce/Env", "tinymce/caret/CaretWalker", "tinymce/caret/CaretPosition", "tinymce/caret/CaretContainer", "tinymce/caret/CaretUtils", "tinymce/caret/FakeCaret", "tinymce/caret/LineWalker", "tinymce/caret/LineUtils", "tinymce/dom/NodeType", "tinymce/dom/RangeUtils", "tinymce/geom/ClientRect", "tinymce/util/VK", "tinymce/util/Fun", "tinymce/util/Arr", "tinymce/util/Delay", "tinymce/DragDropOverrides", "tinymce/text/Zwsp"], function (s, t, u, v, w, x, y, z, A, B, C, D, E, F, G, H, I) {
        var J = E.curry,
            isContentEditableTrue = A.isContentEditableTrue,
            isContentEditableFalse = A.isContentEditableFalse,
            isElement = A.isElement,
            isAfterContentEditableFalse = w.isAfterContentEditableFalse,
            isBeforeContentEditableFalse = w.isBeforeContentEditableFalse,
            getSelectedNode = B.getSelectedNode;

        function getVisualCaretPosition(a, b) {
            while ((b = a(b))) {
                if (b.isVisible()) {
                    return b
                }
            }
            return b
        }
        function SelectionOverrides(o) {
            var p = o.getBody(),
                caretWalker = new t(p);
            var q = J(getVisualCaretPosition, caretWalker.next);
            var r = J(getVisualCaretPosition, caretWalker.prev),
                fakeCaret = new x(o.getBody(), isBlock),
                realSelectionId = 'sel-' + o.dom.uniqueId(),
                selectedContentEditableNode, $ = o.$;

            function getRealSelectionElement() {
                var a = o.dom.get(realSelectionId);
                return a ? a.getElementsByTagName('*')[0] : a
            }
            function isBlock(a) {
                return o.dom.isBlock(a)
            }
            function setRange(a) {
                if (a) {
                    o.selection.setRng(a)
                }
            }
            function getRange() {
                return o.selection.getRng()
            }
            function scrollIntoView(a, b) {
                o.selection.scrollIntoView(a, b)
            }
            function showCaret(a, b, c) {
                var e;
                e = o.fire('ShowCaret', {
                    target: b,
                    direction: a,
                    before: c
                });
                if (e.isDefaultPrevented()) {
                    return null
                }
                scrollIntoView(b, a === -1);
                return fakeCaret.show(c, b)
            }
            function selectNode(a) {
                var e;
                fakeCaret.hide();
                e = o.fire('BeforeObjectSelected', {
                    target: a
                });
                if (e.isDefaultPrevented()) {
                    return null
                }
                return getNodeRange(a)
            }
            function getNodeRange(a) {
                var b = a.ownerDocument.createRange();
                b.selectNode(a);
                return b
            }
            function isMoveInsideSameBlock(a, b) {
                var c = w.isInSameBlock(a, b);
                if (!c && A.isBr(a.getNode())) {
                    return true
                }
                return c
            }
            function getNormalizedRangeEndPoint(a, b) {
                b = w.normalizeRange(a, p, b);
                if (a == -1) {
                    return u.fromRangeStart(b)
                }
                return u.fromRangeEnd(b)
            }
            function isRangeInCaretContainerBlock(a) {
                return v.isCaretContainerBlock(a.startContainer)
            }
            function moveToCeFalseHorizontally(a, b, c, d) {
                var e, caretPosition, peekCaretPosition, rangeIsInContainerBlock;
                if (!d.collapsed) {
                    e = getSelectedNode(d);
                    if (isContentEditableFalse(e)) {
                        return showCaret(a, e, a == -1)
                    }
                }
                rangeIsInContainerBlock = isRangeInCaretContainerBlock(d);
                caretPosition = getNormalizedRangeEndPoint(a, d);
                if (c(caretPosition)) {
                    return selectNode(caretPosition.getNode(a == -1))
                }
                caretPosition = b(caretPosition);
                if (!caretPosition) {
                    if (rangeIsInContainerBlock) {
                        return d
                    }
                    return null
                }
                if (c(caretPosition)) {
                    return showCaret(a, caretPosition.getNode(a == -1), a == 1)
                }
                peekCaretPosition = b(caretPosition);
                if (c(peekCaretPosition)) {
                    if (isMoveInsideSameBlock(caretPosition, peekCaretPosition)) {
                        return showCaret(a, peekCaretPosition.getNode(a == -1), a == 1)
                    }
                }
                if (rangeIsInContainerBlock) {
                    return renderRangeCaret(caretPosition.toRange())
                }
                return null
            }
            function moveToCeFalseVertically(a, b, c) {
                var d, linePositions, nextLinePositions, closestNextLineRect, caretClientRect, clientX, dist1, dist2, contentEditableFalseNode;
                contentEditableFalseNode = getSelectedNode(c);
                d = getNormalizedRangeEndPoint(a, c);
                linePositions = b(p, y.isAboveLine(1), d);
                nextLinePositions = F.filter(linePositions, y.isLine(1));
                caretClientRect = F.last(d.getClientRects());
                if (isBeforeContentEditableFalse(d)) {
                    contentEditableFalseNode = d.getNode()
                }
                if (isAfterContentEditableFalse(d)) {
                    contentEditableFalseNode = d.getNode(true)
                }
                if (!caretClientRect) {
                    return null
                }
                clientX = caretClientRect.left;
                closestNextLineRect = z.findClosestClientRect(nextLinePositions, clientX);
                if (closestNextLineRect) {
                    if (isContentEditableFalse(closestNextLineRect.node)) {
                        dist1 = Math.abs(clientX - closestNextLineRect.left);
                        dist2 = Math.abs(clientX - closestNextLineRect.right);
                        return showCaret(a, closestNextLineRect.node, dist1 < dist2)
                    }
                }
                if (contentEditableFalseNode) {
                    var e = y.positionsUntil(a, p, y.isAboveLine(1), contentEditableFalseNode);
                    closestNextLineRect = z.findClosestClientRect(F.filter(e, y.isLine(1)), clientX);
                    if (closestNextLineRect) {
                        return renderRangeCaret(closestNextLineRect.position.toRange())
                    }
                    closestNextLineRect = F.last(F.filter(e, y.isLine(0)));
                    if (closestNextLineRect) {
                        return renderRangeCaret(closestNextLineRect.position.toRange())
                    }
                }
            }
            function exitPreBlock(b, c) {
                var d, caretPos, newBlock;

                function createTextBlock() {
                    var a = o.dom.create(o.settings.forced_root_block);
                    if (!s.ie || s.ie >= 11) {
                        a.innerHTML = '<br data-mce-bogus="1">'
                    }
                    return a
                }
                if (c.collapsed && o.settings.forced_root_block) {
                    d = o.dom.getParent(c.startContainer, 'PRE');
                    if (!d) {
                        return
                    }
                    if (b == 1) {
                        caretPos = q(u.fromRangeStart(c))
                    } else {
                        caretPos = r(u.fromRangeStart(c))
                    }
                    if (!caretPos) {
                        newBlock = createTextBlock();
                        if (b == 1) {
                            o.$(d).after(newBlock)
                        } else {
                            o.$(d).before(newBlock)
                        }
                        o.selection.select(newBlock, true);
                        o.selection.collapse()
                    }
                }
            }
            function moveH(a, b, c, d) {
                var e;
                e = moveToCeFalseHorizontally(a, b, c, d);
                if (e) {
                    return e
                }
                e = exitPreBlock(a, d);
                if (e) {
                    return e
                }
                return null
            }
            function moveV(a, b, c) {
                var d;
                d = moveToCeFalseVertically(a, b, c);
                if (d) {
                    return d
                }
                d = exitPreBlock(a, c);
                if (d) {
                    return d
                }
                return null
            }
            function getBlockCaretContainer() {
                return $('*[data-mce-caret]')[0]
            }
            function showBlockCaretContainer(a) {
                a = $(a);
                if (a.attr('data-mce-caret')) {
                    fakeCaret.hide();
                    a.removeAttr('data-mce-caret');
                    a.removeAttr('data-mce-bogus');
                    a.removeAttr('style');
                    setRange(getRange());
                    scrollIntoView(a[0])
                }
            }
            function renderCaretAtRange(a) {
                var b, ceRoot;
                a = w.normalizeRange(1, p, a);
                b = u.fromRangeStart(a);
                if (isContentEditableFalse(b.getNode())) {
                    return showCaret(1, b.getNode(), !b.isAtEnd())
                }
                if (isContentEditableFalse(b.getNode(true))) {
                    return showCaret(1, b.getNode(true), false)
                }
                ceRoot = o.dom.getParent(b.getNode(), E.or(isContentEditableFalse, isContentEditableTrue));
                if (isContentEditableFalse(ceRoot)) {
                    return showCaret(1, ceRoot, false)
                }
                fakeCaret.hide();
                return null
            }
            function renderRangeCaret(a) {
                var b;
                if (!a || !a.collapsed) {
                    return a
                }
                b = renderCaretAtRange(a);
                if (b) {
                    return b
                }
                return a
            }
            function deleteContentEditableNode(a) {
                var b, prevCaretPosition, prevCeFalseElm, nextElement;
                if (!isContentEditableFalse(a)) {
                    return null
                }
                if (isContentEditableFalse(a.previousSibling)) {
                    prevCeFalseElm = a.previousSibling
                }
                prevCaretPosition = r(u.before(a));
                if (!prevCaretPosition) {
                    b = q(u.after(a))
                }
                if (b && isElement(b.getNode())) {
                    nextElement = b.getNode()
                }
                v.remove(a.previousSibling);
                v.remove(a.nextSibling);
                o.dom.remove(a);
                clearContentEditableSelection();
                if (o.dom.isEmpty(o.getBody())) {
                    o.setContent('');
                    o.focus();
                    return
                }
                if (prevCeFalseElm) {
                    return u.after(prevCeFalseElm).toRange()
                }
                if (nextElement) {
                    return u.before(nextElement).toRange()
                }
                if (prevCaretPosition) {
                    return prevCaretPosition.toRange()
                }
                if (b) {
                    return b.toRange()
                }
                return null
            }
            function isTextBlock(a) {
                var b = o.schema.getTextBlockElements();
                return a.nodeName in b
            }
            function isEmpty(a) {
                return o.dom.isEmpty(a)
            }
            function mergeTextBlocks(a, b, c) {
                var d = o.dom,
                    fromBlock, toBlock, node, ceTarget;
                fromBlock = d.getParent(b.getNode(), d.isBlock);
                toBlock = d.getParent(c.getNode(), d.isBlock);
                if (a === -1) {
                    ceTarget = c.getNode(true);
                    if (isAfterContentEditableFalse(c) && isBlock(ceTarget)) {
                        if (isTextBlock(fromBlock)) {
                            if (isEmpty(fromBlock)) {
                                d.remove(fromBlock)
                            }
                            return u.after(ceTarget).toRange()
                        }
                        return deleteContentEditableNode(c.getNode(true))
                    }
                } else {
                    ceTarget = b.getNode();
                    if (isBeforeContentEditableFalse(b) && isBlock(ceTarget)) {
                        if (isTextBlock(toBlock)) {
                            if (isEmpty(toBlock)) {
                                d.remove(toBlock)
                            }
                            return u.before(ceTarget).toRange()
                        }
                        return deleteContentEditableNode(b.getNode())
                    }
                }
                if (fromBlock === toBlock || !isTextBlock(fromBlock) || !isTextBlock(toBlock)) {
                    return null
                }
                while ((node = fromBlock.firstChild)) {
                    toBlock.appendChild(node)
                }
                o.dom.remove(fromBlock);
                return c.toRange()
            }
            function backspaceDelete(a, b, c, d) {
                var e, caretPosition, peekCaretPosition, newCaretPosition;
                if (!d.collapsed) {
                    e = getSelectedNode(d);
                    if (isContentEditableFalse(e)) {
                        return renderRangeCaret(deleteContentEditableNode(e))
                    }
                }
                caretPosition = getNormalizedRangeEndPoint(a, d);
                if (c(caretPosition) && v.isCaretContainerBlock(d.startContainer)) {
                    newCaretPosition = a == -1 ? caretWalker.prev(caretPosition) : caretWalker.next(caretPosition);
                    return newCaretPosition ? renderRangeCaret(newCaretPosition.toRange()) : d
                }
                if (b(caretPosition)) {
                    return renderRangeCaret(deleteContentEditableNode(caretPosition.getNode(a == -1)))
                }
                peekCaretPosition = a == -1 ? caretWalker.prev(caretPosition) : caretWalker.next(caretPosition);
                if (b(peekCaretPosition)) {
                    if (a === -1) {
                        return mergeTextBlocks(a, caretPosition, peekCaretPosition)
                    }
                    return mergeTextBlocks(a, peekCaretPosition, caretPosition)
                }
            }
            function registerEvents() {
                var f = J(moveH, 1, q, isBeforeContentEditableFalse);
                var g = J(moveH, -1, r, isAfterContentEditableFalse);
                var h = J(backspaceDelete, 1, isBeforeContentEditableFalse, isAfterContentEditableFalse);
                var i = J(backspaceDelete, -1, isAfterContentEditableFalse, isBeforeContentEditableFalse);
                var j = J(moveV, -1, y.upUntil);
                var k = J(moveV, 1, y.downUntil);

                function override(a, b) {
                    var c = b(getRange());
                    if (c && !a.isDefaultPrevented()) {
                        a.preventDefault();
                        setRange(c)
                    }
                }
                function getContentEditableRoot(a) {
                    var b = o.getBody();
                    while (a && a != b) {
                        if (isContentEditableTrue(a) || isContentEditableFalse(a)) {
                            return a
                        }
                        a = a.parentNode
                    }
                    return null
                }
                function isXYWithinRange(c, d, e) {
                    if (e.collapsed) {
                        return false
                    }
                    return F.reduce(e.getClientRects(), function (a, b) {
                        return a || C.containsXY(b, c, d)
                    }, false)
                }
                o.on('mouseup', function () {
                    var a = getRange();
                    if (a.collapsed) {
                        setRange(renderCaretAtRange(a))
                    }
                });
                o.on('click', function (e) {
                    var a;
                    a = getContentEditableRoot(e.target);
                    if (a) {
                        if (isContentEditableFalse(a)) {
                            e.preventDefault();
                            o.focus()
                        }
                    }
                });

                function handleTouchSelect(b) {
                    var c = false;
                    b.on('touchstart', function () {
                        c = false
                    });
                    b.on('touchmove', function () {
                        c = true
                    });
                    b.on('touchend', function (e) {
                        var a = getContentEditableRoot(e.target);
                        if (isContentEditableFalse(a)) {
                            if (!c) {
                                e.preventDefault();
                                setContentEditableSelection(selectNode(a))
                            }
                        } else {
                            clearContentEditableSelection()
                        }
                    })
                }
                var l = function (a) {
                    var b = new t(a);
                    if (!a.firstChild) {
                        return false
                    }
                    var c = u.before(a.firstChild);
                    var d = b.next(c);
                    return d && !isBeforeContentEditableFalse(d) && !isAfterContentEditableFalse(d)
                };
                var m = function (a, b) {
                    var c = o.dom.getParent(a, o.dom.isBlock);
                    var d = o.dom.getParent(b, o.dom.isBlock);
                    return c === d
                };
                var n = function (a, b) {
                    var c = o.dom.getParent(a, o.dom.isBlock);
                    var d = o.dom.getParent(b, o.dom.isBlock);
                    return c && !m(c, d) && l(c)
                };
                handleTouchSelect(o);
                o.on('mousedown', function (e) {
                    var a;
                    a = getContentEditableRoot(e.target);
                    if (a) {
                        if (isContentEditableFalse(a)) {
                            e.preventDefault();
                            setContentEditableSelection(selectNode(a))
                        } else {
                            clearContentEditableSelection();
                            if (!isXYWithinRange(e.clientX, e.clientY, o.selection.getRng())) {
                                o.selection.placeCaretAt(e.clientX, e.clientY)
                            }
                        }
                    } else {
                        clearContentEditableSelection();
                        fakeCaret.hide();
                        var b = z.closestCaret(p, e.clientX, e.clientY);
                        if (b) {
                            if (!n(e.target, b.node)) {
                                e.preventDefault();
                                o.getBody().focus();
                                setRange(showCaret(1, b.node, b.before))
                            }
                        }
                    }
                });
                o.on('keydown', function (e) {
                    if (D.modifierPressed(e)) {
                        return
                    }
                    switch (e.keyCode) {
                        case D.RIGHT:
                            override(e, f);
                            break;
                        case D.DOWN:
                            override(e, k);
                            break;
                        case D.LEFT:
                            override(e, g);
                            break;
                        case D.UP:
                            override(e, j);
                            break;
                        case D.DELETE:
                            override(e, h);
                            break;
                        case D.BACKSPACE:
                            override(e, i);
                            break;
                        default:
                            if (isContentEditableFalse(o.selection.getNode())) {
                                e.preventDefault()
                            }
                            break
                    }
                });

                function paddEmptyContentEditableArea() {
                    var a, ceRoot = getContentEditableRoot(o.selection.getNode());
                    if (isContentEditableTrue(ceRoot) && isBlock(ceRoot) && o.dom.isEmpty(ceRoot)) {
                        a = o.dom.create('br', {
                            "data-mce-bogus": "1"
                        });
                        o.$(ceRoot).empty().append(a);
                        o.selection.setRng(u.before(a).toRange())
                    }
                }
                function handleBlockContainer(e) {
                    var a = getBlockCaretContainer();
                    if (!a) {
                        return
                    }
                    if (e.type == 'compositionstart') {
                        e.preventDefault();
                        e.stopPropagation();
                        showBlockCaretContainer(a);
                        return
                    }
                    if (a.innerHTML != '&nbsp;') {
                        showBlockCaretContainer(a)
                    }
                }
                function handleEmptyBackspaceDelete(e) {
                    var a;
                    switch (e.keyCode) {
                        case D.DELETE:
                            a = paddEmptyContentEditableArea();
                            break;
                        case D.BACKSPACE:
                            a = paddEmptyContentEditableArea();
                            break
                    }
                    if (a) {
                        e.preventDefault()
                    }
                }
                o.on('keyup compositionstart', function (e) {
                    handleBlockContainer(e);
                    handleEmptyBackspaceDelete(e)
                }, true);
                o.on('cut', function () {
                    var a = o.selection.getNode();
                    if (isContentEditableFalse(a)) {
                        G.setEditorTimeout(o, function () {
                            setRange(renderRangeCaret(deleteContentEditableNode(a)))
                        })
                    }
                });
                o.on('getSelectionRange', function (e) {
                    var a = e.range;
                    if (selectedContentEditableNode) {
                        if (!selectedContentEditableNode.parentNode) {
                            selectedContentEditableNode = null;
                            return
                        }
                        a = a.cloneRange();
                        a.selectNode(selectedContentEditableNode);
                        e.range = a
                    }
                });
                o.on('setSelectionRange', function (e) {
                    var a;
                    a = setContentEditableSelection(e.range);
                    if (a) {
                        e.range = a
                    }
                });
                o.on('focus', function () {
                    G.setEditorTimeout(o, function () {
                        o.selection.setRng(renderRangeCaret(o.selection.getRng()))
                    }, 0)
                });
                o.on('copy', function (e) {
                    var a = e.clipboardData;
                    if (!e.isDefaultPrevented() && e.clipboardData && !s.ie) {
                        var b = getRealSelectionElement();
                        if (b) {
                            e.preventDefault();
                            a.clearData();
                            a.setData('text/html', b.outerHTML);
                            a.setData('text/plain', b.outerText)
                        }
                    }
                });
                H.init(o)
            }
            function addCss() {
                var a = o.contentStyles,
                    rootClass = '.mce-content-body';
                a.push(fakeCaret.getCss());
                a.push(rootClass + ' .mce-offscreen-selection {' + 'position: absolute;' + 'left: -9999999999px;' + '}' + rootClass + ' *[contentEditable=false] {' + 'cursor: default;' + '}' + rootClass + ' *[contentEditable=true] {' + 'cursor: text;' + '}')
            }
            function isRangeInCaretContainer(a) {
                return v.isCaretContainer(a.startContainer) || v.isCaretContainer(a.endContainer)
            }
            function setContentEditableSelection(a) {
                var b, $ = o.$,
                    dom = o.dom,
                    $realSelectionContainer, sel, startContainer, startOffset, endOffset, e, caretPosition, targetClone, origTargetClone;
                if (!a) {
                    clearContentEditableSelection();
                    return null
                }
                if (a.collapsed) {
                    clearContentEditableSelection();
                    if (!isRangeInCaretContainer(a)) {
                        caretPosition = getNormalizedRangeEndPoint(1, a);
                        if (isContentEditableFalse(caretPosition.getNode())) {
                            return showCaret(1, caretPosition.getNode(), !caretPosition.isAtEnd())
                        }
                        if (isContentEditableFalse(caretPosition.getNode(true))) {
                            return showCaret(1, caretPosition.getNode(true), false)
                        }
                    }
                    return null
                }
                startContainer = a.startContainer;
                startOffset = a.startOffset;
                endOffset = a.endOffset;
                if (startContainer.nodeType == 3 && startOffset == 0 && isContentEditableFalse(startContainer.parentNode)) {
                    startContainer = startContainer.parentNode;
                    startOffset = dom.nodeIndex(startContainer);
                    startContainer = startContainer.parentNode
                }
                if (startContainer.nodeType != 1) {
                    clearContentEditableSelection();
                    return null
                }
                if (endOffset == startOffset + 1) {
                    b = startContainer.childNodes[startOffset]
                }
                if (!isContentEditableFalse(b)) {
                    clearContentEditableSelection();
                    return null
                }
                targetClone = origTargetClone = b.cloneNode(true);
                e = o.fire('ObjectSelected', {
                    target: b,
                    targetClone: targetClone
                });
                if (e.isDefaultPrevented()) {
                    clearContentEditableSelection();
                    return null
                }
                targetClone = e.targetClone;
                $realSelectionContainer = $('#' + realSelectionId);
                if ($realSelectionContainer.length === 0) {
                    $realSelectionContainer = $('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr('id', realSelectionId);
                    $realSelectionContainer.appendTo(o.getBody())
                }
                a = o.dom.createRng();
                if (targetClone === origTargetClone && s.ie) {
                    $realSelectionContainer.empty().append(I.ZWSP).append(targetClone).append(I.ZWSP);
                    a.setStart($realSelectionContainer[0].firstChild, 0);
                    a.setEnd($realSelectionContainer[0].lastChild, 1)
                } else {
                    $realSelectionContainer.empty().append(' ').append(targetClone).append(' ');
                    a.setStart($realSelectionContainer[0].firstChild, 1);
                    a.setEnd($realSelectionContainer[0].lastChild, 0)
                }
                $realSelectionContainer.css({
                    top: dom.getPos(b, o.getBody()).y
                });
                $realSelectionContainer[0].focus();
                sel = o.selection.getSel();
                sel.removeAllRanges();
                sel.addRange(a);
                o.$('*[data-mce-selected]').removeAttr('data-mce-selected');
                b.setAttribute('data-mce-selected', 1);
                selectedContentEditableNode = b;
                return a
            }
            function clearContentEditableSelection() {
                if (selectedContentEditableNode) {
                    selectedContentEditableNode.removeAttribute('data-mce-selected');
                    o.$('#' + realSelectionId).remove();
                    selectedContentEditableNode = null
                }
            }
            function destroy() {
                fakeCaret.destroy();
                selectedContentEditableNode = null
            }
            function hideFakeCaret() {
                fakeCaret.hide()
            }
            if (s.ceFalse) {
                registerEvents();
                addCss()
            }
            return {
                showBlockCaretContainer: showBlockCaretContainer,
                hideFakeCaret: hideFakeCaret,
                destroy: destroy
            }
        }
        return SelectionOverrides
    });
    define("tinymce/util/Uuid", [], function () {
        var c = 0;
        var d = function () {
            var a = function () {
                return Math.round(Math.random() * 0xFFFFFFFF).toString(36)
            };
            var b = new Date().getTime();
            return 's' + b.toString(36) + a() + a() + a()
        };
        var e = function (a) {
            return a + (c++) + d()
        };
        return {
            uuid: e
        }
    });
    define("tinymce/Editor", ["tinymce/dom/DOMUtils", "tinymce/dom/DomQuery", "tinymce/AddOnManager", "tinymce/NodeChange", "tinymce/html/Node", "tinymce/dom/Serializer", "tinymce/html/Serializer", "tinymce/dom/Selection", "tinymce/Formatter", "tinymce/UndoManager", "tinymce/EnterKey", "tinymce/ForceBlocks", "tinymce/EditorCommands", "tinymce/util/URI", "tinymce/dom/ScriptLoader", "tinymce/dom/EventUtils", "tinymce/WindowManager", "tinymce/NotificationManager", "tinymce/html/Schema", "tinymce/html/DomParser", "tinymce/util/Quirks", "tinymce/Env", "tinymce/util/Tools", "tinymce/util/Delay", "tinymce/EditorObservable", "tinymce/Mode", "tinymce/Shortcuts", "tinymce/EditorUpload", "tinymce/SelectionOverrides", "tinymce/util/Uuid"], function (k, l, m, p, q, r, s, t, v, x, y, z, A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R) {
        var S = k.DOM,
            ThemeManager = m.ThemeManager,
            PluginManager = m.PluginManager;
        var T = K.extend,
            each = K.each,
            explode = K.explode;
        var U = K.inArray,
            trim = K.trim,
            resolve = K.resolve;
        var V = D.Event;
        var W = J.gecko,
            ie = J.ie;

        function Editor(a, b, c) {
            var d = this,
                documentBaseUrl, baseUri, defaultSettings;
            documentBaseUrl = d.documentBaseUrl = c.documentBaseURL;
            baseUri = c.baseURI;
            defaultSettings = c.defaultSettings;
            b = T({
                id: a,
                theme: 'modern',
                delta_width: 0,
                delta_height: 0,
                popup_css: '',
                plugins: '',
                document_base_url: documentBaseUrl,
                add_form_submit_trigger: true,
                submit_patch: true,
                add_unload_trigger: true,
                convert_urls: true,
                relative_urls: true,
                remove_script_host: true,
                object_resizing: true,
                doctype: '<!DOCTYPE html>',
                visual: true,
                font_size_style_values: 'xx-small,x-small,small,medium,large,x-large,xx-large',
                font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
                forced_root_block: 'p',
                hidden_input: true,
                padd_empty_editor: true,
                render_ui: true,
                indentation: '30px',
                inline_styles: true,
                convert_fonts_to_spans: true,
                indent: 'simple',
                indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
                indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
                validate: true,
                entity_encoding: 'named',
                url_converter: d.convertURL,
                url_converter_scope: d,
                ie7_compat: true
            }, defaultSettings, b);
            if (defaultSettings && defaultSettings.external_plugins && b.external_plugins) {
                b.external_plugins = T({}, defaultSettings.external_plugins, b.external_plugins)
            }
            d.settings = b;
            m.language = b.language || 'en';
            m.languageLoad = b.language_load;
            m.baseURL = c.baseURL;
            d.id = b.id = a;
            d.setDirty(false);
            d.plugins = {};
            d.documentBaseURI = new B(b.document_base_url || documentBaseUrl, {
                base_uri: baseUri
            });
            d.baseURI = baseUri;
            d.contentCSS = [];
            d.contentStyles = [];
            d.shortcuts = new O(d);
            d.loadedCSS = {};
            d.editorCommands = new A(d);
            if (b.target) {
                d.targetElm = b.target
            }
            d.suffix = c.suffix;
            d.editorManager = c;
            d.inline = b.inline;
            d.settings.content_editable = d.inline;
            if (b.cache_suffix) {
                J.cacheSuffix = b.cache_suffix.replace(/^[\?\&]+/, '')
            }
            if (b.override_viewport === false) {
                J.overrideViewPort = false
            }
            c.fire('SetupEditor', d);
            d.execCallback('setup', d);
            d.$ = l.overrideDefaults(function () {
                return {
                    context: d.inline ? d.getBody() : d.getDoc(),
                    element: d.getBody()
                }
            })
        }
        Editor.prototype = {
            render: function () {
                var g = this,
                    settings = g.settings,
                    id = g.id,
                    suffix = g.suffix;

                function readyHandler() {
                    S.unbind(window, 'ready', readyHandler);
                    g.render()
                }
                if (!V.domLoaded) {
                    S.bind(window, 'ready', readyHandler);
                    return
                }
                if (!g.getElement()) {
                    return
                }
                if (!J.contentEditable) {
                    return
                }
                if (!settings.inline) {
                    g.orgVisibility = g.getElement().style.visibility;
                    g.getElement().style.visibility = 'hidden'
                } else {
                    g.inline = true
                }
                var h = g.getElement().form || S.getParent(id, 'form');
                if (h) {
                    g.formElement = h;
                    if (settings.hidden_input && !/TEXTAREA|INPUT/i.test(g.getElement().nodeName)) {
                        S.insertAfter(S.create('input', {
                            type: 'hidden',
                            name: id
                        }), id);
                        g.hasHiddenInput = true
                    }
                    g.formEventDelegate = function (e) {
                        g.fire(e.type, e)
                    };
                    S.bind(h, 'submit reset', g.formEventDelegate);
                    g.on('reset', function () {
                        g.setContent(g.startContent, {
                            format: 'raw'
                        })
                    });
                    if (settings.submit_patch && !h.submit.nodeType && !h.submit.length && !h._mceOldSubmit) {
                        h._mceOldSubmit = h.submit;
                        h.submit = function () {
                            g.editorManager.triggerSave();
                            g.setDirty(false);
                            return h._mceOldSubmit(h)
                        }
                    }
                }
                g.windowManager = new E(g);
                g.notificationManager = new F(g);
                if (settings.encoding == 'xml') {
                    g.on('GetContent', function (e) {
                        if (e.save) {
                            e.content = S.encode(e.content)
                        }
                    })
                }
                if (settings.add_form_submit_trigger) {
                    g.on('submit', function () {
                        if (g.initialized) {
                            g.save()
                        }
                    })
                }
                if (settings.add_unload_trigger) {
                    g._beforeUnload = function () {
                        if (g.initialized && !g.destroyed && !g.isHidden()) {
                            g.save({
                                format: 'raw',
                                no_events: true,
                                set_dirty: false
                            })
                        }
                    };
                    g.editorManager.on('BeforeUnload', g._beforeUnload)
                }
                function loadScripts() {
                    var e = C.ScriptLoader;
                    if (settings.language && settings.language != 'en' && !settings.language_url) {
                        settings.language_url = g.editorManager.baseURL + '/langs/' + settings.language + '.js'
                    }
                    if (settings.language_url) {
                        e.add(settings.language_url)
                    }
                    if (settings.theme && typeof settings.theme != "function" && settings.theme.charAt(0) != '-' && !ThemeManager.urls[settings.theme]) {
                        var f = settings.theme_url;
                        if (f) {
                            f = g.documentBaseURI.toAbsolute(f)
                        } else {
                            f = 'themes/' + settings.theme + '/theme' + suffix + '.js'
                        }
                        ThemeManager.load(settings.theme, f)
                    }
                    if (K.isArray(settings.plugins)) {
                        settings.plugins = settings.plugins.join(' ')
                    }
                    each(settings.external_plugins, function (a, b) {
                        PluginManager.load(b, a);
                        settings.plugins += ' ' + b
                    });
                    each(settings.plugins.split(/[ ,]/), function (c) {
                        c = trim(c);
                        if (c && !PluginManager.urls[c]) {
                            if (c.charAt(0) == '-') {
                                c = c.substr(1, c.length);
                                var d = PluginManager.dependencies(c);
                                each(d, function (a) {
                                    var b = {
                                        prefix: 'plugins/',
                                        resource: a,
                                        suffix: '/plugin' + suffix + '.js'
                                    };
                                    a = PluginManager.createUrl(b, a);
                                    PluginManager.load(a.resource, a)
                                })
                            } else {
                                PluginManager.load(c, {
                                    prefix: 'plugins/',
                                    resource: c,
                                    suffix: '/plugin' + suffix + '.js'
                                })
                            }
                        }
                    });
                    e.loadQueue(function () {
                        if (!g.removed) {
                            g.init()
                        }
                    })
                }
                g.editorManager.add(g);
                loadScripts()
            },
            init: function () {
                var d = this,
                    settings = d.settings,
                    elm = d.getElement();
                var w, h, minHeight, n, o, Theme, url, bodyId, bodyClass, re, i, initializedPlugins = [];
                d.rtl = settings.rtl_ui || d.editorManager.i18n.rtl;
                d.editorManager.i18n.setCode(settings.language);
                settings.aria_label = settings.aria_label || S.getAttrib(elm, 'aria-label', d.getLang('aria.rich_text_area'));
                d.fire('ScriptsLoaded');
                if (settings.theme) {
                    if (typeof settings.theme != "function") {
                        settings.theme = settings.theme.replace(/-/, '');
                        Theme = ThemeManager.get(settings.theme);
                        d.theme = new Theme(d, ThemeManager.urls[settings.theme]);
                        if (d.theme.init) {
                            d.theme.init(d, ThemeManager.urls[settings.theme] || d.documentBaseUrl.replace(/\/$/, ''), d.$)
                        }
                    } else {
                        d.theme = settings.theme
                    }
                }
                function initPlugin(b) {
                    var c = PluginManager.get(b),
                        pluginUrl, pluginInstance;
                    pluginUrl = PluginManager.urls[b] || d.documentBaseUrl.replace(/\/$/, '');
                    b = trim(b);
                    if (c && U(initializedPlugins, b) === -1) {
                        each(PluginManager.dependencies(b), function (a) {
                            initPlugin(a)
                        });
                        if (d.plugins[b]) {
                            return
                        }
                        pluginInstance = new c(d, pluginUrl, d.$);
                        d.plugins[b] = pluginInstance;
                        if (pluginInstance.init) {
                            pluginInstance.init(d, pluginUrl);
                            initializedPlugins.push(b)
                        }
                    }
                }
                each(settings.plugins.replace(/\-/g, '').split(/[ ,]/), initPlugin);
                if (settings.render_ui && d.theme) {
                    d.orgDisplay = elm.style.display;
                    if (typeof settings.theme != "function") {
                        w = settings.width || elm.style.width || elm.offsetWidth;
                        h = settings.height || elm.style.height || elm.offsetHeight;
                        minHeight = settings.min_height || 100;
                        re = /^[0-9\.]+(|px)$/i;
                        if (re.test('' + w)) {
                            w = Math.max(parseInt(w, 10), 100)
                        }
                        if (re.test('' + h)) {
                            h = Math.max(parseInt(h, 10), minHeight)
                        }
                        o = d.theme.renderUI({
                            targetNode: elm,
                            width: w,
                            height: h,
                            deltaWidth: settings.delta_width,
                            deltaHeight: settings.delta_height
                        });
                        if (!settings.content_editable) {
                            h = (o.iframeHeight || h) + (typeof h == 'number' ? (o.deltaHeight || 0) : '');
                            if (h < minHeight) {
                                h = minHeight
                            }
                        }
                    } else {
                        o = settings.theme(d, elm);
                        if (o.editorContainer.nodeType) {
                            o.editorContainer = o.editorContainer.id = o.editorContainer.id || d.id + "_parent"
                        }
                        if (o.iframeContainer.nodeType) {
                            o.iframeContainer = o.iframeContainer.id = o.iframeContainer.id || d.id + "_iframecontainer"
                        }
                        h = o.iframeHeight || elm.offsetHeight
                    }
                    d.editorContainer = o.editorContainer
                }
                if (settings.content_css) {
                    each(explode(settings.content_css), function (u) {
                        d.contentCSS.push(d.documentBaseURI.toAbsolute(u))
                    })
                }
                if (settings.content_style) {
                    d.contentStyles.push(settings.content_style)
                }
                if (settings.content_editable) {
                    elm = n = o = null;
                    return d.initContentBody()
                }
                d.iframeHTML = settings.doctype + '<html><head>';
                if (settings.document_base_url != d.documentBaseUrl) {
                    d.iframeHTML += '<base href="' + d.documentBaseURI.getURI() + '" />'
                }
                if (!J.caretAfter && settings.ie7_compat) {
                    d.iframeHTML += '<meta http-equiv="X-UA-Compatible" content="IE=7" />'
                }
                d.iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
                if (!/#$/.test(document.location.href)) {
                    for (i = 0; i < d.contentCSS.length; i++) {
                        var f = d.contentCSS[i];
                        d.iframeHTML += ('<link type="text/css" ' + 'rel="stylesheet" ' + 'href="' + K._addCacheSuffix(f) + '" />');
                        d.loadedCSS[f] = true
                    }
                }
                bodyId = settings.body_id || 'tinymce';
                if (bodyId.indexOf('=') != -1) {
                    bodyId = d.getParam('body_id', '', 'hash');
                    bodyId = bodyId[d.id] || bodyId
                }
                bodyClass = settings.body_class || '';
                if (bodyClass.indexOf('=') != -1) {
                    bodyClass = d.getParam('body_class', '', 'hash');
                    bodyClass = bodyClass[d.id] || ''
                }
                if (settings.content_security_policy) {
                    d.iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + settings.content_security_policy + '" />'
                }
                d.iframeHTML += '</head><body id="' + bodyId + '" class="mce-content-body ' + bodyClass + '" data-id="' + d.id + '"><br></body></html>';
                var g = 'javascript:(function(){' + 'document.open();document.domain="' + document.domain + '";' + 'var ed = window.parent.tinymce.get("' + d.id + '");document.write(ed.iframeHTML);' + 'document.close();ed.initContentBody(true);})()';
                if (document.domain != location.hostname) {
                    if (J.ie && J.ie < 12) {
                        url = g
                    }
                }
                var j = S.create('iframe', {
                    id: d.id + "_ifr",
                    frameBorder: '0',
                    allowTransparency: "true",
                    title: d.editorManager.translate("Rich Text Area. Press ALT-F9 for menu. " + "Press ALT-F10 for toolbar. Press ALT-0 for help"),
                    style: {
                        width: '100%',
                        height: h,
                        display: 'block'
                    }
                });
                j.onload = function () {
                    j.onload = null;
                    d.fire("load")
                };
                S.setAttrib(j, "src", url || 'javascript:""');
                d.contentAreaContainer = o.iframeContainer;
                d.iframeElement = j;
                n = S.add(o.iframeContainer, j);
                if (ie) {
                    try {
                        d.getDoc()
                    } catch (e) {
                        n.src = url = g
                    }
                }
                if (o.editorContainer) {
                    S.get(o.editorContainer).style.display = d.orgDisplay;
                    d.hidden = S.isHidden(o.editorContainer)
                }
                d.getElement().style.display = 'none';
                S.setAttrib(d.id, 'aria-hidden', true);
                if (!url) {
                    d.initContentBody()
                }
                elm = n = o = null
            },
            initContentBody: function (c) {
                var d = this,
                    settings = d.settings,
                    targetElm = d.getElement(),
                    doc = d.getDoc(),
                    body, contentCssText;
                if (!settings.inline) {
                    d.getElement().style.visibility = d.orgVisibility
                }
                if (!c && !settings.content_editable) {
                    doc.open();
                    doc.write(d.iframeHTML);
                    doc.close()
                }
                if (settings.content_editable) {
                    d.on('remove', function () {
                        var a = this.getBody();
                        S.removeClass(a, 'mce-content-body');
                        S.removeClass(a, 'mce-edit-focus');
                        S.setAttrib(a, 'contentEditable', null)
                    });
                    S.addClass(targetElm, 'mce-content-body');
                    d.contentDocument = doc = settings.content_document || document;
                    d.contentWindow = settings.content_window || window;
                    d.bodyElement = targetElm;
                    settings.content_document = settings.content_window = null;
                    settings.root_name = targetElm.nodeName.toLowerCase()
                }
                body = d.getBody();
                body.disabled = true;
                d.readonly = settings.readonly;
                if (!d.readonly) {
                    if (d.inline && S.getStyle(body, 'position', true) == 'static') {
                        body.style.position = 'relative'
                    }
                    body.contentEditable = d.getParam('content_editable_state', true)
                }
                body.disabled = false;
                d.editorUpload = new P(d);
                d.schema = new G(settings);
                d.dom = new k(doc, {
                    keep_values: true,
                    url_converter: d.convertURL,
                    url_converter_scope: d,
                    hex_colors: settings.force_hex_style_colors,
                    class_filter: settings.class_filter,
                    update_styles: true,
                    root_element: d.inline ? d.getBody() : null,
                    collect: settings.content_editable,
                    schema: d.schema,
                    onSetAttrib: function (e) {
                        d.fire('SetAttrib', e)
                    }
                });
                d.parser = new H(settings, d.schema);
                d.parser.addAttributeFilter('src,href,style,tabindex', function (a, b) {
                    var i = a.length,
                        node, dom = d.dom,
                        value, internalName;
                    while (i--) {
                        node = a[i];
                        value = node.attr(b);
                        internalName = 'data-mce-' + b;
                        if (!node.attributes.map[internalName]) {
                            if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
                                continue
                            }
                            if (b === "style") {
                                value = dom.serializeStyle(dom.parseStyle(value), node.name);
                                if (!value.length) {
                                    value = null
                                }
                                node.attr(internalName, value);
                                node.attr(b, value)
                            } else if (b === "tabindex") {
                                node.attr(internalName, value);
                                node.attr(b, null)
                            } else {
                                node.attr(internalName, d.convertURL(value, b, node.name))
                            }
                        }
                    }
                });
                d.parser.addNodeFilter('script', function (a) {
                    var i = a.length,
                        node, type;
                    while (i--) {
                        node = a[i];
                        type = node.attr('type') || 'no/type';
                        if (type.indexOf('mce-') !== 0) {
                            node.attr('type', 'mce-' + type)
                        }
                    }
                });
                d.parser.addNodeFilter('#cdata', function (a) {
                    var i = a.length,
                        node;
                    while (i--) {
                        node = a[i];
                        node.type = 8;
                        node.name = '#comment';
                        node.value = '[CDATA[' + node.value + ']]'
                    }
                });
                d.parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function (a) {
                    var i = a.length,
                        node, nonEmptyElements = d.schema.getNonEmptyElements();
                    while (i--) {
                        node = a[i];
                        if (node.isEmpty(nonEmptyElements)) {
                            node.append(new q('br', 1)).shortEnded = true
                        }
                    }
                });
                d.serializer = new r(settings, d);
                d.selection = new t(d.dom, d.getWin(), d.serializer, d);
                d.formatter = new v(d);
                d.undoManager = new x(d);
                d.forceBlocks = new z(d);
                d.enterKey = new y(d);
                d._nodeChangeDispatcher = new p(d);
                d._selectionOverrides = new Q(d);
                d.fire('PreInit');
                if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
                    doc.body.spellcheck = false;
                    S.setAttrib(body, "spellcheck", "false")
                }
                d.quirks = new I(d);
                d.fire('PostRender');
                if (settings.directionality) {
                    body.dir = settings.directionality
                }
                if (settings.nowrap) {
                    body.style.whiteSpace = "nowrap"
                }
                if (settings.protect) {
                    d.on('BeforeSetContent', function (e) {
                        each(settings.protect, function (b) {
                            e.content = e.content.replace(b, function (a) {
                                return '<!--mce:protected ' + escape(a) + '-->'
                            })
                        })
                    })
                }
                d.on('SetContent', function () {
                    d.addVisual(d.getBody())
                });
                if (settings.padd_empty_editor) {
                    d.on('PostProcess', function (e) {
                        e.content = e.content.replace(/^(<p[^>]*>(&nbsp;|&#160;|\s| |)<\/p>[\r\n]*|<br \/>[\r\n]*)$/, '')
                    })
                }
                d.load({
                    initial: true,
                    format: 'html'
                });
                d.startContent = d.getContent({
                    format: 'raw'
                });
                d.initialized = true;
                d.bindPendingEventDelegates();
                d.fire('init');
                d.focus(true);
                d.nodeChanged({
                    initial: true
                });
                d.execCallback('init_instance_callback', d);
                d.on('compositionstart compositionend', function (e) {
                    d.composing = e.type === 'compositionstart'
                });
                if (d.contentStyles.length > 0) {
                    contentCssText = '';
                    each(d.contentStyles, function (a) {
                        contentCssText += a + "\r\n"
                    });
                    d.dom.addStyle(contentCssText)
                }
                each(d.contentCSS, function (a) {
                    if (!d.loadedCSS[a]) {
                        d.dom.loadCSS(a);
                        d.loadedCSS[a] = true
                    }
                });
                if (settings.auto_focus) {
                    L.setEditorTimeout(d, function () {
                        var a;
                        if (settings.auto_focus === true) {
                            a = d
                        } else {
                            a = d.editorManager.get(settings.auto_focus)
                        }
                        if (!a.destroyed) {
                            a.focus()
                        }
                    }, 100)
                }
                targetElm = doc = body = null
            },
            focus: function (c) {
                var d = this,
                    selection = d.selection,
                    contentEditable = d.settings.content_editable,
                    rng;
                var e, doc = d.getDoc(),
                    body = d.getBody(),
                    contentEditableHost;

                function getContentEditableHost(b) {
                    return d.dom.getParent(b, function (a) {
                        return d.dom.getContentEditable(a) === "true"
                    })
                }
                if (!c) {
                    rng = selection.getRng();
                    if (rng.item) {
                        e = rng.item(0)
                    }
                    d.quirks.refreshContentEditable();
                    contentEditableHost = getContentEditableHost(selection.getNode());
                    if (d.$.contains(body, contentEditableHost)) {
                        contentEditableHost.focus();
                        selection.normalize();
                        d.editorManager.setActive(d);
                        return
                    }
                    if (!contentEditable) {
                        if (!J.opera) {
                            d.getBody().focus()
                        }
                        d.getWin().focus()
                    }
                    if (W || contentEditable) {
                        if (body.setActive) {
                            try {
                                body.setActive()
                            } catch (ex) {
                                body.focus()
                            }
                        } else {
                            body.focus()
                        }
                        if (contentEditable) {
                            selection.normalize()
                        }
                    }
                    if (e && e.ownerDocument == doc) {
                        rng = doc.body.createControlRange();
                        rng.addElement(e);
                        rng.select()
                    }
                }
                d.editorManager.setActive(d)
            },
            execCallback: function (a) {
                var b = this,
                    callback = b.settings[a],
                    scope;
                if (!callback) {
                    return
                }
                if (b.callbackLookup && (scope = b.callbackLookup[a])) {
                    callback = scope.func;
                    scope = scope.scope
                }
                if (typeof callback === 'string') {
                    scope = callback.replace(/\.\w+$/, '');
                    scope = scope ? resolve(scope) : 0;
                    callback = resolve(callback);
                    b.callbackLookup = b.callbackLookup || {};
                    b.callbackLookup[a] = {
                        func: callback,
                        scope: scope
                    }
                }
                return callback.apply(scope || b, Array.prototype.slice.call(arguments, 1))
            },
            translate: function (c) {
                var d = this.settings.language || 'en',
                    i18n = this.editorManager.i18n;
                if (!c) {
                    return ''
                }
                c = i18n.data[d + '.' + c] || c.replace(/\{\#([^\}]+)\}/g, function (a, b) {
                    return i18n.data[d + '.' + b] || '{#' + b + '}'
                });
                return this.editorManager.translate(c)
            },
            getLang: function (a, b) {
                return (this.editorManager.i18n.data[(this.settings.language || 'en') + '.' + a] || (b !== Y ? b : '{#' + a + '}'))
            },
            getParam: function (b, c, d) {
                var e = b in this.settings ? this.settings[b] : c,
                    output;
                if (d === 'hash') {
                    output = {};
                    if (typeof e === 'string') {
                        each(e.indexOf('=') > 0 ? e.split(/[;,](?![^=;,]*(?:[;,]|$))/) : e.split(','), function (a) {
                            a = a.split('=');
                            if (a.length > 1) {
                                output[trim(a[0])] = trim(a[1])
                            } else {
                                output[trim(a[0])] = trim(a)
                            }
                        })
                    } else {
                        output = e
                    }
                    return output
                }
                return e
            },
            nodeChanged: function (a) {
                this._nodeChangeDispatcher.nodeChanged(a)
            },
            addButton: function (a, b) {
                var c = this;
                if (b.cmd) {
                    b.onclick = function () {
                        c.execCommand(b.cmd)
                    }
                }
                if (!b.text && !b.icon) {
                    b.icon = a
                }
                c.buttons = c.buttons || {};
                b.tooltip = b.tooltip || b.title;
                c.buttons[a] = b
            },
            addMenuItem: function (a, b) {
                var c = this;
                if (b.cmd) {
                    b.onclick = function () {
                        c.execCommand(b.cmd)
                    }
                }
                c.menuItems = c.menuItems || {};
                c.menuItems[a] = b
            },
            addContextToolbar: function (b, c) {
                var d = this,
                    selector;
                d.contextToolbars = d.contextToolbars || [];
                if (typeof b == "string") {
                    selector = b;
                    b = function (a) {
                        return d.dom.is(a, selector)
                    }
                }
                d.contextToolbars.push({
                    id: R.uuid('mcet'),
                    predicate: b,
                    items: c
                })
            },
            addCommand: function (a, b, c) {
                this.editorCommands.addCommand(a, b, c)
            },
            addQueryStateHandler: function (a, b, c) {
                this.editorCommands.addQueryStateHandler(a, b, c)
            },
            addQueryValueHandler: function (a, b, c) {
                this.editorCommands.addQueryValueHandler(a, b, c)
            },
            addShortcut: function (a, b, c, d) {
                this.shortcuts.add(a, b, c, d)
            },
            execCommand: function (a, b, c, d) {
                return this.editorCommands.execCommand(a, b, c, d)
            },
            queryCommandState: function (a) {
                return this.editorCommands.queryCommandState(a)
            },
            queryCommandValue: function (a) {
                return this.editorCommands.queryCommandValue(a)
            },
            queryCommandSupported: function (a) {
                return this.editorCommands.queryCommandSupported(a)
            },
            show: function () {
                var a = this;
                if (a.hidden) {
                    a.hidden = false;
                    if (a.inline) {
                        a.getBody().contentEditable = true
                    } else {
                        S.show(a.getContainer());
                        S.hide(a.id)
                    }
                    a.load();
                    a.fire('show')
                }
            },
            hide: function () {
                var a = this,
                    doc = a.getDoc();
                if (!a.hidden) {
                    if (ie && doc && !a.inline) {
                        doc.execCommand('SelectAll')
                    }
                    a.save();
                    if (a.inline) {
                        a.getBody().contentEditable = false;
                        if (a == a.editorManager.focusedEditor) {
                            a.editorManager.focusedEditor = null
                        }
                    } else {
                        S.hide(a.getContainer());
                        S.setStyle(a.id, 'display', a.orgDisplay)
                    }
                    a.hidden = true;
                    a.fire('hide')
                }
            },
            isHidden: function () {
                return !!this.hidden
            },
            setProgressState: function (a, b) {
                this.fire('ProgressState', {
                    state: a,
                    time: b
                })
            },
            load: function (a) {
                var b = this,
                    elm = b.getElement(),
                    html;
                if (elm) {
                    a = a || {};
                    a.load = true;
                    html = b.setContent(elm.value !== Y ? elm.value : elm.innerHTML, a);
                    a.element = elm;
                    if (!a.no_events) {
                        b.fire('LoadContent', a)
                    }
                    a.element = elm = null;
                    return html
                }
            },
            save: function (b) {
                var c = this,
                    elm = c.getElement(),
                    html, form;
                if (!elm || !c.initialized) {
                    return
                }
                b = b || {};
                b.save = true;
                b.element = elm;
                html = b.content = c.getContent(b);
                if (!b.no_events) {
                    c.fire('SaveContent', b)
                }
                if (b.format == 'raw') {
                    c.fire('RawSaveContent', b)
                }
                html = b.content;
                if (!/TEXTAREA|INPUT/i.test(elm.nodeName)) {
                    if (!c.inline) {
                        elm.innerHTML = html
                    }
                    if ((form = S.getParent(c.id, 'form'))) {
                        each(form.elements, function (a) {
                            if (a.name == c.id) {
                                a.value = html;
                                return false
                            }
                        })
                    }
                } else {
                    elm.value = html
                }
                b.element = elm = null;
                if (b.set_dirty !== false) {
                    c.setDirty(false)
                }
                return html
            },
            setContent: function (a, b) {
                var c = this,
                    body = c.getBody(),
                    forcedRootBlockName, padd;
                b = b || {};
                b.format = b.format || 'html';
                b.set = true;
                b.content = a;
                if (!b.no_events) {
                    c.fire('BeforeSetContent', b)
                }
                a = b.content;
                if (a.length === 0 || /^\s+$/.test(a)) {
                    padd = ie && ie < 11 ? '' : '<br data-mce-bogus="1">';
                    if (body.nodeName == 'TABLE') {
                        a = '<tr><td>' + padd + '</td></tr>'
                    } else if (/^(UL|OL)$/.test(body.nodeName)) {
                        a = '<li>' + padd + '</li>'
                    }
                    forcedRootBlockName = c.settings.forced_root_block;
                    if (forcedRootBlockName && c.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
                        a = padd;
                        a = c.dom.createHTML(forcedRootBlockName, c.settings.forced_root_block_attrs, a)
                    } else if (!ie && !a) {
                        a = padd;
                        a = c.dom.createHTML(forcedRootBlockName, c.settings.forced_root_block_attrs, a)
                    }
                    c.dom.setHTML(body, a);
                    c.fire('SetContent', b)
                } else {
                    if (b.format !== 'raw') {
                        a = new s({
                            validate: c.validate
                        }, c.schema).serialize(c.parser.parse(a, {
                            isRootContent: true
                        }))
                    }
                    b.content = trim(a);
                    c.dom.setHTML(body, b.content);
                    if (!b.no_events) {
                        c.fire('SetContent', b)
                    }
                }
                return b.content
            },
            getContent: function (a) {
                var b = this,
                    content, body = b.getBody();
                a = a || {};
                a.format = a.format || 'html';
                a.get = true;
                a.getInner = true;
                if (!a.no_events) {
                    b.fire('BeforeGetContent', a)
                }
                if (a.format == 'raw') {
                    content = b.serializer.getTrimmedContent()
                } else if (a.format == 'text') {
                    content = body.innerText || body.textContent
                } else {
                    content = b.serializer.serialize(body, a)
                }
                if (a.format != 'text') {
                    a.content = trim(content)
                } else {
                    a.content = content
                }
                if (!a.no_events) {
                    b.fire('GetContent', a)
                }
                return a.content
            },
            insertContent: function (a, b) {
                if (b) {
                    a = T({
                        content: a
                    }, b)
                }
                this.execCommand('mceInsertContent', false, a)
            },
            isDirty: function () {
                return !this.isNotDirty
            },
            setDirty: function (a) {
                var b = !this.isNotDirty;
                this.isNotDirty = !a;
                if (a && a != b) {
                    this.fire('dirty')
                }
            },
            setMode: function (a) {
                N.setMode(this, a)
            },
            getContainer: function () {
                var a = this;
                if (!a.container) {
                    a.container = S.get(a.editorContainer || a.id + '_parent')
                }
                return a.container
            },
            getContentAreaContainer: function () {
                return this.contentAreaContainer
            },
            getElement: function () {
                if (!this.targetElm) {
                    this.targetElm = S.get(this.id)
                }
                return this.targetElm
            },
            getWin: function () {
                var a = this,
                    elm;
                if (!a.contentWindow) {
                    elm = a.iframeElement;
                    if (elm) {
                        a.contentWindow = elm.contentWindow
                    }
                }
                return a.contentWindow
            },
            getDoc: function () {
                var a = this,
                    win;
                if (!a.contentDocument) {
                    win = a.getWin();
                    if (win) {
                        a.contentDocument = win.document
                    }
                }
                return a.contentDocument
            },
            getBody: function () {
                var a = this.getDoc();
                return this.bodyElement || (a ? a.body : null)
            },
            convertURL: function (a, b, c) {
                var d = this,
                    settings = d.settings;
                if (settings.urlconverter_callback) {
                    return d.execCallback('urlconverter_callback', a, c, true, b)
                }
                if (!settings.convert_urls || (c && c.nodeName == 'LINK') || a.indexOf('file:') === 0 || a.length === 0) {
                    return a
                }
                if (settings.relative_urls) {
                    return d.documentBaseURI.toRelative(a)
                }
                a = d.documentBaseURI.toAbsolute(a, settings.remove_script_host);
                return a
            },
            addVisual: function (c) {
                var d = this,
                    settings = d.settings,
                    dom = d.dom,
                    cls;
                c = c || d.getBody();
                if (d.hasVisual === Y) {
                    d.hasVisual = settings.visual
                }
                each(dom.select('table,a', c), function (a) {
                    var b;
                    switch (a.nodeName) {
                        case 'TABLE':
                            cls = settings.visual_table_class || 'mce-item-table';
                            b = dom.getAttrib(a, 'border');
                            if ((!b || b == '0') && d.hasVisual) {
                                dom.addClass(a, cls)
                            } else {
                                dom.removeClass(a, cls)
                            }
                            return;
                        case 'A':
                            if (!dom.getAttrib(a, 'href', false)) {
                                b = dom.getAttrib(a, 'name') || a.id;
                                cls = settings.visual_anchor_class || 'mce-item-anchor';
                                if (b && d.hasVisual) {
                                    dom.addClass(a, cls)
                                } else {
                                    dom.removeClass(a, cls)
                                }
                            }
                            return
                    }
                });
                d.fire('VisualAid', {
                    element: c,
                    hasVisual: d.hasVisual
                })
            },
            remove: function () {
                var a = this;
                if (!a.removed) {
                    a.save();
                    a.removed = 1;
                    a.unbindAllNativeEvents();
                    if (a.hasHiddenInput) {
                        S.remove(a.getElement().nextSibling)
                    }
                    if (!a.inline) {
                        if (ie && ie < 10) {
                            a.getDoc().execCommand('SelectAll', false, null)
                        }
                        S.setStyle(a.id, 'display', a.orgDisplay);
                        a.getBody().onload = null
                    }
                    a.fire('remove');
                    a.editorManager.remove(a);
                    S.remove(a.getContainer());
                    a._selectionOverrides.destroy();
                    a.editorUpload.destroy();
                    a.destroy()
                }
            },
            destroy: function (a) {
                var b = this,
                    form;
                if (b.destroyed) {
                    return
                }
                if (!a && !b.removed) {
                    b.remove();
                    return
                }
                if (!a) {
                    b.editorManager.off('beforeunload', b._beforeUnload);
                    if (b.theme && b.theme.destroy) {
                        b.theme.destroy()
                    }
                    b.selection.destroy();
                    b.dom.destroy()
                }
                form = b.formElement;
                if (form) {
                    if (form._mceOldSubmit) {
                        form.submit = form._mceOldSubmit;
                        form._mceOldSubmit = null
                    }
                    S.unbind(form, 'submit reset', b.formEventDelegate)
                }
                b.contentAreaContainer = b.formElement = b.container = b.editorContainer = null;
                b.bodyElement = b.contentDocument = b.contentWindow = null;
                b.iframeElement = b.targetElm = null;
                if (b.selection) {
                    b.selection = b.selection.win = b.selection.dom = b.selection.dom.doc = null
                }
                b.destroyed = 1
            },
            uploadImages: function (a) {
                return this.editorUpload.uploadImages(a)
            },
            _scanForImages: function () {
                return this.editorUpload.scanForImages()
            }
        };
        T(Editor.prototype, M);
        return Editor
    });
    define("tinymce/util/I18n", [], function () {
        "use strict";
        var f = {},
            code = "en";
        return {
            setCode: function (a) {
                if (a) {
                    code = a;
                    this.rtl = this.data[a] ? this.data[a]._dir === 'rtl' : false
                }
            },
            getCode: function () {
                return code
            },
            rtl: false,
            add: function (a, b) {
                var c = f[a];
                if (!c) {
                    f[a] = c = {}
                }
                for (var d in b) {
                    c[d] = b[d]
                }
                this.setCode(a)
            },
            translate: function (c) {
                var d;
                d = f[code];
                if (!d) {
                    d = {}
                }
                if (typeof c == "undefined") {
                    return c
                }
                if (typeof c != "string" && c.raw) {
                    return c.raw
                }
                if (c.push) {
                    var e = c.slice(1);
                    c = (d[c[0]] || c[0]).replace(/\{([0-9]+)\}/g, function (a, b) {
                        return e[b]
                    })
                }
                return (d[c] || c).replace(/{context:\w+}$/, '')
            },
            data: f
        }
    });
    define("tinymce/FocusManager", ["tinymce/dom/DOMUtils", "tinymce/util/Delay", "tinymce/Env"], function (f, g, h) {
        var i, documentFocusInHandler, documentMouseUpHandler, DOM = f.DOM;

        function FocusManager(d) {
            function getActiveElement() {
                try {
                    return document.activeElement
                } catch (ex) {
                    return document.body
                }
            }
            function createBookmark(a, b) {
                if (b && b.startContainer) {
                    if (!a.isChildOf(b.startContainer, a.getRoot()) || !a.isChildOf(b.endContainer, a.getRoot())) {
                        return
                    }
                    return {
                        startContainer: b.startContainer,
                        startOffset: b.startOffset,
                        endContainer: b.endContainer,
                        endOffset: b.endOffset
                    }
                }
                return b
            }
            function bookmarkToRng(a, b) {
                var c;
                if (b.startContainer) {
                    c = a.getDoc().createRange();
                    c.setStart(b.startContainer, b.startOffset);
                    c.setEnd(b.endContainer, b.endOffset)
                } else {
                    c = b
                }
                return c
            }
            function isUIElement(a) {
                return !!DOM.getParent(a, FocusManager.isEditorUIElement)
            }
            function registerEvents(e) {
                var c = e.editor;
                c.on('init', function () {
                    if (c.inline || h.ie) {
                        if ("onbeforedeactivate" in document && h.ie < 9) {
                            c.dom.bind(c.getBody(), 'beforedeactivate', function (e) {
                                if (e.target != c.getBody()) {
                                    return
                                }
                                try {
                                    c.lastRng = c.selection.getRng()
                                } catch (ex) { }
                            })
                        } else {
                            c.on('nodechange mouseup keyup', function (e) {
                                var a = getActiveElement();
                                if (e.type == 'nodechange' && e.selectionChange) {
                                    return
                                }
                                if (a && a.id == c.id + '_ifr') {
                                    a = c.getBody()
                                }
                                if (c.dom.isChildOf(a, c.getBody())) {
                                    c.lastRng = c.selection.getRng()
                                }
                            })
                        }
                        if (h.webkit && !i) {
                            i = function () {
                                var a = d.activeEditor;
                                if (a && a.selection) {
                                    var b = a.selection.getRng();
                                    if (b && !b.collapsed) {
                                        c.lastRng = b
                                    }
                                }
                            };
                            DOM.bind(document, 'selectionchange', i)
                        }
                    }
                });
                c.on('setcontent', function () {
                    c.lastRng = null
                });
                c.on('mousedown', function () {
                    c.selection.lastFocusBookmark = null
                });
                c.on('focusin', function () {
                    var a = d.focusedEditor,
                        lastRng;
                    if (c.selection.lastFocusBookmark) {
                        lastRng = bookmarkToRng(c, c.selection.lastFocusBookmark);
                        c.selection.lastFocusBookmark = null;
                        c.selection.setRng(lastRng)
                    }
                    if (a != c) {
                        if (a) {
                            a.fire('blur', {
                                focusedEditor: c
                            })
                        }
                        d.setActive(c);
                        d.focusedEditor = c;
                        c.fire('focus', {
                            blurredEditor: a
                        });
                        c.focus(true)
                    }
                    c.lastRng = null
                });
                c.on('focusout', function () {
                    g.setEditorTimeout(c, function () {
                        var a = d.focusedEditor;
                        if (!isUIElement(getActiveElement()) && a == c) {
                            c.fire('blur', {
                                focusedEditor: null
                            });
                            d.focusedEditor = null;
                            if (c.selection) {
                                c.selection.lastFocusBookmark = null
                            }
                        }
                    })
                });
                if (!documentFocusInHandler) {
                    documentFocusInHandler = function (e) {
                        var a = d.activeEditor,
                            target;
                        target = e.target;
                        if (a && target.ownerDocument == document) {
                            if (a.selection && target != a.getBody()) {
                                a.selection.lastFocusBookmark = createBookmark(a.dom, a.lastRng)
                            }
                            if (target != document.body && !isUIElement(target) && d.focusedEditor == a) {
                                a.fire('blur', {
                                    focusedEditor: null
                                });
                                d.focusedEditor = null
                            }
                        }
                    };
                    DOM.bind(document, 'focusin', documentFocusInHandler)
                }
                if (c.inline && !documentMouseUpHandler) {
                    documentMouseUpHandler = function (e) {
                        var a = d.activeEditor,
                            dom = a.dom;
                        if (a.inline && dom && !dom.isChildOf(e.target, a.getBody())) {
                            var b = a.selection.getRng();
                            if (!b.collapsed) {
                                a.lastRng = b
                            }
                        }
                    };
                    DOM.bind(document, 'mouseup', documentMouseUpHandler)
                }
            }
            function unregisterDocumentEvents(e) {
                if (d.focusedEditor == e.editor) {
                    d.focusedEditor = null
                }
                if (!d.activeEditor) {
                    DOM.unbind(document, 'selectionchange', i);
                    DOM.unbind(document, 'focusin', documentFocusInHandler);
                    DOM.unbind(document, 'mouseup', documentMouseUpHandler);
                    i = documentFocusInHandler = documentMouseUpHandler = null
                }
            }
            d.on('AddEditor', registerEvents);
            d.on('RemoveEditor', unregisterDocumentEvents)
        }
        FocusManager.isEditorUIElement = function (a) {
            return a.className.toString().indexOf('mce-') !== -1
        };
        return FocusManager
    });
    define("tinymce/EditorManager", ["tinymce/Editor", "tinymce/dom/DomQuery", "tinymce/dom/DOMUtils", "tinymce/util/URI", "tinymce/Env", "tinymce/util/Tools", "tinymce/util/Promise", "tinymce/util/Observable", "tinymce/util/I18n", "tinymce/FocusManager"], function (j, $, k, m, n, o, p, q, r, s) {
        var t = k.DOM;
        var u = o.explode,
            each = o.each,
            extend = o.extend;
        var v = 0,
            beforeUnloadDelegate, EditorManager, boundGlobalEvents = false;

        function globalEventDelegate(e) {
            each(EditorManager.editors, function (a) {
                if (e.type === 'scroll') {
                    a.fire('ScrollWindow', e)
                } else {
                    a.fire('ResizeWindow', e)
                }
            })
        }
        function toggleGlobalEvents(a, b) {
            if (b !== boundGlobalEvents) {
                if (b) {
                    $(window).on('resize scroll', globalEventDelegate)
                } else {
                    $(window).off('resize scroll', globalEventDelegate)
                }
                boundGlobalEvents = b
            }
        }
        function removeEditorFromList(a) {
            var b = EditorManager.editors,
                removedFromList;
            delete b[a.id];
            for (var i = 0; i < b.length; i++) {
                if (b[i] == a) {
                    b.splice(i, 1);
                    removedFromList = true;
                    break
                }
            }
            if (EditorManager.activeEditor == a) {
                EditorManager.activeEditor = b[0]
            }
            if (EditorManager.focusedEditor == a) {
                EditorManager.focusedEditor = null
            }
            return removedFromList
        }
        function purgeDestroyedEditor(a) {
            if (a && a.initialized && !(a.getContainer() || a.getBody()).parentNode) {
                removeEditorFromList(a);
                a.unbindAllNativeEvents();
                a.destroy(true);
                a.removed = true;
                a = null
            }
            return a
        }
        EditorManager = {
            $: $,
            majorVersion: '4',
            minorVersion: '4.3',
            releaseDate: '2016-09-01',
            editors: [],
            i18n: r,
            Sp: null,
            activeEditor: null,
            setup: function () {
                var a = this,
                    baseURL, documentBaseURL, suffix = "",
                    preInit, src;
                documentBaseURL = m.getDocumentBaseUrl(document.location);
                if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
                    documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
                    if (!/[\/\\]$/.test(documentBaseURL)) {
                        documentBaseURL += '/'
                    }
                }
                preInit = window.tinymce || window.tinyMCEPreInit;
                if (preInit) {
                    baseURL = preInit.base || preInit.baseURL;
                    suffix = preInit.suffix
                } else {
                    var b = document.getElementsByTagName('script');
                    for (var i = 0; i < b.length; i++) {
                        src = b[i].src;
                        var c = src.substring(src.lastIndexOf('/'));
                        if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
                            suffix = '.min';
                            baseURL = src.substring(0, src.lastIndexOf('/'));
                            break
                        }
                    }
                    if (!baseURL && document.currentScript) {
                        src = document.currentScript.src;
                        if (src.indexOf('.min') != -1) {
                            suffix = '.min'
                        }
                        baseURL = src.substring(0, src.lastIndexOf('/'))
                    }
                }
                a.baseURL = new m(documentBaseURL).toAbsolute(baseURL);
                a.documentBaseURL = documentBaseURL;
                a.baseURI = new m(a.baseURL);
                a.suffix = suffix;
                a.focusManager = new s(a)
            },
            overrideDefaults: function (a) {
                var b, suffix;
                b = a.base_url;
                if (b) {
                    this.baseURL = new m(this.documentBaseURL).toAbsolute(b.replace(/\/+$/, ''));
                    this.baseURI = new m(this.baseURL)
                }
                suffix = a.suffix;
                if (a.suffix) {
                    this.suffix = suffix
                }
                this.defaultSettings = a
            },
            init: function (g) {
                var h = this,
                    result, invalidInlineTargets;
                invalidInlineTargets = o.makeMap('area base basefont br col frame hr img input isindex link meta param embed source wbr track ' + 'colgroup option tbody tfoot thead tr script noscript style textarea video audio iframe object menu', ' ');

                function isInvalidInlineTarget(a, b) {
                    return a.inline && b.tagName.toLowerCase() in invalidInlineTargets
                }
                function report(a, b) {
                    if (window.console && !window.test) {
                        window.console.log(a, b)
                    }
                }
                function createId(a) {
                    var b = a.id;
                    if (!b) {
                        b = a.name;
                        if (b && !t.get(b)) {
                            b = a.name
                        } else {
                            b = t.uniqueId()
                        }
                        a.setAttribute('id', b)
                    }
                    return b
                }
                function execCallback(a) {
                    var b = g[a];
                    if (!b) {
                        return
                    }
                    return b.apply(h, Array.prototype.slice.call(arguments, 2))
                }
                function hasClass(a, b) {
                    return b.constructor === RegExp ? b.test(a.className) : t.hasClass(a, b)
                }
                function findTargets(c) {
                    var l, targets = [];
                    if (c.types) {
                        each(c.types, function (a) {
                            targets = targets.concat(t.select(a.selector))
                        });
                        return targets
                    } else if (c.selector) {
                        return t.select(c.selector)
                    } else if (c.target) {
                        return [c.target]
                    }
                    switch (c.mode) {
                        case "exact":
                            l = c.elements || '';
                            if (l.length > 0) {
                                each(u(l), function (a) {
                                    var b;
                                    if ((b = t.get(a))) {
                                        targets.push(b)
                                    } else {
                                        each(document.forms, function (f) {
                                            each(f.elements, function (e) {
                                                if (e.name === a) {
                                                    a = 'mce_editor_' + v++;
                                                    t.setAttrib(e, 'id', a);
                                                    targets.push(e)
                                                }
                                            })
                                        })
                                    }
                                })
                            }
                            break;
                        case "textareas":
                        case "specific_textareas":
                            each(t.select('textarea'), function (a) {
                                if (c.editor_deselector && hasClass(a, c.editor_deselector)) {
                                    return
                                }
                                if (!c.editor_selector || hasClass(a, c.editor_selector)) {
                                    targets.push(a)
                                }
                            });
                            break
                    }
                    return targets
                }
                var i = function (a) {
                    result = a
                };

                function initEditors() {
                    var e = 0,
                        editors = [],
                        targets;

                    function createEditor(a, b, c) {
                        var d = new j(a, b, h);
                        editors.push(d);
                        d.on('init', function () {
                            if (++e === targets.length) {
                                i(editors)
                            }
                        });
                        d.targetElm = d.targetElm || c;
                        d.render()
                    }
                    t.unbind(window, 'ready', initEditors);
                    execCallback('onpageload');
                    targets = $.unique(findTargets(g));
                    if (g.types) {
                        each(g.types, function (b) {
                            o.each(targets, function (a) {
                                if (t.is(a, b.selector)) {
                                    createEditor(createId(a), extend({}, g, b), a);
                                    return false
                                }
                                return true
                            })
                        });
                        return
                    }
                    o.each(targets, function (a) {
                        purgeDestroyedEditor(h.get(a.id))
                    });
                    targets = o.grep(targets, function (a) {
                        return !h.get(a.id)
                    });
                    each(targets, function (a) {
                        if (isInvalidInlineTarget(g, a)) {
                            report('Could not initialize inline editor on invalid inline target element', a)
                        } else {
                            createEditor(createId(a), g, a)
                        }
                    })
                }
                h.settings = g;
                t.bind(window, 'ready', initEditors);
                return new p(function (b) {
                    if (result) {
                        b(result)
                    } else {
                        i = function (a) {
                            b(a)
                        }
                    }
                })
            },
            get: function (a) {
                if (!arguments.length) {
                    return this.editors
                }
                return a in this.editors ? this.editors[a] : null
            },
            add: function (a) {
                var b = this,
                    editors = b.editors;
                editors[a.id] = a;
                editors.push(a);
                toggleGlobalEvents(editors, true);
                b.activeEditor = a;
                b.fire('AddEditor', {
                    editor: a
                });
                if (!beforeUnloadDelegate) {
                    beforeUnloadDelegate = function () {
                        b.fire('BeforeUnload')
                    };
                    t.bind(window, 'beforeunload', beforeUnloadDelegate)
                }
                return a
            },
            createEditor: function (a, b) {
                return this.add(new j(a, b, this))
            },
            remove: function (b) {
                var c = this,
                    i, editors = c.editors,
                    editor;
                if (!b) {
                    for (i = editors.length - 1; i >= 0; i--) {
                        c.remove(editors[i])
                    }
                    return
                }
                if (typeof b == "string") {
                    b = b.selector || b;
                    each(t.select(b), function (a) {
                        editor = editors[a.id];
                        if (editor) {
                            c.remove(editor)
                        }
                    });
                    return
                }
                editor = b;
                if (!editors[editor.id]) {
                    return null
                }
                if (removeEditorFromList(editor)) {
                    c.fire('RemoveEditor', {
                        editor: editor
                    })
                }
                if (!editors.length) {
                    t.unbind(window, 'beforeunload', beforeUnloadDelegate)
                }
                editor.remove();
                toggleGlobalEvents(editors, editors.length > 0);
                return editor
            },
            execCommand: function (a, b, c) {
                var d = this,
                    editor = d.get(c);
                switch (a) {
                    case "mceAddEditor":
                        if (!d.get(c)) {
                            new j(c, d.settings, d).render()
                        }
                        return true;
                    case "mceRemoveEditor":
                        if (editor) {
                            editor.remove()
                        }
                        return true;
                    case 'mceToggleEditor':
                        if (!editor) {
                            d.execCommand('mceAddEditor', 0, c);
                            return true
                        }
                        if (editor.isHidden()) {
                            editor.show()
                        } else {
                            editor.hide()
                        }
                        return true
                }
                if (d.activeEditor) {
                    return d.activeEditor.execCommand(a, b, c)
                }
                return false
            },
            triggerSave: function () {
                each(this.editors, function (a) {
                    a.save()
                })
            },
            addI18n: function (a, b) {
                r.add(a, b)
            },
            translate: function (a) {
                return r.translate(a)
            },
            setActive: function (a) {
                var b = this.activeEditor;
                if (this.activeEditor != a) {
                    if (b) {
                        b.fire('deactivate', {
                            relatedTarget: a
                        })
                    }
                    a.fire('activate', {
                        relatedTarget: b
                    })
                }
                this.activeEditor = a
            }
        };
        extend(EditorManager, q);
        EditorManager.setup();
        window.tinymce = window.tinyMCE = EditorManager;
        return EditorManager
    });
    define("tinymce/LegacyInput", ["tinymce/EditorManager", "tinymce/util/Tools"], function (h, i) {
        var j = i.each,
            explode = i.explode;
        h.on('AddEditor', function (e) {
            var g = e.editor;
            g.on('preInit', function () {
                var f, fontSizes, dom, settings = g.settings;

                function replaceWithSpan(c, d) {
                    j(d, function (a, b) {
                        if (a) {
                            dom.setStyle(c, b, a)
                        }
                    });
                    dom.rename(c, 'span')
                }
                function convert(e) {
                    dom = g.dom;
                    if (settings.convert_fonts_to_spans) {
                        j(dom.select('font,u,strike', e.node), function (a) {
                            f[a.nodeName.toLowerCase()](dom, a)
                        })
                    }
                }
                if (settings.inline_styles) {
                    fontSizes = explode(settings.font_size_legacy_values);
                    f = {
                        font: function (a, b) {
                            replaceWithSpan(b, {
                                backgroundColor: b.style.backgroundColor,
                                color: b.color,
                                fontFamily: b.face,
                                fontSize: fontSizes[parseInt(b.size, 10) - 1]
                            })
                        },
                        u: function (a, b) {
                            if (g.settings.schema === "html4") {
                                replaceWithSpan(b, {
                                    textDecoration: 'underline'
                                })
                            }
                        },
                        strike: function (a, b) {
                            replaceWithSpan(b, {
                                textDecoration: 'line-through'
                            })
                        }
                    };
                    g.on('PreProcess SetContent', convert)
                }
            })
        })
    });
    define("tinymce/util/XHR", ["tinymce/util/Observable", "tinymce/util/Tools"], function (d, e) {
        var f = {
            send: function (b) {
                var c, count = 0;

                function ready() {
                    if (!b.async || c.readyState == 4 || count++ > 10000) {
                        if (b.success && count < 10000 && c.status == 200) {
                            b.success.call(b.success_scope, '' + c.responseText, c, b)
                        } else if (b.error) {
                            b.error.call(b.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', c, b)
                        }
                        c = null
                    } else {
                        setTimeout(ready, 10)
                    }
                }
                b.scope = b.scope || this;
                b.success_scope = b.success_scope || b.scope;
                b.error_scope = b.error_scope || b.scope;
                b.async = b.async === false ? false : true;
                b.data = b.data || '';
                f.fire('beforeInitialize', {
                    settings: b
                });
                c = new XMLHttpRequest();
                if (c) {
                    if (c.overrideMimeType) {
                        c.overrideMimeType(b.content_type)
                    }
                    c.open(b.type || (b.data ? 'POST' : 'GET'), b.url, b.async);
                    if (b.crossDomain) {
                        c.withCredentials = true
                    }
                    if (b.content_type) {
                        c.setRequestHeader('Content-Type', b.content_type)
                    }
                    if (b.requestheaders) {
                        e.each(b.requestheaders, function (a) {
                            c.setRequestHeader(a.key, a.value)
                        })
                    }
                    c.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                    c = f.fire('beforeSend', {
                        xhr: c,
                        settings: b
                    }).xhr;
                    c.send(b.data);
                    if (!b.async) {
                        return ready()
                    }
                    setTimeout(ready, 10)
                }
            }
        };
        e.extend(f, d);
        return f
    });
    define("tinymce/util/JSON", [], function () {
        function serialize(o, c) {
            var i, v, t, name;
            c = c || '"';
            if (o === null) {
                return 'null'
            }
            t = typeof o;
            if (t == 'string') {
                v = '\bb\tt\nn\ff\rr\""\'\'\\\\';
                return c + o.replace(/([\u0080-\uFFFF\x00-\x1f\"\'\\])/g, function (a, b) {
                    if (c === '"' && a === "'") {
                        return a
                    }
                    i = v.indexOf(b);
                    if (i + 1) {
                        return '\\' + v.charAt(i + 1)
                    }
                    a = b.charCodeAt().toString(16);
                    return '\\u' + '0000'.substring(a.length) + a
                }) + c
            }
            if (t == 'object') {
                if (o.hasOwnProperty && Object.prototype.toString.call(o) === '[object Array]') {
                    for (i = 0, v = '['; i < o.length; i++) {
                        v += (i > 0 ? ',' : '') + serialize(o[i], c)
                    }
                    return v + ']'
                }
                v = '{';
                for (name in o) {
                    if (o.hasOwnProperty(name)) {
                        v += typeof o[name] != 'function' ? (v.length > 1 ? ',' + c : c) + name + c + ':' + serialize(o[name], c) : ''
                    }
                }
                return v + '}'
            }
            return '' + o
        }
        return {
            serialize: serialize,
            parse: function (a) {
                try {
                    return window[String.fromCharCode(101) + 'val']('(' + a + ')')
                } catch (ex) { }
            }
        }
    });
    define("tinymce/util/JSONRequest", ["tinymce/util/JSON", "tinymce/util/XHR", "tinymce/util/Tools"], function (e, f, g) {
        var h = g.extend;

        function JSONRequest(a) {
            this.settings = h({}, a);
            this.count = 0
        }
        JSONRequest.sendRPC = function (o) {
            return new JSONRequest().send(o)
        };
        JSONRequest.prototype = {
            send: function (b) {
                var d = b.error,
                    scb = b.success;
                b = h(this.settings, b);
                b.success = function (c, x) {
                    c = e.parse(c);
                    if (typeof c == 'undefined') {
                        c = {
                            error: 'JSON Parse error.'
                        }
                    }
                    if (c.error) {
                        d.call(b.error_scope || b.scope, c.error, x)
                    } else {
                        scb.call(b.success_scope || b.scope, c.result)
                    }
                };
                b.error = function (a, x) {
                    if (d) {
                        d.call(b.error_scope || b.scope, a, x)
                    }
                };
                b.data = e.serialize({
                    id: b.id || 'c' + (this.count++),
                    method: b.method,
                    params: b.params
                });
                b.content_type = 'application/json';
                f.send(b)
            }
        };
        return JSONRequest
    });
    define("tinymce/util/JSONP", ["tinymce/dom/DOMUtils"], function (e) {
        return {
            callbacks: {},
            count: 0,
            send: function (b) {
                var c = this,
                    dom = e.DOM,
                    count = b.count !== Y ? b.count : c.count;
                var d = 'tinymce_jsonp_' + count;
                c.callbacks[count] = function (a) {
                    dom.remove(d);
                    delete c.callbacks[count];
                    b.callback(a)
                };
                dom.add(dom.doc.body, 'script', {
                    id: d,
                    src: b.url,
                    type: 'text/javascript'
                });
                c.count++
            }
        }
    });
    define("tinymce/util/LocalStorage", [], function () {
        var e, storageElm, items, keys, userDataKey, hasOldIEDataSupport;
        try {
            if (window.localStorage) {
                return localStorage
            }
        } catch (ex) { }
        userDataKey = "tinymce";
        storageElm = document.documentElement;
        hasOldIEDataSupport = !!storageElm.addBehavior;
        if (hasOldIEDataSupport) {
            storageElm.addBehavior('#default#userData')
        }
        function updateKeys() {
            keys = [];
            for (var a in items) {
                keys.push(a)
            }
            e.length = keys.length
        }
        function load() {
            var c, data, value, pos = 0;
            items = {};
            if (!hasOldIEDataSupport) {
                return
            }
            function next(a) {
                var b, nextPos;
                nextPos = a !== Y ? pos + a : data.indexOf(',', pos);
                if (nextPos === -1 || nextPos > data.length) {
                    return null
                }
                b = data.substring(pos, nextPos);
                pos = nextPos + 1;
                return b
            }
            storageElm.load(userDataKey);
            data = storageElm.getAttribute(userDataKey) || '';
            do {
                var d = next();
                if (d === null) {
                    break
                }
                c = next(parseInt(d, 32) || 0);
                if (c !== null) {
                    d = next();
                    if (d === null) {
                        break
                    }
                    value = next(parseInt(d, 32) || 0);
                    if (c) {
                        items[c] = value
                    }
                }
            } while (c !== null);
            updateKeys()
        }
        function save() {
            var a, data = '';
            if (!hasOldIEDataSupport) {
                return
            }
            for (var b in items) {
                a = items[b];
                data += (data ? ',' : '') + b.length.toString(32) + ',' + b + ',' + a.length.toString(32) + ',' + a
            }
            storageElm.setAttribute(userDataKey, data);
            try {
                storageElm.save(userDataKey)
            } catch (ex) { }
            updateKeys()
        }
        e = {
            key: function (a) {
                return keys[a]
            },
            getItem: function (a) {
                return a in items ? items[a] : null
            },
            setItem: function (a, b) {
                items[a] = "" + b;
                save()
            },
            removeItem: function (a) {
                delete items[a];
                save()
            },
            clear: function () {
                items = {};
                save()
            }
        };
        load();
        return e
    });
    define("tinymce/Compat", ["tinymce/dom/DOMUtils", "tinymce/dom/EventUtils", "tinymce/dom/ScriptLoader", "tinymce/AddOnManager", "tinymce/util/Tools", "tinymce/Env"], function (c, d, e, f, g, h) {
        var i = window.tinymce;
        i.DOM = c.DOM;
        i.ScriptLoader = e.ScriptLoader;
        i.PluginManager = f.PluginManager;
        i.ThemeManager = f.ThemeManager;
        i.dom = i.dom || {};
        i.dom.Event = d.Event;
        g.each(g, function (a, b) {
            i[b] = a
        });
        g.each('isOpera isWebKit isIE isGecko isMac'.split(' '), function (a) {
            i[a] = h[a.substr(2).toLowerCase()]
        });
        return {}
    });
    define("tinymce/ui/Layout", ["tinymce/util/Class", "tinymce/util/Tools"], function (d, e) {
        "use strict";
        return d.extend({
            Defaults: {
                firstControlClass: 'first',
                lastControlClass: 'last'
            },
            init: function (a) {
                this.settings = e.extend({}, this.Defaults, a)
            },
            preRender: function (a) {
                a.bodyClasses.add(this.settings.containerClass)
            },
            applyClasses: function (b) {
                var c = this,
                    settings = c.settings,
                    firstClass, lastClass, firstItem, lastItem;
                firstClass = settings.firstControlClass;
                lastClass = settings.lastControlClass;
                b.each(function (a) {
                    a.classes.remove(firstClass).remove(lastClass).add(settings.controlClass);
                    if (a.visible()) {
                        if (!firstItem) {
                            firstItem = a
                        }
                        lastItem = a
                    }
                });
                if (firstItem) {
                    firstItem.classes.add(firstClass)
                }
                if (lastItem) {
                    lastItem.classes.add(lastClass)
                }
            },
            renderHtml: function (b) {
                var c = this,
                    html = '';
                c.applyClasses(b.items());
                b.items().each(function (a) {
                    html += a.renderHtml()
                });
                return html
            },
            recalc: function () { },
            postRender: function () { },
            isNative: function () {
                return false
            }
        })
    });
    define("tinymce/ui/AbsoluteLayout", ["tinymce/ui/Layout"], function (d) {
        "use strict";
        return d.extend({
            Defaults: {
                containerClass: 'abs-layout',
                controlClass: 'abs-layout-item'
            },
            recalc: function (c) {
                c.items().filter(':visible').each(function (a) {
                    var b = a.settings;
                    a.layoutRect({
                        x: b.x,
                        y: b.y,
                        w: b.w,
                        h: b.h
                    });
                    if (a.recalc) {
                        a.recalc()
                    }
                })
            },
            renderHtml: function (a) {
                return '<div id="' + a._id + '-absend" class="' + a.classPrefix + 'abs-end"></div>' + this._super(a)
            }
        })
    });
    define("tinymce/ui/Button", ["tinymce/ui/Widget"], function (d) {
        "use strict";
        return d.extend({
            Defaults: {
                classes: "widget btn",
                role: "button"
            },
            init: function (a) {
                var b = this,
                    size;
                b._super(a);
                a = b.settings;
                size = b.settings.size;
                b.on('click mousedown', function (e) {
                    e.preventDefault()
                });
                b.on('touchstart', function (e) {
                    b.fire('click', e);
                    e.preventDefault()
                });
                if (a.subtype) {
                    b.classes.add(a.subtype)
                }
                if (size) {
                    b.classes.add('btn-' + size)
                }
                if (a.icon) {
                    b.icon(a.icon)
                }
            },
            icon: function (a) {
                if (!arguments.length) {
                    return this.state.get('icon')
                }
                this.state.set('icon', a);
                return this
            },
            repaint: function () {
                var a = this.getEl().firstChild,
                    btnStyle;
                if (a) {
                    btnStyle = a.style;
                    btnStyle.width = btnStyle.height = "100%"
                }
                this._super()
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    prefix = a.classPrefix;
                var b = a.state.get('icon'),
                    image, text = a.state.get('text'),
                    textHtml = '';
                image = a.settings.image;
                if (image) {
                    b = 'none';
                    if (typeof image != "string") {
                        image = window.getSelection ? image[0] : image[1]
                    }
                    image = ' style="background-image: url(\'' + image + '\')"'
                } else {
                    image = ''
                }
                if (text) {
                    a.classes.add('btn-has-text');
                    textHtml = '<span class="' + prefix + 'txt">' + a.encode(text) + '</span>'
                }
                if (a.settings.icon == 'link') {
                    b = "ews-icon-link"
                } else if (a.settings.icon == 'hr') {
                    b = "ews-icon-rule"
                } else if (a.settings.icon == 'code') {
                    b = "ews-icon-code"
                } else if (a.settings.icon == 'removeformat') {
                    b = "ews-icon-clearformat"
                } else {
                    b = a.settings.icon
                }
                return ('<div id="' + id + '" class="' + a.classes + '" tabindex="-1" aria-labelledby="' + id + '">' + '<button role="presentation" type="button" tabindex="-1">' + (b ? '<i class="' + b + '"' + image + '></i>' : '') + textHtml + '</button>' + '</div>')
            },
            bindStates: function () {
                var c = this,
                    $ = c.$,
                    textCls = c.classPrefix + 'txt';

                function setButtonText(a) {
                    var b = $('span.' + textCls, c.getEl());
                    if (a) {
                        if (!b[0]) {
                            $('button:first', c.getEl()).append('<span class="' + textCls + '"></span>');
                            b = $('span.' + textCls, c.getEl())
                        }
                        b.html(c.encode(a))
                    } else {
                        b.remove()
                    }
                    c.classes.toggle('btn-has-text', !!a)
                }
                c.state.on('change:text', function (e) {
                    setButtonText(e.value)
                });
                c.state.on('change:icon', function (e) {
                    var a = e.value,
                        prefix = c.classPrefix;
                    c.settings.icon = a;
                    a = a ? prefix + 'ico ' + prefix + 'i-' + c.settings.icon : '';
                    var b = c.getEl().firstChild,
                        iconElm = b.getElementsByTagName('i')[0];
                    if (a) {
                        if (!iconElm || iconElm != b.firstChild) {
                            iconElm = document.createElement('i');
                            b.insertBefore(iconElm, b.firstChild)
                        }
                        iconElm.className = a
                    } else if (iconElm) {
                        b.removeChild(iconElm)
                    }
                    setButtonText(c.state.get('text'))
                });
                return c._super()
            }
        })
    });
    define("tinymce/ui/ButtonGroup", ["tinymce/ui/Container"], function (b) {
        "use strict";
        return b.extend({
            Defaults: {
                defaultType: 'button',
                role: 'group'
            },
            renderHtml: function () {
                var a = this,
                    layout = a._layout;
                a.classes.add('btn-group');
                a.preRender();
                layout.preRender(a);
                return ('<div id="' + a._id + '" class="' + a.classes + '">' + '<div id="' + a._id + '-body">' + (a.settings.html || '') + layout.renderHtml(a) + '</div>' + '</div>')
            }
        })
    });
    define("tinymce/ui/Checkbox", ["tinymce/ui/Widget"], function (d) {
        "use strict";
        return d.extend({
            Defaults: {
                classes: "checkbox",
                role: "checkbox",
                checked: false
            },
            init: function (a) {
                var b = this;
                b._super(a);
                b.on('click mousedown', function (e) {
                    e.preventDefault()
                });
                b.on('click', function (e) {
                    e.preventDefault();
                    if (!b.disabled()) {
                        b.checked(!b.checked())
                    }
                });
                b.checked(b.settings.checked)
            },
            checked: function (a) {
                if (!arguments.length) {
                    return this.state.get('checked')
                }
                this.state.set('checked', a);
                return this
            },
            value: function (a) {
                if (!arguments.length) {
                    return this.checked()
                }
                return this.checked(a)
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    prefix = a.classPrefix;
                return ('<div id="' + id + '" class="' + a.classes + '" unselectable="on" aria-labelledby="' + id + '-al" tabindex="-1">' + '<i class="' + prefix + 'ico ' + prefix + 'i-checkbox"></i>' + '<span id="' + id + '-al" class="' + prefix + 'label">' + a.encode(a.state.get('text')) + '</span>' + '</div>')
            },
            bindStates: function () {
                var c = this;

                function checked(a) {
                    c.classes.toggle("checked", a);
                    c.aria('checked', a)
                }
                c.state.on('change:text', function (e) {
                    c.getEl('al').firstChild.data = c.translate(e.value)
                });
                c.state.on('change:checked change:value', function (e) {
                    c.fire('change');
                    checked(e.value)
                });
                c.state.on('change:icon', function (e) {
                    var a = e.value,
                        prefix = c.classPrefix;
                    if (typeof a == 'undefined') {
                        return c.settings.icon
                    }
                    c.settings.icon = a;
                    a = a ? prefix + 'ico ' + prefix + 'i-' + c.settings.icon : '';
                    var b = c.getEl().firstChild,
                        iconElm = b.getElementsByTagName('i')[0];
                    if (a) {
                        if (!iconElm || iconElm != b.firstChild) {
                            iconElm = document.createElement('i');
                            b.insertBefore(iconElm, b.firstChild)
                        }
                        iconElm.className = a
                    } else if (iconElm) {
                        b.removeChild(iconElm)
                    }
                });
                if (c.state.get('checked')) {
                    checked(true)
                }
                return c._super()
            }
        })
    });
    define("tinymce/ui/ComboBox", ["tinymce/ui/Widget", "tinymce/ui/Factory", "tinymce/ui/DomUtils", "tinymce/dom/DomQuery"], function (f, g, h, $) {
        "use strict";
        return f.extend({
            init: function (c) {
                var d = this;
                d._super(c);
                c = d.settings;
                d.classes.add('combobox');
                d.subinput = true;
                d.ariaTarget = 'inp';
                c.menu = c.menu || c.values;
                if (c.menu) {
                    c.icon = 'caret'
                }
                d.on('click', function (e) {
                    var a = e.target,
                        root = d.getEl();
                    if (!$.contains(root, a) && a != root) {
                        return
                    }
                    while (a && a != root) {
                        if (a.id && a.id.indexOf('-open') != -1) {
                            d.fire('action');
                            if (c.menu) {
                                d.showMenu();
                                if (e.aria) {
                                    d.menu.items()[0].focus()
                                }
                            }
                        }
                        a = a.parentNode
                    }
                });
                d.on('keydown', function (e) {
                    if (e.target.nodeName == "INPUT" && e.keyCode == 13) {
                        d.parents().reverse().each(function (a) {
                            var b = d.state.get('value'),
                                inputValue = d.getEl('inp').value;
                            e.preventDefault();
                            d.state.set('value', inputValue);
                            if (b != inputValue) {
                                d.fire('change')
                            }
                            if (a.hasEventListeners('submit') && a.toJSON) {
                                a.fire('submit', {
                                    data: a.toJSON()
                                });
                                return false
                            }
                        })
                    }
                });
                d.on('keyup', function (e) {
                    if (e.target.nodeName == "INPUT") {
                        d.state.set('value', e.target.value)
                    }
                })
            },
            showMenu: function () {
                var b = this,
                    settings = b.settings,
                    menu;
                if (!b.menu) {
                    menu = settings.menu || [];
                    if (menu.length) {
                        menu = {
                            type: 'menu',
                            items: menu
                        }
                    } else {
                        menu.type = menu.type || 'menu'
                    }
                    b.menu = g.create(menu).parent(b).renderTo(b.getContainerElm());
                    b.fire('createmenu');
                    b.menu.reflow();
                    b.menu.on('cancel', function (e) {
                        if (e.control === b.menu) {
                            b.focus()
                        }
                    });
                    b.menu.on('show hide', function (e) {
                        e.control.items().each(function (a) {
                            a.active(a.value() == b.value())
                        })
                    }).fire('show');
                    b.menu.on('select', function (e) {
                        b.value(e.control.value())
                    });
                    b.on('focusin', function (e) {
                        if (e.target.tagName.toUpperCase() == 'INPUT') {
                            b.menu.hide()
                        }
                    });
                    b.aria('expanded', true)
                }
                b.menu.show();
                b.menu.layoutRect({
                    w: b.layoutRect().w
                });
                b.menu.moveRel(b.getEl(), b.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl'])
            },
            focus: function () {
                this.getEl('inp').focus()
            },
            repaint: function () {
                var a = this,
                    elm = a.getEl(),
                    openElm = a.getEl('open'),
                    rect = a.layoutRect();
                var b, lineHeight;
                if (openElm) {
                    b = rect.w - h.getSize(openElm).width - 10
                } else {
                    b = rect.w - 10
                }
                var c = document;
                if (c.all && (!c.documentMode || c.documentMode <= 8)) {
                    lineHeight = (a.layoutRect().h - 2) + 'px'
                }
                $(elm.firstChild).css({
                    width: b,
                    lineHeight: lineHeight
                });
                a._super();
                return a
            },
            postRender: function () {
                var a = this;
                $(this.getEl('inp')).on('change', function (e) {
                    a.state.set('value', e.target.value);
                    a.fire('change', e)
                });
                return a._super()
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    settings = a.settings,
                    prefix = a.classPrefix;
                var b = a.state.get('value') || '';
                var c, text, openBtnHtml = '',
                    extraAttrs = '';
                if ("spellcheck" in settings) {
                    extraAttrs += ' spellcheck="' + settings.spellcheck + '"'
                }
                if (settings.maxLength) {
                    extraAttrs += ' maxlength="' + settings.maxLength + '"'
                }
                if (settings.size) {
                    extraAttrs += ' size="' + settings.size + '"'
                }
                if (settings.subtype) {
                    extraAttrs += ' type="' + settings.subtype + '"'
                }
                if (a.disabled()) {
                    extraAttrs += ' disabled="disabled"'
                }
                c = settings.icon;
                text = a.state.get('text');
                if (c || text) {
                    openBtnHtml = ('<div id="' + id + '-open" class="' + prefix + 'btn ' + prefix + 'open" tabIndex="-1" role="button">' + '<button id="' + id + '-action" type="button" hidefocus="1" tabindex="-1">' + (c != 'caret' ? '<i class="' + c + '"></i>' : '<i class="' + prefix + 'caret"></i>') + (text ? (c ? ' ' : '') + text : '') + '</button>' + '</div>');
                    a.classes.add('has-open')
                }
                return ('<div id="' + id + '" class="' + a.classes + '">' + '<input id="' + id + '-inp" class="' + prefix + 'textbox" value="' + a.encode(b, false) + '" hidefocus="1"' + extraAttrs + ' placeholder="' + a.encode(settings.placeholder) + '" />' + openBtnHtml + '</div>')
            },
            value: function (a) {
                if (arguments.length) {
                    this.state.set('value', a);
                    return this
                }
                if (this.state.get('rendered')) {
                    this.state.set('value', this.getEl('inp').value)
                }
                return this.state.get('value')
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:value', function (e) {
                    if (a.getEl('inp').value != e.value) {
                        a.getEl('inp').value = e.value
                    }
                });
                a.state.on('change:disabled', function (e) {
                    a.getEl('inp').disabled = e.value
                });
                return a._super()
            },
            remove: function () {
                $(this.getEl('inp')).off();
                this._super()
            }
        })
    });
    define("tinymce/ui/ColorBox", ["tinymce/ui/ComboBox"], function (c) {
        "use strict";
        return c.extend({
            init: function (a) {
                var b = this;
                a.spellcheck = false;
                if (a.onaction) {
                    a.icon = 'none'
                }
                b._super(a);
                b.classes.add('colorbox');
                b.on('change keyup postrender', function () {
                    b.repaintColor(b.value())
                })
            },
            repaintColor: function (a) {
                var b = this.getEl().getElementsByTagName('i')[0];
                if (b) {
                    try {
                        b.style.background = a
                    } catch (ex) { }
                }
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:value', function (e) {
                    if (a.state.get('rendered')) {
                        a.repaintColor(e.value)
                    }
                });
                return a._super()
            }
        })
    });
    define("tinymce/ui/PanelButton", ["tinymce/ui/Button", "tinymce/ui/FloatPanel"], function (c, d) {
        "use strict";
        return c.extend({
            showPanel: function () {
                var a = this,
                    settings = a.settings;
                a.active(true);
                if (!a.panel) {
                    var b = settings.panel;
                    if (b.type) {
                        b = {
                            layout: 'grid',
                            items: b
                        }
                    }
                    b.role = b.role || 'dialog';
                    b.popover = true;
                    b.autohide = true;
                    b.ariaRoot = true;
                    a.panel = new d(b).on('hide', function () {
                        a.active(false)
                    }).on('cancel', function (e) {
                        e.stopPropagation();
                        a.focus();
                        a.hidePanel()
                    }).parent(a).renderTo(a.getContainerElm());
                    a.panel.fire('show');
                    a.panel.reflow()
                } else {
                    a.panel.show()
                }
                a.panel.moveRel(a.getEl(), settings.popoverAlign || (a.isRtl() ? ['bc-tr', 'bc-tc'] : ['bc-tl', 'bc-tc']))
            },
            hidePanel: function () {
                var a = this;
                if (a.panel) {
                    a.panel.hide()
                }
            },
            postRender: function () {
                var a = this;
                a.aria('haspopup', true);
                a.on('click', function (e) {
                    if (e.control === a) {
                        if (a.panel && a.panel.visible()) {
                            a.hidePanel()
                        } else {
                            a.showPanel();
                            a.panel.focus(!!e.aria)
                        }
                    }
                });
                return a._super()
            },
            remove: function () {
                if (this.panel) {
                    this.panel.remove();
                    this.panel = null
                }
                return this._super()
            }
        })
    });
    define("tinymce/ui/ColorButton", ["tinymce/ui/PanelButton", "tinymce/dom/DOMUtils"], function (d, f) {
        "use strict";
        var g = f.DOM;
        return d.extend({
            init: function (a) {
                this._super(a);
                this.classes.add('colorbutton')
            },
            color: function (a) {
                if (a) {
                    this._color = a;
                    this.getEl('preview').style.backgroundColor = a;
                    return this
                }
                return this._color
            },
            resetColor: function () {
                this._color = null;
                this.getEl('preview').style.backgroundColor = null;
                return this
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    prefix = a.classPrefix,
                    text = a.state.get('text');
                var b = a.settings.icon ? prefix + 'ico ' + prefix + 'i-' + a.settings.icon : '';
                var c = a.settings.image ? ' style="background-image: url(\'' + a.settings.image + '\')"' : '',
                    textHtml = '';
                if (text) {
                    a.classes.add('btn-has-text');
                    textHtml = '<span class="' + prefix + 'txt">' + a.encode(text) + '</span>'
                }
                return ('<div id="' + id + '" class="' + a.classes + '" role="button" tabindex="-1" aria-haspopup="true">' + '<button role="presentation" hidefocus="1" type="button" tabindex="-1">' + (b != "forecolor" ? '<i class="' + b + '"' + c + '></i>' : '') + '<span id="' + id + '-preview" class="' + prefix + 'preview"></span>' + textHtml + '</button>' + '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>')
            },
            postRender: function () {
                var a = this,
                    onClickHandler = a.settings.onclick;
                a.on('click', function (e) {
                    if (e.aria && e.aria.key == 'down') {
                        return
                    }
                    if (e.control == a && !g.getParent(e.target, '.' + a.classPrefix + 'open')) {
                        e.stopImmediatePropagation();
                        onClickHandler.call(a, e)
                    }
                });
                delete a.settings.onclick;
                return a._super()
            }
        })
    });
    define("tinymce/util/Color", [], function () {
        var j = Math.min,
            max = Math.max,
            round = Math.round;

        function Color(f) {
            var i = this,
                r = 0,
                g = 0,
                b = 0;

            function rgb2hsv(r, g, b) {
                var h, s, v, d, minRGB, maxRGB;
                h = 0;
                s = 0;
                v = 0;
                r = r / 255;
                g = g / 255;
                b = b / 255;
                minRGB = j(r, j(g, b));
                maxRGB = max(r, max(g, b));
                if (minRGB == maxRGB) {
                    v = minRGB;
                    return {
                        h: 0,
                        s: 0,
                        v: v * 100
                    }
                }
                d = (r == minRGB) ? g - b : ((b == minRGB) ? r - g : b - r);
                h = (r == minRGB) ? 3 : ((b == minRGB) ? 1 : 5);
                h = 60 * (h - d / (maxRGB - minRGB));
                s = (maxRGB - minRGB) / maxRGB;
                v = maxRGB;
                return {
                    h: round(h),
                    s: round(s * 100),
                    v: round(v * 100)
                }
            }
            function hsvToRgb(a, c, d) {
                var e, chroma, x, match;
                a = (parseInt(a, 10) || 0) % 360;
                c = parseInt(c, 10) / 100;
                d = parseInt(d, 10) / 100;
                c = max(0, j(c, 1));
                d = max(0, j(d, 1));
                if (c === 0) {
                    r = g = b = round(255 * d);
                    return
                }
                e = a / 60;
                chroma = d * c;
                x = chroma * (1 - Math.abs(e % 2 - 1));
                match = d - chroma;
                switch (Math.floor(e)) {
                    case 0:
                        r = chroma;
                        g = x;
                        b = 0;
                        break;
                    case 1:
                        r = x;
                        g = chroma;
                        b = 0;
                        break;
                    case 2:
                        r = 0;
                        g = chroma;
                        b = x;
                        break;
                    case 3:
                        r = 0;
                        g = x;
                        b = chroma;
                        break;
                    case 4:
                        r = x;
                        g = 0;
                        b = chroma;
                        break;
                    case 5:
                        r = chroma;
                        g = 0;
                        b = x;
                        break;
                    default:
                        r = g = b = 0
                }
                r = round(255 * (r + match));
                g = round(255 * (g + match));
                b = round(255 * (b + match))
            }
            function toHex() {
                function hex(a) {
                    a = parseInt(a, 10).toString(16);
                    return a.length > 1 ? a : '0' + a
                }
                return '#' + hex(r) + hex(g) + hex(b)
            }
            function toRgb() {
                return {
                    r: r,
                    g: g,
                    b: b
                }
            }
            function toHsv() {
                return rgb2hsv(r, g, b)
            }
            function parse(a) {
                var c;
                if (typeof a == 'object') {
                    if ("r" in a) {
                        r = a.r;
                        g = a.g;
                        b = a.b
                    } else if ("v" in a) {
                        hsvToRgb(a.h, a.s, a.v)
                    }
                } else {
                    if ((c = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(a))) {
                        r = parseInt(c[1], 10);
                        g = parseInt(c[2], 10);
                        b = parseInt(c[3], 10)
                    } else if ((c = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(a))) {
                        r = parseInt(c[1], 16);
                        g = parseInt(c[2], 16);
                        b = parseInt(c[3], 16)
                    } else if ((c = /#([0-F])([0-F])([0-F])/gi.exec(a))) {
                        r = parseInt(c[1] + c[1], 16);
                        g = parseInt(c[2] + c[2], 16);
                        b = parseInt(c[3] + c[3], 16)
                    }
                }
                r = r < 0 ? 0 : (r > 255 ? 255 : r);
                g = g < 0 ? 0 : (g > 255 ? 255 : g);
                b = b < 0 ? 0 : (b > 255 ? 255 : b);
                return i
            }
            if (f) {
                parse(f)
            }
            i.toRgb = toRgb;
            i.toHsv = toHsv;
            i.toHex = toHex;
            i.parse = parse
        }
        return Color
    });
    define("tinymce/ui/ColorPicker", ["tinymce/ui/Widget", "tinymce/ui/DragHelper", "tinymce/ui/DomUtils", "tinymce/util/Color"], function (f, g, h, j) {
        "use strict";
        return f.extend({
            Defaults: {
                classes: "widget colorpicker"
            },
            init: function (a) {
                this._super(a)
            },
            postRender: function () {
                var d = this,
                    color = d.color(),
                    hsv, hueRootElm, huePointElm, svRootElm, svPointElm;
                hueRootElm = d.getEl('h');
                huePointElm = d.getEl('hp');
                svRootElm = d.getEl('sv');
                svPointElm = d.getEl('svp');

                function getPos(a, b) {
                    var c = h.getPos(a),
                        x, y;
                    x = b.pageX - c.x;
                    y = b.pageY - c.y;
                    x = Math.max(0, Math.min(x / a.clientWidth, 1));
                    y = Math.max(0, Math.min(y / a.clientHeight, 1));
                    return {
                        x: x,
                        y: y
                    }
                }
                function updateColor(a, b) {
                    var c = (360 - a.h) / 360;
                    h.css(huePointElm, {
                        top: (c * 100) + '%'
                    });
                    if (!b) {
                        h.css(svPointElm, {
                            left: a.s + '%',
                            top: (100 - a.v) + '%'
                        })
                    }
                    svRootElm.style.background = new j({
                        s: 100,
                        v: 100,
                        h: a.h
                    }).toHex();
                    d.color().parse({
                        s: a.s,
                        v: a.v,
                        h: a.h
                    })
                }
                function updateSaturationAndValue(e) {
                    var a;
                    a = getPos(svRootElm, e);
                    hsv.s = a.x * 100;
                    hsv.v = (1 - a.y) * 100;
                    updateColor(hsv);
                    d.fire('change')
                }
                function updateHue(e) {
                    var a;
                    a = getPos(hueRootElm, e);
                    hsv = color.toHsv();
                    hsv.h = (1 - a.y) * 360;
                    updateColor(hsv, true);
                    d.fire('change')
                }
                d._repaint = function () {
                    hsv = color.toHsv();
                    updateColor(hsv)
                };
                d._super();
                d._svdraghelper = new g(d._id + '-sv', {
                    start: updateSaturationAndValue,
                    drag: updateSaturationAndValue
                });
                d._hdraghelper = new g(d._id + '-h', {
                    start: updateHue,
                    drag: updateHue
                });
                d._repaint()
            },
            rgb: function () {
                return this.color().toRgb()
            },
            value: function (a) {
                var b = this;
                if (arguments.length) {
                    b.color().parse(a);
                    if (b._rendered) {
                        b._repaint()
                    }
                } else {
                    return b.color().toHex()
                }
            },
            color: function () {
                if (!this._color) {
                    this._color = new j()
                }
                return this._color
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    prefix = a.classPrefix,
                    hueHtml;
                var b = '#ff0000,#ff0080,#ff00ff,#8000ff,#0000ff,#0080ff,#00ffff,#00ff80,#00ff00,#80ff00,#ffff00,#ff8000,#ff0000';

                function getOldIeFallbackHtml() {
                    var i, l, html = '',
                        gradientPrefix, stopsList;
                    gradientPrefix = 'filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=';
                    stopsList = b.split(',');
                    for (i = 0, l = stopsList.length - 1; i < l; i++) {
                        html += ('<div class="' + prefix + 'colorpicker-h-chunk" style="' + 'height:' + (100 / l) + '%;' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ');' + '-ms-' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ')' + '"></div>')
                    }
                    return html
                }
                var c = ('background:linear-gradient(to bottom,' + b + ');');
                hueHtml = ('<div id="' + id + '-h" class="' + prefix + 'colorpicker-h" style="' + c + '">' + getOldIeFallbackHtml() + '<div id="' + id + '-hp" class="' + prefix + 'colorpicker-h-marker"></div>' + '</div>');
                return ('<div id="' + id + '" class="' + a.classes + '">' + '<div id="' + id + '-sv" class="' + prefix + 'colorpicker-sv">' + '<div class="' + prefix + 'colorpicker-overlay1">' + '<div class="' + prefix + 'colorpicker-overlay2">' + '<div id="' + id + '-svp" class="' + prefix + 'colorpicker-selector1">' + '<div class="' + prefix + 'colorpicker-selector2"></div>' + '</div>' + '</div>' + '</div>' + '</div>' + hueHtml + '</div>')
            }
        })
    });
    define("tinymce/ui/Path", ["tinymce/ui/Widget"], function (d) {
        "use strict";
        return d.extend({
            init: function (b) {
                var c = this;
                if (!b.delimiter) {
                    b.delimiter = '»'
                }
                c._super(b);
                c.classes.add('path');
                c.canFocus = true;
                c.on('click', function (e) {
                    var a, target = e.target;
                    if ((a = target.getAttribute('data-index'))) {
                        c.fire('select', {
                            value: c.row()[a],
                            index: a
                        })
                    }
                });
                c.row(c.settings.row)
            },
            focus: function () {
                var a = this;
                a.getEl().firstChild.focus();
                return a
            },
            row: function (a) {
                if (!arguments.length) {
                    return this.state.get('row')
                }
                this.state.set('row', a);
                return this
            },
            renderHtml: function () {
                var a = this;
                return ('<div id="' + a._id + '" class="' + a.classes + '">' + a._getDataPathHtml(a.state.get('row')) + '</div>')
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:row', function (e) {
                    a.innerHtml(a._getDataPathHtml(e.value))
                });
                return a._super()
            },
            _getDataPathHtml: function (a) {
                var b = this,
                    parts = a || [],
                    i, l, html = '',
                    prefix = b.classPrefix;
                for (i = 0, l = parts.length; i < l; i++) {
                    html += ((i > 0 ? '<div class="' + prefix + 'divider" aria-hidden="true"> ' + b.settings.delimiter + ' </div>' : '') + '<div role="button" class="' + prefix + 'path-item' + (i == l - 1 ? ' ' + prefix + 'last' : '') + '" data-index="' + i + '" tabindex="-1" id="' + b._id + '-' + i + '" aria-level="' + i + '">' + parts[i].name + '</div>')
                }
                if (!html) {
                    html = '<div class="' + prefix + 'path-item"> </div>'
                }
                return html
            }
        })
    });
    define("tinymce/ui/ElementPath", ["tinymce/ui/Path"], function (d) {
        return d.extend({
            postRender: function () {
                var c = this,
                    editor = c.settings.editor;

                function isHidden(a) {
                    if (a.nodeType === 1) {
                        if (a.nodeName == "BR" || !!a.getAttribute('data-mce-bogus')) {
                            return true
                        }
                        if (a.getAttribute('data-mce-type') === 'bookmark') {
                            return true
                        }
                    }
                    return false
                }
                if (editor.settings.elementpath !== false) {
                    c.on('select', function (e) {
                        editor.focus();
                        editor.selection.select(this.row()[e.index].element);
                        editor.nodeChanged()
                    });
                    editor.on('nodeChange', function (e) {
                        var a = [],
                            parents = e.parents,
                            i = parents.length;
                        while (i--) {
                            if (parents[i].nodeType == 1 && !isHidden(parents[i])) {
                                var b = editor.fire('ResolveName', {
                                    name: parents[i].nodeName.toLowerCase(),
                                    target: parents[i]
                                });
                                if (!b.isDefaultPrevented()) {
                                    a.push({
                                        name: b.name,
                                        element: parents[i]
                                    })
                                }
                                if (b.isPropagationStopped()) {
                                    break
                                }
                            }
                        }
                        c.row(a)
                    })
                }
                return c._super()
            }
        })
    });
    define("tinymce/ui/FormItem", ["tinymce/ui/Container"], function (b) {
        "use strict";
        return b.extend({
            Defaults: {
                layout: 'flex',
                align: 'center',
                defaults: {
                    flex: 1
                }
            },
            renderHtml: function () {
                var a = this,
                    layout = a._layout,
                    prefix = a.classPrefix;
                a.classes.add('formitem');
                layout.preRender(a);
                return ('<div id="' + a._id + '" class="' + a.classes + '" hidefocus="1" tabindex="-1">' + (a.settings.title ? ('<div id="' + a._id + '-title" class="' + prefix + 'title">' + a.settings.title + '</div>') : '') + '<div id="' + a._id + '-body" class="' + a.bodyClasses + '">' + (a.settings.html || '') + layout.renderHtml(a) + '</div>' + '</div>')
            }
        })
    });
    define("tinymce/ui/Form", ["tinymce/ui/Container", "tinymce/ui/FormItem", "tinymce/util/Tools"], function (e, f, g) {
        "use strict";
        return e.extend({
            Defaults: {
                containerCls: 'form',
                layout: 'flex',
                direction: 'column',
                align: 'stretch',
                flex: 1,
                padding: 20,
                labelGap: 30,
                spacing: 10,
                callbacks: {
                    submit: function () {
                        this.submit()
                    }
                }
            },
            preRender: function () {
                var c = this,
                    items = c.items();
                if (!c.settings.formItemDefaults) {
                    c.settings.formItemDefaults = {
                        layout: 'flex',
                        autoResize: "overflow",
                        defaults: {
                            flex: 1
                        }
                    }
                }
                items.each(function (a) {
                    var b, label = a.settings.label;
                    if (label) {
                        b = new f(g.extend({
                            items: {
                                type: 'label',
                                id: a._id + '-l',
                                text: label,
                                flex: 0,
                                forId: a._id,
                                disabled: a.disabled()
                            }
                        }, c.settings.formItemDefaults));
                        b.type = 'formitem';
                        a.aria('labelledby', a._id + '-l');
                        if (typeof a.settings.flex == "undefined") {
                            a.settings.flex = 1
                        }
                        c.replace(a, b);
                        b.add(a)
                    }
                })
            },
            submit: function () {
                return this.fire('submit', {
                    data: this.toJSON()
                })
            },
            postRender: function () {
                var a = this;
                a._super();
                a.fromJSON(a.settings.data)
            },
            bindStates: function () {
                var d = this;
                d._super();

                function recalcLabels() {
                    var c = 0,
                        labels = [],
                        i, labelGap, items;
                    if (d.settings.labelGapCalc === false) {
                        return
                    }
                    if (d.settings.labelGapCalc == "children") {
                        items = d.find('formitem')
                    } else {
                        items = d.items()
                    }
                    items.filter('formitem').each(function (a) {
                        var b = a.items()[0],
                            labelWidth = b.getEl().clientWidth;
                        c = labelWidth > c ? labelWidth : c;
                        labels.push(b)
                    });
                    labelGap = d.settings.labelGap || 0;
                    i = labels.length;
                    while (i--) {
                        labels[i].settings.minWidth = c + labelGap
                    }
                }
                d.on('show', recalcLabels);
                recalcLabels()
            }
        })
    });
    define("tinymce/ui/FieldSet", ["tinymce/ui/Form"], function (b) {
        "use strict";
        return b.extend({
            Defaults: {
                containerCls: 'fieldset',
                layout: 'flex',
                direction: 'column',
                align: 'stretch',
                flex: 1,
                padding: "25 15 5 15",
                labelGap: 30,
                spacing: 10,
                border: 1
            },
            renderHtml: function () {
                var a = this,
                    layout = a._layout,
                    prefix = a.classPrefix;
                a.preRender();
                layout.preRender(a);
                return ('<fieldset id="' + a._id + '" class="' + a.classes + '" hidefocus="1" tabindex="-1">' + (a.settings.title ? ('<legend id="' + a._id + '-title" class="' + prefix + 'fieldset-title">' + a.settings.title + '</legend>') : '') + '<div id="' + a._id + '-body" class="' + a.bodyClasses + '">' + (a.settings.html || '') + layout.renderHtml(a) + '</div>' + '</fieldset>')
            }
        })
    });
    define("tinymce/ui/FilePicker", ["tinymce/ui/ComboBox", "tinymce/util/Tools"], function (g, h) {
        "use strict";
        return g.extend({
            init: function (d) {
                var e = this,
                    editor = tinymce.activeEditor,
                    editorSettings = editor.settings;
                var f, fileBrowserCallback, fileBrowserCallbackTypes;
                d.spellcheck = false;
                fileBrowserCallbackTypes = editorSettings.file_picker_types || editorSettings.file_browser_callback_types;
                if (fileBrowserCallbackTypes) {
                    fileBrowserCallbackTypes = h.makeMap(fileBrowserCallbackTypes, /[, ]/)
                }
                if (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[d.filetype]) {
                    fileBrowserCallback = editorSettings.file_picker_callback;
                    if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[d.filetype])) {
                        f = function () {
                            var c = e.fire('beforecall').meta;
                            c = h.extend({
                                filetype: d.filetype
                            }, c);
                            fileBrowserCallback.call(editor, function (a, b) {
                                e.value(a).fire('change', {
                                    meta: b
                                })
                            }, e.value(), c)
                        }
                    } else {
                        fileBrowserCallback = editorSettings.file_browser_callback;
                        if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[d.filetype])) {
                            f = function () {
                                fileBrowserCallback(e.getEl('inp').id, e.value(), d.filetype, window)
                            }
                        }
                    }
                }
                if (f) {
                    d.icon = 'browse';
                    d.onaction = f
                }
                e._super(d)
            }
        })
    });
    define("tinymce/ui/FitLayout", ["tinymce/ui/AbsoluteLayout"], function (d) {
        "use strict";
        return d.extend({
            recalc: function (b) {
                var c = b.layoutRect(),
                    paddingBox = b.paddingBox;
                b.items().filter(':visible').each(function (a) {
                    a.layoutRect({
                        x: paddingBox.left,
                        y: paddingBox.top,
                        w: c.innerW - paddingBox.right - paddingBox.left,
                        h: c.innerH - paddingBox.top - paddingBox.bottom
                    });
                    if (a.recalc) {
                        a.recalc()
                    }
                })
            }
        })
    });
    define("tinymce/ui/FlexLayout", ["tinymce/ui/AbsoluteLayout"], function (h) {
        "use strict";
        return h.extend({
            recalc: function (a) {
                var i, l, items, contLayoutRect, contPaddingBox, contSettings, align, pack, spacing, totalFlex, availableSpace, direction;
                var b, ctrlLayoutRect, ctrlSettings, flex, maxSizeItems = [],
                    size, maxSize, ratio, rect, pos, maxAlignEndPos;
                var c, minSizeName, posName, maxSizeName, beforeName, innerSizeName, deltaSizeName, contentSizeName;
                var d, alignInnerSizeName, alignSizeName, alignMinSizeName, alignBeforeName, alignAfterName;
                var e, alignContentSizeName;
                var f = Math.max,
                    min = Math.min;
                items = a.items().filter(':visible');
                contLayoutRect = a.layoutRect();
                contPaddingBox = a.paddingBox;
                contSettings = a.settings;
                direction = a.isRtl() ? (contSettings.direction || 'row-reversed') : contSettings.direction;
                align = contSettings.align;
                pack = a.isRtl() ? (contSettings.pack || 'end') : contSettings.pack;
                spacing = contSettings.spacing || 0;
                if (direction == "row-reversed" || direction == "column-reverse") {
                    items = items.set(items.toArray().reverse());
                    direction = direction.split('-')[0]
                }
                if (direction == "column") {
                    posName = "y";
                    c = "h";
                    minSizeName = "minH";
                    maxSizeName = "maxH";
                    innerSizeName = "innerH";
                    beforeName = 'top';
                    deltaSizeName = "deltaH";
                    contentSizeName = "contentH";
                    alignBeforeName = "left";
                    alignSizeName = "w";
                    d = "x";
                    alignInnerSizeName = "innerW";
                    alignMinSizeName = "minW";
                    alignAfterName = "right";
                    e = "deltaW";
                    alignContentSizeName = "contentW"
                } else {
                    posName = "x";
                    c = "w";
                    minSizeName = "minW";
                    maxSizeName = "maxW";
                    innerSizeName = "innerW";
                    beforeName = 'left';
                    deltaSizeName = "deltaW";
                    contentSizeName = "contentW";
                    alignBeforeName = "top";
                    alignSizeName = "h";
                    d = "y";
                    alignInnerSizeName = "innerH";
                    alignMinSizeName = "minH";
                    alignAfterName = "bottom";
                    e = "deltaH";
                    alignContentSizeName = "contentH"
                }
                availableSpace = contLayoutRect[innerSizeName] - contPaddingBox[beforeName] - contPaddingBox[beforeName];
                maxAlignEndPos = totalFlex = 0;
                for (i = 0, l = items.length; i < l; i++) {
                    b = items[i];
                    ctrlLayoutRect = b.layoutRect();
                    ctrlSettings = b.settings;
                    flex = ctrlSettings.flex;
                    availableSpace -= (i < l - 1 ? spacing : 0);
                    if (flex > 0) {
                        totalFlex += flex;
                        if (ctrlLayoutRect[maxSizeName]) {
                            maxSizeItems.push(b)
                        }
                        ctrlLayoutRect.flex = flex
                    }
                    availableSpace -= ctrlLayoutRect[minSizeName];
                    size = contPaddingBox[alignBeforeName] + ctrlLayoutRect[alignMinSizeName] + contPaddingBox[alignAfterName];
                    if (size > maxAlignEndPos) {
                        maxAlignEndPos = size
                    }
                }
                rect = {};
                if (availableSpace < 0) {
                    rect[minSizeName] = contLayoutRect[minSizeName] - availableSpace + contLayoutRect[deltaSizeName]
                } else {
                    rect[minSizeName] = contLayoutRect[innerSizeName] - availableSpace + contLayoutRect[deltaSizeName]
                }
                rect[alignMinSizeName] = maxAlignEndPos + contLayoutRect[e];
                rect[contentSizeName] = contLayoutRect[innerSizeName] - availableSpace;
                rect[alignContentSizeName] = maxAlignEndPos;
                rect.minW = min(rect.minW, contLayoutRect.maxW);
                rect.minH = min(rect.minH, contLayoutRect.maxH);
                rect.minW = f(rect.minW, contLayoutRect.startMinWidth);
                rect.minH = f(rect.minH, contLayoutRect.startMinHeight);
                if (contLayoutRect.autoResize && (rect.minW != contLayoutRect.minW || rect.minH != contLayoutRect.minH)) {
                    rect.w = rect.minW;
                    rect.h = rect.minH;
                    a.layoutRect(rect);
                    this.recalc(a);
                    if (a._lastRect === null) {
                        var g = a.parent();
                        if (g) {
                            g._lastRect = null;
                            g.recalc()
                        }
                    }
                    return
                }
                ratio = availableSpace / totalFlex;
                for (i = 0, l = maxSizeItems.length; i < l; i++) {
                    b = maxSizeItems[i];
                    ctrlLayoutRect = b.layoutRect();
                    maxSize = ctrlLayoutRect[maxSizeName];
                    size = ctrlLayoutRect[minSizeName] + ctrlLayoutRect.flex * ratio;
                    if (size > maxSize) {
                        availableSpace -= (ctrlLayoutRect[maxSizeName] - ctrlLayoutRect[minSizeName]);
                        totalFlex -= ctrlLayoutRect.flex;
                        ctrlLayoutRect.flex = 0;
                        ctrlLayoutRect.maxFlexSize = maxSize
                    } else {
                        ctrlLayoutRect.maxFlexSize = 0
                    }
                }
                ratio = availableSpace / totalFlex;
                pos = contPaddingBox[beforeName];
                rect = {};
                if (totalFlex === 0) {
                    if (pack == "end") {
                        pos = availableSpace + contPaddingBox[beforeName]
                    } else if (pack == "center") {
                        pos = Math.round((contLayoutRect[innerSizeName] / 2) - ((contLayoutRect[innerSizeName] - availableSpace) / 2)) + contPaddingBox[beforeName];
                        if (pos < 0) {
                            pos = contPaddingBox[beforeName]
                        }
                    } else if (pack == "justify") {
                        pos = contPaddingBox[beforeName];
                        spacing = Math.floor(availableSpace / (items.length - 1))
                    }
                }
                rect[d] = contPaddingBox[alignBeforeName];
                for (i = 0, l = items.length; i < l; i++) {
                    b = items[i];
                    ctrlLayoutRect = b.layoutRect();
                    size = ctrlLayoutRect.maxFlexSize || ctrlLayoutRect[minSizeName];
                    if (align === "center") {
                        rect[d] = Math.round((contLayoutRect[alignInnerSizeName] / 2) - (ctrlLayoutRect[alignSizeName] / 2))
                    } else if (align === "stretch") {
                        rect[alignSizeName] = f(ctrlLayoutRect[alignMinSizeName] || 0, contLayoutRect[alignInnerSizeName] - contPaddingBox[alignBeforeName] - contPaddingBox[alignAfterName]);
                        rect[d] = contPaddingBox[alignBeforeName]
                    } else if (align === "end") {
                        rect[d] = contLayoutRect[alignInnerSizeName] - ctrlLayoutRect[alignSizeName] - contPaddingBox.top
                    }
                    if (ctrlLayoutRect.flex > 0) {
                        size += ctrlLayoutRect.flex * ratio
                    }
                    rect[c] = size;
                    rect[posName] = pos;
                    b.layoutRect(rect);
                    if (b.recalc) {
                        b.recalc()
                    }
                    pos += size + spacing
                }
            }
        })
    });
    define("tinymce/ui/FlowLayout", ["tinymce/ui/Layout"], function (c) {
        return c.extend({
            Defaults: {
                containerClass: 'flow-layout',
                controlClass: 'flow-layout-item',
                endClass: 'break'
            },
            recalc: function (b) {
                b.items().filter(':visible').each(function (a) {
                    if (a.recalc) {
                        a.recalc()
                    }
                })
            },
            isNative: function () {
                return true
            }
        })
    });
    define("tinymce/ui/FormatControls", ["tinymce/ui/Control", "tinymce/ui/Widget", "tinymce/ui/FloatPanel", "tinymce/util/Tools", "tinymce/dom/DOMUtils", "tinymce/EditorManager", "tinymce/Env"], function (l, m, n, o, p, q, r) {
        var s = o.each;
        q.on('AddEditor', function (e) {
            var a = e.editor;
            setupRtlMode(a);
            registerControls(a);
            setupContainer(a)
        });
        l.translate = function (a) {
            return q.translate(a)
        };
        m.tooltips = !r.iOS;

        function setupContainer(a) {
            if (a.settings.ui_container) {
                r.container = p.DOM.select(a.settings.ui_container)[0]
            }
        }
        function setupRtlMode(a) {
            a.on('ScriptsLoaded', function () {
                if (a.rtl) {
                    l.rtl = true
                }
            })
        }
        function registerControls(j) {
            var k;

            function createListBoxChangeHandler(g, h) {
                return function () {
                    var f = this;
                    j.on('nodeChange', function (e) {
                        var c = j.formatter;
                        var d = null;
                        s(e.parents, function (b) {
                            s(g, function (a) {
                                if (h) {
                                    if (c.matchNode(b, h, {
                                        value: a.value
                                    })) {
                                        d = a.value
                                    }
                                } else {
                                    if (c.matchNode(b, a.value)) {
                                        d = a.value
                                    }
                                }
                                if (d) {
                                    return false
                                }
                            });
                            if (d) {
                                return false
                            }
                        });
                        f.value(d)
                    })
                }
            }
            function createFormats(a) {
                a = a.replace(/;$/, '').split(';');
                var i = a.length;
                while (i--) {
                    a[i] = a[i].split('=')
                }
                return a
            }
            function createFormatMenu() {
                var f = 0,
                    newFormats = [];
                var g = [{
                    title: 'Headings',
                    items: [{
                        title: 'Heading 1',
                        format: 'h1'
                    }, {
                        title: 'Heading 2',
                        format: 'h2'
                    }, {
                        title: 'Heading 3',
                        format: 'h3'
                    }, {
                        title: 'Heading 4',
                        format: 'h4'
                    }, {
                        title: 'Heading 5',
                        format: 'h5'
                    }, {
                        title: 'Heading 6',
                        format: 'h6'
                    }]
                }, {
                    title: 'Inline',
                    items: [{
                        title: 'Bold',
                        icon: 'bold',
                        format: 'bold'
                    }, {
                        title: 'Italic',
                        icon: 'italic',
                        format: 'italic'
                    }, {
                        title: 'Underline',
                        icon: 'underline',
                        format: 'underline'
                    }, {
                        title: 'Strikethrough',
                        icon: 'strikethrough',
                        format: 'strikethrough'
                    }, {
                        title: 'Superscript',
                        icon: 'superscript',
                        format: 'superscript'
                    }, {
                        title: 'Subscript',
                        icon: 'subscript',
                        format: 'subscript'
                    }, {
                        title: 'Code',
                        icon: 'code',
                        format: 'code'
                    }]
                }, {
                    title: 'Blocks',
                    items: [{
                        title: 'Paragraph',
                        format: 'p'
                    }, {
                        title: 'Blockquote',
                        format: 'blockquote'
                    }, {
                        title: 'Div',
                        format: 'div'
                    }, {
                        title: 'Pre',
                        format: 'pre'
                    }]
                }, {
                    title: 'Alignment',
                    items: [{
                        title: 'Left',
                        icon: 'alignleft',
                        format: 'alignleft'
                    }, {
                        title: 'Center',
                        icon: 'aligncenter',
                        format: 'aligncenter'
                    }, {
                        title: 'Right',
                        icon: 'alignright',
                        format: 'alignright'
                    }, {
                        title: 'Justify',
                        icon: 'alignjustify',
                        format: 'alignjustify'
                    }]
                }];

                function createMenu(d) {
                    var e = [];
                    if (!d) {
                        return
                    }
                    s(d, function (a) {
                        var b = {
                            text: a.title,
                            icon: a.icon
                        };
                        if (a.items) {
                            b.menu = createMenu(a.items)
                        } else {
                            var c = a.format || "custom" + f++;
                            if (!a.format) {
                                a.name = c;
                                newFormats.push(a)
                            }
                            b.format = c;
                            b.cmd = a.cmd
                        }
                        e.push(b)
                    });
                    return e
                }
                function createStylesMenu() {
                    var a;
                    if (j.settings.style_formats_merge) {
                        if (j.settings.style_formats) {
                            a = createMenu(g.concat(j.settings.style_formats))
                        } else {
                            a = createMenu(g)
                        }
                    } else {
                        a = createMenu(j.settings.style_formats || g)
                    }
                    return a
                }
                j.on('init', function () {
                    s(newFormats, function (a) {
                        j.formatter.register(a.name, a)
                    })
                });
                return {
                    type: 'menu',
                    items: createStylesMenu(),
                    onPostRender: function (e) {
                        j.fire('renderFormatsMenu', {
                            control: e.control
                        })
                    },
                    itemDefaults: {
                        preview: true,
                        textStyle: function () {
                            if (this.settings.format) {
                                return j.formatter.getCssText(this.settings.format)
                            }
                        },
                        onPostRender: function () {
                            var b = this;
                            b.parent().on('show', function () {
                                var a, command;
                                a = b.settings.format;
                                if (a) {
                                    b.disabled(!j.formatter.canApply(a));
                                    b.active(j.formatter.match(a))
                                }
                                command = b.settings.cmd;
                                if (command) {
                                    b.active(j.queryCommandState(command))
                                }
                            })
                        },
                        onclick: function () {
                            if (this.settings.format) {
                                toggleFormat(this.settings.format)
                            }
                            if (this.settings.cmd) {
                                j.execCommand(this.settings.cmd)
                            }
                        }
                    }
                }
            }
            k = createFormatMenu();

            function initOnPostRender(c) {
                return function () {
                    var b = this;
                    if (j.formatter) {
                        j.formatter.formatChanged(c, function (a) {
                            b.active(a)
                        })
                    } else {
                        j.on('init', function () {
                            j.formatter.formatChanged(c, function (a) {
                                b.active(a)
                            })
                        })
                    }
                }
            }
            s({
                bold: ['Bold', 'ews-icon-bold'],
                italic: ['Italic', 'ews-icon-italic'],
                underline: ['Underline', 'ews-icon-underline'],
                strikethrough: ['Strikethrough', 'ews-icon-strike'],
                subscript: ['Subscript', 'ews-icon-italic'],
                superscript: ['Superscript', 'ews-icon-italic']
            }, function (a, b) {
                j.addButton(b, {
                    tooltip: a[0],
                    icon: a[1],
                    onPostRender: initOnPostRender(b),
                    onclick: function () {
                        toggleFormat(b)
                    }
                })
            });
            s({
                outdent: ['Decrease indent', 'Outdent', 'ews-icon-outdent'],
                indent: ['Increase indent', 'Indent', 'ews-icon-indent'],
                cut: ['Cut', 'Cut'],
                copy: ['Copy', 'Copy'],
                paste: ['Paste', 'Paste'],
                help: ['Help', 'mceHelp'],
                selectall: ['Select all', 'SelectAll'],
                removeformat: ['Clear formatting', 'RemoveFormat'],
                visualaid: ['Visual aids', 'mceToggleVisualAid'],
                newdocument: ['New document', 'mceNewDocument']
            }, function (a, b) {
                var c = {
                    tooltip: a[0],
                    cmd: a[1]
                };
                if (a[2]) {
                    c.icon = a[2]
                }
                j.addButton(b, c)
            });
            s({
                blockquote: ['Blockquote', 'mceBlockQuote', 'blockquote'],
                numlist: ['Numbered list', 'InsertOrderedList', 'ews-icon-listnum'],
                bullist: ['Bullet list', 'InsertUnorderedList', 'ews-icon-lists'],
                subscript: ['Subscript', 'Subscript', 'subscript'],
                superscript: ['Superscript', 'Superscript', 'superscript'],
                alignleft: ['Align left', 'JustifyLeft', 'ews-icon-left'],
                aligncenter: ['Align center', 'JustifyCenter', 'ews-icon-center'],
                alignright: ['Align right', 'JustifyRight', 'ews-icon-right'],
                alignjustify: ['Justify', 'JustifyFull', 'ews-icon-textalignbothside'],
                alignnone: ['No alignment', 'JustifyNone', 'alignnone']
            }, function (a, b) {
                j.addButton(b, {
                    tooltip: a[0],
                    icon: a[2],
                    cmd: a[1],
                    onPostRender: initOnPostRender(b)
                })
            });

            function toggleUndoRedoState(b) {
                return function () {
                    var a = this;
                    b = b == 'redo' ? 'hasRedo' : 'hasUndo';

                    function checkState() {
                        return j.undoManager ? j.undoManager[b]() : false
                    }
                    a.disabled(!checkState());
                    j.on('Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', function () {
                        a.disabled(j.readonly || !checkState())
                    })
                }
            }
            function toggleVisualAidState() {
                var a = this;
                j.on('VisualAid', function (e) {
                    a.active(e.hasVisual)
                });
                a.active(j.hasVisual)
            }
            j.addButton('undo', {
                tooltip: 'Undo',
                icon: 'ews-icon-reply',
                onPostRender: toggleUndoRedoState('undo'),
                cmd: 'undo'
            });
            j.addButton('redo', {
                tooltip: 'Redo',
                icon: 'ews-icon-redo',
                onPostRender: toggleUndoRedoState('redo'),
                cmd: 'redo'
            });
            j.addMenuItem('newdocument', {
                text: 'New document',
                icon: 'newdocument',
                cmd: 'mceNewDocument'
            });
            j.addMenuItem('undo', {
                text: 'Undo',
                icon: 'undo',
                shortcut: 'Meta+Z',
                onPostRender: toggleUndoRedoState('undo'),
                cmd: 'undo'
            });
            j.addMenuItem('redo', {
                text: 'Redo',
                icon: 'redo',
                shortcut: 'Meta+Y',
                onPostRender: toggleUndoRedoState('redo'),
                cmd: 'redo'
            });
            j.addMenuItem('visualaid', {
                text: 'Visual aids',
                selectable: true,
                onPostRender: toggleVisualAidState,
                cmd: 'mceToggleVisualAid'
            });
            j.addButton('remove', {
                tooltip: 'Remove',
                icon: 'remove',
                cmd: 'Delete'
            });
            s({
                cut: ['Cut', 'Cut', 'Meta+X'],
                copy: ['Copy', 'Copy', 'Meta+C'],
                paste: ['Paste', 'Paste', 'Meta+V'],
                selectall: ['Select all', 'SelectAll', 'Meta+A'],
                bold: ['Bold', 'Bold', 'Meta+B'],
                italic: ['Italic', 'Italic', 'Meta+I'],
                underline: ['Underline', 'Underline'],
                strikethrough: ['Strikethrough', 'Strikethrough'],
                subscript: ['Subscript', 'Subscript'],
                superscript: ['Superscript', 'Superscript'],
                removeformat: ['Clear formatting', 'RemoveFormat']
            }, function (a, b) {
                j.addMenuItem(b, {
                    text: a[0],
                    icon: b,
                    shortcut: a[2],
                    cmd: a[1]
                })
            });
            j.on('mousedown', function () {
                n.hideAll()
            });

            function toggleFormat(a) {
                if (a.control) {
                    a = a.control.value()
                }
                if (a) {
                    j.execCommand('mceToggleFormat', false, a)
                }
            }
            j.addButton('styleselect', {
                type: 'menubutton',
                icon: 'ews-icon-format',
                menu: k
            });
            j.addButton('formatselect', function () {
                var b = [],
                    blocks = createFormats(j.settings.block_formats || 'Paragraph=p;' + 'Heading 1=h1;' + 'Heading 2=h2;' + 'Heading 3=h3;' + 'Heading 4=h4;' + 'Heading 5=h5;' + 'Heading 6=h6;' + 'Preformatted=pre');
                s(blocks, function (a) {
                    b.push({
                        text: a[0],
                        value: a[1],
                        textStyle: function () {
                            return j.formatter.getCssText(a[1])
                        }
                    })
                });
                return {
                    type: 'listbox',
                    text: blocks[0][0],
                    values: b,
                    fixedWidth: true,
                    onselect: toggleFormat,
                    onPostRender: createListBoxChangeHandler(b)
                }
            });
            j.addButton('fontselect', function () {
                var b = 'Andale Mono=andale mono,monospace;' + 'Arial=arial,helvetica,sans-serif;' + 'Arial Black=arial black,sans-serif;' + 'Book Antiqua=book antiqua,palatino,serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Courier New=courier new,courier,monospace;' + 'Georgia=georgia,palatino,serif;' + 'Helvetica=helvetica,arial,sans-serif;' + 'Impact=impact,sans-serif;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' + 'Terminal=terminal,monaco,monospace;' + 'Times New Roman=times new roman,times,serif;' + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;' + 'Verdana=verdana,geneva,sans-serif;' + 'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats';
                var c = [],
                    fonts = createFormats(j.settings.font_formats || b);
                s(fonts, function (a) {
                    c.push({
                        text: {
                            raw: a[0]
                        },
                        value: a[1],
                        textStyle: a[1].indexOf('dings') == -1 ? 'font-family:' + a[1] : ''
                    })
                });
                return {
                    type: 'listbox',
                    text: 'Font Family',
                    tooltip: 'Font Family',
                    values: c,
                    fixedWidth: true,
                    onPostRender: createListBoxChangeHandler(c, 'fontname'),
                    onselect: function (e) {
                        if (e.control.settings.value) {
                            j.execCommand('FontName', false, e.control.settings.value)
                        }
                    }
                }
            });
            j.addButton('fontsizeselect', function () {
                var d = [],
                    defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
                var f = j.settings.fontsize_formats || defaultFontsizeFormats;
                s(f.split(' '), function (a) {
                    var b = a,
                        value = a;
                    var c = a.split('=');
                    if (c.length > 1) {
                        b = c[0];
                        value = c[1]
                    }
                    d.push({
                        text: b,
                        value: value
                    })
                });
                return {
                    type: 'listbox',
                    icon: 'ews-icon-font-size',
                    tooltip: 'Font Sizes',
                    values: d,
                    fixedWidth: true,
                    onPostRender: createListBoxChangeHandler(d, 'fontsize'),
                    onclick: function (e) {
                        if (e.control.settings.value) {
                            j.execCommand('FontSize', false, e.control.settings.value);
                        }
                    }
                }
            });
            j.addMenuItem('formats', {
                text: 'Formats',
                menu: k
            })
        }
    });
    define("tinymce/ui/GridLayout", ["tinymce/ui/AbsoluteLayout"], function (h) {
        "use strict";
        return h.extend({
            recalc: function (a) {
                var b, rows, cols, items, contLayoutRect, width, height, rect, ctrlLayoutRect, ctrl, x, y, posX, posY, ctrlSettings, contPaddingBox, align, spacingH, spacingV, alignH, alignV, maxX, maxY, colWidths = [],
                    rowHeights = [],
                    ctrlMinWidth, ctrlMinHeight, availableWidth, availableHeight, reverseRows, idx;
                b = a.settings;
                items = a.items().filter(':visible');
                contLayoutRect = a.layoutRect();
                cols = b.columns || Math.ceil(Math.sqrt(items.length));
                rows = Math.ceil(items.length / cols);
                spacingH = b.spacingH || b.spacing || 0;
                spacingV = b.spacingV || b.spacing || 0;
                alignH = b.alignH || b.align;
                alignV = b.alignV || b.align;
                contPaddingBox = a.paddingBox;
                reverseRows = 'reverseRows' in b ? b.reverseRows : a.isRtl();
                if (alignH && typeof alignH == "string") {
                    alignH = [alignH]
                }
                if (alignV && typeof alignV == "string") {
                    alignV = [alignV]
                }
                for (x = 0; x < cols; x++) {
                    colWidths.push(0)
                }
                for (y = 0; y < rows; y++) {
                    rowHeights.push(0)
                }
                for (y = 0; y < rows; y++) {
                    for (x = 0; x < cols; x++) {
                        ctrl = items[y * cols + x];
                        if (!ctrl) {
                            break
                        }
                        ctrlLayoutRect = ctrl.layoutRect();
                        ctrlMinWidth = ctrlLayoutRect.minW;
                        ctrlMinHeight = ctrlLayoutRect.minH;
                        colWidths[x] = ctrlMinWidth > colWidths[x] ? ctrlMinWidth : colWidths[x];
                        rowHeights[y] = ctrlMinHeight > rowHeights[y] ? ctrlMinHeight : rowHeights[y]
                    }
                }
                availableWidth = contLayoutRect.innerW - contPaddingBox.left - contPaddingBox.right;
                for (maxX = 0, x = 0; x < cols; x++) {
                    maxX += colWidths[x] + (x > 0 ? spacingH : 0);
                    availableWidth -= (x > 0 ? spacingH : 0) + colWidths[x]
                }
                availableHeight = contLayoutRect.innerH - contPaddingBox.top - contPaddingBox.bottom;
                for (maxY = 0, y = 0; y < rows; y++) {
                    maxY += rowHeights[y] + (y > 0 ? spacingV : 0);
                    availableHeight -= (y > 0 ? spacingV : 0) + rowHeights[y]
                }
                maxX += contPaddingBox.left + contPaddingBox.right;
                maxY += contPaddingBox.top + contPaddingBox.bottom;
                rect = {};
                rect.minW = maxX + (contLayoutRect.w - contLayoutRect.innerW);
                rect.minH = maxY + (contLayoutRect.h - contLayoutRect.innerH);
                rect.contentW = rect.minW - contLayoutRect.deltaW;
                rect.contentH = rect.minH - contLayoutRect.deltaH;
                rect.minW = Math.min(rect.minW, contLayoutRect.maxW);
                rect.minH = Math.min(rect.minH, contLayoutRect.maxH);
                rect.minW = Math.max(rect.minW, contLayoutRect.startMinWidth);
                rect.minH = Math.max(rect.minH, contLayoutRect.startMinHeight);
                if (contLayoutRect.autoResize && (rect.minW != contLayoutRect.minW || rect.minH != contLayoutRect.minH)) {
                    rect.w = rect.minW;
                    rect.h = rect.minH;
                    a.layoutRect(rect);
                    this.recalc(a);
                    if (a._lastRect === null) {
                        var c = a.parent();
                        if (c) {
                            c._lastRect = null;
                            c.recalc()
                        }
                    }
                    return
                }
                if (contLayoutRect.autoResize) {
                    rect = a.layoutRect(rect);
                    rect.contentW = rect.minW - contLayoutRect.deltaW;
                    rect.contentH = rect.minH - contLayoutRect.deltaH
                }
                var d;
                if (b.packV == 'start') {
                    d = 0
                } else {
                    d = availableHeight > 0 ? Math.floor(availableHeight / rows) : 0
                }
                var e = 0;
                var f = b.flexWidths;
                if (f) {
                    for (x = 0; x < f.length; x++) {
                        e += f[x]
                    }
                } else {
                    e = cols
                }
                var g = availableWidth / e;
                for (x = 0; x < cols; x++) {
                    colWidths[x] += f ? f[x] * g : g
                }
                posY = contPaddingBox.top;
                for (y = 0; y < rows; y++) {
                    posX = contPaddingBox.left;
                    height = rowHeights[y] + d;
                    for (x = 0; x < cols; x++) {
                        if (reverseRows) {
                            idx = y * cols + cols - 1 - x
                        } else {
                            idx = y * cols + x
                        }
                        ctrl = items[idx];
                        if (!ctrl) {
                            break
                        }
                        ctrlSettings = ctrl.settings;
                        ctrlLayoutRect = ctrl.layoutRect();
                        width = Math.max(colWidths[x], ctrlLayoutRect.startMinWidth);
                        ctrlLayoutRect.x = posX;
                        ctrlLayoutRect.y = posY;
                        align = ctrlSettings.alignH || (alignH ? (alignH[x] || alignH[0]) : null);
                        if (align == "center") {
                            ctrlLayoutRect.x = posX + (width / 2) - (ctrlLayoutRect.w / 2)
                        } else if (align == "right") {
                            ctrlLayoutRect.x = posX + width - ctrlLayoutRect.w
                        } else if (align == "stretch") {
                            ctrlLayoutRect.w = width
                        }
                        align = ctrlSettings.alignV || (alignV ? (alignV[x] || alignV[0]) : null);
                        if (align == "center") {
                            ctrlLayoutRect.y = posY + (height / 2) - (ctrlLayoutRect.h / 2)
                        } else if (align == "bottom") {
                            ctrlLayoutRect.y = posY + height - ctrlLayoutRect.h
                        } else if (align == "stretch") {
                            ctrlLayoutRect.h = height
                        }
                        ctrl.layoutRect(ctrlLayoutRect);
                        posX += width + spacingH;
                        if (ctrl.recalc) {
                            ctrl.recalc()
                        }
                    }
                    posY += height + spacingV
                }
            }
        })
    });
    define("tinymce/ui/Iframe", ["tinymce/ui/Widget", "tinymce/util/Delay"], function (d, e) {
        "use strict";
        return d.extend({
            renderHtml: function () {
                var a = this;
                a.classes.add('iframe');
                a.canFocus = false;
                return ('<iframe id="' + a._id + '" class="' + a.classes + '" tabindex="-1" src="' + (a.settings.url || "javascript:''") + '" frameborder="0"></iframe>')
            },
            src: function (a) {
                this.getEl().src = a
            },
            html: function (a, b) {
                var c = this,
                    body = this.getEl().contentWindow.document.body;
                if (!body) {
                    e.setTimeout(function () {
                        c.html(a)
                    })
                } else {
                    body.innerHTML = a;
                    if (b) {
                        b()
                    }
                }
                return this
            }
        })
    });
    define("tinymce/ui/InfoBox", ["tinymce/ui/Widget"], function (c) {
        "use strict";
        return c.extend({
            init: function (a) {
                var b = this;
                b._super(a);
                b.classes.add('widget').add('infobox');
                b.canFocus = false
            },
            severity: function (a) {
                this.classes.remove('error');
                this.classes.remove('warning');
                this.classes.remove('success');
                this.classes.add(a)
            },
            help: function (a) {
                this.state.set('help', a)
            },
            renderHtml: function () {
                var a = this,
                    prefix = a.classPrefix;
                return ('<div id="' + a._id + '" class="' + a.classes + '">' + '<div id="' + a._id + '-body">' + a.encode(a.state.get('text')) + '<button role="button" tabindex="-1">' + '<i class="' + prefix + 'ico ' + prefix + 'i-help"></i>' + '</button>' + '</div>' + '</div>')
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:text', function (e) {
                    a.getEl('body').firstChild.data = a.encode(e.value);
                    if (a.state.get('rendered')) {
                        a.updateLayoutRect()
                    }
                });
                a.state.on('change:help', function (e) {
                    a.classes.toggle('has-help', e.value);
                    if (a.state.get('rendered')) {
                        a.updateLayoutRect()
                    }
                });
                return a._super()
            }
        })
    });
    define("tinymce/ui/Label", ["tinymce/ui/Widget", "tinymce/ui/DomUtils"], function (c, d) {
        "use strict";
        return c.extend({
            init: function (a) {
                var b = this;
                b._super(a);
                b.classes.add('widget').add('label');
                b.canFocus = false;
                if (a.multiline) {
                    b.classes.add('autoscroll')
                }
                if (a.strong) {
                    b.classes.add('strong')
                }
            },
            initLayoutRect: function () {
                var a = this,
                    layoutRect = a._super();
                if (a.settings.multiline) {
                    var b = d.getSize(a.getEl());
                    if (b.width > layoutRect.maxW) {
                        layoutRect.minW = layoutRect.maxW;
                        a.classes.add('multiline')
                    }
                    a.getEl().style.width = layoutRect.minW + 'px';
                    layoutRect.startMinH = layoutRect.h = layoutRect.minH = Math.min(layoutRect.maxH, d.getSize(a.getEl()).height)
                }
                return layoutRect
            },
            repaint: function () {
                var a = this;
                if (!a.settings.multiline) {
                    a.getEl().style.lineHeight = a.layoutRect().h + 'px'
                }
                return a._super()
            },
            severity: function (a) {
                this.classes.remove('error');
                this.classes.remove('warning');
                this.classes.remove('success');
                this.classes.add(a)
            },
            renderHtml: function () {
                var a = this,
                    targetCtrl, forName, forId = a.settings.forId;
                if (!forId && (forName = a.settings.forName)) {
                    targetCtrl = a.getRoot().find('#' + forName)[0];
                    if (targetCtrl) {
                        forId = targetCtrl._id
                    }
                }
                if (forId) {
                    return ('<label id="' + a._id + '" class="' + a.classes + '"' + (forId ? ' for="' + forId + '"' : '') + '>' + a.encode(a.state.get('text')) + '</label>')
                }
                return ('<span id="' + a._id + '" class="' + a.classes + '">' + a.encode(a.state.get('text')) + '</span>')
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:text', function (e) {
                    a.innerHtml(a.encode(e.value));
                    if (a.state.get('rendered')) {
                        a.updateLayoutRect()
                    }
                });
                return a._super()
            }
        })
    });
    define("tinymce/ui/Toolbar", ["tinymce/ui/Container"], function (c) {
        "use strict";
        return c.extend({
            Defaults: {
                role: 'toolbar',
                layout: 'flow'
            },
            init: function (a) {
                var b = this;
                b._super(a);
                b.classes.add('toolbar')
            },
            postRender: function () {
                var b = this;
                b.items().each(function (a) {
                    a.classes.add('toolbar-item')
                });
                return b._super()
            }
        })
    });
    define("tinymce/ui/MenuBar", ["tinymce/ui/Toolbar"], function (a) {
        "use strict";
        return a.extend({
            Defaults: {
                role: 'menubar',
                containerCls: 'menubar',
                ariaRoot: true,
                defaults: {
                    type: 'menubutton'
                }
            }
        })
    });
    define("tinymce/ui/MenuButton", ["tinymce/ui/Button", "tinymce/ui/Factory", "tinymce/ui/MenuBar"], function (d, f, g) {
        "use strict";

        function isChildOf(a, b) {
            while (a) {
                if (b === a) {
                    return true
                }
                a = a.parentNode
            }
            return false
        }
        var h = d.extend({
            init: function (a) {
                var b = this;
                b._renderOpen = true;
                b._super(a);
                a = b.settings;
                b.classes.add('menubtn');
                if (a.fixedWidth) {
                    b.classes.add('fixed-width')
                }
                b.aria('haspopup', true);
                b.state.set('menu', a.menu || b.render())
            },
            showMenu: function () {
                var a = this,
                    menu;
                if (a.menu && a.menu.visible()) {
                    return a.hideMenu()
                }
                if (!a.menu) {
                    menu = a.state.get('menu') || [];
                    if (menu.length) {
                        menu = {
                            type: 'menu',
                            items: menu
                        }
                    } else {
                        menu.type = menu.type || 'menu'
                    }
                    if (!menu.renderTo) {
                        a.menu = f.create(menu).parent(a).renderTo()
                    } else {
                        a.menu = menu.parent(a).show().renderTo()
                    }
                    a.fire('createmenu');
                    a.menu.reflow();
                    a.menu.on('cancel', function (e) {
                        if (e.control.parent() === a.menu) {
                            e.stopPropagation();
                            a.focus();
                            a.hideMenu()
                        }
                    });
                    a.menu.on('select', function () {
                        a.focus()
                    });
                    a.menu.on('show hide', function (e) {
                        if (e.control == a.menu) {
                            a.activeMenu(e.type == 'show')
                        }
                        a.aria('expanded', e.type == 'show')
                    }).fire('show')
                }
                a.menu.show();
                a.menu.layoutRect({
                    w: a.layoutRect().w
                });
                a.menu.moveRel(a.getEl(), a.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl'])
            },
            hideMenu: function () {
                var b = this;
                if (b.menu) {
                    b.menu.items().each(function (a) {
                        if (a.hideMenu) {
                            a.hideMenu()
                        }
                    });
                    b.menu.hide()
                }
            },
            activeMenu: function (a) {
                this.classes.toggle('active', a)
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    prefix = a.classPrefix;
                var b = a.settings.icon,
                    image, text = a.state.get('text'),
                    textHtml = '';
                image = a.settings.image;
                if (image) {
                    b = 'none';
                    if (typeof image != "string") {
                        image = window.getSelection ? image[0] : image[1]
                    }
                    image = ' style="background-image: url(\'' + image + '\')"'
                } else {
                    image = ''
                }
                if (text) {
                    a.classes.add('btn-has-text')
                }
                if (a.settings.icon == 'table') {
                    b = "ews-icon-table"
                } else {
                    b = a.settings.icon
                }
                a.aria('role', a.parent() instanceof g ? 'menuitem' : 'button');
                return ('<div id="' + id + '" class="' + a.classes + '" tabindex="-1" aria-labelledby="' + id + '">' + '<button id="' + id + '-open" role="presentation" type="button" tabindex="-1">' + (b ? '<i class="' + b + '"' + image + '></i>' : '') + textHtml + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>')
            },
            postRender: function () {
                var c = this;
                c.on('click', function (e) {
                    if (e.control === c && isChildOf(e.target, c.getEl())) {
                        c.showMenu();
                        if (e.aria) {
                            c.menu.items()[0].focus()
                        }
                    }
                });
                c.on('mouseenter', function (e) {
                    var b = e.control,
                        parent = c.parent(),
                        hasVisibleSiblingMenu;
                    if (b && parent && b instanceof h && b.parent() == parent) {
                        parent.items().filter('MenuButton').each(function (a) {
                            if (a.hideMenu && a != b) {
                                if (a.menu && a.menu.visible()) {
                                    hasVisibleSiblingMenu = true
                                }
                                a.hideMenu()
                            }
                        });
                        if (hasVisibleSiblingMenu) {
                            b.focus();
                            b.showMenu()
                        }
                    }
                });
                return c._super()
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:menu', function () {
                    if (a.menu) {
                        a.menu.remove()
                    }
                    a.menu = null
                });
                return a._super()
            },
            remove: function () {
                this._super();
                if (this.menu) {
                    this.menu.remove()
                }
            }
        });
        return h
    });
    define("tinymce/ui/MenuItem", ["tinymce/ui/Widget", "tinymce/ui/Factory", "tinymce/Env", "tinymce/util/Delay"], function (d, f, g, h) {
        "use strict";
        return d.extend({
            Defaults: {
                border: 0,
                role: 'menuitem'
            },
            init: function (a) {
                var b = this,
                    text;
                b._super(a);
                a = b.settings;
                b.classes.add('menu-item');
                if (a.menu) {
                    b.classes.add('menu-item-expand')
                }
                if (a.preview) {
                    b.classes.add('menu-item-preview')
                }
                text = b.state.get('text');
                if (text === '-' || text === '|') {
                    b.classes.add('menu-item-sep');
                    b.aria('role', 'separator');
                    b.state.set('text', '-')
                }
                if (a.selectable) {
                    b.aria('role', 'menuitemcheckbox');
                    b.classes.add('menu-item-checkbox');
                    a.icon = 'selected'
                }
                if (!a.preview && !a.selectable) {
                    b.classes.add('menu-item-normal')
                }
                b.on('mousedown', function (e) {
                    e.preventDefault()
                });
                if (a.menu && !a.ariaHideMenu) {
                    b.aria('haspopup', true)
                }
            },
            hasMenus: function () {
                return !!this.settings.menu
            },
            showMenu: function () {
                var b = this,
                    settings = b.settings,
                    menu, parent = b.parent();
                parent.items().each(function (a) {
                    if (a !== b) {
                        a.hideMenu()
                    }
                });
                if (settings.menu) {
                    menu = b.menu;
                    if (!menu) {
                        menu = settings.menu;
                        if (menu.length) {
                            menu = {
                                type: 'menu',
                                items: menu
                            }
                        } else {
                            menu.type = menu.type || 'menu'
                        }
                        if (parent.settings.itemDefaults) {
                            menu.itemDefaults = parent.settings.itemDefaults
                        }
                        menu = b.menu = f.create(menu).parent(b).renderTo();
                        menu.reflow();
                        menu.on('cancel', function (e) {
                            e.stopPropagation();
                            b.focus();
                            menu.hide()
                        });
                        menu.on('show hide', function (e) {
                            e.control.items().each(function (a) {
                                a.active(a.settings.selected)
                            })
                        }).fire('show');
                        menu.on('hide', function (e) {
                            if (e.control === menu) {
                                b.classes.remove('selected')
                            }
                        });
                        menu.submenu = true
                    } else {
                        menu.show()
                    }
                    menu._parentMenu = parent;
                    menu.classes.add('menu-sub');
                    var c = menu.testMoveRel(b.getEl(), b.isRtl() ? ['tl-tr', 'bl-br', 'tr-tl', 'br-bl'] : ['tr-tl', 'br-bl', 'tl-tr', 'bl-br']);
                    menu.moveRel(b.getEl(), c);
                    menu.rel = c;
                    c = 'menu-sub-' + c;
                    menu.classes.remove(menu._lastRel).add(c);
                    menu._lastRel = c;
                    b.classes.add('selected');
                    b.aria('expanded', true)
                }
            },
            hideMenu: function () {
                var b = this;
                if (b.menu) {
                    b.menu.items().each(function (a) {
                        if (a.hideMenu) {
                            a.hideMenu()
                        }
                    });
                    b.menu.hide();
                    b.aria('expanded', false)
                }
                return b
            },
            renderHtml: function () {
                var b = this,
                    id = b._id,
                    settings = b.settings,
                    prefix = b.classPrefix,
                    text = b.encode(b.state.get('text'));
                var c = b.settings.icon,
                    image = '',
                    shortcut = settings.shortcut;

                function convertShortcut(a) {
                    var i, value, replace = {};
                    if (g.mac) {
                        replace = {
                            alt: '&#x2325;',
                            ctrl: '&#x2318;',
                            shift: '&#x21E7;',
                            meta: '&#x2318;'
                        }
                    } else {
                        replace = {
                            meta: 'Ctrl'
                        }
                    }
                    a = a.split('+');
                    for (i = 0; i < a.length; i++) {
                        value = replace[a[i].toLowerCase()];
                        if (value) {
                            a[i] = value
                        }
                    }
                    return a.join('+')
                }
                if (c) {
                    b.parent().classes.add('menu-has-icons')
                }
                if (settings.image) {
                    image = ' style="background-image: url(\'' + settings.image + '\')"'
                }
                if (shortcut) {
                    shortcut = convertShortcut(shortcut)
                }
                c = prefix + 'ico ' + prefix + 'i-' + (b.settings.icon || 'none');
                return ('<div id="' + id + '" class="' + b.classes + '" tabindex="-1">' + (text !== '-' ? '<i class="' + c + '"' + image + '></i> ' : '') + (text !== '-' ? '<span id="' + id + '-text" class="' + prefix + 'text">' + text + '</span>' : '') + (shortcut ? '<div id="' + id + '-shortcut" class="' + prefix + 'menu-shortcut">' + shortcut + '</div>' : '') + (settings.menu ? '<div class="' + prefix + 'caret"></div>' : '') + '</div>')
            },
            postRender: function () {
                var a = this,
                    settings = a.settings;
                var b = settings.textStyle;
                if (typeof b == "function") {
                    b = b.call(this)
                }
                if (b) {
                    var c = a.getEl('text');
                    if (c) {
                        c.setAttribute('style', b)
                    }
                }
                a.on('mouseenter click', function (e) {
                    if (e.control === a) {
                        if (!settings.menu && e.type === 'click') {
                            a.fire('select');
                            h.requestAnimationFrame(function () {
                                a.parent().hideAll()
                            })
                        } else {
                            a.showMenu();
                            if (e.aria) {
                                a.menu.focus(true)
                            }
                        }
                    }
                });
                a._super();
                return a
            },
            hover: function () {
                var b = this;
                b.parent().items().each(function (a) {
                    a.classes.remove('selected')
                });
                b.classes.toggle('selected', true);
                return b
            },
            active: function (a) {
                if (typeof a != "undefined") {
                    this.aria('checked', a)
                }
                return this._super(a)
            },
            remove: function () {
                this._super();
                if (this.menu) {
                    this.menu.remove()
                }
            }
        })
    });
    define("tinymce/ui/Throbber", ["tinymce/dom/DomQuery", "tinymce/ui/Control", "tinymce/util/Delay"], function ($, f, g) {
        "use strict";
        return function (c, d) {
            var e = this,
                state, classPrefix = f.classPrefix,
                timer;
            e.show = function (a, b) {
                function render() {
                    if (state) {
                        $(c).append('<div class="' + classPrefix + 'throbber' + (d ? ' ' + classPrefix + 'throbber-inline' : '') + '"></div>');
                        if (b) {
                            b()
                        }
                    }
                }
                e.hide();
                state = true;
                if (a) {
                    timer = g.setTimeout(render, a)
                } else {
                    render()
                }
                return e
            };
            e.hide = function () {
                var a = c.lastChild;
                g.clearTimeout(timer);
                if (a && a.className.indexOf('throbber') != -1) {
                    a.parentNode.removeChild(a)
                }
                state = false;
                return e
            }
        }
    });
    define("tinymce/ui/Menu", ["tinymce/ui/FloatPanel", "tinymce/ui/MenuItem", "tinymce/ui/Throbber", "tinymce/util/Tools"], function (d, e, f, g) {
        "use strict";
        return d.extend({
            Defaults: {
                defaultType: 'menuitem',
                border: 1,
                layout: 'stack',
                role: 'application',
                bodyRole: 'menu',
                ariaRoot: true
            },
            init: function (a) {
                var b = this;
                a.autohide = true;
                a.constrainToViewport = true;
                if (typeof a.items === 'function') {
                    a.itemsFactory = a.items;
                    a.items = []
                }
                if (a.itemDefaults) {
                    var c = a.items,
                        i = c.length;
                    while (i--) {
                        c[i] = g.extend({}, a.itemDefaults, c[i])
                    }
                }
                b._super(a);
                b.classes.add('menu')
            },
            repaint: function () {
                this.classes.toggle('menu-align', true);
                this._super();
                this.getEl().style.height = '';
                this.getEl('body').style.height = '';
                return this
            },
            cancel: function () {
                var a = this;
                a.hideAll();
                a.fire('select')
            },
            load: function () {
                var b = this,
                    time, factory;

                function hideThrobber() {
                    if (b.throbber) {
                        b.throbber.hide();
                        b.throbber = null
                    }
                }
                factory = b.settings.itemsFactory;
                if (!factory) {
                    return
                }
                if (!b.throbber) {
                    b.throbber = new f(b.getEl('body'), true);
                    if (b.items().length === 0) {
                        b.throbber.show();
                        b.fire('loading')
                    } else {
                        b.throbber.show(100, function () {
                            b.items().remove();
                            b.fire('loading')
                        })
                    }
                    b.on('hide close', hideThrobber)
                }
                b.requestTime = time = new Date().getTime();
                b.settings.itemsFactory(function (a) {
                    if (a.length === 0) {
                        b.hide();
                        return
                    }
                    if (b.requestTime !== time) {
                        return
                    }
                    b.getEl().style.width = '';
                    b.getEl('body').style.width = '';
                    hideThrobber();
                    b.items().remove();
                    b.getEl('body').innerHTML = '';
                    b.add(a);
                    b.renderNew();
                    b.fire('loaded')
                })
            },
            hideAll: function () {
                var a = this;
                this.find('menuitem').exec('hideMenu');
                return a._super()
            },
            preRender: function () {
                var c = this;
                c.items().each(function (a) {
                    var b = a.settings;
                    if (b.icon || b.image || b.selectable) {
                        c._hasIcons = true;
                        return false
                    }
                });
                if (c.settings.itemsFactory) {
                    c.on('postrender', function () {
                        if (c.settings.itemsFactory) {
                            c.load()
                        }
                    })
                }
                return c._super()
            }
        })
    });
    define("tinymce/ui/ListBox", ["tinymce/ui/MenuButton", "tinymce/ui/Menu"], function (f, g) {
        "use strict";
        return f.extend({
            init: function (b) {
                var c = this,
                    values, selected, selectedText, lastItemCtrl;

                function setSelected(a) {
                    for (var i = 0; i < a.length; i++) {
                        selected = a[i].selected || b.value === a[i].value;
                        if (selected) {
                            selectedText = selectedText || a[i].text;
                            c.state.set('value', a[i].value);
                            return true
                        }
                        if (a[i].menu) {
                            if (setSelected(a[i].menu)) {
                                return true
                            }
                        }
                    }
                }
                c._super(b);
                b = c.settings;
                c._values = values = b.values;
                if (values) {
                    if (typeof b.value != "undefined") {
                        setSelected(values)
                    }
                    if (!selected && values.length > 0) {
                        selectedText = values[0].text;
                        c.state.set('value', values[0].value)
                    }
                    c.state.set('menu', values)
                }
                c.state.set('text', b.text || selectedText);
                c.classes.add('listbox');
                c.on('select', function (e) {
                    var a = e.control;
                    if (lastItemCtrl) {
                        e.lastControl = lastItemCtrl
                    }
                    if (b.multiple) {
                        a.active(!a.active())
                    } else {
                        c.value(e.control.value())
                    }
                    lastItemCtrl = a
                })
            },
            bindStates: function () {
                var d = this;

                function activateMenuItemsByValue(b, c) {
                    if (b instanceof g) {
                        b.items().each(function (a) {
                            if (!a.hasMenus()) {
                                a.active(a.value() === c)
                            }
                        })
                    }
                }
                function getSelectedItem(a, b) {
                    var c;
                    if (!a) {
                        return
                    }
                    for (var i = 0; i < a.length; i++) {
                        if (a[i].value === b) {
                            return a[i]
                        }
                        if (a[i].menu) {
                            c = getSelectedItem(a[i].menu, b);
                            if (c) {
                                return c
                            }
                        }
                    }
                }
                d.on('show', function (e) {
                    activateMenuItemsByValue(e.control, d.value())
                });
                d.state.on('change:value', function (e) {
                    var a = getSelectedItem(d.state.get('menu'), e.value);
                    if (a) {
                        d.text(a.text)
                    } else {
                        d.text(d.settings.text)
                    }
                });
                return d._super()
            }
        })
    });
    define("tinymce/ui/Radio", ["tinymce/ui/Checkbox"], function (a) {
        "use strict";
        return a.extend({
            Defaults: {
                classes: "radio",
                role: "radio"
            }
        })
    });
    define("tinymce/ui/ResizeHandle", ["tinymce/ui/Widget", "tinymce/ui/DragHelper"], function (b, c) {
        "use strict";
        return b.extend({
            renderHtml: function () {
                var a = this,
                    prefix = a.classPrefix;
                a.classes.add('resizehandle');
                if (a.settings.direction == "both") {
                    a.classes.add('resizehandle-both')
                }
                a.canFocus = false;
                return ('<div id="' + a._id + '" class="' + a.classes + '">' + '<i class="' + prefix + 'ico ' + prefix + 'i-resize"></i>' + '</div>')
            },
            postRender: function () {
                var a = this;
                a._super();
                a.resizeDragHelper = new c(this._id, {
                    start: function () {
                        a.fire('ResizeStart')
                    },
                    drag: function (e) {
                        if (a.settings.direction != "both") {
                            e.deltaX = 0
                        }
                        a.fire('Resize', e)
                    },
                    stop: function () {
                        a.fire('ResizeEnd')
                    }
                })
            },
            remove: function () {
                if (this.resizeDragHelper) {
                    this.resizeDragHelper.destroy()
                }
                return this._super()
            }
        })
    });
    define("tinymce/ui/SelectBox", ["tinymce/ui/Widget"], function (f) {
        "use strict";

        function createOptions(a) {
            var b = '';
            if (a) {
                for (var i = 0; i < a.length; i++) {
                    b += '<option value="' + a[i] + '">' + a[i] + '</option>'
                }
            }
            return b
        }
        return f.extend({
            Defaults: {
                classes: "selectbox",
                role: "selectbox",
                options: []
            },
            init: function (c) {
                var d = this;
                d._super(c);
                if (d.settings.size) {
                    d.size = d.settings.size
                }
                if (d.settings.options) {
                    d._options = d.settings.options
                }
                d.on('keydown', function (e) {
                    var b;
                    if (e.keyCode == 13) {
                        e.preventDefault();
                        d.parents().reverse().each(function (a) {
                            if (a.toJSON) {
                                b = a;
                                return false
                            }
                        });
                        d.fire('submit', {
                            data: b.toJSON()
                        })
                    }
                })
            },
            options: function (a) {
                if (!arguments.length) {
                    return this.state.get('options')
                }
                this.state.set('options', a);
                return this
            },
            renderHtml: function () {
                var a = this,
                    options, size = '';
                options = createOptions(a._options);
                if (a.size) {
                    size = ' size = "' + a.size + '"'
                }
                return ('<select id="' + a._id + '" class="' + a.classes + '"' + size + '>' + options + '</select>')
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:options', function (e) {
                    a.getEl().innerHTML = createOptions(e.value)
                });
                return a._super()
            }
        })
    });
    define("tinymce/ui/Slider", ["tinymce/ui/Widget", "tinymce/ui/DragHelper", "tinymce/ui/DomUtils"], function (h, i, j) {
        "use strict";

        function constrain(a, b, c) {
            if (a < b) {
                a = b
            }
            if (a > c) {
                a = c
            }
            return a
        }
        function setAriaProp(a, b, c) {
            a.setAttribute('aria-' + b, c)
        }
        function updateSliderHandle(a, b) {
            var c, shortSizeName, sizeName, stylePosName, styleValue, handleEl;
            if (a.settings.orientation == "v") {
                stylePosName = "top";
                sizeName = "height";
                shortSizeName = "h"
            } else {
                stylePosName = "left";
                sizeName = "width";
                shortSizeName = "w"
            }
            handleEl = a.getEl('handle');
            c = (a.layoutRect()[shortSizeName] || 100) - j.getSize(handleEl)[sizeName];
            styleValue = (c * ((b - a._minValue) / (a._maxValue - a._minValue))) + 'px';
            handleEl.style[stylePosName] = styleValue;
            handleEl.style.height = a.layoutRect().h + 'px';
            setAriaProp(handleEl, 'valuenow', b);
            setAriaProp(handleEl, 'valuetext', '' + a.settings.previewFilter(b));
            setAriaProp(handleEl, 'valuemin', a._minValue);
            setAriaProp(handleEl, 'valuemax', a._maxValue)
        }
        return h.extend({
            init: function (b) {
                var c = this;
                if (!b.previewFilter) {
                    b.previewFilter = function (a) {
                        return Math.round(a * 100) / 100.0
                    }
                }
                c._super(b);
                c.classes.add('slider');
                if (b.orientation == "v") {
                    c.classes.add('vertical')
                }
                c._minValue = b.minValue || 0;
                c._maxValue = b.maxValue || 100;
                c._initValue = c.state.get('value')
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    prefix = a.classPrefix;
                return ('<div id="' + id + '" class="' + a.classes + '">' + '<div id="' + id + '-handle" class="' + prefix + 'slider-handle" role="slider" tabindex="-1"></div>' + '</div>')
            },
            reset: function () {
                this.value(this._initValue).repaint()
            },
            postRender: function () {
                var g = this,
                    minValue, maxValue, screenCordName, stylePosName, sizeName, shortSizeName;

                function toFraction(a, b, c) {
                    return (c + a) / (b - a)
                }
                function fromFraction(a, b, c) {
                    return (c * (b - a)) - a
                }
                function handleKeyboard(c, d) {
                    function alter(a) {
                        var b;
                        b = g.value();
                        b = fromFraction(c, d, toFraction(c, d, b) + (a * 0.05));
                        b = constrain(b, c, d);
                        g.value(b);
                        g.fire('dragstart', {
                            value: b
                        });
                        g.fire('drag', {
                            value: b
                        });
                        g.fire('dragend', {
                            value: b
                        })
                    }
                    g.on('keydown', function (e) {
                        switch (e.keyCode) {
                            case 37:
                            case 38:
                                alter(-1);
                                break;
                            case 39:
                            case 40:
                                alter(1);
                                break
                        }
                    })
                }
                function handleDrag(b, c, d) {
                    var f, startHandlePos, maxHandlePos, handlePos, value;
                    g._dragHelper = new i(g._id, {
                        handle: g._id + "-handle",
                        start: function (e) {
                            f = e[screenCordName];
                            startHandlePos = parseInt(g.getEl('handle').style[stylePosName], 10);
                            maxHandlePos = (g.layoutRect()[shortSizeName] || 100) - j.getSize(d)[sizeName];
                            g.fire('dragstart', {
                                value: value
                            })
                        },
                        drag: function (e) {
                            var a = e[screenCordName] - f;
                            handlePos = constrain(startHandlePos + a, 0, maxHandlePos);
                            d.style[stylePosName] = handlePos + 'px';
                            value = b + (handlePos / maxHandlePos) * (c - b);
                            g.value(value);
                            g.tooltip().text('' + g.settings.previewFilter(value)).show().moveRel(d, 'bc tc');
                            g.fire('drag', {
                                value: value
                            })
                        },
                        stop: function () {
                            g.tooltip().hide();
                            g.fire('dragend', {
                                value: value
                            })
                        }
                    })
                }
                minValue = g._minValue;
                maxValue = g._maxValue;
                if (g.settings.orientation == "v") {
                    screenCordName = "screenY";
                    stylePosName = "top";
                    sizeName = "height";
                    shortSizeName = "h"
                } else {
                    screenCordName = "screenX";
                    stylePosName = "left";
                    sizeName = "width";
                    shortSizeName = "w"
                }
                g._super();
                handleKeyboard(minValue, maxValue, g.getEl('handle'));
                handleDrag(minValue, maxValue, g.getEl('handle'))
            },
            repaint: function () {
                this._super();
                updateSliderHandle(this, this.value())
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:value', function (e) {
                    updateSliderHandle(a, e.value)
                });
                return a._super()
            }
        })
    });
    define("tinymce/ui/Spacer", ["tinymce/ui/Widget"], function (b) {
        "use strict";
        return b.extend({
            renderHtml: function () {
                var a = this;
                a.classes.add('spacer');
                a.canFocus = false;
                return '<div id="' + a._id + '" class="' + a.classes + '"></div>'
            }
        })
    });
    define("tinymce/ui/SplitButton", ["tinymce/ui/MenuButton", "tinymce/ui/DomUtils", "tinymce/dom/DomQuery"], function (c, d, $) {
        return c.extend({
            Defaults: {
                classes: "widget btn splitbtn",
                role: "button"
            },
            repaint: function () {
                var a = this,
                    elm = a.getEl(),
                    rect = a.layoutRect(),
                    mainButtonElm, menuButtonElm;
                a._super();
                mainButtonElm = elm.firstChild;
                menuButtonElm = elm.lastChild;
                $(mainButtonElm).css({
                    width: rect.w - d.getSize(menuButtonElm).width,
                    height: rect.h - 2
                });
                $(menuButtonElm).css({
                    height: rect.h - 2
                });
                return a
            },
            activeMenu: function (a) {
                var b = this;
                $(b.getEl().lastChild).toggleClass(b.classPrefix + 'active', a)
            },
            renderHtml: function () {
                var a = this,
                    id = a._id,
                    prefix = a.classPrefix,
                    image;
                var b = a.state.get('icon'),
                    text = a.state.get('text'),
                    textHtml = '';
                image = a.settings.image;
                if (image) {
                    b = 'none';
                    if (typeof image != "string") {
                        image = window.getSelection ? image[0] : image[1]
                    }
                    image = ' style="background-image: url(\'' + image + '\')"'
                } else {
                    image = ''
                }
                b = a.settings.icon;
                if (text) {
                    a.classes.add('btn-has-text');
                    textHtml = '<span class="' + prefix + 'txt">' + a.encode(text) + '</span>'
                }
                return ('<div id="' + id + '" class="' + a.classes + '" role="button" tabindex="-1">' + '<button type="button" hidefocus="1" tabindex="-1">' + (b ? '<i class="' + b + '"' + image + '></i>' : '') + textHtml + '</button>' + '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' + (a._menuBtnText ? (b ? ' ' : '') + a._menuBtnText : '') + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>')
            },
            postRender: function () {
                var b = this,
                    onClickHandler = b.settings.onclick;
                b.on('click', function (e) {
                    var a = e.target;
                    if (e.control == this) {
                        while (a) {
                            if ((e.aria && e.aria.key != 'down') || (a.nodeName == 'BUTTON' && a.className.indexOf('open') == -1)) {
                                e.stopImmediatePropagation();
                                if (onClickHandler) {
                                    onClickHandler.call(this, e)
                                }
                                return
                            }
                            a = a.parentNode
                        }
                    }
                });
                delete b.settings.onclick;
                return b._super()
            }
        })
    });
    define("tinymce/ui/StackLayout", ["tinymce/ui/FlowLayout"], function (a) {
        "use strict";
        return a.extend({
            Defaults: {
                containerClass: 'stack-layout',
                controlClass: 'stack-layout-item',
                endClass: 'break'
            },
            isNative: function () {
                return true
            }
        })
    });
    define("tinymce/ui/TabPanel", ["tinymce/ui/Panel", "tinymce/dom/DomQuery", "tinymce/ui/DomUtils"], function (d, $, f) {
        "use strict";
        return d.extend({
            Defaults: {
                layout: 'absolute',
                defaults: {
                    type: 'panel'
                }
            },
            activateTab: function (b) {
                var c;
                if (this.activeTabId) {
                    c = this.getEl(this.activeTabId);
                    $(c).removeClass(this.classPrefix + 'active');
                    c.setAttribute('aria-selected', "false")
                }
                this.activeTabId = 't' + b;
                c = this.getEl('t' + b);
                c.setAttribute('aria-selected', "true");
                $(c).addClass(this.classPrefix + 'active');
                this.items()[b].show().fire('showtab');
                this.reflow();
                this.items().each(function (a, i) {
                    if (b != i) {
                        a.hide()
                    }
                })
            },
            renderHtml: function () {
                var c = this,
                    layout = c._layout,
                    tabsHtml = '',
                    prefix = c.classPrefix;
                c.preRender();
                layout.preRender(c);
                c.items().each(function (a, i) {
                    var b = c._id + '-t' + i;
                    a.aria('role', 'tabpanel');
                    a.aria('labelledby', b);
                    tabsHtml += ('<div id="' + b + '" class="' + prefix + 'tab" ' + 'unselectable="on" role="tab" aria-controls="' + a._id + '" aria-selected="false" tabIndex="-1">' + c.encode(a.settings.title) + '</div>')
                });
                return ('<div id="' + c._id + '" class="' + c.classes + '" hidefocus="1" tabindex="-1">' + '<div id="' + c._id + '-head" class="' + prefix + 'tabs" role="tablist">' + tabsHtml + '</div>' + '<div id="' + c._id + '-body" class="' + c.bodyClasses + '">' + layout.renderHtml(c) + '</div>' + '</div>')
            },
            postRender: function () {
                var b = this;
                b._super();
                b.settings.activeTab = b.settings.activeTab || 0;
                b.activateTab(b.settings.activeTab);
                this.on('click', function (e) {
                    var a = e.target.parentNode;
                    if (e.target.parentNode.id == b._id + '-head') {
                        var i = a.childNodes.length;
                        while (i--) {
                            if (a.childNodes[i] == e.target) {
                                b.activateTab(i)
                            }
                        }
                    }
                })
            },
            initLayoutRect: function () {
                var b = this,
                    rect, minW, minH;
                minW = f.getSize(b.getEl('head')).width;
                minW = minW < 0 ? 0 : minW;
                minH = 0;
                b.items().each(function (a) {
                    minW = Math.max(minW, a.layoutRect().minW);
                    minH = Math.max(minH, a.layoutRect().minH)
                });
                b.items().each(function (a) {
                    a.settings.x = 0;
                    a.settings.y = 0;
                    a.settings.w = minW;
                    a.settings.h = minH;
                    a.layoutRect({
                        x: 0,
                        y: 0,
                        w: minW,
                        h: minH
                    })
                });
                var c = f.getSize(b.getEl('head')).height;
                b.settings.minWidth = minW;
                b.settings.minHeight = minH + c;
                rect = b._super();
                rect.deltaH += c;
                rect.innerH = rect.h - rect.deltaH;
                return rect
            }
        })
    });
    define("tinymce/ui/TextBox", ["tinymce/ui/Widget", "tinymce/util/Tools", "tinymce/ui/DomUtils"], function (f, g, h) {
        return f.extend({
            init: function (c) {
                var d = this;
                d._super(c);
                d.classes.add('textbox');
                if (c.multiline) {
                    d.classes.add('multiline')
                } else {
                    d.on('keydown', function (e) {
                        var b;
                        if (e.keyCode == 13) {
                            e.preventDefault();
                            d.parents().reverse().each(function (a) {
                                if (a.toJSON) {
                                    b = a;
                                    return false
                                }
                            });
                            d.fire('submit', {
                                data: b.toJSON()
                            })
                        }
                    });
                    d.on('keyup', function (e) {
                        d.state.set('value', e.target.value)
                    })
                }
            },
            repaint: function () {
                var a = this,
                    style, rect, borderBox, borderW, borderH = 0,
                    lastRepaintRect;
                style = a.getEl().style;
                rect = a._layoutRect;
                lastRepaintRect = a._lastRepaintRect || {};
                var b = document;
                if (!a.settings.multiline && b.all && (!b.documentMode || b.documentMode <= 8)) {
                    style.lineHeight = (rect.h - borderH) + 'px'
                }
                borderBox = a.borderBox;
                borderW = borderBox.left + borderBox.right + 8;
                borderH = borderBox.top + borderBox.bottom + (a.settings.multiline ? 8 : 0);
                if (rect.x !== lastRepaintRect.x) {
                    style.left = rect.x + 'px';
                    lastRepaintRect.x = rect.x
                }
                if (rect.y !== lastRepaintRect.y) {
                    style.top = rect.y + 'px';
                    lastRepaintRect.y = rect.y
                }
                if (rect.w !== lastRepaintRect.w) {
                    style.width = (rect.w - borderW) + 'px';
                    lastRepaintRect.w = rect.w
                }
                if (rect.h !== lastRepaintRect.h) {
                    style.height = (rect.h - borderH) + 'px';
                    lastRepaintRect.h = rect.h
                }
                a._lastRepaintRect = lastRepaintRect;
                a.fire('repaint', {}, false);
                return a
            },
            renderHtml: function () {
                var b = this,
                    settings = b.settings,
                    attrs, elm;
                attrs = {
                    id: b._id,
                    hidefocus: '1'
                };
                g.each(['rows', 'spellcheck', 'maxLength', 'size', 'readonly', 'min', 'max', 'step', 'list', 'pattern', 'placeholder', 'required', 'multiple'], function (a) {
                    attrs[a] = settings[a]
                });
                if (b.disabled()) {
                    attrs.disabled = 'disabled'
                }
                if (settings.subtype) {
                    attrs.type = settings.subtype
                }
                elm = h.create(settings.multiline ? 'textarea' : 'input', attrs);
                elm.value = b.state.get('value');
                elm.className = b.classes;
                return elm.outerHTML
            },
            value: function (a) {
                if (arguments.length) {
                    this.state.set('value', a);
                    return this
                }
                if (this.state.get('rendered')) {
                    this.state.set('value', this.getEl().value)
                }
                return this.state.get('value')
            },
            postRender: function () {
                var a = this;
                a.getEl().value = a.state.get('value');
                a._super();
                a.$el.on('change', function (e) {
                    a.state.set('value', e.target.value);
                    a.fire('change', e)
                })
            },
            bindStates: function () {
                var a = this;
                a.state.on('change:value', function (e) {
                    if (a.getEl().value != e.value) {
                        a.getEl().value = e.value
                    }
                });
                a.state.on('change:disabled', function (e) {
                    a.getEl().disabled = e.value
                });
                return a._super()
            },
            remove: function () {
                this.$el.off();
                this._super()
            }
        })
    });
    define("tinymce/Register", [], function () {
        var a = this || window;
        var b = function () {
            return a.tinymce
        };
        if (typeof a.define === "function") {
            if (!a.define.amd) {
                a.define("ephox/tinymce", [], b)
            }
        }
        return {}
    });
    expose(["tinymce/geom/Rect", "tinymce/util/Promise", "tinymce/util/Delay", "tinymce/Env", "tinymce/dom/EventUtils", "tinymce/dom/Sizzle", "tinymce/util/Tools", "tinymce/dom/DomQuery", "tinymce/html/Styles", "tinymce/dom/TreeWalker", "tinymce/html/Entities", "tinymce/dom/DOMUtils", "tinymce/dom/ScriptLoader", "tinymce/AddOnManager", "tinymce/dom/RangeUtils", "tinymce/html/Node", "tinymce/html/Schema", "tinymce/html/SaxParser", "tinymce/html/DomParser", "tinymce/html/Writer", "tinymce/html/Serializer", "tinymce/dom/Serializer", "tinymce/util/VK", "tinymce/dom/ControlSelection", "tinymce/dom/BookmarkManager", "tinymce/dom/Selection", "tinymce/Formatter", "tinymce/UndoManager", "tinymce/EditorCommands", "tinymce/util/URI", "tinymce/util/Class", "tinymce/util/EventDispatcher", "tinymce/util/Observable", "tinymce/ui/Selector", "tinymce/ui/Collection", "tinymce/ui/ReflowQueue", "tinymce/ui/Control", "tinymce/ui/Factory", "tinymce/ui/KeyboardNavigation", "tinymce/ui/Container", "tinymce/ui/DragHelper", "tinymce/ui/Scrollable", "tinymce/ui/Panel", "tinymce/ui/Movable", "tinymce/ui/Resizable", "tinymce/ui/FloatPanel", "tinymce/ui/Window", "tinymce/ui/MessageBox", "tinymce/WindowManager", "tinymce/ui/Tooltip", "tinymce/ui/Widget", "tinymce/ui/Progress", "tinymce/ui/Notification", "tinymce/NotificationManager", "tinymce/EditorObservable", "tinymce/Shortcuts", "tinymce/Editor", "tinymce/util/I18n", "tinymce/FocusManager", "tinymce/EditorManager", "tinymce/util/XHR", "tinymce/util/JSON", "tinymce/util/JSONRequest", "tinymce/util/JSONP", "tinymce/util/LocalStorage", "tinymce/Compat", "tinymce/ui/Layout", "tinymce/ui/AbsoluteLayout", "tinymce/ui/Button", "tinymce/ui/ButtonGroup", "tinymce/ui/Checkbox", "tinymce/ui/ComboBox", "tinymce/ui/ColorBox", "tinymce/ui/PanelButton", "tinymce/ui/ColorButton", "tinymce/util/Color", "tinymce/ui/ColorPicker", "tinymce/ui/Path", "tinymce/ui/ElementPath", "tinymce/ui/FormItem", "tinymce/ui/Form", "tinymce/ui/FieldSet", "tinymce/ui/FilePicker", "tinymce/ui/FitLayout", "tinymce/ui/FlexLayout", "tinymce/ui/FlowLayout", "tinymce/ui/FormatControls", "tinymce/ui/GridLayout", "tinymce/ui/Iframe", "tinymce/ui/InfoBox", "tinymce/ui/Label", "tinymce/ui/Toolbar", "tinymce/ui/MenuBar", "tinymce/ui/MenuButton", "tinymce/ui/MenuItem", "tinymce/ui/Throbber", "tinymce/ui/Menu", "tinymce/ui/ListBox", "tinymce/ui/Radio", "tinymce/ui/ResizeHandle", "tinymce/ui/SelectBox", "tinymce/ui/Slider", "tinymce/ui/Spacer", "tinymce/ui/SplitButton", "tinymce/ui/StackLayout", "tinymce/ui/TabPanel", "tinymce/ui/TextBox"])
})(this);
